export default {
  en: {
    language: 'Language',

    // Nav
    browse: 'Browse',
    library: 'Library',
    my_content: 'My content',
    account: 'My account',
    back: 'Go Back',
    more: 'more',
    add_mod: 'Add {ugc}',
    edit_mod: 'Edit on mod.io',
    admin: 'Admin',
    help_center: 'help center',
    subscribed_ugc: 'Subscribed {ugc}',
    followed_collections: 'Followed collections',
    page: 'Page',

    // Guides
    guide: 'Guide | Guides',
    views: 'Views',
    table_of_contents: 'Table of contents',
    reading_time: 'Reading time',
    date_added: 'Date added',
    date_updated: 'Date updated',
    minutes_read: 'Min read',
    published: 'Published',
    show_more_tags: 'Show uncommon tags',
    hide_more_tags: 'Hide uncommon tags',

    // Users
    joined: 'Joined',
    last_online: 'Last online',
    online: 'Online',
    followers: 'Followers',
    partner: 'Partner',
    partnered_creator: 'Partnered creator',
    profile_hidden: `This user's profile is hidden`,
    follow: 'Follow',
    unfollow: 'Unfollow',
    following: 'Following',
    user: 'user',
    user_update_error: 'Failed to update user',
    age_widget_error: 'Failed to load age widget',

    // Mods
    mod: 'Mod | Mods',
    level: 'Level | Levels',
    content: 'Content',
    subscribed: 'Subscribed',
    tags: 'Tags',
    summary: 'Summary',
    contributors: 'Contributors',
    description: 'Description',
    dependencies: 'Dependencies',
    no_dependencies: 'This {ugc} has no dependencies',
    of: 'of',
    ago: 'ago',
    and: 'and',
    by: 'By',
    reset_filters: 'Reset Filters',
    show_more: 'Show More',
    show_less: 'Show Less',
    no_ugc_found: 'No {ugc_name} found',
    no_subscriptions: 'You have not subscribed to any {ugc_name}',
    mod_disclaimer_heading: 'Legal disclaimer',
    mod_disclaimer_privacy: 'Privacy Policy',
    thumbs_up_received: 'Thumbs up received',
    thumbs_up: 'Thumbs up',
    total_downloads: 'Total downloads',
    releases: 'Releases',
    bytes: 'bytes',
    local_mod_disabled:
      'This {ugc} cannot be loaded as one or more dependencies are missing: {dependencies}',
    mod_with_collections: 'Collections with this {ugc}',
    see_all_collections: 'See all {count} collections',
    mod_dependencies:
      'All dependencies need to be installed for this {ugc} to work.',
    mod_dependencies_prompt:
      'This {ugc} has required dependencies. Would you like to subscribe to them too?',
    allow_in_collections: 'Allow to be added to collections',
    allow_in_collections_tip:
      'If this option is enabled, other users will be able to add your {ugc} to collections.',

    // Actions
    login: 'Log in',
    logout: 'Log out',
    search: 'Search',
    clear_all: 'Clear all',
    download: 'Download',
    subscribe: 'Subscribe',
    unsubscribe: 'Unsubscribe',
    resubscribe: 'Resubscribe',
    activate: 'Activate',
    deactivate: 'Deactivate',
    like: 'Like',
    dislike: 'Dislike',
    report: 'Report a problem',
    submit: 'Submit',
    cancel: 'Cancel',
    done: 'Done',
    select: 'Select',
    previous: 'Previous',
    next: 'Next',
    confirm: 'Confirm',
    allow: 'Allow',
    manage: 'Manage',
    discard: 'Discard changes',
    more_actions: 'More actions',
    manage_interaction_settings: 'Manage interaction settings',
    block: 'Block',
    block_user: 'Block user contact',
    unblock: 'Unblock',
    user_blocked:
      'You have blocked this user so they cannot contact you or comment on your content',
    block_user_tooltip:
      'Prevents this user from contacting you or commenting on your content.',
    block_prompt:
      'Are you sure you want to block this user? They will not be able to contact you or comment on your content.',
    block_success: 'User blocked successfully.',
    unblock_success: 'User unblocked successfully.',
    unblock_prompt:
      'Are you sure you want to unblock this user? They will be able to contact you and comment on your content again.',
    mute: 'Mute',
    mute_user: 'Mute user {ugc}',
    unmute: 'Unmute',
    user_muted:
      'You have muted this user so you can not see any of their {ugc}',
    mute_user_tooltip:
      'Prevents {ugc} created by this user from being surfaced to you when browsing games',
    mute_prompt:
      'Are you sure you want to mute this user? You will no longer see any {ugc} submitted by them when browsing games.',
    mute_success: 'User muted successfully.',
    unmute_success: 'User unmuted successfully.',
    unmute_prompt:
      'Are you sure you want to unmute this user? You will able to see their content again.',
    publish: 'Publish',
    block_error: 'Failed to update user block status',
    mute_error: 'Failed to update user mute status',

    // Collections
    collection: 'Collection | Collections',
    total_mods: 'Total {ugc}',
    total_filesize: 'Total file size',
    follow_collection: 'Follow collection',
    unfollow_collection: 'Unfollow collection',
    compatibility: 'Compatibility',
    compat_rating: 'Compatibility rating',
    last_30_days: 'Last 30 days',
    all_time: 'All time',
    does_collection_work: 'Does this collection work for you?',
    collection_works: 'Yes it does',
    collection_doesnt_work: 'No it does not',
    collection_incomplete_subscriptions: 'Incomplete subscriptions',
    vote: 'votes | vote | votes',
    curator: 'Curator',
    creator_count: '{count} creators in this collection',
    mods_in_collection: 'All {ugc} included in this collection',
    mod_not_available: 'This {ugc} is no longer available',
    unavailable: 'unavailable',
    collection_sub_mods: 'Subscribe me to all {ugc} in this collection',
    collection_unsub_mods: 'Unsubscribe me from all {ugc} in this collection',
    collection_unsub_hint:
      'If left unchecked, the collection will be removed from your library, but you will remain subscribed to its {ugc}.',
    collection_error_subscribe: 'Failed to subscribe to collection {ugc}',
    collection_error_unsubscribe: 'Failed to unsubscribe from collection {ugc}',
    collection_error_follow: 'Failed to follow collection',
    collection_error_unfollow: 'Failed to unfollow collection',
    ugc_count: '{ugc} count',
    collections_incomplete:
      'Some {ugc} are unavailable which may affect compatibility',
    adult: 'Adult',
    view_more: 'View more',
    view_less: 'View less',

    // Categories
    category: 'Category',
    miscellaneous: 'Miscellaneous',
    essential: 'Essential',
    themed: 'Themed',
    animation: 'Animation',
    audio: 'Audio',
    bug_fixes: 'Bug fixes',
    cheating: 'Cheating',
    environment: 'Environment',
    gameplay: 'Gameplay',
    quality_of_life: 'Quality of life',
    ui: 'UI',
    visuals: 'Visuals',

    // Filters
    all: 'All',
    available: 'available',
    filesize: 'File size',
    downloads: 'Downloads',
    todays_downloads: "Today's downloads",
    subscribers: 'Subscribers',
    rating: 'Rating',
    sort_by: 'Sort by',
    creator: 'Creator',
    apply: 'Apply',
    reset: 'Reset',
    featured: 'Featured',
    toggle_filters: 'Toggle filters',
    show_filters: 'Show filters',
    hide_filters: 'Hide filters',
    admin_options: 'Admin options',
    hidden: 'Hidden',
    public: 'Public',
    private: 'Private',
    pending: 'Pending',
    archived: 'Archived',
    deleted: 'Deleted',
    last_day: 'Last day',
    hidden_monetization_disabled: 'Hidden as monetization disabled',
    date_live: 'Date live',
    last_week: 'Last week',
    last_month: 'Last month',
    last_3_months: 'Last 3 months',
    last_year: 'Last year',
    exclude: 'Exclude',
    no_matching_content: 'No matching content available',
    content_type: 'Content type',
    free: 'Free',
    premium: 'Premium',

    // Login
    signup: 'Log in or sign up with Email',
    login_with: 'Log in with {service}',
    email_placeholder: 'Email address',
    code_placeholder: '5 digit code',
    have_code: 'I have a code',
    send_new_code: 'Send new code',
    login_disclaimer: 'User-generated content for {game} is managed by mod.io.',
    terms_disclaimer: ` By pressing "Log in", you agree to the {studioterms}{terms} and {privacy} of mod.io and confirm you are {min_age} years of age or older.`,
    terms_disclaimer_studio: '{terms} of {studio}, the ',
    terms_disclaimer_studio_separator: ', ',
    terms_disclaimer_studio_and: ' and ',
    code_error: 'Unable to request code.',
    or: 'or',
    login_prompt:
      'The page you are trying to access requires authentication. Please log in to continue.',
    receive_code: "Didn't receive a code?",
    resend_code: 'Resend code',
    login_with_email: 'Log in with email',
    otp_email:
      'We sent a One-Time Passcode (OTP) to {email}. Please enter it to continue.',
    back_to_login: 'Back to log in options',

    // Terms
    terms: 'Terms of Use',
    privacy: 'Privacy Policy',
    aup: 'Acceptable Use Policy',
    monetization: 'Monetization Terms',
    game: 'Game Terms',
    api: 'API Access Terms',
    refund: 'Refund Policy',
    effective: 'Effective from',

    // Report
    report_heading: 'Report this {ugc}',
    report_intro:
      'You can report issues with content, violations of mod.io {terms} or submit a {dmca} using the form below.',
    report_intro_collection:
      'You can report issues with content, violations of mod.io {terms} using the form below.',
    report_details:
      'Make sure you include all relevant information to facilitate the resolution of your report. Please note that this information will be shared with game moderators and may be shared with the user who posted the allegedly infringing content.',
    report_not_working_prompt:
      '"Not working" reports will be shared directly with the content creator.',
    dmca: 'DMCA complaint',
    report_reason: 'Reason for reporting',
    urls: 'Offending URLs',
    urls_placeholder: 'URLs (1 per line)',
    company_or_name: 'Company or your Name',
    email: 'Email',
    address: 'Address',
    country: 'Country/region',
    country_placeholder: 'Select a country/region',
    details: 'Details of Infringement',
    details_placeholder:
      'In order to help with resolving your report, please provide as much detail and context as possible.',
    dmca_1:
      "{mod_io} respects the intellectual property rights of others, and we ask that everyone using our internet sites and services do the same. Anyone who believes that their work has been reproduced in one of our internet sites or services in a way that constitutes copyright infringement may notify mod.io's copyright agent using the form below.",
    dmca_2:
      'Submitting a claim of copyright infringement is a serious legal matter. Before you proceed, you might consider contacting the individual directly to address the complaint. It might be a simple misunderstanding and possible to address without involving proper legal process.',
    dmca_3:
      'Be aware that under Section 512(f) of the Digital Millennium Copyright Act, any person who knowingly materially misrepresents that material or activity is infringing may be liable for damages. Please also note that the information provided in this legal notice may be shared with third-parties or made public.',
    claim_check:
      'By checking the following boxes and submitting this claim, I state UNDER PENALTY OF PERJURY that',
    copyright_owner: 'I am the Copyright Owner',
    copyright_auth_owner:
      "I am authorized to act on the copyright owner's behalf in this situation.",
    authorization: 'Authorization',
    authorization_check:
      'I have a good faith belief that the use of the material noted in this claim is not authorized by the copyright owner, its agent, or the law.',
    acknowledgement: 'Acknowledgement',
    acknowledgement_check:
      'I acknowledge that under Section 512(f) of the DMCA any person who knowingly materially misrepresent that material or activity is infringing may be liable for damages.',
    required: 'required',
    signature: 'Signature',
    signature_placeholder:
      'Type your full name into this box, acting as your digital signature.',
    report_success_title: 'Your report has been received',
    report_success_text:
      'If more detail is required to resolve your report, you might be contacted to provide it. Thanks for the details.',
    report_error_title: 'Failed to submit report',
    report_email_inform:
      'Your email address is strictly used for processing this report.',

    // Table
    name: 'Name',
    added: 'Added',
    updated: 'Updated',
    date: 'Date',
    item: 'item',
    file: 'File',
    version: 'Version',
    scan: 'Scan',
    actions: 'Actions',
    status: 'Status',
    role: 'Role',
    live: 'Live',
    locally_installed: 'Locally installed',

    // Releases
    download_from_game_client: 'Download {mod} from game client',
    download_payment_required: 'Purchase to download {ugc}',
    download_auth_required: 'Log in to download {ugc}',
    release_notes: 'Release Notes',
    no_release_notes: 'No release notes provided',
    previous_releases: 'Previous releases',
    view_previous_releases: 'View previous releases',
    no_previous_releases: 'There are no previous releases',
    no_files_published: 'No files published',
    download_files_manually: 'Download files manually',
    platforms: 'Platform | Platforms',

    // Ratings
    overwhelmingly_positive: 'Overwhelmingly positive',
    overwhelmingly_negative: 'Overwhelmingly negative',
    very_positive: 'Very positive',
    very_negative: 'Very negative',
    mostly_positive: 'Mostly positive',
    mostly_negative: 'Mostly negative',
    negative: 'Negative',
    positive: 'Positive',
    mixed: 'Mixed',
    unrated: 'Unrated',

    // Sort
    sort_comments: 'Comments',
    sort_total_mods: 'Total Mods',
    sort_trending: 'Trending',
    sort_highest_rated: 'Highest Rated',
    sort_most_popular: 'Popular',
    sort_most_subscribers: 'Most Subscribers',
    sort_recently_added: 'Recent',
    sort_last_updated: 'Last Updated',
    sort_alphabetical: 'Alphabetical',
    sort_smallest_filesize: 'Smallest filesize',

    // Report Reason
    report_dmca: 'DMCA',
    report_not_working: 'Not Working',
    report_rude_content: 'Rude Content',
    report_illegal_content: 'Illegal Content',
    report_stolen_content: 'Stolen Content',
    report_false_information: 'False Information',
    report_other: 'Other',

    // Report not working reason
    report_crash: 'Crashes game',
    report_no_load: 'Does not load',
    report_conflicts: 'Conflicts with other {ugc}',
    report_missing_deps: 'Missing dependencies',
    report_install_issues: 'Installation issues',
    report_bugs: 'Buggy behavior',
    report_incompatability: 'Incompatible with game version',
    report_corrupt: 'Corrupted files',

    // Errors
    warning: 'Warning',
    error_ref: 'Error code: ',
    login_fail: 'Failed to login',
    login_fail_message: 'Failed to login. Please wait a minute and try again.',
    subscribe_fail: 'Failed to subscribe',
    unsubscribe_fail: 'Failed to unsubscribe',
    error: 'Error',
    default_error_message: 'An error has occurred please try again soon.',
    follow_error: 'Failed to follow',
    unfollow_error: 'Failed to unfollow',
    upload_file_error: 'You must upload at least one file to continue',

    filter: 'Filter',
    page_not_found: 'Page not found!',
    take_me_home: 'Take me home',
    previous_version: 'Previous version',
    next_version: 'Next version',
    agreement_not_found: 'Agreement not found',
    loading: 'Loading',
    no_results_found: 'No results found',
    validation_required: 'Field is required',
    validation_checked: 'Field must be checked',
    validation_email: 'Field must be an email',
    validation_min: 'Minimum {min} characters',
    validation_max: 'Maximum {max} characters',
    validation_url: 'Field must be a URL',
    validation_size: 'Field must be {size} characters',
    validation_alpha_num: 'Field can only contain numbers or letters',
    validation_name: 'Field can only contain letters and name-related symbols',
    validation_image: 'File must be a valid jpeg or png image',
    validation_youtube: 'Field must be a valid Youtube URL',
    validation_sketchfab: 'Field must be a valid Sketchfab URL',
    validation_zip: 'File must be a ZIP',
    validation_filesize: 'Filesize must not exceed {size}',
    delete_image: 'Delete image',
    confirm_delete_image: 'Are you sure you want to delete this image?',

    form_chars_remaining: '{count} characters remaining.',
    form_not_enough_chars: '{count} more characters required.',

    // Comments
    comment: 'comment | comments',
    team_member: 'Team member',
    game_admin: 'Game admin',
    site_admin: 'Site admin',
    author: 'Author',
    good_karma: 'Good karma',
    bad_karma: 'Bad karma',
    reply: 'Reply',
    replies: 'reply | replies',
    replied: 'Replied',
    reopen: 'Reopen',
    close: 'Close',
    mark_as_read: 'Mark as read',
    save: 'Save',
    delete: 'Delete',
    archive: 'Archive',
    edit: 'Edit',
    post: 'Post',
    pinned: 'Pinned',
    pin: 'Pin',
    unpin: 'Unpin',
    locked: 'Locked',
    lock: 'Lock',
    unlock: 'Unlock',
    add_comment: 'Add a comment...',
    comment_cant_reply_locked: 'Cannot reply as comment thread is locked',
    comment_cant_edit_locked: 'Cannot edit as comment thread is locked',
    comment_max_pin_limit: 'Maximum pinned comment limit reached',
    comment_below_threshold: 'Comment below threshold. Click to view.',
    comment_login_prompt: 'Log in to join the discussion!',
    comment_error_add: 'Failed to add comment',
    comment_error_edit: 'Failed to edit comment',
    comment_error_delete: 'Failed to delete comment',
    comment_error_rate: 'Failed to rate comment',
    comment_error_update: 'Failed to update comment',
    comments_error_fetch: 'Failed to load more comments',
    discussion: 'Discussion',
    load_more_comments: 'Load more comments',
    comment_confirm_delete: 'Are you sure you want to delete this comment?',
    comment_deleted: 'The comment was successfully deleted',
    comments_disabled:
      "Comments are disabled due to your account's Parental Control settings.",
    comments_age_unverified:
      'You cannot add a comment until your age is verified',
    review_settings: 'Review settings',

    // Mod admin
    mod_status: {
      pending_has_file:
        'The {ugc} requires game moderator approval to go live.',
      pending_curation:
        'The {ugc} will change to a live status once a file has been added and approved.',
      pending_no_curation:
        'The {ugc} will change to a live status once a file has been added.',
      archived:
        'The {ugc} has been archived. All subscribers have been removed and it cannot be viewed or retrieved via API requests.',
      hidden:
        'The {ugc} is hidden and only available to subscribers and team members.',
      hidden_purchase_disabled:
        'The {ugc} is hidden as monetization has been disabled.',
      live: 'The {ugc} is live and available for all to play.',
    },
    mod_profile: '{ugc} profile',
    media: 'Media',
    file_manager: 'File manager',
    step: 'STEP {step}',
    save_next: 'Save & Next',
    auth_required: 'Authentication required',
    public_text: '{ugc} is discoverable on browse pages to everyone.',
    private_text:
      '{ugc} is only accessible to team members, existing subscribers and users with preview access.',
    edit_disabled_on_add:
      'Once this {ugc} has been created, you will not be able to make changes via the web.',
    edit_enabled_on_add:
      'You will be able to make changes to the {ugc} after it has been created.',
    add_mod_monetized:
      'This game supports monetized {ugc1}. If you are planning to monetize this {ugc2}, select {private} for now and make it {public} later after you have set up monetization. You can set up monetization after you have created the {ugc2}.',
    share_access: 'Share access',
    profile_editing_disabled:
      'Profile editing via the web has been disabled by the game.',
    tools_only_1:
      'You cannot upload {ugc} for {game} here, they must be uploaded using tools the game developer has created, so the files can be verified. For more information, see {guides} written for this game. ',
    tools_only_2: 'Here are the instructions provided by the game developer:',
    tools_only_3:
      'We recommend you return to the {ugc} list and browse the links from there. If the problem persists, head to our {help_center} for more information.',
    unsaved_heading: 'You have unsaved changes',
    unsaved_confirm:
      'There are changes that have not been saved, do you still want to leave?',
    settings: 'Settings',
    team: 'Teams',
    reports: 'Reports',
    stats: 'Stats',
    moderator: 'Moderator',
    manager: 'Manager',
    error_get_mod: 'Failed to get {ugc}',
    archive_reason: 'Reason for archiving',
    view_mod: 'View {ugc}',
    error_archive_mod: 'Failed to archive {ugc}',
    archive_mod_prompt:
      'Archiving this {ugc} will unsubscribe all users and remove it from API requests.',
    archive_mod_confirm:
      'Once archived, an email will be sent to all team members notifying them of this action along with the reason provided.\n\nThis action can only be reverted by moderators, are you sure you want to proceed?',

    headline_mod_profile: 'Create your {ugc} profile',
    headline_media: 'Add media to your {ugc} profile',
    headline_files: 'Upload your {ugc} file',
    headline_permissions: 'Set reuse permissions for your {ugc}',
    headline_dependencies: 'Add any {ugc} dependencies',

    // Basics
    basics: 'Basics',
    logo: 'Logo',
    logo_prompt_1: "Image file which will represent your {ugc}'s logo.",
    logo_prompt_2: '512x288 or larger',
    logo_prompt_3: '16:9 aspect ratio recommended',
    logo_prompt_4: '8MB maximum',
    summary_placeholder:
      'Tell us about the changes your {ugc} makes to the game in 1 paragraph.',
    homepage: 'Homepage',
    profile_url: 'Profile URL',
    visibility: 'Visibility',
    visibility_tip:
      'Once live, public {ugc} are visible to everyone. Hidden {ugc} are only visible to team members and subscribers.',
    upload_images: 'Upload images',
    mature_content: 'Contains mature content',
    mature_content_alcohol: 'Alcohol',
    mature_content_drugs: 'Drugs',
    mature_content_violence: 'Violence',
    mature_content_explicit: 'Explicit',
    community: 'Community',
    allow_comments: 'Allow comments',
    allow_dependants: 'Allow dependants',
    create_mod: 'Create {ugc}',
    error_mod_create: 'Failed to create {ugc}',
    error_mod_update: 'Failed to update {ugc}',
    error_tags_update: 'Failed to update tags',
    success_create_mod: 'Successfully created {modname}',
    success_update_mod: 'Successfully updated {modname}',
    description_tip:
      "Optional description for your {ugc}, which can include details such as 'About', 'Features', 'Usage', 'FAQ', etc. HTML supported and encouraged",

    // Media
    models: 'models',
    media_reorder_hint:
      'Drag to reorder existing images or drop new image files to upload.',
    media_zip_hint_1:
      'Upload up to {count} images at a time, or a single zip file containing images.',
    media_zip_hint_2: 'Supported formats are .jpg, .jpeg, .png and .zip.',
    drag_and_drop_image: 'Drag and drop images to upload',
    or_click_to_upload: 'Or click to choose a file',
    error_media_update: 'Failed to update media',
    error_media_add_links: 'Failed to add media links',
    error_media_remove_links: 'Failed to remove media links',
    success_media_updated: 'Updated media successfully',

    // File manager
    add_file: 'Add a file',
    edit_file: 'Edit file',
    select_zip: 'Select zip file',
    upload: 'Upload',
    file_id: 'File ID:',
    virus_none: 'No virus detected',
    virus_waiting: 'Waiting to scan',
    virus_scanning: 'Scan in progress',
    virus_too_large: 'File too large to scan',
    virus_not_found: 'File not found',
    virus_error: 'Error scanning file',
    virus_found: 'Virus detected',
    virus_risk:
      'This file contains an executable and care should be taken upon opening',
    version_placeholder: 'Version number i.e. 1.0.0',
    release_notes_placeholder: 'Enter each change on a separate line',
    game_moderator: 'Game moderator',
    metadata_blob: 'Metadata blob',
    metadata_blob_placeholder:
      'Enter specific metadata such as the version of the game this release is compatible with, how to install it, etc. UTF-8 valid data is supported.',
    select_platforms: 'Platforms (select all that apply)',
    file_pending: 'Pending approval',
    file_approved: 'Approved',
    file_approved_live: 'Approved and live',
    file_approved_not_live: 'Approved but not live',
    file_denied: 'Denied',
    file_targeted: 'Targeted',
    live_file: 'This file is currently live.',
    file_is_live: 'File is live',
    file_is_not_live: 'File is not live',
    no_delete_file_live: 'Cannot delete as file is live',
    make_file_live: 'Make this release live',
    make_file_live_platforms: 'Make this release live for approved platforms',
    delete_file_prompt:
      'Are you sure you want to delete this file? This action cannot be undone.',
    file_processing_title: 'File processing',
    file_processing:
      'Your file is being processed. You can continue to browse the site but please do not close the tab or browser window until it has finished.',
    file_instructions_1:
      'ZIP and upload the base folder of your {ugc}, or if it is a collection of files which live in a pre-existing game folder, you should ZIP those files:',
    file_instructions_2: 'Must be a ZIP file',
    file_instructions_3: 'Cannot exceed 20GB in filesize',
    file_instructions_4:
      'Filenames cannot contain any of the following characters: \\ / ? " &lt; &gt; &#124; : *',
    file_instructions_5:
      '{ugc} which overwrite files are not supported unless the game manages this',
    file_instructions_6:
      '{ugc} which span multiple game directories are not supported unless the game manages this',
    file_terms: 'I agree to the {terms} and {privacy}.',
    error_get_files: 'Failed to get files',
    error_upload_file_name: 'Failed to upload file {filename}',
    error_upload_file: 'Failed to upload file',
    error_update_file: 'Failed to update file',
    error_delete_file: 'Failed to delete file',
    no_permission_delete_files: "You don't have permission to delete files",
    error_file_required: 'File is required',
    error_platform_required: 'You must select at least one platform',
    success_file_uploaded: 'File uploaded successfully',
    success_file_moderation:
      'A moderator will review platforms that require moderation',
    success_file_updated: 'File updated successfully',
    error_no_approved_platforms: 'No platforms to set live',
    error_no_approved_platforms_text:
      'This file has no approved platforms that are not currently live',
    drag_and_drop_file: 'Drag and drop file to upload',
    file_upload_hint: 'Only .zip files accepted | {max} max file size',
    upload_draft: 'Upload & keep as draft',
    upload_publish: 'Upload & publish',
    save_draft: 'Save & keep as draft',
    save_publish: 'Save & publish',
    keep_as_draft: 'Keep as draft',
    publish_confirmation: 'Are you sure you want to publish this file?',
    marketplace_file_hint:
      'If you are planning to monetize this {mod}, you should keep this file as a draft and set up monetization first before publishing.',
    curation_file_hint:
      'A game moderator must approve your {mod} before players can access it.',
    platform_file_hint:
      'This game requires platform approval for each {mod} file for the selected platform(s): {platforms}.',
    two_step_approval_process:
      'This game requires a 2-step approval process before it will be accessible for players:',
    two_step_approval_process_step1:
      'Game moderator approval for this {mod} file for the selected platform(s): {platforms}',
    two_step_approval_process_step2:
      'Game moderator approval for the {mod} to go live',
    two_step_approval_process_live:
      'Publishing this file will also set the {mod} live automatically once both approvals are complete.',
    one_step_approval_process_live:
      'Publishing this file will also set the {mod} live automatically once approved.',

    // Reuse permissions form
    reuse_permissions: {
      heading: 'Reuse permissions',
      allow_redistribution:
        'Allow others to upload my {ugc} assets on other sites, but I must be credited as the original creator',
      allow_porting:
        'Allow others to convert my {ugc} assets to work in other games, but I must be credited as the original creator',
      allow_patching_no_credit:
        'Allow others to modify my {ugc} assets (including releasing bug fixes or improvements) and release it as a new {ugc}',
      require_credit: 'I must be credited as the original creator',
      require_permission: 'Require permission from me first',
      require_repackage_no_credit:
        'Allow others to use my {0} assets in their own {1}',
      allow_resell:
        'Allow others to use my {ugc} assets in any {ugc}/files in any commercial works',
      original_assets:
        'My {ugc} contains 100% original work, or assets which can be redistributed',
      error_update: 'Failed to update reuse permissions',
      success_update: 'Successfully updated reuse permissions',
      prompt:
        "Set permissions on how your {ugc} assets can be used for other's content creation. By granting permission for others to use or modify your files, you acknowledge that such authorization cannot be retroactively revoked with respect to works already created.",
    },

    // Dependencies form
    dependencies_prompt:
      "Select {0} required for this {1} to function correctly (if a {1} isn't shown, it means it hasn't allowed dependencies, and you should contact the creator to turn it on):",
    remove_dependency: 'Remove dependency',
    dependants: 'Dependants',
    important: 'IMPORTANT',
    error_update_dependencies: 'Failed to update dependencies',
    success_update_dependencies: 'Successfully updated dependency settings',
    dependants_warning_1:
      'Once allowed, please be aware that {ugc} with dependants connected:',
    dependants_warning_2: 'Cannot disable dependants',
    dependants_warning_3: 'Cannot be deleted',
    dependants_warning_4: 'Cannot be monetized',
    no_dependants: 'No dependants found',
    dependencies_allow_prompt:
      'You must turn on Allow Dependants above for other {ugc} to add yours as a dependant.',
    dependencies_deny_prompt:
      "You can turn off Allow Dependants above if you don't want other {ugc} to select it as a dependency",
    dependencies_not_supported:
      'Dependencies are not supported by {gamename}, all {ugc} must run independently and be entirely self contained.',
    dependency_disabled_monetization:
      'Monetized {ugc} cannot enable dependants',
    dependency_disabled_dependants:
      'Cannot disable dependants for this {ugc_single} as other {ugc_plural} depend on it. These can be viewed from the dependencies tab.',
    dependants_confirm_enable:
      'This is to ensure ongoing compatibility of connected {ugc}. Please confirm to enable.',
    dependants_confirm_disable:
      'Are you sure you want to disallow dependants? This means other {0} will be unable to add your {1} as a dependency.',
    dependency_monetization_warning:
      '{game} allows for {mod} monetization. Monetization does not currently support {mods} with dependencies. If you intend to monetize this {mod}, please skip this step.',

    // Parental controls
    notify_parent_title: 'Notify parent or guardian',
    notify_parent:
      'If you proceed, your parent or guardian will be notified and must approve these changes before they take effect.',
    confirm_notify_parent:
      'Would you like to send a notification to your parent or guardian to request access to the proposed permission changes?',
    request_access: 'Request access',

    // Platforms (English only)
    source: 'Source',
    windows: 'Windows',
    mac: 'Mac',
    linux: 'Linux',
    android: 'Android',
    ios: 'iOS',
    xboxone: 'Xbox One',
    xboxseriesx: 'Xbox Series X/S',
    ps4: 'PlayStation 4',
    ps5: 'PlayStation 5',
    switch: 'Nintendo Switch',
    oculus: 'Oculus',

    // Cloud cooking
    cook_source: 'Cook a source file',
    source_file: 'Source file',
    targeted_platform: 'Targeted platform',
    metadata: 'Metadata',
    cook_time: 'Cook time',
    download_time: 'Download time',
    file_compression_time: 'File compression time',
    file_decompression_time: 'File decompression time',
    upload_time: 'Upload time',
    total_job_time: 'Total job time',
    logs: 'Logs',
    view_logs: 'View logs',
    logs_available_on_completion: 'Logs will be available upon cook completion',
    logs_for_file: 'Cook logs for {file}.',
    no_logs: 'No logs found for {file}.',
    get_logs_error: 'Failed to get cook logs',
    admin_only: 'Admin Only',
    queue: 'Queue',
    source_file_history: 'Source file history',
    no_source_files_found: 'No source files found',
    no_cooks_found: 'No cooks found',
    cook_jobs_available: 'File cook jobs available: {count}',
    view_details: 'View details',
    cloud_cooking: 'Cloud Cooking',
    add_file_type: 'Add a New {string}',
    edit_file_type: 'Edit {string}',
    files: 'Files',
    cook_details: 'Cook details',
    status_queued: 'Queued',
    status_cooking: 'Cooking',
    status_success: 'Successful',
    status_failed: 'Failed',
    status_pending_moderation: 'Pending moderation',
    status_moderation_rejected: 'Cook rejected',
    get_cook_files_error: 'Failed to get cloud cooking files',
    get_source_files_error: 'Failed to get source files',
    download_file_error: 'Failed to download file',
    source_instructions:
      'Upload your source file and choose the intended platform(s) below. The file will then be processed through Cloud Cooking that produces individual files for the platforms.',

    // Marketplace
    marketplace: {
      available_stock: 'Limited quantity available - {count} remaining',
      virtual_currency: 'Virtual currency',
      marketplace: 'Marketplace',
      order_summary: 'Order summary',
      payment_method: 'Payment method | Payment methods',
      wallet_balance: 'Wallet balance',
      vc_balance: 'Virtual currency balance',
      credits: 'Credits',
      currency: 'Currency',
      balance_after: 'Balance after purchase',
      token_purchase_success:
        'Thank you for your purchase. Your payment has been processed and a tax receipt will be sent to your email shortly. Your virtual currency balance has now been updated for {game}',
      transaction_id: 'Transaction ID',
      total_paid: 'Total amount paid',
      agreement: "I agree to mod.io's {terms} and {refund}",
      change_payment: 'Change payment',
      error_register: 'Failed to register for monetization',
      error_wallet: 'Failed to get game wallet',
      error_process: 'Unable to process payment',
      error_complete: 'Unable to complete payment',
      checkout: 'Checkout',
      vc_topup_confirmed: 'Virtual currency top up confirmed',
      confirm_purchase: 'Confirm purchase',
      continue_browsing: 'Continue browsing',
      back_to_mod: 'Back to {ugc} purchase',
      ugc_not_refundable:
        '{ugc_plural} purchases are not refundable. Please see our {terms} and {refund} before purchasing this {ugc}.',
      ugc_purchase_success:
        'Thank you for your purchase. The {ugc} has been added to your subscriptions in your {library} and is available in-game.',
      game_virtual_currency: 'Game virtual currency ({virtual_currency})',
      proceed_to_checkout: 'Proceed to checkout',
      ugc_purchase_confirmed: '{ugc} purchase confirmed',
      error_already_purchased: 'You already own this {ugc}',
      error_sku_packs: 'Failed to get {ugc} prices',
      error_payment_methods: 'Failed to get payment methods',
      calculated_at_checkout: 'Calculated at checkout',
      subtotal: 'Subtotal',
      taxes: 'Taxes',
      total_due: 'Total amount due',
      price: 'Price',
      purchased: 'Purchased',
      purchases: 'Purchased {ugc}',
      no_purchases: 'You have not purchased any {ugc}',
      purchase_to_rate: 'You can only rate {ugc} that you have purchased',
      usd_ugc_license:
        'Purchasing this {ugc} instantly grants {count} credits in exchange for a license to access it.',
      top_up: 'Top up',
      remaining_balance: 'Remaining balance',
      not_enough_vc:
        'You do not have enough virtual currency to proceed. Please top up your game wallet',
      error_virtual_currency_packs: 'Failed to get virtual currency packs',
      vc_prompt: 'Get your virtual currency packs',
      vc_description:
        'Support content creators and access premium content by purchasing virtual currency packs for {game}',
      vc_agreement:
        'Please see our {terms} and {refund} before purchasing a virtual currency pack. Any applicable taxes are applied at checkout.',
      error_session: 'Failed to get purchase session',
      sold_out: 'Sold out',
      currency_packs: 'Currency packs',
      cancel_transaction: 'Cancel transaction',
      cancel_transaction_text:
        'Are you sure you want to cancel this transaction?',
    },
  },
  fr: {
    language: 'Langue',

    // Nav
    browse: 'Parcourir',
    library: 'Bibliothèque',
    my_content: 'Mon contenu',
    account: 'Mon compte',
    back: 'Retourner',
    more: 'plus',
    add_mod: 'Ajouter {ugc}',
    edit_mod: 'Modifier sur mod.io',
    admin: 'Administrateur',
    help_center: "centre d'aide",
    subscribed_ugc: 'Abonné {ugc}',
    followed_collections: 'Collections suivies',
    page: 'Page',

    // Guides
    guide: 'Guide | Guides',
    views: 'Vues',
    table_of_contents: 'Table des matières',
    reading_time: 'Temps de lecture',
    date_added: 'Date ajoutée',
    date_updated: 'Date de mise à jour',
    minutes_read: 'Minute de lecture',
    published: 'Publié',
    show_more_tags: 'Afficher les balises inhabituelles',
    hide_more_tags: 'Masquer les balises inhabituelles',

    // Users
    joined: 'Rejoint',
    last_online: 'Dernière connexion',
    online: 'En ligne',
    followers: 'Suiveurs',
    partner: 'Partenaire',
    partnered_creator: 'Créateur partenaire',
    profile_hidden: 'Le profil de cet utilisateur est masqué',
    follow: 'Suivre',
    unfollow: 'Ne plus suivre',
    following: 'Suivant',
    user: 'utilisateur',
    user_update_error: "Échec de la mise à jour de l'utilisateur",
    age_widget_error: "Impossible de charger le widget d'âge",

    // Mods
    mod: 'Mod | Mods',
    level: 'Niveau | Les niveaux',
    content: 'Contenu',
    subscribed: 'Abonné',
    tags: 'Tags',
    summary: 'Résumé',
    contributors: 'Contributeurs',
    description: 'Description',
    dependencies: 'Dépendances',
    no_dependencies: "Ce {ugc} n'a aucune dépendance",
    of: 'sur',
    ago: 'il y a',
    and: 'et',
    by: 'Par',
    reset_filters: 'Réinitialiser les filtres',
    show_more: 'Montre plus',
    show_less: 'Afficher moins',
    no_ugc_found: 'Aucun {ugc_name} trouvé',
    no_subscriptions: "Vous n'êtes abonné à aucun {ugc_name}",
    mod_disclaimer_heading: 'Mentions légales',
    mod_disclaimer_privacy: "Charte d'utilisation des données personnelles",
    thumbs_up_received: 'Bravo reçu',
    thumbs_up: 'Pouces vers le haut',
    total_downloads: 'Total des téléchargements',
    releases: 'Sorties',
    bytes: 'octets',
    local_mod_disabled:
      'Ce {ugc} ne peut pas être chargé car une ou plusieurs dépendances sont manquantes : {dependencies}',
    mod_with_collections: 'Collections contenant ce {ugc}',
    see_all_collections: 'Voir toutes les collections {count}',
    mod_dependencies:
      'Toutes les dépendances doivent être installées pour que {ugc} fonctionne.',
    mod_dependencies_prompt:
      'Ce {ugc} nécessite des dépendances. Vous souhaitez également vous y abonner ?',
    allow_in_collections: "Autoriser l'ajout aux collections",
    allow_in_collections_tip:
      'Si cette option est activée, les autres utilisateurs pourront ajouter votre {ugc} à leurs collections.',

    // Actions
    login: 'Se connecter',
    logout: 'Déconnexion',
    search: 'Recherche',
    clear_all: 'Réinitialiser',
    download: 'Télécharger',
    subscribe: "S'abonner",
    unsubscribe: 'Se désabonner',
    resubscribe: 'Se réabonner',
    activate: 'Activer',
    deactivate: 'Désactiver',
    like: "J'aime",
    dislike: "Je n'aime pas",
    report: 'Signaler un problème',
    submit: 'Envoyer',
    cancel: 'Annuler',
    done: 'Terminé',
    select: 'Sélectionner',
    previous: 'Précédent',
    next: 'Suivant',
    confirm: 'Confirmer',
    allow: 'Autoriser',
    manage: 'Gérez',
    discard: 'Ignorer les modifications',
    more_actions: "Plus d'actions",
    manage_interaction_settings: "Gérer les paramètres d'interaction",
    block: 'Bloquer',
    block_user: "Bloquer le contact de l'utilisateur",
    unblock: 'Débloquer',
    user_blocked:
      "Vous avez bloqué cet utilisateur afin qu'il ne puisse pas vous contacter ni commenter votre contenu",
    block_user_tooltip:
      'Empêche cet utilisateur de vous contacter ou de commenter votre contenu.',
    block_prompt:
      'Êtes-vous sûr de vouloir bloquer cet utilisateur ? Il ne pourra pas vous contacter ni commenter votre contenu.',
    block_success: 'Utilisateur bloqué avec succès.',
    unblock_success: 'Utilisateur débloqué avec succès.',
    unblock_prompt:
      'Êtes-vous sûr de vouloir débloquer cet utilisateur ? Il pourra de nouveau vous contacter et commenter votre contenu.',
    mute: 'Muet',
    mute_user: "Masquer les {ugc} de l'utilisateur",
    unmute: 'Désactiver le son',
    user_muted:
      'Vous avez désactivé cet utilisateur afin de ne voir aucun de ses {ugc}',
    mute_user_tooltip:
      'Empêche les {ugc} créés par cet utilisateur de vous être proposés lors de la navigation dans les jeux',
    mute_prompt:
      'Êtes-vous sûr de vouloir désactiver le son de cet utilisateur ? Vous ne verrez plus aucun {ugc} soumis par eux lors de la navigation dans les jeux.',
    mute_success: 'Utilisateur mis en sourdine avec succès.',
    unmute_success: 'Utilisateur réactivé avec succès.',
    unmute_prompt:
      'Êtes-vous sûr de vouloir réactiver le son de cet utilisateur ? Vous pourrez à nouveau voir leur contenu.',
    publish: 'Publier',
    block_error:
      "Échec de la mise à jour du statut de blocage de l'utilisateur",
    mute_error:
      "Échec de la mise à jour du statut de désactivation du son de l'utilisateur",

    // Collections
    collection: 'Collection | Collections',
    total_mods: 'Total {ugc}',
    total_filesize: 'Taille totale du fichier',
    follow_collection: 'Suivez la collection',
    unfollow_collection: 'Ne plus suivre la collection',
    compatibility: 'Compatibilité',
    compat_rating: 'Cote de compatibilité',
    last_30_days: 'Les 30 derniers jours',
    all_time: 'Tout le temps',
    does_collection_work: 'Cette collection vous convient-elle ?',
    collection_works: "Oui c'est le cas",
    collection_doesnt_work: 'Non, il ne le fait pas',
    collection_incomplete_subscriptions: 'Abonnements incomplets',
    vote: 'voix',
    curator: 'Curateur',
    creator_count: '{count} créateurs dans cette collection',
    mods_in_collection: 'Tous les {ugc} inclus dans cette collection',
    mod_not_available: "Ce {ugc} n'est plus disponible",
    unavailable: 'indisponible',
    collection_sub_mods: 'Abonnez-moi à tous les {ugc} de cette collection',
    collection_unsub_mods:
      'Désabonnez-moi de tous les {ugc} de cette collection',
    collection_unsub_hint:
      "Si cette case n'est pas cochée, la collection sera supprimée de votre bibliothèque, mais vous resterez abonné à son {ugc}.",
    collection_error_subscribe: "Impossible de s'abonner à la collection {ugc}",
    collection_error_unsubscribe:
      'Impossible de se désinscrire de la collection {ugc}',
    collection_error_follow: 'Impossible de suivre la collecte',
    collection_error_unfollow: 'Impossible de ne plus suivre la collection',
    ugc_count: 'nombre {ugc}',
    collections_incomplete:
      'Certains {ugc} ne sont pas disponibles, ce qui peut affecter la compatibilité',
    adult: 'Adulte',
    view_more: 'Voir plus',
    view_less: 'Voir moins',

    // Categories
    category: 'Catégorie',
    miscellaneous: 'Divers',
    essential: 'Essentiel',
    themed: 'Thématique',
    animation: 'Animation',
    audio: 'Audio',
    bug_fixes: 'Corrections de bugs',
    cheating: 'Tricherie',
    environment: "L'environnement",
    gameplay: 'Gameplay',
    quality_of_life: 'Qualité de vie',
    ui: 'UI',
    visuals: 'Visuels',

    // Filters
    all: 'Tous',
    available: 'disponible(s)',
    filesize: 'Taille du fichier',
    downloads: 'Téléchargements',
    todays_downloads: 'Téléchargements du jour',
    subscribers: 'Abonnés',
    rating: 'Notation',
    sort_by: 'Trier par',
    creator: 'Créateur',
    apply: 'Appliquer',
    reset: 'Réinitialiser',
    featured: 'En vedette',
    toggle_filters: 'Faire basculer les filtres',
    show_filters: 'Afficher les filtres',
    hide_filters: 'Masquer les filtres',
    admin_options: "Options d'administration",
    hidden: 'Caché',
    public: 'Publique',
    private: 'Privé',
    pending: 'En attente',
    archived: 'Archivé',
    deleted: 'Supprimé',
    last_day: 'Dernier jour',
    hidden_monetization_disabled: 'Masqué car la monétisation est désactivée',
    date_live: 'Date en direct',
    last_week: 'La semaine dernière',
    last_month: 'Mois dernier',
    last_3_months: '3 derniers mois',
    last_year: `L'année dernière`,
    exclude: 'Exclure',
    no_matching_content: "Aucun contenu correspondant n'est disponible",
    content_type: 'Type de contenu',
    free: 'Gratuit',
    premium: 'Prime',

    // Login
    signup: 'Connectez-vous ou inscrivez-vous avec votre adresse e-mail',
    login_with: 'Connectez-vous avec {service}',
    email_placeholder: 'Adresse e-mail',
    code_placeholder: 'Code à 5 chiffres',
    have_code: "J'ai un code",
    send_new_code: 'Envoyer un nouveau code',
    login_disclaimer:
      "Le contenu généré par l'utilisateur pour {game} est géré par mod.io.",
    terms_disclaimer: `En appuyant sur « Connectez-vous », vous acceptez les {studioterms}{terms} et la {privacy} de mod.io et confirmez que vous avez {min_age} ans ou plus.`,
    terms_disclaimer_studio: '{terms} de {studio}, les ',
    terms_disclaimer_studio_separator: ', ',
    terms_disclaimer_studio_and: ' et la ',
    code_error: 'Demande de code impossible.',
    or: 'ou',
    login_prompt:
      "La page à laquelle vous essayez d'accéder nécessite une authentification. Veuillez vous connecter pour continuer.",
    receive_code: "Vous n'avez pas reçu de code?",
    resend_code: 'Renvoyer le code',
    login_with_email: 'Connectez-vous avec votre e-mail',
    otp_email:
      "Nous avons envoyé un code d'accès à usage unique (OTP) à {email}. Veuillez le saisir pour continuer.",
    back_to_login: 'Retour aux options de connexion',

    // Terms
    terms: "Conditions d'utilisation",
    privacy: 'Politique de confidentialité',
    aup: "Politique d'utilisation acceptable",
    monetization: 'Conditions de monétisation',
    game: 'Conditions du jeu',
    api: "Conditions d'accès à l'API",
    refund: 'Politique de remboursement',
    effective: 'En vigueur à partir de',

    // Report
    report_heading: 'Signalez ceci {ugc}',
    report_intro:
      'Vous pouvez signaler des problèmes de contenu, des violations des {terms} de mod.io ou soumettre un {dmca} en utilisant le formulaire ci-dessous.',
    report_intro_collection:
      'Vous pouvez signaler des problèmes de contenu, des violations des {terms} de mod.io en utilisant le formulaire ci-dessous.',
    report_details:
      "Assurez-vous d'inclure toutes les informations pertinentes pour faciliter la résolution de votre rapport. Veuillez noter que ces informations seront partagées avec les modérateurs du jeu et pourront être partagées avec l'utilisateur qui a publié le contenu présumé en infraction.",
    report_not_working_prompt:
      'Les rapports « Ne fonctionne pas » seront partagés directement avec le créateur de contenu.',
    report_reason: 'Raison du signalement',
    urls: 'URL incriminées',
    urls_placeholder: 'URL (1 par ligne)',
    company_or_name: 'Société ou votre nom',
    email: 'Adresse e-mail',
    address: 'Adresse',
    country: 'Pays/région',
    country_placeholder: 'Sélectionnez un pays/une région',
    details: "Détails de l'infraction",
    details_placeholder:
      'Afin de vous aider à résoudre votre rapport, veuillez fournir autant de détails et de contexte que possible.',
    dmca_1:
      "{mod_io} respecte les droits de propriété intellectuelle d'autrui et nous demandons à tous ceux qui utilisent nos sites et services Internet de faire de même. Toute personne qui estime que son travail a été reproduit sur l'un de nos sites Internet ou services d'une manière qui constitue une violation du droit d'auteur peut en informer l'agent des droits d'auteur de mod.io en utilisant le formulaire ci-dessous.",
    dmca_2:
      "Soumettre une réclamation pour infraction au droit d'auteur est une affaire juridique sérieuse. Avant de poursuivre, vous pouvez envisager de contacter directement la personne pour résoudre la plainte. Il peut s'agir d'un simple malentendu qui puisse être résolu sans impliquer une procédure judiciaire appropriée.",
    dmca_3:
      "Sachez qu'en vertu de l'article 512 (f) de la loi Digital Millennium Copyright Act, toute personne qui déclare faussement, sciemment et/ou matériellement que le matériel ou l'activité est en infraction peut être tenue responsable des dommages. Veuillez également noter que les informations fournies dans la présente notice légale peuvent être partagées avec des tiers ou rendues publiques.",
    claim_check:
      'En cochant les cases suivantes et en soumettant cette réclamation, je déclare SOUS PEINE DE PARJURE que',
    copyright_owner: "Je suis le titulaire du droit d'auteur",
    copyright_auth_owner:
      "J'ai l'autorisation d'agir au nom du titulaire du droit d'auteur dans cette situation.",
    authorization: 'Autorisation',
    authorization_check:
      "Je crois en toute bonne foi que l'utilisation du matériel indiqué dans cette réclamation n'est pas autorisée par le titulaire du droit d'auteur, son agent ou la loi.",
    acknowledgement: 'Reconnaissance',
    acknowledgement_check:
      "Je reconnais qu'en vertu de l'article 512 (f) du DMCA, toute personne qui déclare faussement, sciemment et/ou matériellement que le matériel ou l'activité est en infraction peut être tenue responsable des dommages.",
    required: 'requis',
    signature: 'Signature',
    signature_placeholder:
      'Saisissez votre nom complet dans cette case, agissant comme votre signature numérique.',
    report_success_title: 'Votre signalement a été reçu',
    report_success_text:
      'Si des informations supplémentaires sont nécessaires pour résoudre votre signalement, nous pourrions vous contacter. Merci pour ces précisions.',
    report_error_title: "Échec de l'envoi du signalement",
    report_email_inform:
      'Votre adresse e-mail est utilisée exclusivement pour traiter ce signalement.',

    // Table
    name: 'Nom',
    added: 'Ajouté',
    updated: 'Mis à jour',
    date: 'Date',
    item: 'article',
    file: 'Fichier',
    version: 'Version',
    scan: 'Analyse antivirus',
    actions: 'Actions',
    status: 'État',
    role: 'Rôle',
    live: 'En direct',
    locally_installed: 'Installé localement',

    // Releases
    download_from_game_client: 'Télécharger {mod} depuis le client du jeu',
    download_payment_required: 'Achetez pour télécharger {ugc}',
    download_auth_required: 'Connectez-vous pour télécharger {ugc}',
    release_notes: 'Notes de version',
    no_release_notes: 'Aucune note de version fournie',
    previous_releases: 'Versions précédentes',
    view_previous_releases: 'Voir les versions précédentes',
    no_previous_releases: 'Aucune version précédente',
    no_files_published: 'Aucun fichier publié',
    download_files_manually: 'Télécharger des fichiers manuellement',
    platforms: 'Plateforme | Plateformes',

    // Ratings
    overwhelmingly_positive: 'Extrêmement positif',
    overwhelmingly_negative: 'Extrêmement négatif',
    very_positive: 'Très positif',
    very_negative: 'Très négatif',
    mostly_positive: 'Plutôt positif',
    mostly_negative: 'Plutôt négatif',
    negative: 'Négatif',
    positive: 'Positif',
    mixed: 'Mixte',
    unrated: 'Non classé',

    // Sort
    sort_comments: 'Commentaires',
    sort_total_mods: 'Mods totaux',
    sort_trending: 'Tendance',
    sort_highest_rated: 'Les mieux notés',
    sort_most_popular: 'Le plus populaire',
    sort_most_subscribers: "Le plus d'abonnés",
    sort_recently_added: 'Récemment ajouté',
    sort_last_updated: 'Dernière mise à jour',
    sort_alphabetical: 'Alphabétique',
    sort_smallest_filesize: 'Taille de fichier la plus petite',

    // Report Reason
    report_dmca: 'DMCA',
    report_not_working: 'Ne fonctionne pas',
    report_rude_content: 'Contenu inapproprié',
    report_illegal_content: 'Contenu illégal',
    report_stolen_content: 'Contenu volé',
    report_false_information: 'Informations fausses',
    report_other: 'Autre',

    // Report not working reasons
    report_crash: 'Jeu de crash',
    report_no_load: 'Ne charge pas',
    report_conflicts: "Conflits avec d'autres {ugc}",
    report_missing_deps: 'Dépendances manquantes',
    report_install_issues: "Problèmes d'installation",
    report_bugs: 'Comportement bogué',
    report_incompatability: 'Incompatible avec la version du jeu',
    report_corrupt: 'Fichiers corrompus',

    // Errors
    warning: 'Avertissement',
    error_ref: "Code d'erreur : ",
    login_fail: 'Échec de la connexion',
    login_fail_message:
      'Échec de la connexion. Veuillez attendre une minute et réessayer.',
    subscribe_fail: "Échec de l'abonnement",
    unsubscribe_fail: 'Échec de la désabonnement',
    error: 'Erreur',
    default_error_message:
      "Une erreur s'est produite, veuillez réessayer bientôt.",
    follow_error: 'Impossible de suivre',
    unfollow_error: "Échec de l'abandon du suivi",
    upload_file_error:
      'Vous devez télécharger au moins un fichier pour continuer',

    agreement_not_found: 'Accord introuvable',
    form_chars_remaining: '{count} caractères restants.',
    form_not_enough_chars: '{count} plus de caractères requis.',
    filter: 'Filtre',
    loading: 'Chargement',
    next_version: 'Version suivante',
    no_results_found: 'Aucun résultat trouvé',
    page_not_found: 'Page non trouvée!',
    previous_version: 'La version précédente',
    take_me_home: 'Emmène moi chez toi',
    validation_alpha_num:
      'Le champ ne peut contenir que des chiffres ou des lettres',
    validation_size: 'Le champ doit contenir {size} caractères',
    validation_url: 'Le champ doit être une URL',
    validation_min: 'Caractères minimum {min}',
    validation_max: 'Caractères maximum {max}',
    validation_email: 'Le champ doit être un e-mail',
    validation_checked: 'Le champ doit être vérifié',
    validation_required: 'Champ requis',
    validation_name:
      'Le champ ne peut contenir que des lettres et des symboles liés au nom',
    validation_image: 'Le fichier doit être une image JPEG ou PNG valide',
    validation_youtube: 'Le champ doit être une URL Youtube valide',
    validation_sketchfab: 'Le champ doit être une URL Sketchfab valide',
    validation_zip: 'Le fichier doit être au format ZIP',
    validation_filesize: 'La taille du fichier ne doit pas dépasser {size}',
    delete_image: "Supprimer l'image",
    confirm_delete_image: 'Êtes-vous sûr de vouloir supprimer cette image ?',

    comment: 'commentaire | commentaires',
    team_member: "Membre de l'équipe",
    game_admin: 'Administrateur du jeu',
    site_admin: 'Administrateur du site',
    author: 'Auteur',
    good_karma: 'Bon karma',
    bad_karma: 'Mauvais karma',
    reply: 'Répondre',
    replies: 'réponse | réponses',
    replied: 'Répondu',
    reopen: 'Rouvrir',
    close: 'Fermer',
    mark_as_read: 'Marquer comme lu',
    save: 'Sauvegarder',
    delete: 'Supprimer',
    archive: 'Archive',
    edit: 'Modifier',
    post: 'Poste',
    pinned: 'Épinglé',
    pin: 'Épinglette',
    unpin: 'Désépingler',
    locked: 'Fermé à clé',
    lock: 'Verrouiller',
    unlock: 'Débloquer',
    add_comment: 'Ajouter un commentaire...',
    comment_cant_reply_locked:
      'Impossible de répondre car le fil de commentaires est verrouillé',
    comment_cant_edit_locked:
      'Impossible de modifier car le fil de commentaires est verrouillé',
    comment_max_pin_limit: 'Limite maximale de commentaires épinglés atteinte',
    comment_below_threshold:
      'Commentaire en dessous du seuil. Cliquez pour voir.',
    comment_login_prompt: 'Connectez-vous pour rejoindre la discussion!',
    comment_error_add: "Échec de l'ajout de commentaires",
    comment_error_edit: 'Échec de la modification du commentaire',
    comment_error_delete: 'Échec de la suppression des commentaires',
    comment_error_rate: "Impossible d'évaluer le commentaire",
    comment_error_update: 'Impossible de mettre à jour le commentaire',
    comments_error_fetch: 'Échec du chargement de plus de commentaires',
    discussion: 'Discussion',
    load_more_comments: 'Chargez plus de commentaires',
    comment_confirm_delete:
      'êtes-vous sûr de vouloir supprimer ce commentaire?',
    comment_deleted: 'Le commentaire a été supprimé avec succès',
    comments_disabled:
      'Les commentaires sont désactivés en raison des paramètres de contrôle parental de votre compte.',
    comments_age_unverified:
      "Vous ne pouvez pas ajouter de commentaire tant que votre âge n'est pas vérifié.",
    review_settings: 'Paramètres de révision',

    // Mod admin
    mod_status: {
      pending_has_file:
        "Le {ugc} nécessite l'approbation du modérateur du jeu pour être mis en ligne.",
      pending_curation:
        "Le {ugc} passera au statut actif une fois qu'un fichier aura été ajouté et approuvé.",
      pending_no_curation:
        "Le {ugc} passe à l'état actif une fois qu'un fichier a été ajouté.",
      archived:
        "Le {ugc} a été archivé. Tous les abonnés ont été supprimés et il ne peut pas être consulté ou récupéré via des requêtes d'API.",
      hidden:
        "Le {ugc} est masqué et réservé aux abonnés et aux membres de l'équipe.",
      hidden_purchase_disabled:
        'Le {ugc} est masqué car la monétisation a été désactivée.',
      live: 'Le {ugc} est en ligne et accessible à tous.',
    },
    mod_profile: 'Profil {ugc}',
    media: 'Médias',
    file_manager: 'Gestionnaire de fichiers',
    step: 'ÉTAPE {step}',
    save_next: 'Enregistrer et suivre',
    auth_required: 'Authentification requise',
    public_text: '{ugc} est accessible à tous sur les pages de navigation.',
    private_text:
      "{ugc} n'est accessible qu'aux membres de l'équipe, aux abonnés existants et aux utilisateurs ayant accès à la prévisualisation.",
    edit_disabled_on_add:
      'Une fois cet {ugc} créé, vous ne pourrez plus apporter de modifications via le Web.',
    edit_enabled_on_add:
      "Vous pourrez apporter des modifications au {ugc} une fois qu'il aura été créé.",
    add_mod_monetized:
      'Ce jeu prend en charge la version monétisée {ugc1}. Si vous envisagez de monétiser cet {ugc2}, sélectionnez {private} pour le moment et créez-le {public} plus tard après avoir configuré la monétisation. Vous pouvez configurer la monétisation après avoir créé le {ugc2}.',
    share_access: 'Accès partagé',
    profile_editing_disabled:
      "L'édition de profil via le Web a été désactivée par le jeu.",
    tools_only_1:
      "Vous ne pouvez pas télécharger {ugc} pour {game} ici, ils doivent être chargés à l'aide des outils créés par le développeur du jeu, afin que les fichiers puissent être vérifiés. Pour plus d'informations, consultez les {guides} écrits pour ce jeu. ",
    tools_only_2: 'Voici les instructions fournies par le développeur du jeu :',
    tools_only_3:
      "Nous vous recommandons de revenir à la liste {ugc} et de parcourir les liens qui s'y trouvent. Si le problème persiste, rendez-vous dans notre {help_center} pour plus d'informations.",
    unsaved_heading: 'Vous avez des modifications non enregistrées',
    unsaved_confirm:
      "Certaines modifications n'ont pas été enregistrées. Voulez-vous toujours partir ?",
    settings: 'Réglages',
    team: 'Équipes',
    reports: 'Rapports',
    stats: 'Statistiques',
    moderator: 'Modérateur',
    manager: 'Directeur',
    error_get_mod: "Impossible d'obtenir {ugc}",
    archive_reason: "Motif de l'archivage",
    view_mod: 'Afficher {ugc}',
    error_archive_mod: "Impossible d'archiver {ugc}",
    archive_mod_prompt:
      "L'archivage de cet {ugc} désabonnera tous les utilisateurs et le supprimera des demandes d'API.",
    archive_mod_confirm:
      "Une fois archivé, un e-mail sera envoyé à tous les membres de l'équipe pour les informer de cette action, avec la raison fournie.\n\nCette action ne peut être annulée que par les modérateurs, êtes-vous sûr de vouloir continuer ?",

    headline_mod_profile: 'Créez votre profil {ugc}',
    headline_media: 'Ajoutez des médias à votre profil {ugc}',
    headline_files: 'Téléchargez votre fichier {ugc}',
    headline_permissions:
      'Définir les autorisations de réutilisation pour votre {ugc}',
    headline_dependencies: 'Ajoutez des dépendances {ugc}',

    // Basics
    basics: 'Principes de base',
    logo: 'Logo',
    logo_prompt_1: 'Fichier image qui représentera le logo de votre {ugc}.',
    logo_prompt_2: '512 x 288 ou plus',
    logo_prompt_3: "Format d'image 16:9 recommandé",
    logo_prompt_4: '8 Mo maximum',
    summary_placeholder:
      'Parlez-nous des modifications que votre {ugc} apporte au jeu en un seul paragraphe.',
    homepage: "Page d'accueil",
    profile_url: 'URL du profil',
    visibility: 'Visibilité',
    visibility_tip:
      "Une fois en ligne, les {ugc} publics sont visibles par tous. Les {ugc} cachés ne sont visibles que par les membres de l'équipe et les abonnés.",
    upload_images: 'Téléchargez des images',
    mature_content: 'Contient du contenu réservé aux adultes',
    mature_content_alcohol: 'Alcool',
    mature_content_drugs: 'Médicaments',
    mature_content_violence: 'Violence',
    mature_content_explicit: 'Explicite',
    community: 'Communauté',
    allow_comments: 'Autoriser les commentaires',
    allow_dependants: 'Autoriser les personnes à charge',
    create_mod: 'Créer {ugc}',
    error_mod_create: 'Impossible de créer {ugc}',
    error_mod_update: 'Impossible de mettre à jour {ugc}',
    error_tags_update: 'Impossible de mettre à jour les balises',
    success_create_mod: '{modname} créé avec succès',
    success_update_mod: '{modname} a été mis à jour avec succès',
    description_tip:
      'Description facultative de votre {ugc}, qui peut inclure des détails tels que « À propos », « Fonctionnalités », « Utilisation », « FAQ », etc. Le HTML est pris en charge et encouragé',

    // Media
    models: 'des modèles',
    media_reorder_hint:
      'Faites glisser pour réorganiser les images existantes ou déposez de nouveaux fichiers image pour les télécharger.',
    media_zip_hint_1:
      "Téléchargez jusqu'à {count} images à la fois, ou un seul fichier zip contenant des images.",
    media_zip_hint_2: 'Les formats supportés sont .jpg, .jpeg, .png et .zip.',
    drag_and_drop_image: 'Glissez-déposez les images pour les télécharger',
    or_click_to_upload: 'Ou cliquez pour choisir un fichier',
    error_media_update: 'Impossible de mettre à jour le média',
    error_media_add_links: "Impossible d'ajouter des liens multimédia",
    error_media_remove_links: 'Impossible de supprimer les liens multimédia',
    success_media_updated: 'Médias mis à jour avec succès',

    // File manager
    add_file: 'Ajouter un fichier',
    edit_file: 'Modifier le fichier',
    select_zip: 'Sélectionnez le fichier zip',
    upload: 'Téléverser',
    file_id: 'ID du fichier :',
    virus_none: 'Aucun virus détecté',
    virus_waiting: 'En attente de numérisation',
    virus_scanning: 'Scan en cours',
    virus_too_large: 'Fichier trop volumineux pour être scanné',
    virus_not_found: 'Fichier introuvable',
    virus_error: 'Erreur lors de la numérisation du fichier',
    virus_found: 'Virus détecté',
    virus_risk:
      "Ce fichier contient un exécutable et des précautions doivent être prises lors de l'ouverture",
    version_placeholder: "Numéro de version, c'est-à-dire 1.0.0",
    release_notes_placeholder:
      'Entrez chaque modification sur une ligne distincte',
    game_moderator: 'Modérateur de jeu',
    metadata_blob: 'Blob de métadonnées',
    metadata_blob_placeholder:
      "Entrez des métadonnées spécifiques telles que la version du jeu avec laquelle cette version est compatible, comment l'installer, etc. Les données valides UTF-8 sont prises en charge.",
    select_platforms:
      "Plateformes (sélectionnez toutes les options qui s'appliquent)",
    file_pending: "En attente d'approbation",
    file_approved: 'Approuvé',
    file_approved_live: 'Approuvé et en ligne',
    file_approved_not_live: 'Approuvé mais pas en ligne',
    file_denied: 'Refusé',
    file_targeted: 'Ciblé',
    live_file: 'Ce fichier est actuellement en ligne.',
    file_is_live: 'Le fichier est en ligne',
    file_is_not_live: "Le fichier n'est pas en ligne",
    no_delete_file_live:
      'Impossible de supprimer le fichier car il est en ligne',
    make_file_live: 'Diffuser cette version en direct',
    make_file_live_platforms:
      'Diffuser cette version pour les plateformes approuvées',
    delete_file_prompt:
      'Êtes-vous sûr de vouloir supprimer ce fichier ? Cette action ne peut pas être annulée.',
    file_processing_title: 'Traitement des fichiers',
    file_processing:
      "Votre dossier est en cours de traitement. Vous pouvez continuer à naviguer sur le site, mais veuillez ne pas fermer l'onglet ou la fenêtre du navigateur avant d'avoir terminé.",
    file_instructions_1:
      "Compressez et chargez le dossier de base de votre {ugc}, ou s'il s'agit d'une collection de fichiers qui se trouvent dans un dossier de jeu préexistant, vous devez compresser ces fichiers au format ZIP:",
    file_instructions_2: 'Doit être un fichier ZIP',
    file_instructions_3: 'La taille du fichier ne peut pas dépasser 20 Go',
    file_instructions_4:
      'Les noms de fichiers ne peuvent contenir aucun des caractères suivants: \\ / ? " &lt; &gt; &#124; : *',
    file_instructions_5:
      '{ugc} dont les fichiers de remplacement ne sont pas pris en charge à moins que le jeu ne gère cela',
    file_instructions_6:
      "{ugc} qui s'étend sur plusieurs répertoires de jeux ne sont pas pris en charge à moins que le jeu ne gère cela",
    file_terms: "J'accepte les {terms} et {privacy}.",
    error_get_files: "Impossible d'obtenir les fichiers",
    error_upload_file_name: 'Échec du téléchargement du fichier {filename}',
    error_upload_file: 'Impossible de charger le fichier',
    error_update_file: 'Impossible de mettre à jour le fichier',
    error_delete_file: 'Impossible de supprimer le fichier',
    no_permission_delete_files:
      "Vous n'êtes pas autorisé à supprimer des fichiers",
    error_file_required: 'Le fichier est obligatoire',
    error_platform_required: 'Vous devez sélectionner au moins une plateforme',
    success_file_uploaded: 'Le fichier a été chargé avec succès',
    success_file_moderation:
      'Un modérateur passera en revue les plateformes nécessitant une modération',
    success_file_updated: 'Fichier mis à jour avec succès',
    error_no_approved_platforms: 'Aucune plateforme à mettre en ligne',
    error_no_approved_platforms_text:
      "Ce fichier ne contient aucune plateforme approuvée qui n'est pas actuellement en ligne",
    drag_and_drop_file: 'Glissez-déposez le fichier pour le télécharger',
    file_upload_hint:
      'Seuls les fichiers .zip sont acceptés | taille maximale du fichier {max}',
    upload_draft: 'Télécharger et conserver comme brouillon',
    upload_publish: 'Télécharger et publier',
    save_draft: 'Enregistrer et conserver comme brouillon',
    save_publish: 'Enregistrer et publier',
    keep_as_draft: 'Conserver comme brouillon',
    publish_confirmation: 'Êtes-vous sûr de vouloir publier ce fichier ?',
    marketplace_file_hint:
      'Si vous envisagez de monétiser ce {mod}, vous devriez conserver ce fichier comme brouillon et configurer la monétisation avant de publier.',
    curation_file_hint:
      'Un modérateur de jeu doit approuver votre {mod} avant que les joueurs puissent y accéder.',
    platform_file_hint:
      "Ce jeu nécessite l'approbation de la plateforme pour chaque fichier {mod} pour la/les plateforme(s) sélectionnée(s) : {platforms}.",
    two_step_approval_process:
      "Ce jeu nécessite un processus d'approbation en 2 étapes :",
    two_step_approval_process_step1:
      'Approbation du modérateur de jeu pour ce fichier {mod} pour la/les plateforme(s) sélectionnée(s) : {platforms}',
    two_step_approval_process_step2:
      'Approbation du modérateur de jeu pour que le {mod} devienne actif',
    two_step_approval_process_live:
      'La publication de ce fichier mettra également le {mod} en ligne automatiquement une fois que les deux approbations seront terminées.',
    one_step_approval_process_live:
      'La publication de ce fichier mettra également le {mod} en ligne automatiquement une fois approuvé.',

    // Reuse permissions form
    reuse_permissions: {
      heading: 'Réutiliser les autorisations',
      allow_redistribution:
        "Autoriser d'autres personnes à télécharger mes ressources {ugc} sur d'autres sites, mais je dois être crédité en tant que créateur d'origine",
      allow_porting:
        "Autoriser d'autres personnes à convertir mes ressources {ugc} pour les utiliser dans d'autres jeux, mais je dois être crédité en tant que créateur d'origine",
      allow_patching_no_credit:
        'Permettre aux autres de modifier mes ressources {ugc} (y compris en publiant des corrections de bugs ou des améliorations) et de les publier en tant que nouveau {ugc}',
      require_credit: 'Je dois être crédité en tant que créateur original',
      require_permission: "Demande-moi d'abord mon autorisation",
      require_repackage_no_credit:
        'Autoriser les autres à utiliser mes {0} actifs pour leurs propres besoins {1}',
      allow_resell:
        "Autoriser d'autres personnes à utiliser mes actifs {ugc} dans n'importe quel fichier {ugc} /dans toute œuvre commerciale",
      original_assets:
        'Mon {ugc} contient des œuvres originales à 100 %, ou des ressources qui peuvent être redistribuées',
      error_update:
        'Impossible de mettre à jour les autorisations de réutilisation',
      success_update: 'Autorisations de réutilisation mises à jour avec succès',
      prompt:
        "Définissez des autorisations sur la manière dont vos ressources {ugc} peuvent être utilisées pour la création de contenu par d'autres personnes. En autorisant d'autres personnes à utiliser ou à modifier vos fichiers, vous reconnaissez que cette autorisation ne peut pas être révoquée rétroactivement en ce qui concerne les œuvres déjà créées.",
    },

    // Dependencies form
    dependencies_prompt:
      "Sélectionnez {0} comme requis pour que {1} fonctionne correctement (si un {1} n'est pas affiché, cela signifie qu'il n'autorise pas les dépendances, et vous devez contacter le créateur pour l'activer) :",
    remove_dependency: 'Supprimer la dépendance',
    dependants: 'Personnes à charge',
    important: 'IMPORTANT',
    error_update_dependencies: 'Impossible de mettre à jour les dépendances',
    success_update_dependencies:
      'Paramètres de dépendance mis à jour avec succès',
    dependants_warning_1:
      'Une fois autorisé, sachez que {ugc} avec des personnes à charge connectées :',
    dependants_warning_2: 'Impossible de désactiver les personnes à charge',
    dependants_warning_3: 'Ne peut pas être supprimé',
    dependants_warning_4: 'Ne peut pas être monétisé',
    no_dependants: "Aucune personne à charge n'a été trouvée",
    dependencies_allow_prompt:
      'Vous devez activer Autoriser les personnes à charge ci-dessus pour que les autres {ugc} ajoutent la vôtre en tant que personne à charge.',
    dependencies_deny_prompt:
      'Vous pouvez désactiver Autoriser les personnes à charge ci-dessus si vous ne voulez pas que les autres {ugc} la sélectionnent comme dépendance',
    dependencies_not_supported:
      'Les dépendances ne sont pas prises en charge par {gamename}, tous les {ugc} doivent fonctionner indépendamment et être entièrement autonomes.',
    dependency_disabled_monetization:
      'Monetized {ugc} ne peut pas activer les personnes à charge',
    dependency_disabled_dependants:
      "Impossible de désactiver les personnes à charge pour ce {ugc_single} car d'autres {ugc_plural} en dépendent. Vous pouvez les consulter à partir de l'onglet Dépendances.",
    dependants_confirm_enable:
      "Cela permet de garantir la compatibilité permanente de connected {ugc}. Veuillez confirmer pour l'activer.",
    dependants_confirm_disable:
      "Êtes-vous sûr de vouloir interdire l'accès aux personnes à charge ? Cela signifie que les autres {0} ne pourront pas ajouter votre {1} en tant que dépendance.",

    dependency_monetization_warning:
      "{game} permet la monétisation de {mod}. La monétisation ne prend actuellement pas en charge les {mods} avec des dépendances. Si vous avez l'intention de monétiser ce {mod}, veuillez ignorer cette étape.",

    // Parental controls
    notify_parent_title: 'Avertir le parent ou le tuteur',
    notify_parent:
      "Si vous poursuivez, votre parent ou tuteur sera informé et devra approuver ces modifications avant qu'elles ne prennent effet.",
    confirm_notify_parent:
      "Souhaitez-vous envoyer une notification à votre parent ou tuteur pour lui demander l'accès aux modifications d'autorisation proposées ?",
    request_access: "request_access: 'Demande d'accès',",

    // Cloud cooking
    cook_source: 'Cuisiner un fichier source',
    source_file: 'Fichier source',
    targeted_platform: 'Plateforme ciblée',
    metadata: 'Métadonnées',
    cook_time: 'Temps de cuisson',
    download_time: 'Temps de téléchargement',
    file_compression_time: 'Temps de compression du fichier',
    file_decompression_time: 'Temps de décompression du fichier',
    upload_time: 'Heure de chargement',
    total_job_time: 'Temps de travail total',
    logs: 'bûches',
    view_logs: 'Afficher les journaux',
    logs_available_on_completion:
      'Les journaux seront disponibles une fois la cuisson terminée',
    logs_for_file: 'Faites cuire des journaux pour {file}.',
    no_logs: "Aucun journal n'a été trouvé pour {file}.",
    get_logs_error: "Impossible d'obtenir les journaux de cuisson",
    admin_only: 'Réservé aux administrateurs',
    queue: "File d'attente",
    source_file_history: 'Historique des fichiers sources',
    no_source_files_found: 'Aucun fichier source trouvé',
    no_cooks_found: 'Aucun cuisinier trouvé',
    cook_jobs_available:
      'Emplois de cuisinier de fichiers disponibles : {count}',
    view_details: 'Voir les détails',
    cloud_cooking: 'Cuisine dans les nuages',
    add_file_type: 'Ajouter une nouvelle {string}',
    edit_file_type: 'Modifier {string}',
    files: 'Fichiers',
    cook_details: 'Détails du cuisinier',
    status_queued: "File d'attente",
    status_cooking: 'Cuisson',
    status_success: 'Réussi',
    status_failed: 'Échoué',
    status_pending_moderation: 'En attente de modération',
    status_moderation_rejected: 'Cook a rejeté',
    get_cook_files_error:
      'Impossible de récupérer les fichiers de cuisson dans le cloud',
    get_source_files_error: 'Impossible de récupérer les fichiers sources',
    download_file_error: 'Échec du téléchargement du fichier',
    source_instructions:
      'Téléversez votre fichier source et choisissez la ou les plateformes cibles ci-dessous. Le fichier sera ensuite traité par Cloud Cooking, qui générera des fichiers individuels pour chaque plateforme.',

    // Marketplace
    marketplace: {
      available_stock: 'Quantité limitée disponible - {count} restants',
      virtual_currency: 'Monnaie virtuelle',
      marketplace: 'Place de marché',
      order_summary: 'Résumé de la commande',
      payment_method: 'Mode de paiement | Modes de paiement',
      wallet_balance: 'Solde du portefeuille',
      vc_balance: 'Solde en devises virtuelles',
      credits: 'Crédits',
      currency: 'Devise',
      balance_after: 'Solde après achat',
      token_purchase_success:
        'Merci pour votre achat. Votre paiement a été traité et un reçu fiscal vous sera envoyé sous peu par e-mail. Votre solde en monnaie virtuelle a maintenant été mis à jour pour {game}',
      transaction_id: 'ID de transaction',
      total_paid: 'Montant total payé',
      agreement: "J'accepte les conditions {terms} et {refund} de mod.io",
      change_payment: 'Modifier le paiement',
      error_register: "Impossible de s'inscrire à la monétisation",
      error_wallet: "Impossible d'obtenir le portefeuille du jeu",
      error_process: 'Impossible de traiter le paiement',
      error_complete: "Impossible d'effectuer le paiement",
      checkout: 'Commander',
      vc_topup_confirmed: 'Recharge en monnaie virtuelle confirmée',
      confirm_purchase: "Confirmer l'achat",
      continue_browsing: 'Poursuivre la navigation',
      back_to_mod: "Retour à l'achat {ugc}",
      ugc_not_refundable:
        "les achats effectués sur {ugc_plural} ne sont pas remboursables. Veuillez consulter nos {terms} et {refund} avant d'acheter cet {ugc}.",
      ugc_purchase_success:
        'Merci pour votre achat. Le {ugc} a été ajouté à vos abonnements dans votre {library} et est disponible dans le jeu.',
      game_virtual_currency: 'Monnaie virtuelle du jeu ({virtual_currency})',
      proceed_to_checkout: 'Passez à la caisse',
      ugc_purchase_confirmed: '{ugc} achat confirmé',
      error_already_purchased: 'Vous possédez déjà ce {ugc}',
      error_sku_packs: "Impossible d'obtenir les prix de {ugc}",
      error_payment_methods: "Impossible d'obtenir les modes de paiement",
      calculated_at_checkout: 'Calculé au moment du paiement',
      subtotal: 'Sous-total',
      taxes: 'Impôts',
      total_due: 'Montant total dû',
      price: 'Prix',
      purchased: 'Acheté',
      purchases: 'Acheté {ugc}',
      no_purchases: "Vous n'avez acheté aucun {ugc}",
      purchase_to_rate: 'Vous ne pouvez évaluer {ugc} que vous avez acheté',
      usd_ugc_license:
        "L'achat de cet {ugc} octroie instantanément des crédits {count} en échange d'une licence pour y accéder.",
      top_up: 'Rechargez',
      remaining_balance: 'Solde restant',
      not_enough_vc:
        "Vous n'avez pas assez de monnaie virtuelle pour continuer. Veuillez recharger votre portefeuille de jeux",
      error_virtual_currency_packs:
        "Impossible d'obtenir des packs de devises virtuelles",
      vc_prompt: 'Procurez-vous vos packs de devises virtuelles',
      vc_description:
        'Soutenez les créateurs de contenu et accédez à du contenu premium en achetant des packs de devises virtuelles pour {game}',
      vc_agreement:
        "Consultez nos {terms} et {refund} avant d'acheter un pack de monnaie virtuelle. Toutes les taxes applicables sont appliquées au moment du paiement.",
      error_session: "Impossible d'obtenir la session d'achat",
      sold_out: 'Épuisé',
      currency_packs: 'Packs de devises',
      cancel_transaction: 'Annuler la transaction',
      cancel_transaction_text:
        'Êtes-vous sûr de vouloir annuler cette transaction ?',
    },
  },
  de: {
    language: 'Sprache',

    // Nav
    browse: 'Durchsuchen',
    library: 'Bibliothek',
    my_content: 'Mein Inhalt',
    account: 'Mein Konto',
    back: 'Geh zurück',
    more: 'mehr',
    add_mod: '{ugc} hinzufügen',
    edit_mod: 'Auf mod.io bearbeiten',
    admin: 'Admin',
    help_center: 'hilfecenter',
    subscribed_ugc: '{ugc} abonniert',
    followed_collections: 'Verfolgte Sammlungen',
    page: 'Seite',

    // Guides
    guide: 'Leitfaden | Führer',
    views: 'Ansichten',
    table_of_contents: 'Inhaltsverzeichnis',
    reading_time: 'Lesezeit',
    date_added: 'Datum hinzugefügt',
    date_updated: 'Datum aktualisiert',
    minutes_read: 'Minutenablesung',
    published: 'Veröffentlicht',
    show_more_tags: 'Ungewöhnliche Tags anzeigen',
    hide_more_tags: 'Ungewöhnliche Tags ausblenden',

    // Users
    joined: 'Beigetreten',
    last_online: 'Zuletzt Online',
    online: 'Online',
    followers: 'Anhänger',
    partner: 'Partner',
    partnered_creator: 'Partner-Ersteller',
    profile_hidden: 'Das Profil dieses Benutzers ist ausgeblendet',
    follow: 'Folgen',
    unfollow: 'Nicht mehr folgen',
    following: 'Folgend',
    user: 'Benutzer',
    user_update_error: 'Benutzeraktualisierung fehlgeschlagen',
    age_widget_error: 'Das Alters-Widget konnte nicht geladen werden.',

    // Mods
    mod: 'Mod | Mods',
    level: 'Ebene | Ebenen',
    content: 'Inhalt',
    subscribed: 'Abonniert',
    tags: 'Tags',
    summary: 'Zusammenfassung',
    contributors: 'Mitwirkende',
    description: 'Beschreibung',
    dependencies: 'Abhängigkeiten',
    no_dependencies: 'Dieses {ugc} hat keine Abhängigkeiten',
    of: 'von',
    ago: 'vor',
    and: 'und',
    by: 'Von',
    reset_filters: 'Filter zurücksetzen',
    show_more: 'Zeig mehr',
    show_less: 'Weniger anzeigen',
    no_ugc_found: 'Kein {ugc_name} gefunden',
    no_subscriptions: 'Sie haben kein {ugc_name} abonniert',
    mod_disclaimer_heading: 'Rechtlicher Hinweis',
    mod_disclaimer_privacy: 'Datenschutzerklärung',
    thumbs_up_received: 'Daumen hoch erhalten',
    thumbs_up: 'Daumen hoch',
    total_downloads: 'Gesamtzahl der Downloads',
    releases: 'Veröffentlichungen',
    bytes: 'Bytes',
    local_mod_disabled:
      'Dieses {ugc} kann nicht geladen werden, da eine oder mehrere Abhängigkeiten fehlen: {dependencies}',
    mod_with_collections: 'Sammlungen mit diesem {ugc}',
    see_all_collections: 'Alle {count} Sammlungen ansehen',
    mod_dependencies:
      'Alle Abhängigkeiten müssen installiert sein, damit {ugc} funktioniert.',
    mod_dependencies_prompt:
      'Für dieses {ugc} sind Abhängigkeiten erforderlich. Möchtest du sie auch abonnieren?',
    allow_in_collections: 'Zu Sammlungen hinzufügen erlauben',
    allow_in_collections_tip:
      'Wenn diese Option aktiviert ist, können andere Benutzer Ihre {ugc}-Dateien zu Sammlungen hinzufügen.',

    // Actions
    login: 'Einloggen',
    logout: 'Abmelden',
    search: 'Suchen',
    clear_all: 'Alle löschen',
    download: 'Herunterladen',
    subscribe: 'Abonnieren',
    unsubscribe: 'Nicht mehr abonnieren',
    resubscribe: 'Erneut abonnieren',
    activate: 'Aktivieren',
    deactivate: 'Deaktivieren',
    like: 'Gefällt mir',
    dislike: 'Gefällt mir nicht',
    report: 'Ein Problem melden',
    submit: 'Absenden',
    cancel: 'Abbrechen',
    done: 'Fertig',
    select: 'Wählen',
    previous: 'Bisherige',
    next: 'Weiter',
    confirm: 'Bestätigen',
    allow: 'Erlauben',
    manage: 'Managen',
    discard: 'Änderungen verwerfen',
    more_actions: 'Mehr Aktionen',
    manage_interaction_settings: 'Interaktionseinstellungen verwalten',
    block: 'Blockieren',
    block_user: 'Benutzerkontakt blockieren',
    unblock: 'Entblocken',
    user_blocked:
      'Sie haben diesen Benutzer blockiert, sodass er Sie nicht kontaktieren oder Ihre Inhalte kommentieren kann',
    block_user_tooltip:
      'Verhindert, dass dieser Benutzer Sie kontaktiert oder Ihre Inhalte kommentiert.',
    block_prompt:
      'Möchtest du diesen Benutzer wirklich blockieren? Er kann dich nicht kontaktieren oder deine Inhalte kommentieren.',
    block_success: 'Benutzer erfolgreich blockiert.',
    unblock_success: 'Benutzer erfolgreich entblockt.',
    unblock_prompt:
      'Möchtest du die Blockierung dieses Benutzers wirklich aufheben? Er kann dich wieder kontaktieren und deine Inhalte kommentieren.',
    mute: 'Stumm',
    mute_user: 'Benutzer-{ugc} stummschalten',
    unmute: 'Stummschalten',
    user_muted:
      'Sie haben diesen Benutzer stummgeschaltet, sodass Sie nichts von seinem {ugc} sehen können',
    mute_user_tooltip:
      'Verhindert, dass Ihnen beim Durchsuchen von Spielen von diesem Benutzer erstellte {ugc} angezeigt werden',
    mute_prompt:
      'Bist du sicher, dass du diesen Benutzer stummschalten möchtest? Du wirst keine von ihm eingereichten {ugc} mehr sehen, wenn du nach Spielen surfst.',
    mute_success: 'Benutzer erfolgreich stummgeschaltet.',
    unmute_success: 'Stummschaltung des Benutzers erfolgreich aufgehoben.',
    unmute_prompt:
      'Möchten Sie die Stummschaltung dieses Benutzers wirklich aufheben? Du wirst seinen Inhalt wieder sehen können.',
    publish: 'Veröffentlichen',
    block_error: 'Benutzer-Blockierungsstatus konnte nicht aktualisiert werden',
    mute_error:
      'Benutzer-Stummschaltungsstatus konnte nicht aktualisiert werden',

    // Collections
    collection: 'Sammlung | Sammlungen',
    total_mods: 'Insgesamt {ugc}',
    total_filesize: 'Gesamtgröße der Datei',
    follow_collection: 'Kollektion folgen',
    unfollow_collection: 'Sammlung nicht mehr folgen',
    compatibility: 'Kompatibilität',
    compat_rating: 'Kompatibilitätsbewertung',
    last_30_days: 'Letzte 30 Tage',
    all_time: 'Alle Zeiten',
    does_collection_work: 'Funktioniert diese Sammlung für Sie?',
    collection_works: 'Ja, das tut es.',
    collection_doesnt_work: 'Nein, tut es nicht',
    collection_incomplete_subscriptions: 'Unvollständige Abonnements',
    vote: 'Stimmen | Stimme | Stimmen',
    curator: 'Kurator',
    creator_count: '{count} Schöpfer in dieser Sammlung',
    mods_in_collection: 'Alle {ugc} sind in dieser Sammlung enthalten',
    mod_not_available: 'Dieses {ugc} ist nicht mehr verfügbar',
    unavailable: 'nicht verfügbar',
    collection_sub_mods: 'Abonniere mich für alle {ugc} in dieser Sammlung',
    collection_unsub_mods: 'Melde mich von allen {ugc} in dieser Sammlung ab',
    collection_unsub_hint:
      'Wenn das Häkchen nicht gesetzt ist, wird die Sammlung aus deiner Bibliothek entfernt, aber du wirst ihre {ugc} weiterhin abonniert.',
    collection_error_subscribe: 'Sammlung {ugc} konnte nicht abonniert werden',
    collection_error_unsubscribe:
      'Die Sammlung {ugc} konnte nicht abbestellt werden',
    collection_error_follow: 'Sammlung konnte nicht verfolgt werden',
    collection_error_unfollow: 'Sammlung konnte nicht mehr verfolgt werden',
    ugc_count: '{ugc} Anzahl',
    collections_incomplete:
      'Einige {ugc} sind nicht verfügbar, was die Kompatibilität beeinträchtigen kann',
    adult: 'Erwachsene',
    view_more: 'Mehr anzeigen',
    view_less: 'Weniger anzeigen',

    // Categories
    category: 'Kategorie',
    miscellaneous: 'Diverses',
    essential: 'Essentiell',
    themed: 'Thematisch',
    animation: 'Animationsfilm',
    audio: 'Audio',
    bug_fixes: 'Fehlerbehebungen',
    cheating: 'Fremdgehen',
    environment: 'Umwelt',
    gameplay: 'Spielablauf',
    quality_of_life: 'Qualität des Lebens',
    ui: 'UI',
    visuals: 'Bildmaterial',

    // Filters
    all: 'Alle',
    available: 'verfügbar',
    filesize: 'Dateigröße',
    downloads: 'Downloads',
    todays_downloads: 'Heutige Downloads',
    subscribers: 'Abonnenten',
    rating: 'Bewertung',
    sort_by: 'Sortieren nach',
    creator: 'Creator',
    apply: 'Anwenden',
    reset: 'Zurücksetzen',
    featured: 'Vorgestellt',
    toggle_filters: 'Filter umschalten',
    show_filters: 'Filter anzeigen',
    hide_filters: 'Filter ausblenden',
    admin_options: 'Admin-Optionen',
    hidden: 'Versteckt',
    public: 'Öffentlich',
    private: 'Privat',
    pending: 'Ausstehend',
    archived: 'Archiviert',
    deleted: 'Gelöscht',
    last_day: 'Letzter Tag',
    hidden_monetization_disabled:
      'Versteckt, da Monetarisierung deaktiviert ist',
    date_live: 'Datum live',
    last_week: 'Letzte Woche',
    last_month: 'Letzten Monat',
    last_3_months: 'Letzte 3 Monate',
    last_year: 'Letztes Jahr',
    exclude: 'Ausschließen',
    no_matching_content: 'Kein passender Inhalt verfügbar',
    content_type: 'Art des Inhalts',
    free: 'Kostenlos',
    premium: 'Prämie',

    // Login
    signup: 'Anmelden oder mit E-Mail-Adresse registrieren',
    login_with: 'Anmelden Sie sich mit {service} an',
    email_placeholder: 'E-Mail-Adresse',
    code_placeholder: '5-stelliger Code',
    have_code: 'Ich habe einen Code',
    send_new_code: 'Neuen Code senden',
    login_disclaimer:
      'Benutzergenerierte Inhalte für {game} werden von mod.io verwaltet.',
    terms_disclaimer: `Indem Sie auf „Anmelden“ klicken, stimmen Sie den {studioterms}{terms} und der {privacy} von mod.io zu und bestätigen, dass Sie mindestens {min_age} Jahre alt sind.`,
    terms_disclaimer_studio: '{terms} von {studio}, den ',
    terms_disclaimer_studio_separator: ', ',
    terms_disclaimer_studio_and: ' und ',
    code_error: 'Code kann nicht angefordert werden.',
    or: 'oder',
    login_prompt:
      'Die Seite, auf die Sie zugreifen möchten, erfordert eine Authentifizierung. Bitte melden Sie sich an, um fortzufahren.',
    receive_code: 'Keinen Code erhalten?',
    resend_code: 'Code erneut senden',
    login_with_email: 'Mit E-Mail anmelden',
    otp_email:
      'Wir haben einen Einmalpasscode (OTP) an {email} gesendet. Bitte geben Sie ihn ein, um fortzufahren.',
    back_to_login: 'Zurück zu den Anmeldeoptionen',

    // Terms
    terms: 'Nutzungsbedingungen',
    privacy: 'Datenschutzerklärung',
    aup: 'Richtlinien zur akzeptablen Nutzung',
    monetization: 'Monetarisierungsbedingungen',
    game: 'Spielbedingungen',
    api: 'API-Zugriffsbedingungen',
    refund: 'Richtlinien für Rückerstattungen',
    effective: 'Gültig ab',

    // Report
    report_heading: 'Melde das {ugc}',
    report_intro:
      'Sie können Probleme mit Inhalten oder Verstöße gegen die {Bedingungen} von mod.io melden oder einen {dmca} über das unten stehende Formular einreichen.',
    report_intro_collection:
      'Sie können Probleme mit Inhalten und Verstöße gegen die {Bedingungen} von mod.io mithilfe des unten stehenden Formulars melden.',
    report_details:
      'Stellen Sie sicher, dass Sie alle relevanten Informationen angeben, um die Lösung Ihres Berichts zu erleichtern. Bitte beachten Sie, dass diese Informationen an Spielmoderatoren weitergegeben werden und möglicherweise an den Benutzer weitergegeben werden, der den mutmaßlich rechtsverletzenden Inhalt gepostet hat.',
    report_not_working_prompt:
      '„Funktioniert nicht“-Meldungen werden direkt mit dem Ersteller des Inhalts geteilt.',
    dmca: 'DMCA-Beschwerde',
    report_reason: 'Grund für die Meldung',
    urls: 'Problematische URLs',
    urls_placeholder: 'URLs (eine pro Zeile)',
    company_or_name: 'Unternehmen oder Ihr Name',
    email: 'E-Mail',
    address: 'Adresse',
    country: 'Land/Region',
    country_placeholder: 'Wählen Sie ein Land/eine Region',
    details: 'Einzelheiten zum Verstoß',
    details_placeholder:
      'Um Ihnen bei der Lösung Ihrer Meldung behilflich zu sein, geben Sie bitte so viele Details und Kontexte wie möglich an.',
    dmca_1:
      '{mod_io} respektiert die geistigen Eigentumsrechte anderer und wir bitten darum, dass jeder, der unsere Internet-Websites und Dienste nutzt, dies ebenfalls tut. Wenn Sie der Meinung sind, dass Ihr Werk auf einer unserer Internet-Websites oder im Rahmen eines unserer Dienste in einer Weise reproduziert wurde, die eine Urheberrechtsverletzung darstellt, können Sie den Vertreter für Urheberrechte bei mod.io über das unten stehende Formular informieren.',
    dmca_2:
      'Das Einreichen einer Beschwerde wegen Urheberrechtsverletzung ist eine ernste rechtliche Angelegenheit. Bevor Sie fortfahren, sollten Sie erwägen, die Person direkt zu kontaktieren, um das Problem anzusprechen. Möglicherweise handelt es sich um ein einfaches Missverständnis, das sich abseits des Rechtswegs klären lässt.',
    dmca_3:
      'Bitte beachten Sie, dass gemäß Abschnitt 512 (f) des Digital Millennium Copyright Act jede Person, die wissentlich falsche Angaben über die Rechtsverletzung von Material oder Aktivitäten macht, schadensersatzpflichtig sein kann. Bitte beachten Sie weiterhin, dass die in diesem rechtlichen Hinweis enthaltenen Informationen an Dritte weitergegeben oder veröffentlicht werden können.',
    claim_check:
      'Indem ich die folgenden Kästchen ankreuze und diese Beschwerde einreiche, erkläre ich UNTER ANDROHUNG VON STRAFE FÜR SCHULDHAFTES VERHALTEN, dass',
    copyright_owner: 'ich der Urheberrechtsinhaber bin',
    copyright_auth_owner:
      'ich berechtigt bin, in dieser Situation im Namen des Urheberrechtsinhabers zu handeln.',
    authorization: 'Genehmigung',
    authorization_check:
      'Ich bin in gutem Glauben davon überzeugt, dass die Verwendung des in dieser Beschwerde genannten Materials nicht durch den Urheberrechtsinhaber, dessen Vertreter oder das Gesetz genehmigt ist.',
    acknowledgement: 'Bestätigung',
    acknowledgement_check:
      'Ich erkenne an, dass gemäß Abschnitt 512 (f) des DMCA jede Person, die wissentlich falsche Angaben über die Rechtsverletzung von Material oder Aktivitäten macht, schadensersatzpflichtig sein kann.',
    required: 'erforderlich',
    signature: 'Unterschrift',
    signature_placeholder:
      'Geben Sie Ihren vollständigen Namen in dieses Feld ein, was als Ihre digitale Unterschrift dient.',
    report_success_title: 'Ihre Meldung ist eingegangen',
    report_success_text:
      'Sollten zur Lösung Ihres Berichts weitere Einzelheiten erforderlich sein, werden wir Sie möglicherweise kontaktieren, um diese mitzuteilen. Vielen Dank für die Einzelheiten.',
    report_error_title: 'Fehler beim Senden der Meldung',
    report_email_inform:
      'Ihre E-Mail-Adresse wird ausschließlich zur Bearbeitung dieses Berichts verwendet.',

    // Table
    name: 'Name',
    added: 'Hinzugefügt',
    updated: 'Aktualisiert',
    date: 'Datum',
    item: 'Artikel',
    file: 'Datei',
    version: 'Version',
    scan: 'Virenscan',
    actions: 'Aktionen',
    status: 'Status',
    role: 'Rolle',
    live: 'Lebe',
    locally_installed: 'Lokal installiert',

    // Releases
    download_from_game_client: '{mod} im Spielclient herunterladen',
    download_payment_required: 'Zum Herunterladen kaufen {ugc}',
    download_auth_required: 'Loggen Sie sich ein, um {ugc} herunterzuladen',
    release_notes: 'Versionshinweise',
    no_release_notes: 'Keine Versionshinweise verfügbar',
    previous_releases: 'Vorherige Versionen',
    view_previous_releases: 'Frühere Veröffentlichungen anzeigen',
    no_previous_releases: 'Es gibt keine vorherigen Versionen',
    no_files_published: 'Keine Dateien veröffentlicht',
    download_files_manually: 'Laden Sie Dateien manuell herunter',
    platforms: 'Plattform | Plattformen',

    // Ratings
    overwhelmingly_positive: 'Äußerst positiv',
    overwhelmingly_negative: 'Äußerst negativ',
    very_positive: 'Sehr positiv',
    very_negative: 'Sehr negativ',
    mostly_positive: 'Größtenteils positiv',
    mostly_negative: 'Größtenteils negativ',
    negative: 'Negativ',
    positive: 'Positiv',
    mixed: 'Gemischt',
    unrated: 'Keine Bewertung',

    // Sort
    sort_comments: 'Kommentare',
    sort_total_mods: 'Gesamtzahl der Mods',
    sort_trending: 'Im Trend',
    sort_highest_rated: 'Am besten bewertet',
    sort_most_popular: 'Am beliebtesten',
    sort_most_subscribers: 'Die meisten Abonnenten',
    sort_recently_added: 'Kürzlich hinzugefügt',
    sort_last_updated: 'Letzte Aktualisierung',
    sort_alphabetical: 'Alphabetisch',
    sort_smallest_filesize: 'Kleinste Dateigröße',

    // Report Reason
    report_dmca: 'DMCA',
    report_not_working: 'Funktioniert nicht',
    report_rude_content: 'Unhöflicher Inhalt',
    report_illegal_content: 'Illegaler Inhalt',
    report_stolen_content: 'Gestohlener Inhalt',
    report_false_information: 'Falsche Informationen',
    report_other: 'Andere',

    // Report not working reasons
    report_crash: 'Spiel stürzt ab',
    report_no_load: 'Lädt nicht',
    report_conflicts: 'Konflikte mit anderen {ugc}',
    report_missing_deps: 'Fehlende Abhängigkeiten',
    report_install_issues: 'Installationsprobleme',
    report_bugs: 'Buggy-Verhalten',
    report_incompatability: 'Inkompatibel mit der Spielversion',
    report_corrupt: 'Beschädigte Dateien',

    // Errors
    warning: 'Warnung',
    error_ref: 'Fehlercode: ',
    login_fail: 'Einloggen fehlgeschlagen',
    login_fail_message:
      'Einloggen fehlgeschlagen. Bitte warten Sie eine Minute und versuchen Sie es erneut.',
    subscribe_fail: 'Nicht abonnieren',
    unsubscribe_fail: 'Versäumnis, sich abzumelden',
    error: 'Fehler',
    default_error_message:
      'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es bald erneut.',
    follow_error: 'Konnte nicht folgen',
    unfollow_error: 'Das Entfolgen ist fehlgeschlagen',
    upload_file_error:
      'Sie müssen mindestens eine Datei hochladen, um fortfahren zu können',

    agreement_not_found: 'Vereinbarung nicht gefunden',
    form_chars_remaining: '{count} Zeichen verbleibend.',
    form_not_enough_chars: '{count} Weitere Zeichen erforderlich.',
    filter: 'Filtern',
    loading: 'Wird geladen',
    next_version: 'Nächste Version',
    no_results_found: 'keine Ergebnisse gefunden',
    page_not_found: 'Seite nicht gefunden!',
    previous_version: 'Vorherige Version',
    take_me_home: 'Bring mich nach Hause',
    validation_alpha_num: 'Feld kann nur Zahlen oder Buchstaben enthalten',
    validation_size: 'Das Feld muss {size} Zeichen sein',
    validation_url: 'Feld muss eine URL sein',
    validation_min: 'Mindestens {min} Zeichen',
    validation_max: 'Maximum {max} Zeichen',
    validation_email: 'Das Feld muss eine E-Mail sein',
    validation_checked: 'Das Feld muss überprüft werden',
    validation_required: 'Feld ist erforderlich',
    validation_name:
      'Das Feld darf nur Buchstaben und namensbezogene Symbole enthalten',
    validation_image: 'Die Datei muss ein gültiges JPEG- oder PNG-Bild sein',
    validation_youtube: 'Das Feld muss eine gültige Youtube-URL sein',
    validation_sketchfab: 'Das Feld muss eine gültige Sketchfab-URL sein',
    validation_zip: 'Die Datei muss eine ZIP-Datei sein',
    validation_filesize: 'Die Dateigröße darf {size} nicht überschreiten',
    delete_image: 'Bild löschen',
    confirm_delete_image: 'Möchten Sie dieses Bild wirklich löschen?',

    comment: 'Kommentar | Kommentare',
    team_member: 'Teammitglied',
    game_admin: 'Spieladministrator',
    site_admin: 'Site-Administrator',
    author: 'Autor',
    good_karma: 'Gutes Karma',
    bad_karma: 'Schlechtes Karma',
    reply: 'Antwort',
    replies: 'antworten | Antworten',
    replied: 'Geantwortet',
    reopen: 'Erneut öffnen',
    close: 'Schließen',
    mark_as_read: 'Als gelesen markieren',
    save: 'Speichern',
    delete: 'Löschen',
    archive: 'Archivieren',
    edit: 'Bearbeiten',
    post: 'Post',
    pinned: 'Angepinnt',
    pin: 'Stift',
    unpin: 'Entpinnen',
    locked: 'Gesperrt',
    lock: 'Sperren',
    unlock: 'Entsperren',
    add_comment: 'Einen Kommentar hinzufügen...',
    comment_cant_reply_locked:
      'Kann nicht antworten, da der Kommentarthread gesperrt ist',
    comment_cant_edit_locked:
      'Kann nicht bearbeitet werden, da der Kommentarthread gesperrt ist',
    comment_max_pin_limit:
      'Maximales Limit für angeheftete Kommentare erreicht',
    comment_below_threshold:
      'Kommentar unter dem Schwellenwert. Zum Ansehen hier klicken.',
    comment_login_prompt: 'Melden Sie sich an, um der Diskussion beizutreten!',
    comment_error_add: 'Fehlte keinen Kommentar hinzufügen',
    comment_error_edit: 'Kommentar nicht bearbeiten',
    comment_error_delete: 'Kommentar nicht gelöscht',
    comment_error_rate: 'Kommentar konnte nicht bewertet werden',
    comment_error_update: 'Kommentar konnte nicht aktualisiert werden',
    comments_error_fetch: 'Weitere Kommentare nicht laden',
    discussion: 'Diskussion',
    load_more_comments: 'Laden Sie weitere Kommentare',
    comment_confirm_delete:
      'Sind Sie sicher, dass Sie diesen Kommentar löschen möchten?',
    comment_deleted: 'Der Kommentar wurde erfolgreich gelöscht',
    comments_disabled:
      'Die Kommentarfunktion ist aufgrund der Kindersicherungseinstellungen Ihres Kontos deaktiviert.',
    comments_age_unverified:
      'Sie können erst dann einen Kommentar hinzufügen, wenn Ihr Alter bestätigt wurde.',
    review_settings: 'Einstellungen überprüfen',

    // Mod admin
    mod_status: {
      pending_has_file:
        '{ugc} erfordert die Genehmigung des Spielmoderators, um live gehen zu können.',
      pending_curation:
        'Das {ugc} wechselt in einen Live-Status, sobald eine Datei hinzugefügt und genehmigt wurde.',
      pending_no_curation:
        'Das {ugc} wechselt in einen Live-Status, sobald eine Datei hinzugefügt wurde.',
      archived:
        'Das {ugc} wurde archiviert. Alle Abonnenten wurden entfernt und es kann nicht über API-Anfragen angezeigt oder abgerufen werden.',
      hidden:
        'Das {ugc} ist versteckt und nur für Abonnenten und Teammitglieder verfügbar.',
      hidden_purchase_disabled:
        'Das {ugc} ist ausgeblendet, da die Monetarisierung deaktiviert wurde.',
      live: 'Das {ugc} ist live und für alle spielbar.',
    },
    mod_profile: '{ugc}-Profil',
    media: 'Medien',
    file_manager: 'Dateimanager',
    step: 'SCHRITT {step}',
    save_next: 'Speichern und Weiter',
    auth_required: 'Authentifizierung erforderlich',
    public_text: '{ugc} ist auf Suchseiten für jeden auffindbar.',
    private_text:
      '{ugc} ist nur für Teammitglieder, bestehende Abonnenten und Benutzer mit Vorschauzugriff zugänglich.',
    edit_disabled_on_add:
      'Sobald dieses {ugc} erstellt wurde, können Sie keine Änderungen mehr über das Internet vornehmen.',
    edit_enabled_on_add:
      'Sie können Änderungen an {ugc} vornehmen, nachdem es erstellt wurde.',
    add_mod_monetized:
      'Dieses Spiel unterstützt monetarisiertes {ugc1}. Wenn du vorhast, dieses {ugc2} zu monetarisieren, wähle vorerst {private} aus und mache es später, nachdem du die Monetarisierung eingerichtet hast, zu {public}. Du kannst die Monetarisierung einrichten, nachdem du das {ugc2} erstellt hast.',
    share_access: 'Zugriff teilen',
    profile_editing_disabled:
      'Die Profilbearbeitung über das Internet wurde vom Spiel deaktiviert.',
    tools_only_1:
      'Du kannst hier keine {ugc} für {game} hochladen. Sie müssen mit Tools hochgeladen werden, die der Spieleentwickler erstellt hat, damit die Dateien verifiziert werden können. Weitere Informationen findest du in den {guides}, die für dieses Spiel geschrieben wurden. ',
    tools_only_2: 'Hier sind die Anweisungen des Spieleentwicklers:',
    tools_only_3:
      'Wir empfehlen Ihnen, zur {ugc} -Liste zurückzukehren und von dort aus die Links zu durchsuchen. Wenn das Problem weiterhin besteht, besuchen Sie unser {help_center} für weitere Informationen.',
    unsaved_heading: 'Sie haben ungespeicherte Änderungen',
    unsaved_confirm:
      'Es gibt Änderungen, die nicht gespeichert wurden. Möchten Sie trotzdem gehen?',
    settings: 'Einstellungen',
    team: 'Mannschaften',
    reports: 'Berichte',
    stats: 'Statistiken',
    moderator: 'Moderator',
    manager: 'Geschäftsführer',
    error_get_mod: '{ugc} konnte nicht abgerufen werden',
    archive_reason: 'Grund für die Archivierung',
    view_mod: '{ugc} ansehen',
    error_archive_mod: '{ugc} konnte nicht archiviert werden',
    archive_mod_prompt:
      'Wenn Sie dieses {ugc} archivieren, melden sich alle Benutzer ab und es wird aus API-Anfragen entfernt.',
    archive_mod_confirm:
      'Nach der Archivierung erhalten alle Teammitglieder eine E-Mail, in der sie zusammen mit dem angegebenen Grund über diese Aktion informiert werden.\n\nDiese Aktion kann nur von Moderatoren rückgängig gemacht werden. Möchten Sie wirklich fortfahren?',

    headline_mod_profile: 'Erstellen Sie Ihr {ugc}-Profil',
    headline_media: 'Fügen Sie Ihrem {ugc}-Profil Medien hinzu',
    headline_files: 'Laden Sie Ihre {ugc}-Datei hoch',
    headline_permissions:
      'Legen Sie Wiederverwendungsberechtigungen für Ihr {ugc} fest',
    headline_dependencies: 'Fügen Sie alle {ugc}-Abhängigkeiten hinzu',

    // Basics
    basics: 'Grundlagen',
    logo: 'Logo',
    logo_prompt_1: 'Bilddatei, die das Logo Ihres {ugc} darstellt.',
    logo_prompt_2: '512x288 oder größer',
    logo_prompt_3: 'Seitenverhältnis 16:9 empfohlen',
    logo_prompt_4: 'Maximal 8 MB',
    summary_placeholder:
      'Erzähle uns in einem Absatz von den Änderungen, die dein {ugc} am Spiel vornimmt.',
    homepage: 'Startseite',
    profile_url: 'Profil-URL',
    visibility: 'Sichtbarkeit',
    visibility_tip:
      'Sobald sie live sind, sind öffentliche {ugc} für jeden sichtbar. Hidden {ugc} sind nur für Teammitglieder und Abonnenten sichtbar.',
    upload_images: 'Bilder hochladen',
    mature_content: 'Enthält Inhalte für Erwachsene',
    mature_content_alcohol: 'Alkohol',
    mature_content_drugs: 'Drogen',
    mature_content_violence: 'Gewalt',
    mature_content_explicit: 'Explizit',
    community: 'Gemeinschaft',
    allow_comments: 'Kommentare zulassen',
    allow_dependants: 'Angehörige zulassen',
    create_mod: '{ugc} erstellen',
    error_mod_create: '{ugc} konnte nicht erstellt werden',
    error_mod_update: '{ugc} konnte nicht aktualisiert werden',
    error_tags_update: 'Die Tags konnten nicht aktualisiert werden',
    success_create_mod: '{modname} wurde erfolgreich erstellt',
    success_update_mod: '{modname} wurde erfolgreich aktualisiert',
    description_tip:
      'Optionale Beschreibung für Ihr {ugc}, die Details wie „Über uns“, „Funktionen“, „Nutzung“, „Häufig gestellte Fragen“ usw. enthalten kann. HTML wird unterstützt und empfohlen',

    // Media
    models: 'Modelle',
    media_reorder_hint:
      'Ziehen Sie, um vorhandene Bilder neu zu ordnen, oder legen Sie neue Bilddateien ab, um sie hochzuladen.',
    media_zip_hint_1:
      'Laden Sie bis zu {count} Bilder gleichzeitig oder eine einzelne ZIP-Datei mit Bildern hoch.',
    media_zip_hint_2: 'Unterstützte Formate sind .jpg, .jpeg, .png und .zip.',
    drag_and_drop_image: 'Bilder zum Hochladen ziehen und ablegen',
    or_click_to_upload: 'Oder klicken Sie, um eine Datei auszuwählen',
    error_media_update: 'Medien konnten nicht aktualisiert werden',
    error_media_add_links: 'Medienlinks konnten nicht hinzugefügt werden',
    error_media_remove_links: 'Medienlinks konnten nicht entfernt werden',
    success_media_updated: 'Medien wurden erfolgreich aktualisiert',

    // File manager
    add_file: 'Eine Datei hinzufügen',
    edit_file: 'Datei bearbeiten',
    select_zip: 'Wählen Sie eine Zip-Datei',
    upload: 'Upload',
    file_id: 'Datei-ID:',
    virus_none: 'Kein Virus erkannt',
    virus_waiting: 'Warte auf den Scan',
    virus_scanning: 'Scan läuft',
    virus_too_large: 'Datei ist zu groß zum Scannen',
    virus_not_found: 'Die Datei wurde nicht gefunden',
    virus_error: 'Fehler beim Scannen der Datei',
    virus_found: 'Virus entdeckt',
    virus_risk:
      'Diese Datei enthält eine ausführbare Datei und beim Öffnen ist Vorsicht geboten',
    version_placeholder: 'Versionsnummer, z. B. 1.0.0',
    release_notes_placeholder:
      'Geben Sie jede Änderung in einer separaten Zeile ein',
    game_moderator: 'Spielmoderator',
    metadata_blob: 'Metadaten-Blob',
    metadata_blob_placeholder:
      'Geben Sie spezifische Metadaten ein, z. B. die Version des Spiels, mit der diese Version kompatibel ist, wie sie installiert wird usw. Gültige UTF-8-Daten werden unterstützt.',
    select_platforms:
      'Plattformen (wählen Sie alle zutreffenden Antworten aus)',
    file_pending: 'Ausstehende Genehmigung',
    file_approved: 'Genehmigt',
    file_approved_live: 'Genehmigt und live',
    file_approved_not_live: 'Genehmigt, aber nicht live',
    file_denied: 'Abgelehnt',
    file_targeted: 'Gezielt',
    live_file: 'Diese Datei ist derzeit live.',
    file_is_live: 'Datei ist live',
    file_is_not_live: 'Datei ist nicht live',
    no_delete_file_live: 'Kann nicht gelöscht werden, da die Datei live ist',
    make_file_live: 'Machen Sie diese Veröffentlichung live',
    make_file_live_platforms:
      'Machen Sie diese Version für zugelassene Plattformen live',
    delete_file_prompt:
      'Möchten Sie diese Datei wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    file_processing_title: 'Dateiverarbeitung',
    file_processing:
      'Ihre Datei wird bearbeitet. Sie können die Website weiter durchsuchen, aber bitte schließen Sie den Tab oder das Browserfenster erst, wenn der Vorgang abgeschlossen ist.',
    file_instructions_1:
      'ZIPPEN Sie den Basisordner Ihres {ugc} und laden Sie ihn hoch. Wenn es sich um eine Sammlung von Dateien handelt, die sich in einem bereits vorhandenen Spielordner befinden, sollten Sie diese Dateien komprimieren:',
    file_instructions_2: 'Muss eine ZIP-Datei sein',
    file_instructions_3: 'Die Dateigröße darf 20 GB nicht überschreiten',
    file_instructions_4:
      'Dateinamen dürfen keines der folgenden Zeichen enthalten: \\ / ? " &lt; &gt; &#124; : *',
    file_instructions_5:
      '{ugc} welche das Überschreiben von Dateien nicht unterstützt werden, es sei denn, das Spiel schafft das',
    file_instructions_6:
      '{ugc}, die sich über mehrere Spielverzeichnisse erstrecken, werden nicht unterstützt, es sei denn, das Spiel schafft dies',
    file_terms: 'Ich stimme den {terms} und {privacy} zu.',
    error_get_files: 'Dateien konnten nicht abgerufen werden',
    error_upload_file_name:
      'Das Hochladen der Datei {filename} ist fehlgeschlagen.',
    error_upload_file: 'Datei konnte nicht hochgeladen werden',
    error_update_file: 'Datei konnte nicht aktualisiert werden',
    error_delete_file: 'Datei konnte nicht gelöscht werden',
    no_permission_delete_files: 'Sie sind nicht berechtigt, Dateien zu löschen',
    error_file_required: 'Datei ist erforderlich',
    error_platform_required: 'Sie müssen mindestens eine Plattform auswählen',
    success_file_uploaded: 'Datei wurde erfolgreich hochgeladen',
    success_file_moderation:
      'Ein Moderator überprüft Plattformen, die moderiert werden müssen',
    success_file_updated: 'Datei wurde erfolgreich aktualisiert',
    error_no_approved_platforms:
      'Keine Plattformen, die live gestellt werden können',
    error_no_approved_platforms_text:
      'Diese Datei hat keine zugelassenen Plattformen, die derzeit nicht live sind',
    drag_and_drop_file: 'Datei zum Hochladen ziehen und ablegen',
    file_upload_hint: 'Nur .zip-Dateien akzeptiert | {max} maximale Dateigröße',
    upload_draft: 'Hochladen und als Entwurf behalten',
    upload_publish: 'Hochladen und veröffentlichen',
    save_draft: 'Speichern und als Entwurf behalten',
    save_publish: 'Speichern und veröffentlichen',
    keep_as_draft: 'Als Entwurf behalten',
    publish_confirmation: 'Möchten Sie diese Datei wirklich veröffentlichen?',
    marketplace_file_hint:
      'Wenn Sie planen, diesen {mod} zu monetarisieren, sollten Sie diese Datei als Entwurf behalten und zuerst die Monetarisierung einrichten, bevor Sie veröffentlichen.',
    curation_file_hint:
      'Ein Spiel-Moderator muss Ihren {mod} genehmigen, bevor Spieler darauf zugreifen können.',
    platform_file_hint:
      'Dieses Spiel erfordert eine Plattform-Genehmigung für jede {mod}-Datei für die ausgewählte(n) Plattform(en): {platforms}.',
    two_step_approval_process:
      'Dieses Spiel erfordert einen 2-stufigen Genehmigungsprozess:',
    two_step_approval_process_step1:
      'Spiel-Moderator-Genehmigung für diese {mod}-Datei für die ausgewählte(n) Plattform(en): {platforms}',
    two_step_approval_process_step2:
      'Spiel-Moderator-Genehmigung für den {mod} um live zu gehen',
    two_step_approval_process_live:
      'Das Veröffentlichen dieser Datei wird auch den {mod} automatisch live schalten, sobald beide Genehmigungen abgeschlossen sind.',
    one_step_approval_process_live:
      'Das Veröffentlichen dieser Datei wird auch den {mod} automatisch live schalten, sobald es genehmigt ist.',

    // Reuse permissions form
    reuse_permissions: {
      heading: 'Berechtigungen wiederverwenden',
      allow_redistribution:
        'Erlaube anderen, meine {ugc} -Assets auf anderen Websites hochzuladen, aber ich muss als ursprünglicher Ersteller genannt werden',
      allow_porting:
        'Erlaube anderen, meine {ugc} -Assets so zu konvertieren, dass sie in anderen Spielen funktionieren, aber ich muss als ursprünglicher Schöpfer genannt werden',
      allow_patching_no_credit:
        'Erlaube anderen, meine {ugc} -Assets zu ändern (einschließlich der Veröffentlichung von Bugfixes oder Verbesserungen) und sie als neues {ugc} zu veröffentlichen',
      require_credit: 'Ich muss als der ursprüngliche Schöpfer genannt werden',
      require_permission: 'Erfordern Sie zuerst die Erlaubnis von mir',
      require_repackage_no_credit:
        'Erlaube anderen, meine {0} Assets in ihren eigenen {1} zu verwenden',
      allow_resell:
        'Erlaube anderen, meine {ugc} -Assets in beliebigen {ugc} /Dateien in kommerziellen Werken zu verwenden',
      original_assets:
        'Mein {ugc} enthält zu 100% Originalarbeiten oder Ressourcen, die weiterverteilt werden können',
      error_update:
        'Die Wiederverwendungsberechtigungen konnten nicht aktualisiert werden',
      success_update:
        'Die Wiederverwendungsberechtigungen wurden erfolgreich aktualisiert',
      prompt:
        'Lege Berechtigungen fest, wie deine {ugc} -Assets für die Erstellung von Inhalten anderer verwendet werden können. Indem Sie anderen die Erlaubnis erteilen, Ihre Dateien zu verwenden oder zu ändern, erkennen Sie an, dass eine solche Genehmigung in Bezug auf bereits erstellte Werke nicht rückwirkend widerrufen werden kann.',
    },

    // Dependencies form
    dependencies_prompt:
      'Wählen Sie {0} aus, damit {1} korrekt funktioniert (wenn {1} nicht angezeigt wird, bedeutet dies, dass keine Abhängigkeiten zulässig sind, und Sie sollten den Ersteller kontaktieren, um ihn einzuschalten):',
    remove_dependency: 'Abhängigkeit entfernen',
    dependants: 'Familienangehörige',
    important: 'WICHTIG',
    error_update_dependencies:
      'Abhängigkeiten konnten nicht aktualisiert werden',
    success_update_dependencies:
      'Die Abhängigkeitseinstellungen wurden erfolgreich aktualisiert',
    dependants_warning_1:
      'Sobald dies erlaubt ist, beachten Sie bitte, dass {ugc} mit verbundenen Angehörigen:',
    dependants_warning_2: 'Angehörige können nicht deaktiviert werden',
    dependants_warning_3: 'Kann nicht gelöscht werden',
    dependants_warning_4: 'Kann nicht monetarisiert werden',
    no_dependants: 'Keine Angehörigen gefunden',
    dependencies_allow_prompt:
      'Sie müssen oben für andere {ugc} die Option „Angehörige zulassen“ aktivieren, um Ihre Person als Angehörige hinzuzufügen.',
    dependencies_deny_prompt:
      'Sie können die Option „Angehörige zulassen“ oben deaktivieren, wenn Sie nicht möchten, dass andere {ugc} sie als Abhängigkeit auswählen',
    dependencies_not_supported:
      'Abhängigkeiten werden von {gamename} nicht unterstützt, alle {ugc} müssen unabhängig laufen und vollständig eigenständig sein.',
    dependency_disabled_monetization:
      'Monetarized {ugc} kann keine Angehörigen aktivieren',
    dependency_disabled_dependants:
      'Abhängigkeiten für dieses {ugc_single} können nicht deaktiviert werden, da andere {ugc_plural} davon abhängen. Diese können auf der Registerkarte „Abhängigkeiten“ eingesehen werden.',
    dependants_confirm_enable:
      'Dies dient dazu, die fortlaufende Kompatibilität von connected {ugc} sicherzustellen. Bitte bestätigen Sie, um es zu aktivieren.',
    dependants_confirm_disable:
      'Möchten Sie Angehörige wirklich verbieten? Das bedeutet, dass andere {0} Ihre {1} nicht als Abhängigkeit hinzufügen können.',
    dependency_monetization_warning:
      '{game} erlaubt die Monetarisierung von {mod}. Die Monetarisierung unterstützt derzeit keine {mods} mit Abhängigkeiten. Wenn Sie diesen {mod} monetarisieren möchten, überspringen Sie bitte diesen Schritt.',

    // Parental controls
    notify_parent_title:
      'Benachrichtige die Eltern oder Erziehungsberechtigten',
    notify_parent:
      'Wenn Sie fortfahren, werden Ihre Eltern oder Erziehungsberechtigten benachrichtigt und müssen diesen Änderungen zustimmen, bevor sie in Kraft treten.',
    confirm_notify_parent:
      'Möchten Sie Ihre Eltern oder Erziehungsberechtigten benachrichtigen, um Zugriff auf die vorgeschlagenen Berechtigungsänderungen zu erhalten?',
    request_access: 'Zugriff anfordern',

    // Cloud cooking
    cook_source: 'Eine Quelldatei komponieren',
    source_file: 'Quelldatei',
    targeted_platform: 'Zielplattform',
    metadata: 'Metadaten',
    cook_time: 'Garzeit',
    download_time: 'Downloadzeit',
    file_compression_time: 'Dateikomprimierungszeit',
    file_decompression_time: 'Dateidekomprimierungszeit',
    upload_time: 'Uploadzeit',
    total_job_time: 'Gesamtarbeitszeit',
    logs: 'Protokolle',
    view_logs: 'Logs ansehen',
    logs_available_on_completion:
      'Logs sind nach Abschluss des Kochvorgangs verfügbar',
    logs_for_file: 'Koche Protokolle für {file}.',
    no_logs: 'Keine Logs für {file} gefunden.',
    get_logs_error: 'Kochprotokolle konnten nicht abgerufen werden',
    admin_only: 'Nur für Administratoren',
    queue: 'Warteschlange',
    source_file_history: 'Quelldateiverlauf',
    no_source_files_found: 'Es wurden keine Quelldateien gefunden.',
    no_cooks_found: 'Keine Köche gefunden',
    cook_jobs_available: 'Verfügbare Jobs als Dateikoch: {count}',
    view_details: 'Details anzeigen',
    cloud_cooking: 'Cloud Cooking',
    add_file_type: 'Füge eine neue {string} hinzu',
    edit_file_type: 'Bearbeiten {string}',
    files: 'Dateien',
    cook_details: 'Kochdetails',
    status_queued: 'In der Warteschlange',
    status_cooking: 'Kochen',
    status_success: 'Erfolgreich',
    status_failed: 'Fehlgeschlagen',
    status_pending_moderation: 'Moderation ausstehend',
    status_moderation_rejected: 'Cook lehnte ab',
    get_cook_files_error:
      'Cloud-Cooking-Dateien konnten nicht abgerufen werden.',
    get_source_files_error: 'Fehler beim Abrufen der Quelldateien',
    download_file_error: 'Datei konnte nicht heruntergeladen werden',
    source_instructions:
      'Laden Sie Ihre Quelldatei hoch und wählen Sie unten die gewünschte(n) Plattform(en) aus. Die Datei wird anschließend von Cloud Cooking verarbeitet, wodurch individuelle Dateien für die jeweiligen Plattformen erstellt werden.',

    // Marketplace
    marketplace: {
      available_stock:
        'Nur noch begrenzte Stückzahl verfügbar – {count} verbleibend',
      virtual_currency: 'Virtuelle Währung',
      marketplace: 'Marktplatz',
      order_summary: 'Zusammenfassung der Bestellung',
      payment_method: 'Zahlungsmethode | Zahlungsmethoden',
      wallet_balance: 'Guthaben im Geldbeutel',
      vc_balance: 'Virtuelles Währungssaldo',
      credits: 'Credits',
      currency: 'Währung',
      balance_after: 'Restbetrag nach dem Kauf',
      token_purchase_success:
        'Vielen Dank für Ihren Kauf. Ihre Zahlung wurde bearbeitet und eine Steuerquittung wird in Kürze an Ihre E-Mail-Adresse gesendet. Ihr virtuelles Währungsguthaben wurde jetzt für {game} aktualisiert',
      transaction_id: 'Transaktions-ID',
      total_paid: 'Bezahlter Gesamtbetrag',
      agreement: 'Ich stimme den {terms} und {refund} von mod.io zu',
      change_payment: 'Zahlung ändern',
      error_register: 'Fehler bei der Registrierung für die Monetarisierung',
      error_wallet: 'Die Spiel-Brieftasche konnte nicht abgerufen werden',
      error_process: 'Zahlung kann nicht verarbeitet werden',
      error_complete: 'Zahlung kann nicht abgeschlossen werden',
      checkout: 'Auschecken',
      vc_topup_confirmed: 'Aufladung virtueller Währungen bestätigt',
      confirm_purchase: 'Kauf bestätigen',
      continue_browsing: 'Stöbern Sie weiter',
      back_to_mod: 'Zurück zum {ugc}-Kauf',
      ugc_not_refundable:
        '{ugc_plural} Käufe sind nicht erstattungsfähig. Bitte schauen Sie sich unsere {terms} und {refund} an, bevor Sie diesen {ugc} kaufen.',
      ugc_purchase_success:
        'Vielen Dank für Ihren Kauf. Das {ugc} wurde zu deinen Abonnements in deinem {library} hinzugefügt und ist im Spiel verfügbar.',
      game_virtual_currency:
        'Virtuelle Währung des Spiels ({virtual_currency})',
      proceed_to_checkout: 'Gehen Sie zur Kasse',
      ugc_purchase_confirmed: '{ugc} Kauf bestätigt',
      error_already_purchased: 'Das besitzt du bereits {ugc}',
      error_sku_packs: '{ugc} Preise konnten nicht abgerufen werden',
      error_payment_methods: 'Zahlungsmethoden konnten nicht abgerufen werden',
      calculated_at_checkout: 'Wird an der Kasse berechnet',
      subtotal: 'Zwischensumme',
      taxes: 'Steuern',
      total_due: 'Fälliger Gesamtbetrag',
      price: 'Preis',
      purchased: 'gekauft',
      purchases: '{ugc} gekauft',
      no_purchases: 'Sie haben keine {ugc} gekauft',
      purchase_to_rate: 'Du kannst nur {ugc} bewerten, das du gekauft hast',
      usd_ugc_license:
        'Wenn Sie dieses {ugc} kaufen, erhalten Sie sofort {count} Credits als Gegenleistung für eine Lizenz, um darauf zuzugreifen.',
      top_up: 'Aufladen',
      remaining_balance: 'Verbleibender Saldo',
      not_enough_vc:
        'Sie haben nicht genug virtuelle Währung, um fortzufahren. Bitte lade deine Spiel-Wallet auf',
      error_virtual_currency_packs:
        'Virtuelle Währungspakete konnten nicht abgerufen werden',
      vc_prompt: 'Holen Sie sich Ihre virtuellen Währungspakete',
      vc_description:
        'Unterstützen Sie die Ersteller von Inhalten und greifen Sie auf Premium-Inhalte zu, indem Sie virtuelle Währungspakete für {game} kaufen',
      vc_agreement:
        'Bitte sieh dir unsere {terms} und {refund} an, bevor du ein virtuelles Währungspaket kaufst. Alle anfallenden Steuern werden an der Kasse berechnet.',
      error_session: 'Kaufsitzung konnte nicht abgerufen werden',
      sold_out: 'Ausverkauft',
      currency_packs: 'Währungspakete',
      cancel_transaction: 'Transaktion stornieren',
      cancel_transaction_text:
        'Möchten Sie diese Transaktion wirklich stornieren?',
    },
  },
  it: {
    language: 'Lingua',

    // Nav
    browse: 'Esplora',
    library: 'Biblioteca',
    my_content: 'I miei contenuti',
    account: 'Il mio conto',
    back: 'Torna indietro',
    more: 'Di più',
    add_mod: 'Aggiungi {ugc}',
    edit_mod: 'Modifica su mod.io',
    admin: 'Amministratore',
    help_center: 'centro assistenza',
    subscribed_ugc: 'Iscritto {ugc}',
    followed_collections: 'Raccolte seguite',
    page: 'Pagina',

    // Guides
    guide: 'Guida | Guide',
    views: 'Visualizzazioni',
    table_of_contents: 'Sommario',
    reading_time: 'Momento della lettura',
    date_added: 'Data aggiunta',
    date_updated: 'Data aggiornata',
    minutes_read: 'Minuto letto',
    published: 'Pubblicato',
    show_more_tags: 'Mostra tag non comuni',
    hide_more_tags: 'Nascondi tag non comuni',

    // Users
    joined: 'Partecipato',
    last_online: 'Ultimo Online',
    online: 'in linea',
    followers: 'Seguaci',
    partner: 'Compagno',
    partnered_creator: 'Creatore partner',
    profile_hidden: 'Il profilo di questo utente è nascosto',
    follow: 'Seguire',
    unfollow: 'Smetti di seguire',
    following: 'A seguire',
    user: 'utente',
    user_update_error: "Impossibile aggiornare l'utente",
    age_widget_error: 'Impossibile caricare il widget età',

    // Mods
    mod: 'Mod | Mods',
    level: 'Livello | Livelli',
    content: 'Contenuto',
    subscribed: 'Iscritto',
    tags: 'Tag',
    summary: 'Riepilogo',
    contributors: 'Collaboratori',
    description: 'Descrizione',
    dependencies: 'Dipendenze',
    no_dependencies: 'Questo {ugc} non ha dipendenze',
    of: 'di',
    ago: 'fa',
    and: 'E',
    by: 'Di',
    reset_filters: 'Reimposta filtri',
    show_more: 'Mostra di più',
    show_less: 'Mostra meno',
    no_ugc_found: 'Nessun {ugc_name} trovato',
    no_subscriptions: 'Non sei abbonato a nessun {ugc_name}',
    mod_disclaimer_heading: 'Dichiarazione di non responsabilità',
    mod_disclaimer_privacy: 'Informativa sulla privacy',
    thumbs_up_received: 'Pollice in su ricevuto',
    thumbs_up: 'Pollice su',
    total_downloads: 'Download totali',
    releases: 'Rilasci',
    bytes: 'byte',
    local_mod_disabled:
      'Questo {ugc} non può essere caricato poiché mancano una o più dipendenze: {dependencies}',
    mod_with_collections: 'Raccolte con questo {ugc}',
    see_all_collections: 'Vedi tutte le collezioni {count}',
    mod_dependencies:
      'Tutte le dipendenze devono essere installate affinché {ugc} funzioni.',
    mod_dependencies_prompt:
      'Questo {ugc} ha delle dipendenze obbligatorie. Vuoi abbonarti anche tu a loro?',
    allow_in_collections: 'Consenti di essere aggiunto alle raccolte',
    allow_in_collections_tip:
      'Se questa opzione è abilitata, altri utenti potranno aggiungere il tuo {ugc} alle raccolte.',

    // Actions
    login: 'Login',
    logout: 'Esci',
    search: 'Cerca',
    clear_all: 'Cancella tutto',
    download: 'Scarica',
    subscribe: 'Iscriviti',
    unsubscribe: "Annulla l'iscrizione",
    resubscribe: "Ripristina l'iscrizione",
    activate: 'Attiva',
    deactivate: 'Disattiva',
    like: 'Mi piace',
    dislike: 'Non mi piace',
    report: 'Segnala un problema',
    submit: 'Invia',
    cancel: 'Annulla',
    done: 'Fatto',
    select: 'Selezionare',
    previous: 'Precedente',
    next: 'Prossimo',
    confirm: 'Confermare',
    allow: 'Consenti',
    manage: 'Gestisci',
    discard: 'Ignora le modifiche',
    more_actions: 'Altre azioni',
    manage_interaction_settings: 'Gestisci le impostazioni di interazione',
    block: 'Blocca',
    block_user: "Blocca il contatto dell'utente",
    unblock: 'Sblocca',
    user_blocked:
      'Hai bloccato questo utente, quindi non può contattarti o commentare i tuoi contenuti',
    block_user_tooltip:
      'Impedisce a questo utente di contattarti o commentare i tuoi contenuti.',
    block_prompt:
      'Sei sicuro di voler bloccare questo utente? Non potrà contattarti o commentare i tuoi contenuti.',
    block_success: 'Utente bloccato con successo.',
    unblock_success: 'Utente sbloccato con successo.',
    unblock_prompt:
      'Sei sicuro di voler sbloccare questo utente? Potrà contattarti di nuovo e commentare i tuoi contenuti.',
    mute: 'Silenzia',
    mute_user: "Silenzia i {ugc} dell'utente",
    unmute: "Riattiva l'audio",
    user_muted:
      "Hai disattivato l'audio di questo utente in modo da non poter vedere nessuno dei suoi {ugc}",
    mute_user_tooltip:
      'Impedisce che i {ugc} creati da questo utente ti vengano mostrati durante la navigazione dei giochi',
    mute_prompt:
      "Sei sicuro di voler disattivare l'audio di questo utente? Non vedrai più alcun {ugc} inviato da loro durante la navigazione dei giochi.",
    mute_success: 'Utente silenziato con successo.',
    unmute_success: "Audio dell'utente riattivato con successo.",
    unmute_prompt:
      "Sei sicuro di voler riattivare l'audio di questo utente? Potrai vedere nuovamente i loro contenuti.",
    publish: 'Pubblica',
    block_error: "Impossibile aggiornare lo stato di blocco dell'utente",
    mute_error: "Impossibile aggiornare lo stato di silenziamento dell'utente",

    // Collections
    collection: 'Collezione | Collezioni',
    total_mods: 'Totale {ugc}',
    total_filesize: 'Dimensione totale del file',
    follow_collection: 'Segui la collezione',
    unfollow_collection: 'Collezione Unfollow',
    compatibility: 'Compatibilità',
    compat_rating: 'Valutazione di compatibilità',
    last_30_days: 'Ultimi 30 giorni',
    all_time: 'Tutto il tempo',
    does_collection_work: 'Questa collezione funziona per te?',
    collection_works: 'Sì, lo fa',
    collection_doesnt_work: 'No, non è così',
    collection_incomplete_subscriptions: 'Abbonamenti incompleti',
    vote: 'voti | voto | voti',
    curator: 'Curatrice',
    creator_count: '{count} creatori in questa collezione',
    mods_in_collection: 'Tutti i {ugc} inclusi in questa raccolta',
    mod_not_available: 'Questo {ugc} non è più disponibile',
    unavailable: 'non disponibile',
    collection_sub_mods: 'Iscrivimi a tutti i {ugc} di questa raccolta',
    collection_unsub_mods: 'Cancellami da tutti i {ugc} di questa raccolta',
    collection_unsub_hint:
      'Se non viene selezionata, la raccolta verrà rimossa dalla tua libreria, ma rimarrai iscritto al suo {ugc}.',
    collection_error_subscribe: 'Iscrizione alla collezione {ugc} non riuscita',
    collection_error_unsubscribe:
      "Annullamento dell'iscrizione alla raccolta {ugc} non riuscito",
    collection_error_follow: 'Non è stato possibile seguire la raccolta',
    collection_error_unfollow:
      'Non è stato possibile smettere di seguire la raccolta',
    ugc_count: 'conteggio {ugc}',
    collections_incomplete:
      'Alcuni {ugc} non sono disponibili, il che potrebbe influire sulla compatibilità',
    adult: 'Adulto',
    view_more: 'Vedi di più',
    view_less: 'Vedi di meno',

    // Categories
    category: 'Categoria',
    miscellaneous: 'Varie',
    essential: 'Essenziale',
    themed: 'A tema',
    animation: 'Animazione',
    audio: 'Audio',
    bug_fixes: 'Correzioni di bug',
    cheating: 'Imbrogliare',
    environment: 'Ambiente',
    gameplay: 'Gameplay',
    quality_of_life: 'Qualità della vita',
    ui: 'UI',
    visuals: 'Immagini',

    // Filters
    all: 'Tutto',
    available: 'disponibili',
    filesize: 'Dimensione file',
    downloads: 'Download',
    todays_downloads: 'I download di oggi',
    subscribers: 'Iscritti',
    rating: 'Valutazione',
    sort_by: 'Ordina per',
    creator: 'Creatore',
    apply: 'Fare domanda a',
    reset: 'Ripristina',
    featured: 'In primo piano',
    toggle_filters: 'Attiva i filtri',
    show_filters: 'Mostra filtri',
    hide_filters: 'Nascondi filtri',
    admin_options: 'Opzioni di amministrazione',
    hidden: 'Nascosto',
    public: 'Pubblico',
    private: 'Privato',
    pending: 'In attesa di',
    archived: 'Archiviato',
    deleted: 'Eliminato',
    last_day: 'Ultimo giorno',
    hidden_monetization_disabled:
      'Nascosto perché la monetizzazione è disattivata',
    date_live: 'Data dal vivo',
    last_week: 'La settimana scorsa',
    last_month: 'Il mese scorso',
    last_3_months: 'Ultimi 3 mesi',
    last_year: `L'anno scorso`,
    exclude: 'Escludere',
    no_matching_content: 'Nessun contenuto corrispondente disponibile',
    content_type: 'Tipo di contenuto',
    free: 'Gratuito',
    premium: 'premio',

    // Login
    signup: 'Accedi o registrati con email',
    login_with: 'Accedi con {service}',
    email_placeholder: 'Indirizzo email',
    code_placeholder: 'Codice a 5 cifre',
    have_code: 'Ho un codice',
    send_new_code: 'Invia nuovo codice',
    login_disclaimer:
      'I contenuti generati dagli utenti per {game} sono gestiti da mod.io.',
    terms_disclaimer: `Premendo "Accedi", accetti i {studioterms}{terms} e la {privacy} di mod.io e confermi di avere {min_age} anni o più.`,
    terms_disclaimer_studio: '{terms} di {studio}, i ',
    terms_disclaimer_studio_separator: ', ',
    terms_disclaimer_studio_and: ' e ',
    code_error: 'Impossibile richiedere il codice.',
    or: 'O',
    login_prompt:
      "La pagina a cui stai tentando di accedere richiede l'autenticazione. Effettua il login per continuare.",
    receive_code: 'Non hai ricevuto il codice?',
    resend_code: 'Invia nuovamente il codice',
    login_with_email: "Accedi con l'email",
    otp_email:
      'Abbiamo inviato un codice di accesso monouso (OTP) a {email}. Inseriscilo per continuare.',
    back_to_login: 'Torna alle opzioni di accesso',

    // Terms
    terms: "Termini d'uso",
    privacy: 'Informativa sulla privacy',
    aup: 'Politica di utilizzo accettabile',
    monetization: 'Termini di monetizzazione',
    game: 'Termini di gioco',
    api: "Termini di accesso all'API",
    refund: 'Politica di rimborso',
    effective: 'Efficace da',

    // Report
    report_heading: 'Segnala questo {ugc}',
    report_intro:
      'Puoi segnalare problemi con i contenuti, violazioni di mod.io {terms} o inviare un {dmca} utilizzando il modulo sottostante.',
    report_intro_collection:
      'Puoi segnalare problemi con i contenuti e violazioni dei {terms} di mod.io utilizzando il modulo sottostante.',
    report_details:
      "Assicurati di includere tutte le informazioni rilevanti per facilitare la risoluzione della tua segnalazione. Tieni presente che queste informazioni verranno condivise con i moderatori del gioco e potrebbero essere condivise con l'utente che ha pubblicato il contenuto in presunta violazione.",
    report_not_working_prompt:
      'Le segnalazioni "Non funzionanti" verranno condivise direttamente con il creatore del contenuto.',
    dmca: 'Reclamo DMCA',
    report_reason: 'Motivo della segnalazione',
    urls: 'URL della violazione',
    urls_placeholder: 'URL (1 per riga)',
    company_or_name: "Nome proprio o dell'azienda",
    email: 'Email',
    address: 'Indirizzo',
    country: 'Paese/regione',
    country_placeholder: 'Seleziona un paese/regione',
    details: 'Informazioni sulla violazione',
    details_placeholder:
      'Per aiutarti a risolvere la tua segnalazione, fornisci quanti più dettagli e contesto possibile.',
    dmca_1:
      "{mod_io} rispetta i diritti di proprietà intellettuale altrui e richiede altrettanto a tutti coloro che utilizzano i suoi siti internet e servizi. Chiunque ritenga che la propria opera sia stata riprodotta in uno dei nostri siti internet o servizi in modo tale da costituire una violazione del copyright, può segnalarlo all'agente designato al DMCA di mod.io attraverso il modulo sottostante.",
    dmca_2:
      'Inoltrare un reclamo per violazione del copyright presenta serie implicazioni giuridiche. Prima di procedere, valutare la possibilità di sporgere reclamo al diretto interessato contattandolo personalmente. Potrebbe trattarsi di un semplice malinteso risolvibile senza il ricorso a provvedimenti legali.',
    dmca_3:
      "Nota bene: secondo il Digital Millennium Copyright Act, Sezione 512 (f), chiunque consapevolmente e sostanzialmente dichiari il falso sulla violazione di un materiale o un'attività, può essere chiamato a rispondere di eventuali danni. Inoltre, le informazioni fornite sotto la presente nota legale potranno essere condivise con terze parti o rese pubbliche.",
    claim_check:
      'Selezionando le seguenti caselle e inviando il presente reclamo, dichiaro SOTTO PENA DI SPERGIURO che',
    copyright_owner: 'Sono il titolare del copyright',
    copyright_auth_owner:
      "Ho l'autorizzazione ad agire per conto del titolare del copyright nelle presenti circostanze.",
    authorization: 'Autorizzazione',
    authorization_check:
      "Ritengo in buona fede che l'utilizzo del materiale segnalato in questo reclamo non sia autorizzato dal titolare del copyright, dal suo agente o dalla legge.",
    acknowledgement: 'Riconoscimento',
    acknowledgement_check:
      "Riconosco che secondo il DMCA, Sezione 512 (f), chiunque consapevolmente e sostanzialmente dichiari il falso sulla violazione di un materiale o un'attività, può essere chiamato a rispondere di eventuali danni.",
    required: 'campo obbligatorio',
    signature: 'Firma',
    signature_placeholder:
      'Digitare nome e cognome nel campo sottostante. Fungerà da firma digitale.',
    report_success_title: 'La segnalazione è stata ricevuta',
    report_success_text:
      'Se fossero necessari maggiori dettagli per risolvere il tuo problema, potremmo contattarti per fornirli. Grazie per i dettagli.',
    report_error_title: 'Impossibile inviare la segnalazione',
    report_email_inform:
      'Il tuo indirizzo email viene utilizzato esclusivamente per elaborare questa segnalazione.',

    // Table
    name: 'Nome',
    added: 'Periodo pubblicazione',
    updated: 'Aggiornamento',
    date: 'Data',
    item: 'articolo',
    file: 'File',
    version: 'Versione',
    scan: 'Scansione antivirus',
    actions: 'Azioni',
    status: 'Status',
    role: 'Ruolo',
    live: 'Dal vivo',
    locally_installed: 'Installazione locale',

    // Releases
    download_from_game_client: 'Scarica {mod} dal client di gioco',
    download_payment_required: 'Acquista per scaricare {ugc}',
    download_auth_required: 'Accedi per scaricare {ugc}',
    release_notes: 'Note di versione',
    no_release_notes: 'Nessuna nota di versione',
    previous_releases: 'Versioni precedenti',
    view_previous_releases: 'Visualizza le versioni precedenti',
    no_previous_releases: 'Nessuna versione precedente',
    no_files_published: 'Nessun file pubblicato',
    download_files_manually: 'Scaricare i file manualmente',
    platforms: 'Piattaforma | Piattaforme',

    // Ratings
    overwhelmingly_positive: 'Estremamente positivo',
    overwhelmingly_negative: 'Estremamente negativo',
    very_positive: 'Molto positivo',
    very_negative: 'Molto negativo',
    mostly_positive: 'Prevalentemente positivo',
    mostly_negative: 'Prevalentemente negativo',
    negative: 'Negativo',
    positive: 'Positivo',
    mixed: 'Ambivalente',
    unrated: 'Non classificato',

    // Sort
    sort_comments: 'Commenti',
    sort_total_mods: 'Mod totali',
    sort_trending: 'Di tendenza',
    sort_highest_rated: 'Voto più alto',
    sort_most_popular: 'Più popolare',
    sort_most_subscribers: 'La maggior parte degli abbonati',
    sort_recently_added: 'Aggiunto recentemente',
    sort_last_updated: 'Ultimo aggiornamento',
    sort_alphabetical: 'Alfabetico',
    sort_smallest_filesize: 'Dimensione del file più piccola',

    // Report Reason
    report_dmca: 'DMCA',
    report_not_working: 'Non funzionante',
    report_rude_content: 'Contenuti maleducati',
    report_illegal_content: 'Contenuto illegale',
    report_stolen_content: 'Contenuto rubato',
    report_false_information: 'Informazioni false',
    report_other: 'Altro',

    // Report not working reasons
    report_crash: 'Gioco in crash',
    report_no_load: 'Non si carica',
    report_conflicts: 'Conflitti con altri {ugc}',
    report_missing_deps: 'Dipendenze mancanti',
    report_install_issues: 'Problemi di installazione',
    report_bugs: 'Comportamento buggato',
    report_incompatability: 'Incompatibile con la versione del gioco',
    report_corrupt: 'File danneggiati',

    // Errors
    warning: 'Avvertenza',
    error_ref: 'Codice di errore: ',
    login_fail: 'Impossibile accedere',
    login_fail_message:
      'Impossibile accedere. Per favore aspetta un minuto e riprova.',
    subscribe_fail: 'Impossibile iscriversi',
    unsubscribe_fail: "Impossibile annullare l'iscrizione",
    error: 'Errore',
    default_error_message: 'Si è verificato un errore, riprova presto.',
    follow_error: 'Impossibile seguire',
    unfollow_error: 'Impossibile smettere di seguire',
    upload_file_error: 'Devi caricare almeno un file per continuare',

    agreement_not_found: 'Accordo non trovato',
    form_chars_remaining: '{count} personaggi rimanenti.',
    form_not_enough_chars: '{count} più caratteri richiesti.',
    filter: 'Filtro',
    loading: 'Caricamento',
    next_version: 'Versione successiva',
    no_results_found: 'nessun risultato trovato',
    page_not_found: 'Pagina non trovata!',
    previous_version: 'Versione precedente',
    take_me_home: 'Portami a casa',
    validation_alpha_num: 'Il campo può contenere solo numeri o lettere',
    validation_size: 'Il campo deve essere {size} caratteri',
    validation_url: 'Il campo deve essere un URL',
    validation_min: 'Minimo {min} caratteri',
    validation_max: 'Massimi caratteri {max}',
    validation_email: "Il campo deve essere un'e-mail",
    validation_checked: 'Il campo deve essere controllato',
    validation_required: 'Il campo è obbligatiorio',
    validation_name:
      'Il campo può contenere solo lettere e simboli relativi al nome',
    validation_image: "Il file deve essere un'immagine jpeg o png valida",
    validation_youtube: 'Il campo deve essere un URL Youtube valido',
    validation_sketchfab: 'Il campo deve essere un URL Sketchfab valido',
    validation_zip: 'Il file deve essere un file ZIP',
    validation_filesize: 'La dimensione del file non deve superare {size}',
    delete_image: 'Elimina immagine',
    confirm_delete_image: 'Sei sicuro di voler eliminare questa immagine?',

    comment: 'commento | commenti',
    team_member: 'Membro della squadra',
    game_admin: 'Amministratore del gioco',
    site_admin: 'Amministratore del sito',
    author: 'Autore',
    good_karma: 'Buon karma',
    bad_karma: 'Cattivo karma',
    reply: 'Rispondere',
    replies: 'risposta | risposte',
    replied: 'Risposto',
    reopen: 'Riaprire',
    close: 'Chiudi',
    mark_as_read: 'Segna come letto',
    save: 'Salva',
    delete: 'Eliminare',
    archive: 'Archivio',
    edit: 'Modificare',
    post: 'Inviare',
    pinned: 'Appuntato',
    pin: 'Perno',
    unpin: 'Sblocca',
    locked: 'Bloccato',
    lock: 'Serratura',
    unlock: 'Sblocca',
    add_comment: 'Aggiungi un commento...',
    comment_cant_reply_locked:
      'Impossibile rispondere perché il thread dei commenti è bloccato',
    comment_cant_edit_locked:
      'Impossibile modificare poiché il thread dei commenti è bloccato',
    comment_max_pin_limit: 'Raggiunto il limite massimo di commenti bloccati',
    comment_below_threshold:
      'Commento al di sotto della soglia. Fai clic per visualizzare.',
    comment_login_prompt: 'Accedi per unirti alla discussione!',
    comment_error_add: 'Impossibile aggiungere un commento',
    comment_error_edit: 'Impossibile modificare il commento',
    comment_error_delete: 'Impossibile eliminare il commento',
    comment_error_rate: 'Impossibile valutare il commento',
    comment_error_update: 'Aggiornamento del commento non riuscito',
    comments_error_fetch: 'Impossibile caricare più commenti',
    discussion: 'Discussione',
    load_more_comments: 'Carica più commenti',
    comment_confirm_delete: 'Sei sicuro di voler eliminare questo commento?',
    comment_deleted: 'Il commento è stato eliminato con successo',
    comments_disabled:
      'I commenti sono disabilitati a causa delle impostazioni del Controllo genitori del tuo account.',
    comments_age_unverified:
      'Non puoi aggiungere un commento finché la tua età non sarà verificata',
    review_settings: 'Impostazioni di revisione',

    // Mod admin
    mod_status: {
      pending_has_file:
        "Il {ugc} richiede l'approvazione del moderatore del gioco per essere pubblicato.",
      pending_curation:
        'Lo {ugc} passerà allo stato attivo una volta che un file sarà stato aggiunto e approvato.',
      pending_no_curation:
        'Lo {ugc} passerà allo stato attivo una volta aggiunto un file.',
      archived:
        'Il {ugc} è stato archiviato. Tutti gli abbonati sono stati rimossi e non può essere visualizzato o recuperato tramite richieste API.',
      hidden:
        'Il {ugc} è nascosto e disponibile solo per gli abbonati e i membri del team.',
      hidden_purchase_disabled:
        'Il {ugc} è nascosto poiché la monetizzazione è stata disattivata.',
      live: 'Il {ugc} è attivo e può essere giocato da tutti.',
    },
    mod_profile: 'profilo {ugc}',
    media: 'Media',
    file_manager: 'Gestore dei file',
    step: 'PASSO {step}',
    save_next: 'Salva e Avanti',
    auth_required: 'Autenticazione richiesta',
    public_text: '{ugc} è individuabile nelle pagine di navigazione per tutti.',
    private_text:
      '{ugc} è accessibile solo ai membri del team, agli abbonati esistenti e agli utenti con accesso in anteprima.',
    edit_disabled_on_add:
      'Una volta creato questo {ugc}, non potrai apportare modifiche via web.',
    edit_enabled_on_add:
      'Potrai apportare modifiche a {ugc} dopo che è stato creato.',
    add_mod_monetized:
      'Questo gioco supporta {ugc1} monetizzato. Se hai intenzione di monetizzare questo {ugc2}, seleziona {private} per ora e impostalo {public} più tardi dopo aver impostato la monetizzazione. Puoi configurare la monetizzazione dopo aver creato {ugc2}.',
    share_access: "Condividi l'accesso",
    profile_editing_disabled:
      'La modifica del profilo via web è stata disattivata dal gioco.',
    tools_only_1:
      'Non puoi caricare {ugc} per {game} qui, devono essere caricati utilizzando gli strumenti creati dallo sviluppatore del gioco, in modo che i file possano essere verificati. Per maggiori informazioni, consulta le {guides} scritte per questo gioco. ',
    tools_only_2: 'Ecco le istruzioni fornite dallo sviluppatore del gioco:',
    tools_only_3:
      "Ti consigliamo di tornare all'elenco {ugc} e di sfogliare i link da lì. Se il problema persiste, visita il nostro {help_center} per maggiori informazioni.",
    unsaved_heading: 'Hai modifiche non salvate',
    unsaved_confirm:
      'Ci sono modifiche che non sono state salvate, vuoi ancora andartene?',
    settings: 'Impostazioni',
    team: 'Squadre',
    reports: 'Rapporti',
    stats: 'Statistiche',
    moderator: 'Moderatore',
    manager: 'Manager',
    error_get_mod: 'Impossibile ottenere {ugc}',
    archive_reason: "Motivo dell'archiviazione",
    view_mod: 'Visualizza {ugc}',
    error_archive_mod: 'Archiviazione {ugc} non riuscita',
    archive_mod_prompt:
      "L'archiviazione di questo {ugc} annullerà l'iscrizione a tutti gli utenti e lo rimuoverà dalle richieste API.",
    archive_mod_confirm:
      "Una volta archiviata, verrà inviata un'email a tutti i membri del team per notificarli di questa azione insieme al motivo fornito.\n\nQuesta azione può essere annullata solo dai moderatori, sei sicuro di voler procedere?",

    headline_mod_profile: 'Crea il tuo profilo {ugc}',
    headline_media: 'Aggiungi contenuti multimediali al tuo profilo {ugc}',
    headline_files: 'Carica il tuo file {ugc}',
    headline_permissions:
      'Imposta le autorizzazioni di riutilizzo per il tuo {ugc}',
    headline_dependencies: 'Aggiungi eventuali dipendenze {ugc}',

    // Basics
    basics: 'Nozioni di base',
    logo: 'Logo',
    logo_prompt_1: 'File di immagine che rappresenterà il logo del tuo {ugc}.',
    logo_prompt_2: '512x288 o superiore',
    logo_prompt_3: "Rapporto d'aspetto 16:9 consigliato",
    logo_prompt_4: 'massimo 8 MB',
    summary_placeholder:
      'Parlaci delle modifiche che il tuo {ugc} apporta al gioco in 1 paragrafo.',
    homepage: 'Homepage',
    profile_url: 'URL del profilo',
    visibility: 'Visibilità',
    visibility_tip:
      'Una volta pubblicati, i {ugc} pubblici sono visibili a tutti. I {ugc} nascosti sono visibili solo ai membri del team e agli iscritti.',
    upload_images: 'Carica immagini',
    mature_content: 'Contiene contenuti per adulti',
    mature_content_alcohol: 'Alcol',
    mature_content_drugs: 'Farmaci',
    mature_content_violence: 'Violenza',
    mature_content_explicit: 'Esplicito',
    community: 'Comunità',
    allow_comments: 'Consenti commenti',
    allow_dependants: 'Consenti persone a carico',
    create_mod: 'Crea {ugc}',
    error_mod_create: 'Creazione di {ugc} non riuscita',
    error_mod_update: 'Aggiornamento {ugc} non riuscito',
    error_tags_update: 'Aggiornamento dei tag non riuscito',
    success_create_mod: '{modname} creato con successo',
    success_update_mod: '{modname} aggiornato correttamente',
    description_tip:
      'Descrizione opzionale per il tuo {ugc}, che può includere dettagli come «Informazioni», «Caratteristiche», «Utilizzo», «Domande frequenti», ecc. HTML supportato e incoraggiato',

    // Media
    models: 'modelli',
    media_reorder_hint:
      'Trascina per riordinare le immagini esistenti o rilascia nuovi file immagine per caricarli.',
    media_zip_hint_1:
      'Carica fino a {count} immagini alla volta, o un singolo file zip contenente immagini.',
    media_zip_hint_2: 'I formati supportati sono .jpg, .jpeg, .png e .zip.',
    drag_and_drop_image: 'Trascina e rilascia le immagini per caricarle',
    or_click_to_upload: 'O clicca per scegliere un file',
    error_media_update: 'Aggiornamento dei file multimediali non riuscito',
    error_media_add_links: 'Impossibile aggiungere collegamenti multimediali',
    error_media_remove_links:
      'Rimozione dei collegamenti multimediali non riuscita',
    success_media_updated: 'File multimediali aggiornati con successo',

    // File manager
    add_file: 'Aggiungere un file',
    edit_file: 'Modifica file',
    select_zip: 'Seleziona il file zip',
    upload: 'Carica',
    file_id: 'ID del file:',
    virus_none: 'Nessun virus rilevato',
    virus_waiting: 'In attesa della scansione',
    virus_scanning: 'Scansione in corso',
    virus_too_large: 'File troppo grande per la scansione',
    virus_not_found: 'File non trovato',
    virus_error: 'Errore durante la scansione del file',
    virus_found: 'Virus rilevato',
    virus_risk:
      "Questo file contiene un file eseguibile e occorre fare attenzione all'apertura",
    version_placeholder: 'Numero di versione, ad esempio 1.0.0',
    release_notes_placeholder: 'Inserisci ogni modifica su una riga separata',
    game_moderator: 'Moderatore del gioco',
    metadata_blob: 'Blob di metadati',
    metadata_blob_placeholder:
      'Inserisci metadati specifici come la versione del gioco con cui questa versione è compatibile, come installarla, ecc. Sono supportati dati validi UTF-8.',
    select_platforms: 'Piattaforme (seleziona tutte le risposte pertinenti)',
    file_pending: 'In attesa di approvazione',
    file_approved: 'Approvato',
    file_approved_live: 'Approvato e in diretta',
    file_approved_not_live: 'Approvato ma non attivo',
    file_denied: 'Negata',
    file_targeted: 'Mirato',
    live_file: 'Questo file è attualmente attivo.',
    file_is_live: 'Il file è attivo',
    file_is_not_live: 'Il file non è attivo',
    no_delete_file_live: 'Impossibile eliminare poiché il file è attivo',
    make_file_live: 'Rendi attiva questa versione',
    make_file_live_platforms:
      'Rendi attiva questa versione per le piattaforme approvate',
    delete_file_prompt:
      'Sei sicuro di voler eliminare questo file? Questa azione non può essere annullata.',
    file_processing_title: 'Elaborazione dei file',
    file_processing:
      'Il tuo file è in fase di elaborazione. Puoi continuare a navigare nel sito ma non chiudere la scheda o la finestra del browser finché non è terminata.',
    file_instructions_1:
      'Comprimi e carica la cartella base del tuo {ugc}, o se si tratta di una raccolta di file che si trovano in una cartella di gioco preesistente, dovresti comprimere quei file:',
    file_instructions_2: 'Deve essere un file ZIP',
    file_instructions_3: 'La dimensione del file non può superare i 20 GB',
    file_instructions_4:
      'I nomi di file non possono contenere nessuno dei seguenti caratteri: \\ / ? " &lt; &gt; &#124; : *',
    file_instructions_5:
      '{ugc} che sovrascrivono i file non sono supportati a meno che il gioco non lo gestisca',
    file_instructions_6:
      'I {ugc} che si estendono su più cartelle di gioco non sono supportati a meno che il gioco non gestisca questa funzionalità',
    file_terms: 'Accetto i {terms} e la {privacy}.',
    error_get_files: 'Impossibile recuperare i file',
    error_upload_file_name: 'Impossibile caricare il file {filename}',
    error_upload_file: 'Caricamento del file non riuscito',
    error_update_file: 'Aggiornamento del file non riuscito',
    error_delete_file: 'Eliminazione del file non riuscita',
    no_permission_delete_files: 'Non sei autorizzato a eliminare i file',
    error_file_required: 'Il file è obbligatorio',
    error_platform_required: 'È necessario selezionare almeno una piattaforma',
    success_file_uploaded: 'File caricato con successo',
    success_file_moderation:
      'Un moderatore esaminerà le piattaforme che richiedono moderazione',
    success_file_updated: 'File aggiornato con successo',
    error_no_approved_platforms: 'Nessuna piattaforma da mettere in diretta',
    error_no_approved_platforms_text:
      'Questo file non ha piattaforme approvate che non sono attualmente attive',
    drag_and_drop_file: 'Trascina e rilascia il file per caricarlo',
    file_upload_hint:
      'Solo file .zip accettati | {max} dimensione massima del file',
    upload_draft: 'Carica e mantieni come bozza',
    upload_publish: 'Carica e pubblica',
    save_draft: 'Salva e mantieni come bozza',
    save_publish: 'Salva e pubblica',
    keep_as_draft: 'Mantieni come bozza',
    publish_confirmation: 'Sei sicuro di voler pubblicare questo file?',
    marketplace_file_hint:
      'Se stai pianificando di monetizzare questo {mod}, dovresti mantenere questo file come bozza e impostare prima la monetizzazione prima di pubblicare.',
    curation_file_hint:
      'Un moderatore di gioco deve approvare il tuo {mod} prima che i giocatori possano accedervi.',
    platform_file_hint:
      "Questo gioco richiede l'approvazione della piattaforma per ogni file {mod} per la/le piattaforma/e selezionata/e: {platforms}.",
    two_step_approval_process:
      'Questo gioco richiede un processo di approvazione in 2 passaggi:',
    two_step_approval_process_step1:
      'Approvazione del moderatore di gioco per questo file {mod} per la/le piattaforma/e selezionata/e: {platforms}',
    two_step_approval_process_step2:
      'Approvazione del moderatore di gioco per rendere il {mod} attivo',
    two_step_approval_process_live:
      'Pubblicare questo file imposterà anche il {mod} live automaticamente una volta che entrambe le approvazioni sono completate.',
    one_step_approval_process_live:
      'Pubblicare questo file imposterà anche il {mod} live automaticamente una volta approvato.',

    // Reuse permissions form
    reuse_permissions: {
      heading: 'Riutilizzare le autorizzazioni',
      allow_redistribution:
        'Consenti ad altri di caricare le mie risorse {ugc} su altri siti, ma devo essere accreditato come creatore originale',
      allow_porting:
        'Consenti ad altri di convertire le mie risorse {ugc} in modo che funzionino in altri giochi, ma devo essere accreditato come creatore originale',
      allow_patching_no_credit:
        'Consenti ad altri di modificare le mie risorse {ugc} (incluso il rilascio di correzioni di bug o miglioramenti) e rilasciarle come nuove {ugc}',
      require_credit: 'Devo essere accreditato come creatore originale',
      require_permission: 'Richiedi prima il mio permesso',
      require_repackage_no_credit:
        'Consenti ad altri di utilizzare i miei {0} asset nei propri {1}',
      allow_resell:
        'Consenti ad altri di utilizzare le mie risorse {ugc} in qualsiasi file {ugc} in qualsiasi opera commerciale',
      original_assets:
        'Il mio {ugc} contiene opere originali al 100% o risorse che possono essere ridistribuite',
      error_update:
        'Aggiornamento delle autorizzazioni di riutilizzo non riuscito',
      success_update: 'Autorizzazioni di riutilizzo aggiornate correttamente',
      prompt:
        'Imposta le autorizzazioni su come le tue risorse {ugc} possono essere utilizzate per la creazione di contenuti altrui. Concedendo il permesso ad altri di utilizzare o modificare i tuoi file, riconosci che tale autorizzazione non può essere revocata retroattivamente rispetto alle opere già create.',
    },

    // Dependencies form
    dependencies_prompt:
      'Seleziona {0} richiesto affinché questo {1} funzioni correttamente (se non viene visualizzato un {1}, significa che non ha consentito dipendenze e devi contattare il creatore per attivarlo):',
    remove_dependency: 'Rimuovi la dipendenza',
    dependants: 'Persone a carico',
    important: 'IMPORTANTE',
    error_update_dependencies: 'Aggiornamento delle dipendenze non riuscito',
    success_update_dependencies:
      'Impostazioni delle dipendenze aggiornate correttamente',
    dependants_warning_1:
      'Una volta consentito, tieni presente che {ugc} con persone a carico collegate:',
    dependants_warning_2: 'Impossibile disattivare le persone a carico',
    dependants_warning_3: 'Non può essere eliminato',
    dependants_warning_4: 'Non può essere monetizzato',
    no_dependants: 'Nessuna persona a carico trovata',
    dependencies_allow_prompt:
      "Devi attivare l'opzione Consenti persone a carico sopra per consentire ad altri {ugc} di aggiungere la tua come persona a carico.",
    dependencies_deny_prompt:
      'Puoi disattivare Allow Dependants sopra se non vuoi che altri {ugc} lo selezionino come dipendenza',
    dependencies_not_supported:
      'Le dipendenze non sono supportate da {gamename}, tutti gli {ugc} devono funzionare indipendentemente ed essere completamente autonomi.',
    dependency_disabled_monetization:
      'I {ugc} monetizzati non possono abilitare le persone a carico',
    dependency_disabled_dependants:
      'Impossibile disabilitare le persone a carico per questo {ugc_single} poiché altri {ugc_plural} dipendono da esso. Queste possono essere visualizzate dalla scheda dipendenze.',
    dependants_confirm_enable:
      'Questo serve a garantire la compatibilità continua di connected {ugc}. Conferma per abilitare.',
    dependants_confirm_disable:
      "Sei sicuro di voler negare l'autorizzazione alle persone a carico? Ciò significa che altri {0} non saranno in grado di aggiungere la tua {1} come dipendenza.",
    dependency_monetization_warning:
      '{game} consente la monetizzazione di {mod}. La monetizzazione attualmente non supporta {mods} con dipendenze. Se intendi monetizzare questo {mod}, salta questo passaggio.',

    // Parental controls
    notify_parent_title: 'Avvisare il genitore o il tutore',
    notify_parent:
      'Se procedi, il tuo genitore o tutore verrà avvisato e dovrà approvare queste modifiche prima che diventino effettive.',
    confirm_notify_parent:
      "Desideri inviare una notifica al tuo genitore o tutore per richiedere l'accesso alle modifiche di autorizzazione proposte?",
    request_access: "Richiedi l'accesso",

    // Cloud cooking
    cook_source: 'Cucinare un file sorgente',
    source_file: 'File sorgente',
    targeted_platform: 'Piattaforma mirata',
    metadata: 'Metadati',
    cook_time: 'Tempo di cottura',
    download_time: 'Tempo di download',
    file_compression_time: 'Tempo di compressione del file',
    file_decompression_time: 'Tempo di decompressione del file',
    upload_time: 'Tempo di caricamento',
    total_job_time: 'Tempo totale di lavoro',
    logs: 'Registri',
    view_logs: 'Visualizza i log',
    logs_available_on_completion:
      'I log saranno disponibili al completamento della cottura',
    logs_for_file: 'Cook registra {file}.',
    no_logs: 'Nessun log trovato per {file}.',
    get_logs_error: 'Impossibile ottenere i registri dei cuochi',
    admin_only: 'Solo amministratore',
    queue: 'Coda',
    source_file_history: 'Cronologia del file sorgente',
    no_source_files_found: 'Nessun file sorgente trovato',
    no_cooks_found: 'Nessun cuoco trovato',
    cook_jobs_available: 'Offerte di lavoro di File Cook disponibili: {count}',
    view_details: 'Visualizza i dettagli',
    cloud_cooking: 'Cucinare in nuvola',
    add_file_type: 'Aggiungi una nuova {string}',
    edit_file_type: 'Modifica {string}',
    files: 'File',
    cook_details: 'Dettagli del cuoco',
    status_queued: 'In coda',
    status_cooking: 'Cucina',
    status_success: 'Riuscito',
    status_failed: 'Fallito',
    status_pending_moderation: 'In attesa di moderazione',
    status_moderation_rejected: 'Cook ha rifiutato',
    get_cook_files_error: 'Impossibile ottenere i file di cloud cooking',
    get_source_files_error: 'Impossibile ottenere i file sorgente',
    download_file_error: 'Impossibile scaricare il file',
    source_instructions:
      'Carica il tuo file sorgente e seleziona la/le piattaforma/e desiderata/e qui sotto. Il file verrà quindi elaborato tramite Cloud Cooking, che produrrà file individuali per le piattaforme.',

    // Marketplace
    marketplace: {
      available_stock: 'Quantità limitata disponibile - {count} rimanenti',
      virtual_currency: 'Valuta virtuale',
      marketplace: 'Marketplace',
      order_summary: "Riepilogo dell'ordine",
      payment_method: 'Metodo di pagamento | Metodi di pagamento',
      wallet_balance: 'Saldo del portafoglio',
      vc_balance: 'Saldo in valuta virtuale',
      credits: 'Crediti',
      currency: 'Valuta',
      balance_after: "Saldo dopo l'acquisto",
      token_purchase_success:
        "Grazie per l'acquisto. Il pagamento è stato elaborato e una ricevuta fiscale verrà inviata al tuo indirizzo email a breve. Il tuo saldo in valuta virtuale è stato aggiornato per {game}",
      transaction_id: 'ID transazione',
      total_paid: 'Importo totale pagato',
      agreement: 'Accetto {terms} e {refund} di mod.io',
      change_payment: 'Modifica pagamento',
      error_register: 'Registrazione per la monetizzazione non riuscita',
      error_wallet: 'Impossibile ottenere il portafoglio del gioco',
      error_process: 'Impossibile elaborare il pagamento',
      error_complete: 'Impossibile completare il pagamento',
      checkout: 'Checkout',
      vc_topup_confirmed: 'Ricarica in valuta virtuale confermata',
      confirm_purchase: "Conferma l'acquisto",
      continue_browsing: 'Continua a navigare',
      back_to_mod: "Torna all'acquisto {ugc}",
      ugc_not_refundable:
        'Gli acquisti di {ugc_plural} non sono rimborsabili. Consulta i nostri {terms} e {refund} prima di acquistare questo {ugc}.',
      ugc_purchase_success:
        "Grazie per l'acquisto. Il {ugc} è stato aggiunto ai tuoi abbonamenti nel tuo {library} ed è disponibile nel gioco.",
      game_virtual_currency: 'Valuta virtuale del gioco ({virtual_currency})',
      proceed_to_checkout: 'Procedi al checkout',
      ugc_purchase_confirmed: '{ugc} acquisto confermato',
      error_already_purchased: 'Possiedi già questo {ugc}',
      error_sku_packs: 'Impossibile ottenere i prezzi {ugc}',
      error_payment_methods: 'Impossibile ottenere i metodi di pagamento',
      calculated_at_checkout: 'Calcolato al momento del pagamento',
      subtotal: 'Totale parziale',
      taxes: 'Imposte',
      total_due: 'Importo totale dovuto',
      price: 'Prezzo',
      purchased: 'Acquistato',
      purchases: 'Acquistato {ugc}',
      no_purchases: 'Non hai acquistato {ugc}',
      purchase_to_rate: 'Puoi valutare solo {ugc} che hai acquistato',
      usd_ugc_license:
        "L'acquisto di questo {ugc} garantisce istantaneamente {count} crediti in cambio di una licenza per accedervi.",
      top_up: 'Ricarica',
      remaining_balance: 'Saldo residuo',
      not_enough_vc:
        'Non hai abbastanza valuta virtuale per procedere. Ricarica il tuo portafoglio di gioco',
      error_virtual_currency_packs:
        'Impossibile ottenere i pacchetti di valuta virtuale',
      vc_prompt: 'Ottieni i tuoi pacchetti di valute virtuali',
      vc_description:
        'Sostieni i creatori di contenuti e accedi a contenuti premium acquistando pacchetti di valuta virtuale per {game}',
      vc_agreement:
        'Consulta i nostri {terms} e {refund} prima di acquistare un pacchetto di valute virtuali. Tutte le tasse applicabili vengono applicate al momento del pagamento.',
      error_session: 'Impossibile ottenere la sessione di acquisto',
      sold_out: 'Esaurito',
      currency_packs: 'Pacchetti di valute',
      cancel_transaction: 'Annulla transazione',
      cancel_transaction_text:
        'Sei sicuro di voler annullare questa transazione?',
    },
  },
  es: {
    language: 'Idioma',

    // Nav
    browse: 'Explorar',
    library: 'Biblioteca',
    my_content: 'Mi contenido',
    account: 'Mi cuenta',
    back: 'Regresa',
    more: 'más',
    add_mod: 'Añadir {ugc}',
    edit_mod: 'Editar en mod.io',
    admin: 'Administrador',
    help_center: 'centro de ayuda',
    subscribed_ugc: 'Suscrito {ugc}',
    followed_collections: 'Colecciones seguidas',
    page: 'Página',

    // Guides
    guide: 'Guía | Guías',
    views: 'Puntos de vista',
    table_of_contents: 'Tabla de contenido',
    reading_time: 'Tiempo de leer',
    date_added: 'Fecha Agregada',
    date_updated: 'Fecha actualizada',
    minutes_read: 'Lectura de minutos',
    published: 'Publicado',
    show_more_tags: 'Mostrar etiquetas poco comunes',
    hide_more_tags: 'Ocultar etiquetas poco comunes',

    // Users
    joined: 'Unido',
    last_online: 'Último en línea',
    online: 'En línea',
    followers: 'Seguidores',
    partner: 'Pareja',
    partnered_creator: 'Creador asociado',
    profile_hidden: 'El perfil de este usuario está oculto',
    follow: 'Seguir',
    unfollow: 'Dejar de seguir',
    following: 'Siguiendo',
    user: 'usuario',
    user_update_error: 'No se pudo actualizar el usuario',
    age_widget_error: 'No se pudo cargar el widget de edad',

    // Mods
    mod: 'Mod | Mods',
    level: 'Nivel | Niveles',
    content: 'Contenido',
    subscribed: 'Suscrito',
    tags: 'Etiquetas',
    summary: 'Resumen',
    contributors: 'Contribuciones',
    description: 'Descripción',
    dependencies: 'Dependencias',
    no_dependencies: 'Este {ugc} no tiene dependencias',
    of: 'de',
    ago: 'atrás',
    and: 'y',
    by: 'Por',
    reset_filters: 'Restablecer filtros',
    show_more: 'Mostrar más',
    show_less: 'Mostrar menos',
    no_ugc_found: 'No se encontró {ugc_name}',
    no_subscriptions: 'No te has suscrito a ningún {ugc_name}',
    mod_disclaimer_heading: 'Aviso legal',
    mod_disclaimer_privacy: 'Política de privacidad',
    thumbs_up_received: 'Pulgar arriba recibido',
    thumbs_up: 'Pulgares hacia arriba',
    total_downloads: 'Descargas totales',
    releases: 'Lanzamientos',
    bytes: 'bytes',
    local_mod_disabled:
      'Este {ugc} no se puede cargar porque faltan una o más dependencias: {dependencies}',
    mod_with_collections: 'Colecciones con este {ugc}',
    see_all_collections: 'Ver todas las colecciones de {count}',
    mod_dependencies:
      'Es necesario instalar todas las dependencias para que este {ugc} funcione.',
    mod_dependencies_prompt:
      'Este {ugc} tiene dependencias obligatorias. ¿También quieres suscribirte a ellos?',
    allow_in_collections: 'Permitir ser añadido a colecciones',
    allow_in_collections_tip:
      'Si esta opción está habilitada, otros usuarios podrán agregar su {ugc} a las colecciones.',

    // Actions
    login: 'Acceso',
    logout: 'Cerrar sesión',
    search: 'Buscar',
    clear_all: 'Borrar todo',
    download: 'Descargar',
    subscribe: 'Suscribirse',
    unsubscribe: 'Anular suscripción',
    resubscribe: 'Volver a suscribirse',
    activate: 'Activar',
    deactivate: 'Desactivar',
    like: 'Me gusta',
    dislike: 'No me gusta',
    report: 'Informar de un problema',
    submit: 'Enviar',
    cancel: 'Cancelar',
    done: 'Hecho',
    select: 'Seleccionar',
    previous: 'Anterior',
    next: 'Próxima',
    confirm: 'Confirmar',
    allow: 'Permitir',
    manage: 'Administrar',
    discard: 'Descartar cambios',
    more_actions: 'Más acciones',
    manage_interaction_settings: 'Gestionar la configuración de interacción',
    block: 'Bloquear',
    block_user: 'Bloquear contacto del usuario',
    unblock: 'Desbloquear',
    user_blocked:
      'Has bloqueado a este usuario, por lo que no puede ponerse en contacto contigo ni comentar tu contenido',
    block_user_tooltip:
      'Impide que este usuario se ponga en contacto contigo o comente tu contenido.',
    block_prompt:
      '¿Estás seguro de que quieres bloquear a este usuario? No podrá ponerse en contacto contigo ni comentar tu contenido.',
    block_success: 'Usuario bloqueado correctamente.',
    unblock_success: 'Usuario desbloqueado correctamente.',
    unblock_prompt:
      '¿Estás seguro de que quieres desbloquear a este usuario? Podrá volver a ponerse en contacto contigo y comentar tu contenido.',
    mute: 'Silenciar',
    mute_user: 'Silenciar {ugc} del usuario',
    unmute: 'Dejar de silenciar',
    user_muted:
      'Has silenciado a este usuario para que no puedas ver ninguno de sus {ugc}',
    mute_user_tooltip:
      'Evita que se te muestren {ugc} creados por este usuario al navegar por juegos',
    mute_prompt:
      '¿Estás seguro de que quieres silenciar a este usuario? Ya no verás ningún {ugc} que haya enviado cuando navegues por los juegos.',
    mute_success: 'Usuario silenciado correctamente.',
    unmute_success: 'Usuario reactivado correctamente.',
    unmute_prompt:
      '¿Estás seguro de que quieres dejar de silenciar a este usuario? Podrás volver a ver su contenido.',
    publish: 'Publicar',
    block_error: 'No se pudo actualizar el estado de bloqueo del usuario',
    mute_error: 'No se pudo actualizar el estado de silenciamiento del usuario',

    // Collections
    collection: 'Colección | Colecciones',
    total_mods: 'Total {ugc}',
    total_filesize: 'Tamaño total del archivo',
    follow_collection: 'Sigue la colección',
    unfollow_collection: 'Colección Unfollow',
    compatibility: 'Compatibilidad',
    compat_rating: 'Clasificación de compatibilidad',
    last_30_days: 'Últimos 30 días',
    all_time: 'Todo el tiempo',
    does_collection_work: '¿Esta colección funciona para ti?',
    collection_works: 'Sí, lo hace',
    collection_doesnt_work: 'No, no lo hace',
    collection_incomplete_subscriptions: 'Suscripciones incompletas',
    vote: 'votos | voto | votos',
    curator: 'Curadora',
    creator_count: '{count} creadores en esta colección',
    mods_in_collection: 'Todos los {ugc} incluidos en esta colección',
    mod_not_available: 'Este {ugc} ya no está disponible',
    unavailable: 'indisponible',
    collection_sub_mods: 'Suscríbeme a todos los {ugc} de esta colección',
    collection_unsub_mods: 'Darme de baja de todos los {ugc} de esta colección',
    collection_unsub_hint:
      'Si no lo seleccionas, la colección se eliminará de tu biblioteca, pero permanecerás suscrito a su {ugc}.',
    collection_error_subscribe: 'No se pudo suscribir a la colección {ugc}',
    collection_error_unsubscribe:
      'No se pudo cancelar la suscripción a la colección {ugc}',
    collection_error_follow: 'No se pudo seguir la colección',
    collection_error_unfollow: 'No se pudo dejar de seguir la colección',
    ugc_count: 'Cuenta {ugc}',
    collections_incomplete:
      'Algunos {ugc} no están disponibles, lo que puede afectar a la compatibilidad',
    adult: 'Adulto',
    view_more: 'Ver más',
    view_less: 'Ver menos',

    // Categories
    category: 'Categoría',
    miscellaneous: 'Misceláneo',
    essential: 'Imprescindible',
    themed: 'Temático',
    animation: 'Animación',
    audio: 'Audio',
    bug_fixes: 'Correcciones de errores',
    cheating: 'Hacer trampa',
    environment: 'Medio ambiente',
    gameplay: 'Jugabilidad',
    quality_of_life: 'Calidad de vida',
    ui: 'UI',
    visuals: 'Visuales',

    // Filters
    all: 'Todo',
    available: 'disponible(s)',
    filesize: 'Tamaño de archivo',
    downloads: 'Descargas',
    todays_downloads: 'Descargados hoy',
    subscribers: 'Suscriptores',
    rating: 'Valuación',
    sort_by: 'Ordenar por',
    creator: 'Creador',
    apply: 'Aplicar',
    reset: 'Reiniciar',
    featured: 'Presentado',
    toggle_filters: 'Filtros de al revés',
    show_filters: 'Mostrar filtros',
    hide_filters: 'Ocultar filtros',
    admin_options: 'Opciones de administración',
    hidden: 'Oculto',
    public: 'Público',
    private: 'Privada',
    pending: 'Pendiente',
    archived: 'Archivado',
    deleted: 'Eliminado',
    last_day: 'Día último',
    hidden_monetization_disabled:
      'Oculto porque la monetización está desactivada',
    date_live: 'Fecha en vivo',
    last_week: 'La semana pasada',
    last_month: 'Mes pasado',
    last_3_months: 'últimos 3 meses',
    last_year: 'El año pasado',
    exclude: 'Excluir',
    no_matching_content: 'No hay contenido coincidente disponible',
    content_type: 'Tipo de contenido',
    free: 'Gratuito',
    premium: 'Premium',

    // Login
    signup: 'Inicie sesión o regístrese con correo electrónico',
    login_with: 'Iniciar sesión con {service}',
    email_placeholder: 'Dirección de correo electrónico',
    code_placeholder: 'Código de 5 dígitos',
    have_code: 'Tengo un código',
    send_new_code: 'Enviar otro código',
    login_disclaimer:
      'El contenido generado por el usuario para {game} lo administra mod.io.',
    terms_disclaimer: `Al presionar 'Iniciar sesión', aceptas los {studioterms}{terms} y la {privacy} de mod.io y confirmas que tienes {min_age} años de edad o más.`,
    terms_disclaimer_studio: '{terms} de {studio}, los ',
    terms_disclaimer_studio_separator: ', ',
    terms_disclaimer_studio_and: ' y ',
    code_error: 'No se ha podido solicitar el código.',
    or: 'o',
    login_prompt:
      'La página a la que intenta acceder requiere autenticación. Por favor inicia sesión para continuar.',
    receive_code: '¿No recibiste un código?',
    resend_code: 'Reenviar código',
    login_with_email: 'Iniciar sesión con correo electrónico',
    otp_email:
      'Enviamos un código de acceso de un solo uso (OTP) a {email}. Introdúzcalo para continuar.',
    back_to_login: 'Volver a las opciones de inicio de sesión',

    // Terms
    terms: 'Términos de uso',
    privacy: 'Política de privacidad',
    aup: 'Política de uso aceptable',
    monetization: 'Términos de monetización',
    game: 'Términos del juego',
    api: 'Términos de acceso a la API',
    refund: 'Política de reembolso',
    effective: 'Efectivo desde',

    // Report
    report_heading: 'Denunciar esto {ugc}',
    report_intro:
      'Puede informar problemas con el contenido, violaciones de los {términos} de mod.io o enviar un {dmca} mediante el siguiente formulario.',
    report_intro_collection:
      'Puede informar problemas con el contenido, violaciones de los {términos} de mod.io utilizando el formulario a continuación.',
    report_details:
      'Asegúrese de incluir toda la información relevante para facilitar la resolución de su informe. Tenga en cuenta que esta información se compartirá con los moderadores del juego y puede compartirse con el usuario que publicó el contenido supuestamente infractor.',
    report_not_working_prompt:
      'Los informes "no funcionan" se compartirán directamente con el creador del contenido.',
    dmca: 'queja DMCA',
    report_reason: 'Motivo de la denuncia',
    urls: 'URL ilícita',
    urls_placeholder: 'URL (1 por línea)',
    company_or_name: 'Empresa o nombre',
    email: 'Correo electrónico',
    address: 'Dirección',
    country: 'País/región',
    country_placeholder: 'Selecciona un país o una región',
    details: 'Detalles de la infracción',
    details_placeholder:
      'Para ayudar a resolver su informe, proporcione tantos detalles y contexto como sea posible.',
    dmca_1:
      '{mod_io} respeta los derechos de propiedad intelectual de todas las personas, por lo que pedimos a quienes hacen uso de nuestros sitios web que también respeten dichos derechos. Cualquier persona que considere que su trabajo se ha replicado en alguno de nuestros sitios web o servicios de manera que constituya un incumplimiento de los derechos de copyright debe notificar al intermediario de derechos copyright de mod.io a través del siguiente formulario.',
    dmca_2:
      'Presentar una reclamación por infracción de los derechos de copyright es un asunto legal grave. Antes de continuar, intente contactar directamente con la persona para remitir directamente su queja. Es posible que se trate de un malentendido y se pueda resolver sin recurrir a un proceso judicial.',
    dmca_3:
      'Tenga en cuenta que, según la sección 512(f) de la Digital Millennium Copyright Act (La Ley de Derechos de Autor de la Era Digital), cualquier persona que informe intencionalmente y sin fundamento acerca de material o actividad ilícita, podrá declararse responsable de los daños. Tenga en cuenta también que la información que proporcione en este aviso legal podrá hacerse pública o compartirse con terceros.',
    claim_check:
      'Al seleccionar las siguientes casillas y enviar esta reclamación declaro BAJO PENA DE PERJURIO que',
    copyright_owner: 'Soy titular de los derechos de Copyright',
    copyright_auth_owner:
      'Tengo autoridad para actuar en nombre del titular de los derechos de copyright en este caso.',
    authorization: 'Autorización',
    authorization_check:
      'Creo de buena fe que el uso del material mencionado en esta reclamación no cuenta con autorización del titular de los derechos de copyright, su representante o la ley.',
    acknowledgement: 'Confirmación',
    acknowledgement_check:
      'Reconozco que, según la sección 512(f) del DMCA, cualquier persona que informe intencionalmente y sin fundamentos de material o actividad ilícito, podrá declararse responsable de los daños.',
    required: 'obligatorio',
    signature: 'Firma',
    signature_placeholder:
      'Escriba su nombre completo en este cuadro como firma digital.',
    report_success_title: 'Hemos recibido su denuncia.',
    report_success_text:
      'Si se requieren más detalles para resolver su informe, es posible que nos pongamos en contacto con usted para que los proporcione. Gracias por la información.',
    report_error_title: 'Error al enviar la denuncia',
    report_email_inform:
      'Tu dirección de correo electrónico se utiliza exclusivamente para procesar esta denuncia.',

    // Table
    name: 'Nombre',
    added: 'Añadida',
    updated: 'Actualizada',
    date: 'Fecha',
    item: 'ítem',
    file: 'Archivo',
    version: 'Versión',
    scan: 'Análisis de virus',
    actions: 'Medidas',
    status: 'Estado',
    role: 'Rol',
    live: 'En vivo',
    locally_installed: 'Instalado en local',

    // Releases
    download_from_game_client: 'Descargar {mod} desde el cliente del juego',
    download_payment_required: 'Compra para descargar {ugc}',
    download_auth_required: 'Inicia sesión para descargar {ugc}',
    release_notes: 'Notas de la versión',
    no_release_notes: 'No se han proporcionado notas de la versión',
    previous_releases: 'Versiones anteriores',
    view_previous_releases: 'Ver lanzamientos anteriores',
    no_previous_releases: 'No hay versiones anteriores',
    no_files_published: 'No se han publicado archivos',
    download_files_manually: 'Descargar archivos manualmente',
    platforms: 'Plataforma | Plataformas',

    // Ratings
    overwhelmingly_positive: 'Extremadamente positivo',
    overwhelmingly_negative: 'Extremadamente negativo',
    very_positive: 'Muy positivo',
    very_negative: 'Muy negativo',
    mostly_positive: 'Generalmente positivo',
    mostly_negative: 'Generalmente negativo',
    negative: 'Negativo',
    positive: 'Positivo',
    mixed: 'Variado',
    unrated: 'Sin clasificar',

    // Sort
    sort_comments: 'Comentarios',
    sort_total_mods: 'Modos totales',
    sort_trending: 'Tendencias',
    sort_highest_rated: 'El mejor valorado',
    sort_most_popular: 'Más popular',
    sort_most_subscribers: 'La mayoría de los suscriptores',
    sort_recently_added: 'Recientemente añadido',
    sort_last_updated: 'Última actualización',
    sort_alphabetical: 'Alfabético',
    sort_smallest_filesize: 'Tamaño de archivo más pequeño',

    // Report Reason
    report_dmca: 'DMCA',
    report_not_working: 'No funciona',
    report_rude_content: 'Contenido grosero',
    report_illegal_content: 'Contenido ilegal',
    report_stolen_content: 'Contenido Robado',
    report_false_information: 'Información Falsa',
    report_other: 'Otro',

    // Report not working reasons
    report_crash: 'Se bloquea el juego',
    report_no_load: 'no carga',
    report_conflicts: 'Conflictos con otros {ugc}',
    report_missing_deps: 'Dependencias faltantes',
    report_install_issues: 'Problemas de instalación',
    report_bugs: 'Comportamiento con errores',
    report_incompatability: 'Incompatible con la versión del juego',
    report_corrupt: 'Archivos corruptos',

    // Errors
    warning: 'Advertencia',
    error_ref: 'Código de error: ',
    login_fail: 'Error al iniciar sesión',
    login_fail_message:
      'Error al iniciar sesión. Espere un minuto y vuelva a intentarlo.',
    subscribe_fail: 'No se suscribió',
    unsubscribe_fail: 'No se puso de baja',
    error: 'Error',
    default_error_message:
      'Se ha producido un error, inténtelo de nuevo pronto.',
    follow_error: 'No se pudo seguir',
    unfollow_error: 'No se pudo dejar de seguir',
    upload_file_error: 'Debes subir al menos un archivo para continuar',

    agreement_not_found: 'Acuerdo no encontrado',
    form_chars_remaining: '{count} caracteres restantes.',
    form_not_enough_chars: '{count} se requieren más caracteres.',
    filter: 'Filtrar',
    loading: 'Cargando',
    next_version: 'Siguiente versión',
    no_results_found: 'No se han encontrado resultados',
    page_not_found: '¡Página no encontrada!',
    previous_version: 'Versión previa',
    take_me_home: 'Llévame a casa',
    validation_alpha_num: 'El campo solo puede contener números o letras',
    validation_size: 'El campo debe ser {size} caracteres',
    validation_url: 'El campo debe ser una URL',
    validation_min: 'Mínimo {min} caracteres',
    validation_max: 'Máximo caracteres {max}',
    validation_email: 'El campo debe ser un correo electrónico',
    validation_checked: 'El campo debe ser marcado',
    validation_required: 'Se requiere campo',
    validation_name:
      'El campo solo puede contener letras y símbolos relacionados con el nombre.',
    validation_image: 'El archivo debe ser una imagen jpeg o png válida',
    validation_youtube: 'El campo debe ser una URL de Youtube válida',
    validation_sketchfab: 'El campo debe ser una URL de Sketchfab válida',
    validation_zip: 'El archivo debe ser un archivo ZIP',
    validation_filesize: 'El tamaño del archivo no debe superar {size}',
    delete_image: 'Eliminar imagen',
    confirm_delete_image: '¿Seguro que quieres eliminar esta imagen?',

    comment: 'comentario | comentarios',
    team_member: 'Miembro del equipo',
    game_admin: 'Administrador del juego',
    site_admin: 'Administrador del sitio',
    author: 'Autor',
    good_karma: 'Buen karma',
    bad_karma: 'Karma negativo',
    reply: 'Responder',
    replies: 'responder | respuestas',
    replied: 'Respondido',
    reopen: 'Reabrir',
    close: 'Cerrar',
    mark_as_read: 'Marcar como leído',
    save: 'Ahorrar',
    delete: 'Borrar',
    archive: 'Archivo',
    edit: 'Editar',
    post: 'Correo',
    pinned: 'Fijado',
    pin: 'Alfiler',
    unpin: 'Desanclar',
    locked: 'bloqueado',
    lock: 'Bloquear',
    unlock: 'Desbloquear',
    add_comment: 'Añadir un comentario...',
    comment_cant_reply_locked:
      'No se puede responder porque el hilo de comentarios está bloqueado',
    comment_cant_edit_locked:
      'No se puede editar porque el hilo de comentarios está bloqueado',
    comment_max_pin_limit:
      'Se ha alcanzado el límite máximo de comentarios anclados',
    comment_below_threshold:
      'Comenta por debajo del umbral. Haga clic para ver.',
    comment_login_prompt: '¡Inicie sesión para unirse a la discusión!',
    comment_error_add: 'No se pudo agregar comentarios',
    comment_error_edit: 'No se pudo editar comentarios',
    comment_error_delete: 'No se pudo eliminar el comentario',
    comment_error_rate: 'No se pudo calificar el comentario',
    comment_error_update: 'No se pudo actualizar el comentario',
    comments_error_fetch: 'No se pudo cargar más comentarios',
    discussion: 'Discusión',
    load_more_comments: 'Cargar más comentarios',
    comment_confirm_delete:
      '¿Estás seguro de que quieres eliminar este comentario?',
    comment_deleted: 'El comentario fue eliminado con éxito',
    comments_disabled:
      'Los comentarios están desactivados debido a la configuración de control parental de tu cuenta.',
    comments_age_unverified:
      'No puedes añadir un comentario hasta que se verifique tu edad.',
    review_settings: 'Revisar la configuración',

    // Mod admin
    mod_status: {
      pending_has_file:
        'El {ugc} requiere la aprobación del moderador del juego para publicarse.',
      pending_curation:
        'El {ugc} pasará a estar activo una vez que se haya agregado y aprobado un archivo.',
      pending_no_curation:
        'El {ugc} cambiará a un estado activo una vez que se haya agregado un archivo.',
      archived:
        'El {ugc} se ha archivado. Se han eliminado todos los suscriptores y no se puede ver ni recuperar mediante solicitudes de API.',
      hidden:
        'El {ugc} está oculto y solo está disponible para los suscriptores y miembros del equipo.',
      hidden_purchase_disabled:
        'El {ugc} está oculto porque se ha desactivado la monetización.',
      live: 'El {ugc} está en vivo y disponible para que todos lo jueguen.',
    },
    mod_profile: 'perfil de {ugc}',
    media: 'Medios de comunicación',
    file_manager: 'Gestor de archivos',
    step: 'PASO {step}',
    save_next: 'Guardar y seguir',
    auth_required: 'Se requiere autenticación',
    public_text:
      '{ugc} es visible para todo el mundo en las páginas de navegación.',
    private_text:
      'Solo pueden acceder a {ugc} los miembros del equipo, los suscriptores actuales y los usuarios con acceso a la vista previa.',
    edit_disabled_on_add:
      'Una vez creado este {ugc}, no podrás hacer cambios a través de la web.',
    edit_enabled_on_add: 'Podrás realizar cambios en el {ugc} una vez creado.',
    add_mod_monetized:
      'Este juego admite {ugc1} monetizados. Si planeas monetizar este {ugc2}, selecciona {private} por ahora y conviértelo en {public} más adelante, una vez que hayas configurado la monetización. Puedes configurar la monetización después de haber creado el {ugc2}.',
    share_access: 'Acceso compartido',
    profile_editing_disabled:
      'El juego ha desactivado la edición de perfiles a través de la web.',
    tools_only_1:
      'No puedes subir {ugc} para {game} aquí. Debes subirlos con las herramientas que el desarrollador del juego haya creado para poder verificar los archivos. Para obtener más información, consulta las {guides} escritas para este juego. ',
    tools_only_2:
      'Estas son las instrucciones proporcionadas por el desarrollador del juego:',
    tools_only_3:
      'Le recomendamos que vuelva a la lista {ugc} y explore los enlaces desde allí. Si el problema persiste, visita nuestro {help_center} para obtener más información.',
    unsaved_heading: 'Tienes cambios sin guardar',
    unsaved_confirm:
      'Hay cambios que no se han guardado, ¿quieres marcharte de todos modos?',
    settings: 'Ajustes',
    team: 'Equipos',
    reports: 'Informes',
    stats: 'Estadísticas',
    moderator: 'Moderador',
    manager: 'Gerente',
    error_get_mod: 'No se pudo obtener {ugc}',
    archive_reason: 'Motivo del archivo',
    view_mod: 'Ver {ugc}',
    error_archive_mod: 'No se pudo archivar {ugc}',
    archive_mod_prompt:
      'Al archivar este {ugc}, se cancelará la suscripción de todos los usuarios y se eliminará de las solicitudes de API.',
    archive_mod_confirm:
      'Una vez archivado, se enviará un correo electrónico a todos los miembros del equipo en el que se les notificará esta acción junto con el motivo indicado.\n\nEsta acción solo la pueden revertir los moderadores, ¿estás seguro de que deseas continuar?',

    headline_mod_profile: 'Crea tu perfil {ugc}',
    headline_media: 'Añade medios a tu perfil de {ugc}',
    headline_files: 'Sube tu archivo {ugc}',
    headline_permissions: 'Establece permisos de reutilización para tu {ugc}',
    headline_dependencies: 'Agregue cualquier dependencia de {ugc}',

    // Basics
    basics: 'Conceptos básicos',
    logo: 'Logotipo',
    logo_prompt_1:
      'Archivo de imagen que representará el logotipo de tu {ugc}.',
    logo_prompt_2: '512x288 o más',
    logo_prompt_3: 'Se recomienda una relación de aspecto de 16:9',
    logo_prompt_4: '8 MB como máximo',
    summary_placeholder:
      'Cuéntanos los cambios que tu {ugc} realiza en el juego en 1 párrafo.',
    homepage: 'Página principal',
    profile_url: 'URL del perfil',
    visibility: 'Visibilidad',
    visibility_tip:
      'Una vez en vivo, los {ugc} públicos son visibles para todos. Los {ugc} ocultos solo son visibles para los miembros del equipo y los suscriptores.',
    upload_images: 'Subir imágenes',
    mature_content: 'Contiene contenido para adultos',
    mature_content_alcohol: 'Alcohol',
    mature_content_drugs: 'Fármacos',
    mature_content_violence: 'Violencia',
    mature_content_explicit: 'Explícito',
    community: 'Comunidad',
    allow_comments: 'Permitir comentarios',
    allow_dependants: 'Permitir dependientes',
    create_mod: 'Crea {ugc}',
    error_mod_create: 'No se pudo crear {ugc}',
    error_mod_update: 'No se pudo actualizar {ugc}',
    error_tags_update: 'No se pudieron actualizar las etiquetas',
    success_create_mod: '{modname} se creó correctamente',
    success_update_mod: '{modname} se actualizó correctamente',
    description_tip:
      'Descripción opcional para tu {ugc}, que puede incluir detalles como «Acerca de», «Características», «Uso», «Preguntas frecuentes», etc. Se admite y recomienda usar HTML',

    // Media
    models: 'modelos',
    media_reorder_hint:
      'Arrastre para reordenar imágenes existentes o suelte nuevos archivos de imagen para cargarlos.',
    media_zip_hint_1:
      'Sube hasta {count} imágenes a la vez, o un solo archivo zip que contenga imágenes.',
    media_zip_hint_2: 'Los formatos soportados son .jpg, .jpeg, .png y .zip.',
    drag_and_drop_image: 'Arrastra y suelta imágenes para subirlas',
    or_click_to_upload: 'O haz clic para elegir un archivo',
    error_media_update: 'No se pudo actualizar el contenido multimedia',
    error_media_add_links: 'No se pudieron agregar enlaces multimedia',
    error_media_remove_links: 'No se pudieron eliminar los enlaces multimedia',
    success_media_updated: 'El contenido multimedia se actualizó correctamente',

    // File manager
    add_file: 'Añadir un archivo',
    edit_file: 'Editar archivo',
    select_zip: 'Seleccione un archivo zip',
    upload: 'Cargar',
    file_id: 'ID del archivo:',
    virus_none: 'No se detectó ningún virus',
    virus_waiting: 'Esperando para escanear',
    virus_scanning: 'Escaneo en curso',
    virus_too_large: 'El archivo es demasiado grande para escanearlo',
    virus_not_found: 'No se encontró el archivo',
    virus_error: 'Error al escanear el archivo',
    virus_found: 'Virus detectado',
    virus_risk:
      'Este archivo contiene un ejecutable y se debe tener cuidado al abrirlo.',
    version_placeholder: 'Número de versión, es decir, 1.0.0',
    release_notes_placeholder: 'Ingresa cada cambio en una línea separada',
    game_moderator: 'Moderador del juego',
    metadata_blob: 'Blob de metadatos',
    metadata_blob_placeholder:
      'Introduce metadatos específicos, como la versión del juego con la que es compatible esta versión, cómo instalarlo, etc. Se admiten datos válidos en UTF-8.',
    select_platforms: 'Plataformas (seleccione todas las que correspondan)',
    file_pending: 'Pendiente de aprobación',
    file_approved: 'Aprobado',
    file_approved_live: 'Aprobado y en vivo',
    file_approved_not_live: 'Aprobado pero no en vivo',
    file_denied: 'Denegado',
    file_targeted: 'Dirigido',
    live_file: 'Este archivo está activo actualmente.',
    file_is_live: 'El archivo está activo',
    file_is_not_live: 'El archivo no está activo',
    no_delete_file_live: 'No se puede eliminar porque el archivo está activo',
    make_file_live: 'Publica este lanzamiento',
    make_file_live_platforms:
      'Haga que esta versión esté disponible para las plataformas aprobadas',
    delete_file_prompt:
      '¿Está seguro de que desea eliminar este archivo? Esta acción no se puede deshacer.',
    file_processing_title: 'Procesamiento de archivos',
    file_processing:
      'Se está procesando tu archivo. Puede continuar navegando por el sitio, pero no cierre la pestaña o la ventana del navegador hasta que haya terminado.',
    file_instructions_1:
      'Comprime y sube la carpeta base de tu {ugc} o, si se trata de una colección de archivos que se encuentran en una carpeta de juego preexistente, debes comprimirlos en ZIP:',
    file_instructions_2: 'Debe ser un archivo ZIP',
    file_instructions_3: 'El tamaño del archivo no puede superar los 20 GB',
    file_instructions_4:
      'Los nombres de archivo no pueden contener ninguno de los siguientes caracteres: \\ / ? " &lt; &gt; &#124; : *',
    file_instructions_5:
      '{ugc} que sobrescriben archivos no son compatibles a menos que el juego lo consiga',
    file_instructions_6:
      'No se admiten {ugc}, que abarcan varios directorios del juego, a menos que el juego lo gestione',
    file_terms: 'Acepto las {terms} y la {privacy}.',
    error_get_files: 'No se pudieron obtener los archivos',
    error_upload_file_name: 'Nem sikerült feltölteni a(z) {filename} fájlt',
    error_upload_file: 'No se pudo cargar el archivo',
    error_update_file: 'No se pudo actualizar el archivo',
    error_delete_file: 'No se pudo eliminar el archivo',
    no_permission_delete_files: 'No tienes permiso para eliminar archivos',
    error_file_required: 'El archivo es obligatorio',
    error_platform_required: 'Debes seleccionar al menos una plataforma',
    success_file_uploaded: 'El archivo se ha subido correctamente',
    success_file_moderation:
      'Un moderador revisará las plataformas que requieren moderación',
    success_file_updated: 'El archivo se actualizó correctamente',
    error_no_approved_platforms: 'No hay plataformas para poner en marcha',
    error_no_approved_platforms_text:
      'Este archivo no tiene plataformas aprobadas que no estén activas actualmente',
    drag_and_drop_file: 'Arrastra y suelta el archivo para subirlo',
    file_upload_hint:
      'Solo se aceptan archivos .zip | tamaño máximo de archivo {max}',
    upload_draft: 'Subir y mantener como borrador',
    upload_publish: 'Subir y publicar',
    save_draft: 'Guardar y mantener como borrador',
    save_publish: 'Guardar y publicar',
    keep_as_draft: 'Mantener como borrador',
    publish_confirmation: '¿Estás seguro de que quieres publicar este archivo?',
    marketplace_file_hint:
      'Si planeas monetizar este {mod}, deberías mantener este archivo como borrador y configurar la monetización primero antes de publicar.',
    curation_file_hint:
      'Un moderador del juego debe aprobar tu {mod} antes de que los jugadores puedan acceder a él.',
    platform_file_hint:
      'Este juego requiere aprobación de la plataforma para cada archivo {mod} para la(s) plataforma(s) seleccionada(s): {platforms}.',
    two_step_approval_process:
      'Este juego requiere un proceso de aprobación de 2 pasos:',
    two_step_approval_process_step1:
      'Aprobación del moderador del juego para este archivo {mod} para la(s) plataforma(s) seleccionada(s): {platforms}',
    two_step_approval_process_step2:
      'Aprobación del moderador del juego para que el {mod} esté en vivo',
    two_step_approval_process_live:
      'Publicar este archivo también pondrá el {mod} en vivo automáticamente una vez que ambas aprobaciones estén completadas.',
    one_step_approval_process_live:
      'Publicar este archivo también pondrá el {mod} en vivo automáticamente una vez aprobado.',

    // Reuse permissions form
    reuse_permissions: {
      heading: 'Reutilizar permisos',
      allow_redistribution:
        'Permitir que otros suban mis recursos de {ugc} a otros sitios, pero se me debe acreditar como el creador original',
      allow_porting:
        'Permitir que otros conviertan mis recursos de {ugc} para que funcionen en otros juegos, pero se me debe acreditar como creador original',
      allow_patching_no_credit:
        'Permitir que otros modifiquen mis recursos de {ugc} (incluida la publicación de correcciones de errores o mejoras) y publicarlos como un nuevo {ugc}',
      require_credit: 'Debo ser acreditado como el creador original',
      require_permission: 'Exige mi permiso primero',
      require_repackage_no_credit:
        'Permitir que otros usen mis {0} activos en sus propios {1}',
      allow_resell:
        'Permitir que otros usen mis recursos {ugc} en cualquier {ugc} /archivo de cualquier obra comercial',
      original_assets:
        'Mi {ugc} contiene obras o activos 100% originales que se pueden redistribuir',
      error_update: 'No se pudieron actualizar los permisos de reutilización',
      success_update:
        'Los permisos de reutilización se actualizaron correctamente',
      prompt:
        'Establece permisos sobre cómo se pueden usar tus recursos de {ugc} para la creación de contenido de otras personas. Al conceder permiso a otras personas para que usen o modifiquen tus archivos, reconoces que dicha autorización no se puede revocar retroactivamente con respecto a las obras ya creadas.',
    },

    // Dependencies form
    dependencies_prompt:
      'Selecciona {0} necesario para que este {1} funcione correctamente (si no se muestra un {1}, significa que no ha permitido dependencias y debes ponerte en contacto con el creador para activarlo):',
    remove_dependency: 'Eliminar la dependencia',
    dependants: 'Dependientes',
    important: 'IMPORTANTE',
    error_update_dependencies: 'No se pudieron actualizar las dependencias',
    success_update_dependencies:
      'La configuración de dependencias se actualizó correctamente',
    dependants_warning_1:
      'Una vez permitido, ten en cuenta que {ugc} con dependientes conectados:',
    dependants_warning_2: 'No se pueden deshabilitar los dependientes',
    dependants_warning_3: 'No se puede eliminar',
    dependants_warning_4: 'No se puede monetizar',
    no_dependants: 'No se han encontrado personas a cargo',
    dependencies_allow_prompt:
      'Debes activar la opción Permitir dependientes arriba para que otros {ugc} añadan el tuyo como dependiente.',
    dependencies_deny_prompt:
      'Puedes desactivar la opción Permitir dependientes más arriba si no quieres que otros {ugc} la seleccionen como dependencia',
    dependencies_not_supported:
      '{gamename} no admite dependencias, todos los {ugc} deben ejecutarse de forma independiente y ser completamente autónomos.',
    dependency_disabled_monetization:
      'El {ugc} monetizado no puede habilitar a los dependientes',
    dependency_disabled_dependants:
      'No se pueden deshabilitar los dependientes para este {ugc_single} ya que otros {ugc_plural} dependen de él. Se pueden ver en la pestaña de dependencias.',
    dependants_confirm_enable:
      'Esto es para garantizar la compatibilidad continua de los {ugc} conectados. Confirma para habilitarlo.',
    dependants_confirm_disable:
      '¿Estás seguro de que quieres no permitir a los dependientes? Esto significa que otros {0} no podrán agregar tu {1} como dependencia.',
    dependency_monetization_warning:
      '{game} permite la monetización de {mod}. La monetización actualmente no es compatible con {mods} que tienen dependencias. Si tienes la intención de monetizar este {mod}, omite este paso.',

    // Parental controls
    notify_parent_title: 'Notificar al padre o tutor',
    notify_parent:
      'Si continúa, su padre, madre o tutor legal será notificado y deberá aprobar estos cambios antes de que entren en vigor.',
    confirm_notify_parent:
      '¿Desea enviar una notificación a su padre, madre o tutor legal para solicitar acceso a los cambios de permisos propuestos?',
    request_access: 'Solicitar acceso',

    // Cloud cooking
    cook_source: 'Cocinar un archivo fuente',
    source_file: 'Archivo fuente',
    targeted_platform: 'Plataforma objetivo',
    metadata: 'Metadatos',
    cook_time: 'Tiempo de cocción',
    download_time: 'Tiempo de descarga',
    file_compression_time: 'Tiempo de compresión de archivos',
    file_decompression_time: 'Tiempo de descompresión de archivos',
    upload_time: 'Tiempo de subida',
    total_job_time: 'Tiempo total de trabajo',
    logs: 'Registros',
    view_logs: 'Ver registros',
    logs_available_on_completion:
      'Los registros estarán disponibles al completar la cocción',
    logs_for_file: 'Cocina troncos para {file}.',
    no_logs: 'No se han encontrado registros para {file}.',
    get_logs_error: 'No se pudieron obtener los registros de cocción',
    admin_only: 'Solo administrador',
    queue: 'Cola',
    source_file_history: 'Historial del archivo fuente',
    no_source_files_found: 'No se encontraron archivos de origen',
    no_cooks_found: 'No se encontraron cocineros',
    cook_jobs_available:
      'Trabajos de cocinero de archivos disponibles: {count}',
    view_details: 'Ver detalles',
    cloud_cooking: 'Cocina en la nube',
    add_file_type: 'Agregar una nueva {string}',
    edit_file_type: 'Editar {string}',
    files: 'Archivos',
    cook_details: 'Detalles del cocinero',
    status_queued: 'En cola',
    status_cooking: 'Cocinando',
    status_success: 'Exitoso',
    status_failed: 'Fallido',
    status_pending_moderation: 'Pendiente de moderación',
    status_moderation_rejected: 'Cook rechazó',
    get_cook_files_error:
      'No se pudieron obtener los archivos de cocción en la nube',
    get_source_files_error: 'No se pudieron obtener los archivos fuente',
    download_file_error: 'No se pudo descargar el archivo',
    source_instructions:
      'Sube tu archivo fuente y selecciona la(s) plataforma(s) deseada(s) a continuación. El archivo se procesará mediante Cloud Cooking, que genera archivos individuales para cada plataforma.',

    // Marketplace
    marketplace: {
      available_stock: 'Cantidad limitada disponible - {count} restantes',
      virtual_currency: 'Moneda virtual',
      marketplace: 'Marketplace',
      order_summary: 'Resumen del pedido',
      payment_method: 'Método de pago | Métodos de pago',
      wallet_balance: 'Saldo de cartera',
      vc_balance: 'Saldo en moneda virtual',
      credits: 'Créditos',
      currency: 'Moneda',
      balance_after: 'Saldo después de la compra',
      token_purchase_success:
        'Gracias por su compra. Su pago se ha procesado y en breve se le enviará un recibo fiscal a su correo electrónico. Ya se ha actualizado tu saldo en moneda virtual para {game}',
      transaction_id: 'ID de transacción',
      total_paid: 'Importe total pagado',
      agreement: 'Estoy de acuerdo con {terms} y {refund} de mod.io',
      change_payment: 'Cambiar pago',
      error_register: 'No se pudo registrar para la monetización',
      error_wallet: 'No se pudo obtener la billetera del juego',
      error_process: 'No se puede procesar el pago',
      error_complete: 'No se puede completar el pago',
      checkout: 'Checkout',
      vc_topup_confirmed: 'Se confirma la recarga de moneda virtual',
      confirm_purchase: 'Confirmar la compra',
      continue_browsing: 'Continuar navegando',
      back_to_mod: 'Volver a la compra de {ugc}',
      ugc_not_refundable:
        'Las compras de {ugc_plural} no son reembolsables. Consulta nuestras {terms} y {refund} antes de comprar este {ugc}.',
      ugc_purchase_success:
        'Gracias por su compra. El {ugc} se ha añadido a tus suscripciones en tu {library} y está disponible en el juego.',
      game_virtual_currency: 'Moneda virtual del juego ({virtual_currency})',
      proceed_to_checkout: 'Proceder a la compra',
      ugc_purchase_confirmed: '{ugc} compra confirmada',
      error_already_purchased: 'Ya tienes este {ugc}',
      error_sku_packs: 'No se pudieron obtener los precios de {ugc}',
      error_payment_methods: 'No se pudieron obtener los métodos de pago',
      calculated_at_checkout: 'Se calcula al finalizar la compra',
      subtotal: 'Subtotal',
      taxes: 'Impuestos',
      total_due: 'Importe total adeudado',
      price: 'Precio',
      purchased: 'Comprado',
      purchases: 'Comprado {ugc}',
      no_purchases: 'No has comprado ningún {ugc}',
      purchase_to_rate: 'Solo puedes valorar {ugc} lo que hayas comprado',
      usd_ugc_license:
        'La compra de este {ugc} otorga instantáneamente {count} créditos a cambio de una licencia para acceder a él.',
      top_up: 'Recargar',
      remaining_balance: 'Saldo restante',
      not_enough_vc:
        'No tienes suficiente moneda virtual para continuar. Recarga tu monedero de juego',
      error_virtual_currency_packs:
        'No se pudieron obtener los paquetes de monedas virtuales',
      vc_prompt: 'Consigue tus paquetes de monedas virtuales',
      vc_description:
        'Apoye a los creadores de contenido y acceda a contenido premium mediante la compra de paquetes de moneda virtual para {game}',
      vc_agreement:
        'Consulta nuestros {terms} y {refund} antes de comprar un paquete de moneda virtual. Todos los impuestos aplicables se aplican al finalizar la compra.',
      error_session: 'No se pudo obtener la sesión de compra',
      sold_out: 'Agotado',
      currency_packs: 'Paquetes de divisas',
      cancel_transaction: 'Cancelar transacción',
      cancel_transaction_text:
        '¿Está seguro de que desea cancelar esta transacción?',
    },
  },
  pl: {
    language: 'Język',

    // Nav
    browse: 'Przeglądaj',
    library: 'Biblioteka',
    my_content: 'Moje treści',
    account: 'Moje konto',
    back: 'Wróć',
    more: 'więcej',
    add_mod: 'Dodaj {ugc}',
    edit_mod: 'Edytuj na mod.io',
    admin: 'Administrator',
    help_center: 'centrum pomocy',
    subscribed_ugc: 'Subskrybowany {ugc}',
    followed_collections: 'Obserwowane kolekcje',
    page: 'Strona',

    // Guides
    guide: 'Przewodnik | Przewodniki',
    views: 'Wyświetlenia',
    table_of_contents: 'Spis treści',
    reading_time: 'Czas czytania',
    date_added: 'Data dodania',
    date_updated: 'Data zaktualizowana',
    minutes_read: 'Minuta czytania',
    published: 'Opublikowany',
    show_more_tags: 'Pokaż nietypowe tagi',
    hide_more_tags: 'Ukryj nietypowe tagi',

    // Users
    joined: 'Dołączył',
    last_online: 'Ostatnio online',
    online: 'online',
    followers: 'Obserwujący',
    partner: 'Partner',
    partnered_creator: 'Twórca współpracujący',
    profile_hidden: 'Profil tego użytkownika jest ukryty',
    follow: 'Podążać',
    unfollow: 'Przestań obserwować',
    following: 'Następujący',
    user: 'użytkownika',
    user_update_error: 'Nie udało się zaktualizować użytkownika',
    age_widget_error: 'Nie udało się załadować widżetu wieku',

    // Mods
    mod: 'Mod | Mods',
    level: 'Poziom | Poziomy',
    content: 'Zawartość',
    subscribed: 'Subskrybujesz',
    tags: 'Tagi',
    summary: 'Podsumowanie',
    contributors: 'Współtwórcy',
    description: 'Opis',
    dependencies: 'Zależności',
    no_dependencies: 'Ten {ugc} nie ma zależności',
    of: 'z',
    ago: 'temu',
    and: 'I',
    by: 'Przez',
    reset_filters: 'Zresetuj filtry',
    show_more: 'Pokaż więcej',
    show_less: 'Pokaż mniej',
    no_ugc_found: 'Nie znaleziono {ugc_name}',
    no_subscriptions: 'Nie zasubskrybowałeś żadnego {ugc_name}',
    mod_disclaimer_heading: 'Wyłączenie odpowiedzialności',
    mod_disclaimer_privacy: 'Polityce prywatności',
    thumbs_up_received: 'Kciuki w górę odebrane',
    thumbs_up: 'Kciuki w górę',
    total_downloads: 'Całkowita liczba pobrań',
    releases: 'Wydania',
    bytes: 'bajty',
    local_mod_disabled:
      'Tego {ugc} nie można załadować, ponieważ brakuje jednej lub więcej zależności: {dependencies}',
    mod_with_collections: 'Kolekcje zawierające {ugc}',
    see_all_collections: 'Zobacz wszystkie kolekcje {count}',
    mod_dependencies:
      'Wszystkie zależności muszą być zainstalowane, aby ten {ugc} działał.',
    mod_dependencies_prompt:
      'Ten {ugc} ma wymagane zależności. Czy też chcesz je zasubskrybować?',
    allow_in_collections: 'Zezwalaj na dodawanie do kolekcji',
    allow_in_collections_tip:
      'Jeśli ta opcja jest włączona, inni użytkownicy będą mogli dodawać Twój {ugc} do kolekcji.',

    // Actions
    login: 'Zaloguj się',
    logout: 'Wyloguj',
    search: 'Szukaj',
    clear_all: 'Wyczyść wszystko',
    download: 'Pobierz',
    subscribe: 'Subskrybuj',
    unsubscribe: 'Anuluj subskrypcję',
    resubscribe: 'Subskrybuj ponownie',
    activate: 'Aktywuj',
    deactivate: 'Dezaktywuj',
    like: 'Lubię',
    dislike: 'Nie lubię',
    report: 'Zgłoś problem',
    submit: 'Prześlij',
    cancel: 'Anuluj',
    done: 'Gotowe',
    select: 'Wybierać',
    previous: 'Poprzednie',
    next: 'Kolejny',
    confirm: 'Potwierdź',
    allow: 'Zezwalaj',
    manage: 'Zarządzaj',
    discard: 'Odrzuć zmiany',
    more_actions: 'Więcej akcji',
    manage_interaction_settings: 'Zarządzaj ustawieniami interakcji',
    block: 'Zablokuj',
    block_user: 'Zablokuj kontakt z użytkownikiem',
    unblock: 'Odblokuj',
    user_blocked:
      'Zablokowałeś tego użytkownika, więc nie może się z Tobą kontaktować ani komentować Twoich treści',
    block_user_tooltip:
      'Uniemożliwia temu użytkownikowi kontakt z Tobą lub komentowanie Twoich treści.',
    block_prompt:
      'Czy na pewno chcesz zablokować tego użytkownika? Nie będzie mógł się z Tobą kontaktować ani komentować Twoich treści.',
    block_success: 'Użytkownik został pomyślnie zablokowany.',
    unblock_success: 'Użytkownik został pomyślnie odblokowany.',
    unblock_prompt:
      'Czy na pewno chcesz odblokować tego użytkownika? Będzie mógł ponownie się z Tobą kontaktować i komentować Twoje treści.',
    mute: 'Wycisz',
    mute_user: 'Wycisz {ugc} użytkownika',
    unmute: 'Wyłącz wyciszenie',
    user_muted:
      'Wyciszyłeś tego użytkownika, więc nie możesz zobaczyć żadnego z jego {ugc}',
    mute_user_tooltip:
      'Zapobiega wyświetlaniu {ugc} utworzonych przez tego użytkownika podczas przeglądania gier',
    mute_prompt:
      'Czy na pewno chcesz wyciszyć tego użytkownika? Nie będziesz już widzieć żadnego {ugc} przesłanego przez nich podczas przeglądania gier.',
    mute_success: 'Użytkownik został pomyślnie wyciszony.',
    unmute_success: 'Wyciszenie użytkownika zostało pomyślnie wyłączone.',
    unmute_prompt:
      'Czy na pewno chcesz wyłączyć wyciszenie tego użytkownika? Będziesz mógł ponownie zobaczyć ich treść.',
    publish: 'Opublikuj',
    block_error: 'Nie udało się zaktualizować statusu blokady użytkownika',
    mute_error: 'Nie udało się zaktualizować statusu wyciszenia użytkownika',

    // Collections
    collection: 'Kolekcja | Kolekcje',
    total_mods: 'Razem {ugc}',
    total_filesize: 'Całkowity rozmiar pliku',
    follow_collection: 'Śledź kolekcję',
    unfollow_collection: 'Przestań obserwować kolekcję',
    compatibility: 'Kompatybilność',
    compat_rating: 'Ocena zgodności',
    last_30_days: 'Ostatnie 30 dni',
    all_time: 'Cały czas',
    does_collection_work: 'Czy ta kolekcja działa dla Ciebie?',
    collection_works: 'Tak, to robi',
    collection_doesnt_work: 'Nie, to nie',
    collection_incomplete_subscriptions: 'Niepełne subskrypcje',
    vote: 'głosów | głos |głosy',
    curator: 'Kurator',
    creator_count: '{count} twórców w tej kolekcji',
    mods_in_collection: 'Wszystkie {ugc} zawarte w tej kolekcji',
    mod_not_available: 'Ten {ugc} nie jest już dostępny',
    unavailable: 'nie płynny',
    collection_sub_mods: 'Zapisz mnie do wszystkich {ugc} w tej kolekcji',
    collection_unsub_mods:
      'Zrezygnuj z subskrypcji wszystkich {ugc} w tej kolekcji',
    collection_unsub_hint:
      'Jeśli nie zostanie zaznaczona, kolekcja zostanie usunięta z biblioteki, ale pozostaniesz subskrybowany na jej {ugc}.',
    collection_error_subscribe: 'Nie udało się zasubskrybować kolekcji {ugc}',
    collection_error_unsubscribe:
      'Nie udało się zrezygnować z subskrypcji kolekcji {ugc}',
    collection_error_follow: 'Nie udało się śledzić kolekcji',
    collection_error_unfollow: 'Nie udało się przestać obserwować kolekcji',
    ugc_count: '{ugc} liczba',
    collections_incomplete:
      'Niektóre {ugc} są niedostępne, co może mieć wpływ na zgodność',
    adult: 'Dorosły',
    view_more: 'Zobacz więcej',
    view_less: 'Zobacz mniej',

    // Categories
    category: 'Kategoria',
    miscellaneous: 'Różne',
    essential: 'Niezbędne',
    themed: 'Tematyczne',
    animation: 'Animacja',
    audio: 'Dźwięk',
    bug_fixes: 'Poprawki błędów',
    cheating: 'Oszukiwanie',
    environment: 'Środowisko',
    gameplay: 'Rozgrywka',
    quality_of_life: 'Jakość życia',
    ui: 'UI',
    visuals: 'Wizualizacje',

    // Filters
    all: 'Wszystko',
    available: 'dostępne(-ych)',
    filesize: 'Rozmiar pliku',
    downloads: 'Liczba pobrań',
    todays_downloads: 'Pobrania dziś',
    subscribers: 'Subskrybenci',
    rating: 'Ocena',
    sort_by: 'Sortuj według',
    creator: 'Twórca',
    apply: 'Stosować',
    reset: 'Resetowanie',
    featured: 'Wyróżniony',
    toggle_filters: 'Przełącz filtry',
    show_filters: 'Pokaż filtry',
    hide_filters: 'Ukryj filtry',
    admin_options: 'Opcje administratora',
    hidden: 'Ukryty',
    public: 'Publiczne',
    private: 'Prywatny',
    pending: 'Aż do',
    archived: 'Zarchiwizowane',
    deleted: 'Usunięto',
    last_day: 'Ostatni dzień',
    hidden_monetization_disabled: 'Ukryte jako wyłączone zarabianie',
    date_live: 'Data na żywo',
    last_week: 'Ostatni tydzień',
    last_month: 'Ostatni miesiąc',
    last_3_months: 'Ostatnie 3 miesiące',
    last_year: 'W ubiegłym roku',
    exclude: 'Wykluczać',
    no_matching_content: 'Brak dostępnych pasujących treści',
    content_type: 'Rodzaj zawartości',
    free: 'Wolny',
    premium: 'Premia',

    // Login
    signup: 'Zaloguj się lub zarejestruj za pomocą adresu e-mail',
    login_with: 'Zaloguj się za pomocą {service}',
    email_placeholder: 'Adres e-mail',
    code_placeholder: '5-cyfrowy kod',
    have_code: 'Mam kod.',
    send_new_code: 'Wyślij nowy kod',
    login_disclaimer:
      'Treściami gry {game} generowanymi przez użytkowników zarządza mod.io.',
    terms_disclaimer: `Naciskając „Zaloguj się”, wyrażasz zgodę na {studioterms}{terms} i {privacy} mod.io i potwierdzasz, że masz ukończone {min_age} lat.`,
    terms_disclaimer_studio: '{terms} {studio}, ',
    terms_disclaimer_studio_separator: ', ',
    terms_disclaimer_studio_and: ' i ',
    code_error: 'Nie można poprosić o kod.',
    or: 'Lub',
    login_prompt:
      'Strona, do której próbujesz uzyskać dostęp, wymaga uwierzytelnienia. Zaloguj się, aby kontynuować.',
    receive_code: 'Nie otrzymałeś kodu?',
    resend_code: 'Wyślij ponownie kod',
    login_with_email: 'Zaloguj się za pomocą adresu e-mail',
    otp_email:
      'Wysłaliśmy jednorazowy kod dostępu (OTP) na adres {email}. Wprowadź go, aby kontynuować.',
    back_to_login: 'Powrót do opcji logowania',

    // Terms
    terms: 'Warunki korzystania',
    privacy: 'Polityka prywatności',
    aup: 'Zasady dopuszczalnego użytkowania',
    monetization: 'Warunki monetyzacji',
    game: 'Warunki gry',
    api: 'Warunki dostępu do API',
    refund: 'Polityka zwrotów',
    effective: 'Obowiązuje od',

    // Report
    report_heading: 'Zgłoś to {ugc}',
    report_intro:
      'Możesz zgłosić problemy z treścią, naruszenia mod.io {terms} lub przesłać {dmca} za pomocą poniższego formularza.',
    report_intro_collection:
      'Problemy związane z treścią i naruszenia warunków mod.io możesz zgłaszać za pomocą poniższego formularza.',
    report_details:
      'Upewnij się, że zamieściłeś wszystkie istotne informacje, które ułatwią rozpatrzenie Twojego zgłoszenia. Należy pamiętać, że informacje te zostaną udostępnione moderatorom gier i mogą zostać udostępnione użytkownikowi, który opublikował treści rzekomo naruszające prawa.',
    report_not_working_prompt:
      'Raporty „Nie działa” zostaną udostępnione bezpośrednio twórcy treści.',
    report_reason: 'Powód zgłoszenia',
    urls: 'Obraźliwe adresy URL',
    urls_placeholder: 'Adresy URL (po jednym na wiersz)',
    company_or_name: 'Nazwa firmy lub Twoje imię i nazwisko',
    email: 'Adres e-mail',
    address: 'Adres',
    country: 'Kraj/region',
    country_placeholder: 'Wybierz kraj/region',
    details: 'Szczegóły naruszenia',
    details_placeholder:
      'Aby pomóc w rozwiązaniu Twojego zgłoszenia, podaj jak najwięcej szczegółów i kontekstu.',
    dmca_1:
      'Zespół {mod_io} szanuje prawa własności intelektualnej innych osób i prosimy wszystkich korzystających z naszych stron internetowych i usług o to samo. Każdy, kto uważa, że jego praca została powielona na jednej z naszych stron internetowych lub w jednej z usług w sposób stanowiący naruszenie praw autorskich, może powiadomić przedstawiciela ds. praw autorskich mod.io, korzystając z poniższego formularza.',
    dmca_2:
      'Zgłoszenie roszczenia dotyczącego naruszenia praw autorskich to poważna kwestia prawna. Zanim przejdziesz dalej, możesz rozważyć bezpośredni kontakt z daną osobą w celu złożenia skargi. To może być zwykłe nieporozumienie, które można rozwiązać bez angażowania się w faktyczny proces prawny.',
    dmca_3:
      'Pamiętaj, że zgodnie z sekcją 512(f) amerykańskiej ustawy Digital Millennium Copyright Act każda osoba, która świadomie wprowadza innych w błąd, twierdząc, że materiał lub działanie narusza prawa autorskie, może zostać pociągnięta do odpowiedzialności za wynikłe szkody. Pamiętaj też, że informacje zawarte w niniejszej nocie prawnej mogą być udostępniane stronom trzecim lub upubliczniane.',
    claim_check:
      'Zaznaczając poniższe pola i przesyłając niniejsze roszczenie, oświadczam POD KARĄ ZA SKŁADANIE FAŁSZYWYCH ZEZNIAŃ, co następuje:',
    copyright_owner: 'Jestem właścicielem(-ką) praw autorskich.',
    copyright_auth_owner:
      'Mam upoważnienie do działania w imieniu właściciela(-ki) praw autorskich w takiej sytuacji.',
    authorization: 'Upoważnienie',
    authorization_check:
      'W dobrej wierze wyrażam przekonanie, że wykorzystanie materiału wymienionego w tym roszczeniu nie zostało autoryzowane przez właściciela(-kę) praw autorskich, jego/jej przedstawiciela(-kę) lub nie jest zgodne z prawem.',
    acknowledgement: 'Potwierdzenie',
    acknowledgement_check:
      'Przyjmuję do wiadomości, że zgodnie z sekcją 512(f) amerykańskiej ustawy Digital Millennium Copyright Act każda osoba, która świadomie wprowadza innych w błąd, twierdząc, że materiał lub działanie narusza prawa autorskie, może zostać pociągnięta do odpowiedzialności za wynikłe szkody.',
    required: 'wymagane',
    signature: 'Podpis',
    signature_placeholder:
      'Wpisz imię i nazwisko w tym polu – będzie równoznaczne z Twoim podpisem cyfrowym.',
    report_success_title: 'Otrzymaliśmy Twoje zgłoszenie',
    report_success_text:
      'Jeśli do rozwiązania Twojego zgłoszenia potrzebne będą dodatkowe szczegóły, możemy się z Tobą skontaktować w celu ich przekazania. Dziękujemy za szczegóły.',
    report_error_title: 'Nie udało się przesłać zgłoszenia',
    report_email_inform:
      'Twój adres e-mail jest używany wyłącznie do przetwarzania tego zgłoszenia.',

    // Table
    name: 'Nazwa',
    added: 'Dodano',
    updated: 'Zaktualizowano',
    date: 'Data',
    item: 'pozycja',
    file: 'Plik',
    version: 'Wersja',
    scan: 'Skanowanie wirusowe',
    actions: 'Działania',
    status: 'Status',
    role: 'Rola',
    live: 'Na żywo',
    locally_installed: 'Zainstalowane lokalnie',

    // Releases
    download_from_game_client: 'Pobierz moda {mod} z klienta gry',
    download_payment_required: 'Zakup, aby pobrać {ugc}',
    download_auth_required: 'Zaloguj się, aby pobrać {ugc}',
    release_notes: 'Informacje o wydaniu',
    no_release_notes: 'Brak informacji o wydaniu',
    previous_releases: 'Poprzednie wydania',
    view_previous_releases: 'Zobacz poprzednie wydania',
    no_previous_releases: 'Nie ma poprzednich wydań.',
    no_files_published: 'Brak opublikowanych plików',
    download_files_manually: 'Pobierz pliki ręcznie',
    platforms: 'Platforma | Platformy',

    // Ratings
    overwhelmingly_positive: 'Przytłaczająco pozytywne',
    overwhelmingly_negative: 'Przytłaczająco negatywne',
    very_positive: 'Bardzo pozytywne',
    very_negative: 'Bardzo negatywne',
    mostly_positive: 'Głównie pozytywne',
    mostly_negative: 'Głównie negatywne',
    negative: 'Negatywne',
    positive: 'Pozytywne',
    mixed: 'Mieszane',
    unrated: 'Brak ocen',

    // Sort
    sort_comments: 'Uwagi',
    sort_total_mods: 'Wszystkie mody',
    sort_trending: 'Popularne',
    sort_highest_rated: 'Najwyżej oceniany',
    sort_most_popular: 'Najbardziej popularny',
    sort_most_subscribers: 'Większość abonentów',
    sort_recently_added: 'Niedawno dodane',
    sort_last_updated: 'Ostatnio zaktualizowany',
    sort_alphabetical: 'Alfabetyczny',
    sort_smallest_filesize: 'Najmniejszy rozmiar pliku',

    // Report Reason
    report_dmca: 'DMCA',
    report_not_working: 'Nie działa',
    report_rude_content: 'Niegrzeczna treść',
    report_illegal_content: 'Nielegalna treść',
    report_stolen_content: 'Skradziona zawartość',
    report_false_information: 'Fałszywe informacje',
    report_other: 'Inne',

    // Report not working reasons
    report_crash: 'Zawiesza grę',
    report_no_load: 'Nie ładuje się',
    report_conflicts: 'Konflikty z innymi {ugc}',
    report_missing_deps: 'Brakujące zależności',
    report_install_issues: 'Problemy z instalacją',
    report_bugs: 'Bugiczne zachowanie',
    report_incompatability: 'Niekompatybilny z wersją gry',
    report_corrupt: 'Uszkodzone pliki',

    // Errors
    warning: 'Ostrzeżenie',
    error_ref: 'Kod błędu: ',
    login_fail: 'Nie udało się zalogować',
    login_fail_message:
      'Nie udało się zalogować. Poczekaj chwilę i spróbuj ponownie.',
    subscribe_fail: 'Nie udało się zasubskrybować',
    unsubscribe_fail: 'Nie udało się zrezygnować z subskrypcji',
    error: 'Błąd',
    default_error_message: 'Wystąpił błąd. Spróbuj ponownie wkrótce.',
    follow_error: 'Nie udało się śledzić',
    unfollow_error: 'Nie udało się przestać obserwować',
    upload_file_error:
      'Musisz przesłać co najmniej jeden plik, aby kontynuować',

    agreement_not_found: 'Umowa nie została znaleziona',
    form_chars_remaining: '{count} pozostałe znaki.',
    form_not_enough_chars: '{count} Wymagane więcej znaków.',
    filter: 'Filtr',
    loading: 'Ładowanie',
    next_version: 'Następna wersja',
    no_results_found: 'Nie znaleziono wyników',
    page_not_found: 'Strona nie znaleziona!',
    previous_version: 'Poprzednia wersja',
    take_me_home: 'Zabierz mnie do domu',
    validation_alpha_num: 'Pole może zawierać tylko liczby lub litery',
    validation_size: 'Pole musi być znakami {size}',
    validation_url: 'Pole musi być adresem URL',
    validation_min: 'Minimum {min} znaków',
    validation_max: 'Maksymalne znaki {max}',
    validation_email: 'Pole musi być e -mailem',
    validation_checked: 'Pole musi być sprawdzone',
    validation_required: 'To pole jest wymagane',
    validation_name:
      'Pole może zawierać wyłącznie litery i symbole związane z nazwą',
    validation_image: 'Plik musi być prawidłowym obrazem jpeg lub png',
    validation_youtube: 'Pole musi być prawidłowym adresem URL Youtube',
    validation_sketchfab: 'Pole musi być prawidłowym adresem URL Sketchfab',
    validation_zip: 'Plik musi być ZIP',
    validation_filesize: 'Rozmiar pliku nie może przekraczać {size}',
    delete_image: 'Usuń obraz',
    confirm_delete_image: 'Czy na pewno chcesz usunąć to zdjęcie?',

    comment: 'komentarz | komentarze',
    team_member: 'Członek zespołu',
    game_admin: 'Administrator gry',
    site_admin: 'Administrator witryny',
    author: 'Autor',
    good_karma: 'Dobra Karma',
    bad_karma: 'Zła karma',
    reply: 'Odpowiedź',
    replies: 'odpowiedź | odpowiedzi',
    replied: 'Odpowiedział',
    reopen: 'Ponownie otwórz',
    close: 'Zamknij',
    mark_as_read: 'Oznacz jako przeczytane',
    save: 'Ratować',
    delete: 'Usuwać',
    archive: 'Archiwum',
    edit: 'Edytować',
    post: 'Post',
    pinned: 'Przypięty',
    pin: 'Przypinka',
    unpin: 'Rozpiąć',
    locked: 'Zablokowany',
    lock: 'Zamek',
    unlock: 'Odblokuj',
    add_comment: 'Dodaj komentarz...',
    comment_cant_reply_locked:
      'Nie można odpowiedzieć, ponieważ wątek komentarza jest zablokowany',
    comment_cant_edit_locked:
      'Nie można edytować, ponieważ wątek komentarza jest zablokowany',
    comment_max_pin_limit: 'Osiągnięto maksymalny limit komentarzy',
    comment_below_threshold:
      'Komentarz poniżej progu. Kliknij, aby wyświetlić.',
    comment_login_prompt: 'Zaloguj się, aby dołączyć do dyskusji!',
    comment_error_add: 'Nie udało się dodać komentarza',
    comment_error_edit: 'Nie udało się edytować komentarza',
    comment_error_delete: 'Nie udało się usunąć komentarza',
    comment_error_rate: 'Nie udało się ocenić komentarza',
    comment_error_update: 'Nie udało się zaktualizować komentarza',
    comments_error_fetch: 'Nie udało się załadować więcej komentarzy',
    discussion: 'Dyskusja',
    load_more_comments: 'Załaduj więcej komentarzy',
    comment_confirm_delete: 'Czy na pewno chcesz usunąć ten komentarz?',
    comment_deleted: 'Komentarz został pomyślnie usunięty',
    comments_disabled:
      'Komentarze są wyłączone ze względu na ustawienia kontroli rodzicielskiej na Twoim koncie.',
    comments_age_unverified:
      'Nie możesz dodać komentarza, dopóki Twój wiek nie zostanie zweryfikowany',
    review_settings: 'Przejrzyj ustawienia',

    // Mod admin
    mod_status: {
      pending_has_file: '{ugc} wymaga zgody moderatora gry, aby uruchomić grę.',
      pending_curation:
        'Stan {ugc} zmieni się na stan aktywny po dodaniu i zatwierdzeniu pliku.',
      pending_no_curation: 'Po dodaniu pliku {ugc} zmieni się na stan aktywny.',
      archived:
        '{ugc} został zarchiwizowany. Wszyscy subskrybenci zostali usunięci i nie można ich przeglądać ani odzyskać za pomocą żądań API.',
      hidden:
        '{ugc} jest ukryty i dostępny tylko dla subskrybentów i członków zespołu.',
      hidden_purchase_disabled:
        '{ugc} jest ukryty, ponieważ monetyzacja została wyłączona.',
      live: '{ugc} jest na żywo i dostępny dla wszystkich.',
    },
    mod_profile: 'profil {ugc}',
    media: 'Głoska bezdźwięczna',
    file_manager: 'Menedżer plików',
    step: 'KROK {step}',
    save_next: 'Zapisz i Dalej',
    auth_required: 'Uwierzytelnianie wymagane',
    public_text: '{ugc} można znaleźć na stronach przeglądania dla wszystkich.',
    private_text:
      '{ugc} jest dostępny tylko dla członków zespołu, istniejących subskrybentów i użytkowników z dostępem do podglądu.',
    edit_disabled_on_add:
      'Po utworzeniu tego {ugc} nie będziesz mógł wprowadzać zmian za pośrednictwem sieci.',
    edit_enabled_on_add:
      'Będziesz mógł wprowadzać zmiany w {ugc} po jego utworzeniu.',
    add_mod_monetized:
      'Ta gra obsługuje monetizowane {ugc1}. Jeśli planujesz zarabiać na tym {ugc2}, wybierz {private} na razie i zrób to {public} później po skonfigurowaniu zarabiania. Możesz skonfigurować monetyzację po utworzeniu {ugc2}.',
    share_access: 'Udostępnij dostęp',
    profile_editing_disabled:
      'Edycja profilu przez Internet została wyłączona przez grę.',
    tools_only_1:
      'Nie możesz przesłać tutaj {ugc} dla {game}, muszą one zostać przesłane za pomocą narzędzi stworzonych przez twórcę gry, aby pliki mogły zostać zweryfikowane. Aby uzyskać więcej informacji, zobacz {guides} napisane dla tej gry. ',
    tools_only_2: 'Oto instrukcje dostarczone przez twórcę gry:',
    tools_only_3:
      'Zalecamy powrót do listy {ugc} i przeglądanie linków stamtąd. Jeśli problem będzie się powtarzał, przejdź do naszego {help_center}, aby uzyskać więcej informacji.',
    unsaved_heading: 'Masz niezapisane zmiany',
    unsaved_confirm:
      'Są zmiany, które nie zostały zapisane, czy nadal chcesz odejść?',
    settings: 'Ustawienia',
    team: 'Zespoły',
    reports: 'Raporty',
    stats: 'Statystyki',
    moderator: 'Moderator',
    manager: 'Menedżer',
    error_get_mod: 'Nie udało się uzyskać {ugc}',
    archive_reason: 'Powód archiwizacji',
    view_mod: 'Wyświetl {ugc}',
    error_archive_mod: 'Nie udało się archiwizować {ugc}',
    archive_mod_prompt:
      'Archiwizacja tego {ugc} spowoduje anulowanie subskrypcji wszystkich użytkowników i usunięcie go z żądań API.',
    archive_mod_confirm:
      'Po zarchiwizowaniu do wszystkich członków zespołu zostanie wysłana wiadomość e-mail z powiadomieniem ich o tej akcji wraz z podanym powodem.\n\nTa akcja może zostać cofnięta tylko przez moderatorów, czy na pewno chcesz kontynuować?',

    headline_mod_profile: 'Utwórz swój profil {ugc}',
    headline_media: 'Dodaj multimedia do swojego profilu {ugc}',
    headline_files: 'Prześlij swój plik {ugc}',
    headline_permissions:
      'Ustaw uprawnienia do ponownego wykorzystania dla swojego {ugc}',
    headline_dependencies: 'Dodaj wszelkie zależności {ugc}',

    // Basics
    basics: 'Podstawy',
    logo: 'Logo',
    logo_prompt_1:
      'Plik obrazu, który będzie reprezentował logo Twojego {ugc}.',
    logo_prompt_2: '512x288 lub więcej',
    logo_prompt_3: 'Zalecany współczynnik proporcji 16:9',
    logo_prompt_4: 'Maksymalnie 8 MB',
    summary_placeholder:
      'Opowiedz nam o zmianach wprowadzonych przez użytkownika {ugc} w grze w 1 akapicie.',
    homepage: 'Strona domowa',
    profile_url: 'Adres URL profilu',
    visibility: 'Widoczność',
    visibility_tip:
      'Raz na żywo, publiczne {ugc} są widoczne dla wszystkich. Ukryte {ugc} są widoczne tylko dla członków zespołu i subskrybentów.',
    upload_images: 'Przesyłanie obrazów',
    mature_content: 'Zawiera dojrzałe treści',
    mature_content_alcohol: 'Alkohol',
    mature_content_drugs: 'Narkotyki',
    mature_content_violence: 'Przemoc',
    mature_content_explicit: 'Wyraźny',
    community: 'Społeczność',
    allow_comments: 'Zezwalaj na komentarze',
    allow_dependants: 'Zezwalaj osobom na utrzymaniu',
    create_mod: 'Utwórz {ugc}',
    error_mod_create: 'Nie udało się utworzyć {ugc}',
    error_mod_update: 'Nie udało się zaktualizować {ugc}',
    error_tags_update: 'Nie udało się zaktualizować tagów',
    success_create_mod: 'Pomyślnie utworzono {modname}',
    success_update_mod: 'Pomyślnie zaktualizowano {modname}',
    description_tip:
      'Opcjonalny opis użytkownika {ugc}, który może zawierać szczegóły, takie jak „Informacje”, „Funkcje”, „Użycie”, „FAQ” itp. Obsługiwane i zalecane HTML',

    // Media
    models: 'modele',
    media_reorder_hint:
      'Przeciągnij, aby zmienić kolejność istniejących obrazów lub upuść nowe pliki obrazów, aby je przesłać.',
    media_zip_hint_1:
      'Prześlij do {count} obrazów na raz, lub pojedynczy plik zip zawierający obrazy.',
    media_zip_hint_2: 'Obsługiwane formaty to .jpg, .jpeg, .png i .zip.',
    drag_and_drop_image: 'Przeciągnij i upuść obrazy, aby je przesłać',
    or_click_to_upload: 'Lub kliknij, aby wybrać plik',
    error_media_update: 'Aktualizacja nośnika nie powiodła się',
    error_media_add_links: 'Dodawanie linków multimedialnych nie powiodło się',
    error_media_remove_links: 'Nie udało się usunąć linków multimedialnych',
    success_media_updated: 'Pomyślnie zaktualizowano media',

    // File manager
    add_file: 'Dodawanie pliku',
    edit_file: 'Edytuj plik',
    select_zip: 'Wybierz plik zip',
    upload: 'Przesyłanie',
    file_id: 'Identyfikator pliku:',
    virus_none: 'Nie wykryto wirusa',
    virus_waiting: 'Czekam na skanowanie',
    virus_scanning: 'Skanowanie w toku',
    virus_too_large: 'Plik zbyt duży do skanowania',
    virus_not_found: 'Plik nie został znaleziony',
    virus_error: 'Błąd skanowania pliku',
    virus_found: 'Wykryto wirus',
    virus_risk:
      'Ten plik zawiera plik wykonywalny i należy zachować ostrożność przy otwarciu',
    version_placeholder: 'Numer wersji tj. 1.0.0',
    release_notes_placeholder: 'Wprowadź każdą zmianę w osobnym wierszu',
    game_moderator: 'Moderator gry',
    metadata_blob: 'Blob metadanych',
    metadata_blob_placeholder:
      'Wprowadź określone metadane, takie jak wersja gry, z którą jest kompatybilna ta wersja, jak ją zainstalować itp. Obsługiwane są prawidłowe dane UTF-8.',
    select_platforms: 'Platformy (wybierz wszystkie, które mają zastosowanie)',
    file_pending: 'Oczekiwanie na zatwierdzenie',
    file_approved: 'Zatwierdzony',
    file_approved_live: 'Zatwierdzony i aktywny',
    file_approved_not_live: 'Zatwierdzone, ale nie na żywo',
    file_denied: 'Odmowa',
    file_targeted: 'Ukierunkowany',
    live_file: 'Ten plik jest aktualnie dostępny.',
    file_is_live: 'Plik jest aktywny',
    file_is_not_live: 'Plik nie jest aktywny',
    no_delete_file_live: 'Nie można usunąć, ponieważ plik jest aktywny',
    make_file_live: 'Uruchom to wydanie',
    make_file_live_platforms:
      'Uruchom to wydanie na zatwierdzonych platformach',
    delete_file_prompt:
      'Czy na pewno chcesz usunąć ten plik? Tej czynności nie można cofnąć.',
    file_processing_title: 'Przetwarzanie plików',
    file_processing:
      'Twój plik jest przetwarzany. Możesz kontynuować przeglądanie witryny, ale nie zamykaj karty lub okna przeglądarki, dopóki nie zostanie zakończona.',
    file_instructions_1:
      'ZIP i prześlij folder bazowy swojego {ugc}, lub jeśli jest to zbiór plików, które znajdują się w wcześniej istniejącym folderze gry, należy je ZIP:',
    file_instructions_2: 'Musi być plikiem ZIP',
    file_instructions_3: 'Rozmiar pliku nie może przekraczać 20 GB',
    file_instructions_4:
      'Nazwy plików nie mogą zawierać żadnego z następujących znaków: \\ / ? " &lt; &gt; &#124; : *',
    file_instructions_5:
      '{ugc}, które nadpisują pliki nie są obsługiwane, chyba że gra to zarządza',
    file_instructions_6:
      '{ugc}, które obejmują wiele katalogów gier, nie są obsługiwane, chyba że gra to zarządza',
    file_terms: 'Zgadzam się na {terms} i {privacy}.',
    error_get_files: 'Nie udało się pobrać plików',
    error_upload_file_name: 'Nie udało się przesłać pliku {filename}',
    error_upload_file: 'Nie udało się przesłać pliku',
    error_update_file: 'Nie udało się zaktualizować pliku',
    error_delete_file: 'Nie udało się usunąć pliku',
    no_permission_delete_files: 'Nie masz uprawnień do usuwania plików',
    error_file_required: 'Plik jest wymagany',
    error_platform_required: 'Musisz wybrać co najmniej jedną platformę',
    success_file_uploaded: 'Plik przesłany pomyślnie',
    success_file_moderation:
      'Moderator dokona przeglądu platform wymagających moderacji',
    success_file_updated: 'Plik został pomyślnie zaktualizowany',
    error_no_approved_platforms: 'Brak platform do uruchomienia',
    error_no_approved_platforms_text:
      'Ten plik nie ma zatwierdzonych platform, które nie są obecnie dostępne',
    drag_and_drop_file: 'Przeciągnij i upuść plik, aby go przesłać',
    file_upload_hint:
      'Akceptowane są tylko pliki .zip | maksymalny rozmiar pliku {max}',
    upload_draft: 'Prześlij i zachowaj jako szkic',
    upload_publish: 'Prześlij i opublikuj',
    save_draft: 'Zapisz i zachowaj jako szkic',
    save_publish: 'Zapisz i opublikuj',
    keep_as_draft: 'Zachowaj jako szkic',
    publish_confirmation: 'Czy na pewno chcesz opublikować ten plik?',
    marketplace_file_hint:
      'Jeśli planujesz zmonetyzować ten {mod}, powinieś zachować ten plik jako szkic i skonfigurować monetyzację przed publikowaniem.',
    curation_file_hint:
      'Moderator gry musi zatwierdzić twój {mod}, zanim gracze będą mogli uzyskać do niego dostęp.',
    platform_file_hint:
      'Ta gra wymaga zatwierdzenia platformy dla każdego pliku {mod} dla wybranej platformy/platform: {platforms}.',
    two_step_approval_process:
      'Ta gra wymaga 2-etapowego procesu zatwierdzania:',
    two_step_approval_process_step1:
      'Zatwierdzenie moderatora gry dla tego pliku {mod} dla wybranej platformy/platform: {platforms}',
    two_step_approval_process_step2:
      'Zatwierdzenie moderatora gry, aby {mod} stał się aktywny',
    two_step_approval_process_live:
      'Opublikowanie tego pliku również automatycznie ustawi {mod} jako żywy po zakończeniu obu zatwierdzeń.',
    one_step_approval_process_live:
      'Opublikowanie tego pliku również automatycznie ustawi {mod} jako żywy po zatwierdzeniu.',

    // Reuse permissions form
    reuse_permissions: {
      heading: 'Ponowne wykorzystanie uprawnień',
      allow_redistribution:
        'Pozwól innym na przesyłanie moich zasobów {ugc} na inne strony, ale muszę zostać uznany za oryginalnego twórcę',
      allow_porting:
        'Pozwól innym na konwersję moich zasobów {ugc} do pracy w innych grach, ale muszę zostać uznany za oryginalnego twórcę',
      allow_patching_no_credit:
        'Zezwalaj innym na modyfikację moich zasobów {ugc} (w tym uwalnianie poprawek błędów lub ulepszeń) i udostępnij je jako nowy {ugc}',
      require_credit: 'Muszę zostać uznany za pierwotnego twórcę',
      require_permission: 'Najpierw zażądaj ode mnie zgody',
      require_repackage_no_credit:
        'Pozwól innym korzystać z moich {0} zasobów we własnym {1}',
      allow_resell:
        'Pozwól innym na używanie moich zasobów {ugc} w dowolnych plikach {ugc} /w dowolnych dziełach komercyjnych',
      original_assets:
        'Mój {ugc} zawiera w 100% oryginalne dzieło lub zasoby, które można redystrybuować',
      error_update: 'Nie udało się zaktualizować uprawnień ponownego użycia',
      success_update: 'Pomyślnie zaktualizowane uprawnienia ponownego',
      prompt:
        'Ustaw uprawnienia do wykorzystywania zasobów {ugc} do tworzenia treści innych osób. Udzielając zezwolenia innym osobom na używanie lub modyfikowanie Twoich plików, użytkownik przyjmuje do wiadomości, że takie zezwolenie nie może zostać cofnięte z mocą wsteczną w odniesieniu do utworów już utworzonych.',
    },

    // Dependencies form
    dependencies_prompt:
      'Wybierz {0} wymagane, aby ten {1} działał poprawnie (jeśli {1} nie jest wyświetlany, oznacza to, że nie zezwala na zależności i powinieneś skontaktować się z twórcą, aby go włączyć):',
    remove_dependency: 'Usuń zależność',
    dependants: 'Osoby na utrzymaniu',
    important: 'WAŻNY',
    error_update_dependencies: 'Aktualizacja zależności nie powiodła się',
    success_update_dependencies:
      'Pomyślnie zaktualizowano ustawienia zależności',
    dependants_warning_1:
      'Po zezwoleniu należy pamiętać, że {ugc} z podłączonymi osobami na utrzymaniu:',
    dependants_warning_2: 'Nie można wyłączyć osób zależnych',
    dependants_warning_3: 'Nie można usunąć',
    dependants_warning_4: 'Nie można zarabiać',
    no_dependants: 'Nie znaleziono osób pozostających na utrzymaniu',
    dependencies_allow_prompt:
      'Aby inne {ugc} dodać swoją osobę jako osobę zależną, musisz włączyć opcję Zezwalaj na zależne powyżej.',
    dependencies_deny_prompt:
      'Możesz wyłączyć opcję Zezwalaj na zależne powyżej, jeśli nie chcesz, aby inne {ugc} zaznaczały go jako zależność',
    dependencies_not_supported:
      'Zależności nie są obsługiwane przez {gamename}, wszystkie {ugc} muszą działać niezależnie i być całkowicie samodzielne.',
    dependency_disabled_monetization:
      'Zarabiany {ugc} nie może włączyć osób pozostających na utrzymaniu',
    dependency_disabled_dependants:
      'Nie można wyłączyć zależnych dla tego {ugc_single}, ponieważ zależą od niego inne {ugc_plural}. Można je wyświetlić na karcie zależności.',
    dependants_confirm_enable:
      'Ma to na celu zapewnienie stałej kompatybilności połączonego {ugc}. Potwierdź, aby włączyć.',
    dependants_confirm_disable:
      'Jesteś pewien, że chcesz zakazać osobom pozostającym na utrzymaniu? Oznacza to, że inne {0} nie będą mogły dodać twojego {1} jako zależności.',
    dependency_monetization_warning:
      '{game} pozwala na monetyzację {mod}. Monetyzacja obecnie nie obsługuje {mods} z zależnościami. Jeśli zamierzasz zmonetyzować ten {mod}, pomiń ten krok.',

    // Parental controls
    notify_parent_title: 'Powiadom rodzica lub opiekuna',
    notify_parent:
      'Jeśli zdecydujesz się kontynuować, Twój rodzic lub opiekun zostanie o tym powiadomiony i będzie musiał zatwierdzić zmiany, aby mogły wejść w życie.',
    confirm_notify_parent:
      'Czy chcesz wysłać powiadomienie do rodzica lub opiekuna z prośbą o dostęp do proponowanych zmian uprawnień?',
    request_access: 'Poproś o dostęp',

    // Cloud cooking
    cook_source: 'Utwórz plik źródłowy',
    source_file: 'Plik źródłowy',
    targeted_platform: 'Platforma docelowa',
    metadata: 'Metadane',
    cook_time: 'Czas gotowania',
    download_time: 'Czas pobierania',
    file_compression_time: 'Czas kompresji pliku',
    file_decompression_time: 'Czas dekompresji pliku',
    upload_time: 'Czas przesyłania',
    total_job_time: 'Całkowity czas pracy',
    logs: 'Dzienniki',
    view_logs: 'Wyświetl dzienniki',
    logs_available_on_completion:
      'Dzienniki będą dostępne po zakończeniu gotowania',
    logs_for_file: 'Gotuj dzienniki dla {file}.',
    no_logs: 'Nie znaleziono dzienników dla {file}.',
    get_logs_error: 'Nie udało się uzyskać dzienników gotowania',
    admin_only: 'Tylko dla administratora',
    queue: 'Kolejka',
    source_file_history: 'Historia pliku źródłowego',
    no_source_files_found: 'Nie znaleziono plików źródłowych',
    no_cooks_found: 'Nie znaleziono kucharzy',
    cook_jobs_available: 'Dostępne oferty pracy kucharza plików: {count}',
    view_details: 'Zobacz szczegóły',
    cloud_cooking: 'Gotowanie w chmurze',
    add_file_type: 'Dodaj nowy {string}',
    edit_file_type: 'Edytuj {string}',
    files: 'Akta',
    cook_details: 'Szczegóły dotyczące gotowania',
    status_queued: 'W kolejce',
    status_cooking: 'Gotowanie',
    status_success: 'Udany',
    status_failed: 'Przegrany',
    status_pending_moderation: 'Oczekuje na moderację',
    status_moderation_rejected: 'Cook odrzucił',
    get_cook_files_error: 'Nie udało się pobrać plików do gotowania w chmurze',
    get_source_files_error: 'Nie udało się pobrać plików źródłowych',
    download_file_error: 'Nie udało się pobrać pliku',
    source_instructions:
      'Prześlij plik źródłowy i wybierz odpowiednią platformę (lub platformy) poniżej. Plik zostanie następnie przetworzony przez Cloud Cooking, który wygeneruje osobne pliki dla poszczególnych platform.',

    // Marketplace
    marketplace: {
      available_stock: 'Dostępna ograniczona ilość – pozostało {count}',
      virtual_currency: 'Wirtualna waluta',
      marketplace: 'Rynek',
      order_summary: 'Podsumowanie zamówienia',
      payment_method: 'Metoda płatności | Metody płatności',
      wallet_balance: 'Saldo portfela',
      vc_balance: 'Wirtualne saldo waluty',
      credits: 'Kredyty',
      currency: 'Waluta',
      balance_after: 'Saldo po zakupie',
      token_purchase_success:
        'Dziękujemy za zakup. Twoja płatność została przetworzona, a pokwitowanie podatkowe zostanie wkrótce wysłane na Twój e-mail. Twoje saldo wirtualnej waluty zostało zaktualizowane dla {game}',
      transaction_id: 'Identyfikator transakcji',
      total_paid: 'Całkowita zapłacona kwota',
      agreement: 'Zgadzam się na mod.io {terms} i {refund}',
      change_payment: 'Zmień płatność',
      error_register: 'Nie udało się zarejestrować w celu zarabiania',
      error_wallet: 'Nie udało się uzyskać portfela gry',
      error_process: 'Nie można przetworzyć płatności',
      error_complete: 'Nie można ukończyć płatności',
      checkout: 'Zamówienie',
      vc_topup_confirmed: 'Potwierdzono doładowanie wirtualnej waluty',
      confirm_purchase: 'Potwierdź zakup',
      continue_browsing: 'Kontynuuj przeglądanie',
      back_to_mod: 'Powrót do zakupu {ugc}',
      ugc_not_refundable:
        'Zakupy {ugc_plural} nie podlegają zwrotowi. Przed zakupem tego {ugc} zapoznaj się z naszymi {terms} i {refund}.',
      ugc_purchase_success:
        'Dziękujemy za zakup. {ugc} został dodany do twoich subskrypcji w twoim {library} i jest dostępny w grze.',
      game_virtual_currency: 'Wirtualna waluta gry ({virtual_currency})',
      proceed_to_checkout: 'Przejdź do kasy',
      ugc_purchase_confirmed: '{ugc} zakup potwierdzony',
      error_already_purchased: 'Jesteś już właścicielem tego {ugc}',
      error_sku_packs: 'Nie udało się uzyskać cen {ugc}',
      error_payment_methods: 'Nie udało się uzyskać metod płatności',
      calculated_at_checkout: 'Obliczone przy kasie',
      subtotal: 'Suma częściowa',
      taxes: 'Podatki',
      total_due: 'Całkowita kwota należna',
      price: 'Cena',
      purchased: 'Zakupiony',
      purchases: 'Zakupiono {ugc}',
      no_purchases: 'Nie kupiłeś żadnego {ugc}',
      purchase_to_rate: 'Możesz ocenić tylko {ugc}, które kupiłeś',
      usd_ugc_license:
        'Zakup tego {ugc} natychmiast przyznaje kredyty {count} w zamian za licencję na dostęp do niego.',
      top_up: 'Doładuj',
      remaining_balance: 'Pozostałe saldo',
      not_enough_vc:
        'Nie masz wystarczającej ilości wirtualnej waluty, aby kontynuować. Doładuj swój portfel gry',
      error_virtual_currency_packs:
        'Nie udało się uzyskać pakietów walut wirtualnych',
      vc_prompt: 'Zdobądź pakiety wirtualnych walut',
      vc_description:
        'Wspieraj twórców treści i uzyskuj dostęp do treści premium, kupując pakiety wirtualnych walut dla {game}',
      vc_agreement:
        'Przed zakupem pakietu walut wirtualnych zapoznaj się z naszymi {terms} i {refund}. Wszelkie obowiązujące podatki są naliczane przy kasie.',
      error_session: 'Nie udało się uzyskać sesji zakupu',
      sold_out: 'Wyprzedane',
      currency_packs: 'Pakiety walutowe',
      cancel_transaction: 'Anuluj transakcję',
      cancel_transaction_text: 'Czy na pewno chcesz anulować tę transakcję?',
    },
  },
  ja: {
    language: '言語',

    // Nav
    browse: '閲覧',
    library: '図書館',
    my_content: 'マイコンテンツ',
    account: '私のアカウント',
    back: '戻る',
    more: 'もっと',
    add_mod: '{ugc} を追加',
    edit_mod: 'mod.io で編集',
    admin: '管理者',
    help_center: 'ヘルプセンター',
    subscribed_ugc: 'サブスクライブ済み {ugc}',
    followed_collections: 'フォローされているコレクション',
    page: 'ページ',

    // Guides
    guide: 'ガイド |ガイド',
    views: 'ビュー',
    table_of_contents: '目次',
    reading_time: '読書の時間',
    date_added: '追加日',
    date_updated: '更新日',
    minutes_read: '分読み',
    published: '発行済み',
    show_more_tags: '珍しいタグを表示',
    hide_more_tags: '珍しいタグを非表示にする',

    // Users
    joined: '参加しました',
    last_online: 'ラストオンライン',
    online: 'オンライン',
    followers: 'フォロワー',
    partner: '相棒',
    partnered_creator: '提携クリエイター',
    profile_hidden: 'このユーザーのプロフィールは非表示です',
    follow: 'フォローする',
    unfollow: 'フォローを解除する',
    following: 'フォロー中',
    user: 'ユーザー',
    user_update_error: 'ユーザーの更新に失敗しました',
    age_widget_error: '年齢ウィジェットの読み込みに失敗しました',

    // Mods
    mod: 'Mod | Mods',
    level: 'レベル |レベル',
    content: 'コンテンツ',
    subscribed: '購読中',
    tags: 'タグ',
    summary: '概要',
    contributors: '貢献者',
    description: '説明',
    dependencies: '依存関係',
    no_dependencies: 'この {ugc} には依存関係がありません',
    of: '/',
    ago: '前',
    and: 'そして',
    by: 'による',
    reset_filters: 'フィルターをリセット',
    show_more: 'もっと見せる',
    show_less: '表示を減らす',
    no_ugc_found: '{ugc_name} は見つかりませんでした',
    no_subscriptions: 'どの {ugc_name} も購読していません',
    mod_disclaimer_heading: '法的免責事項',
    mod_disclaimer_privacy: 'プライバシーポリシー',
    thumbs_up_received: '親指を受け取りました',
    thumbs_up: 'いいぞ',
    total_downloads: '総ダウンロード数',
    releases: 'リリース',
    bytes: 'バイト',
    local_mod_disabled:
      'この {ugc} は、1 つ以上の依存関係がないため読み込めません:{dependencies}',
    mod_with_collections: 'この {ugc} を含むコレクション',
    see_all_collections: '{count} の全コレクションを見る',
    mod_dependencies:
      'この {ugc} を動作させるには、すべての依存関係をインストールする必要があります。',
    mod_dependencies_prompt:
      'この {ugc} には必要な依存関係があります。そちらも購読しますか?',
    allow_in_collections: 'コレクションに追加できるようにする',
    allow_in_collections_tip:
      'このオプションを有効にすると、他のユーザーがあなたの{ugc}をコレクションに追加できるようになります。',

    // Actions
    login: 'ログイン',
    logout: 'ログアウト',
    search: '検索',
    clear_all: 'すべてクリア',
    download: 'ダウンロード',
    subscribe: '購読',
    unsubscribe: '購読解除',
    resubscribe: '再講読',
    activate: '有効化',
    deactivate: '無効化',
    like: 'いいね',
    dislike: '気に入らない',
    report: '問題を報告します',
    submit: '送信',
    cancel: 'キャンセル',
    done: '完了',
    select: '選択',
    previous: '前へ',
    next: '[次へ]',
    confirm: '確認',
    allow: '許可',
    manage: '管理',
    discard: '変更を破棄',
    more_actions: 'その他のアクション',
    manage_interaction_settings: 'インタラクション設定を管理',
    block: 'ブロック',
    block_user: 'ユーザーからの連絡をブロック',
    unblock: 'ブロック解除',
    user_blocked:
      'このユーザーをブロックしたため、あなたに連絡したり、あなたのコンテンツにコメントしたりできません。',
    block_user_tooltip:
      'このユーザーがあなたに連絡したり、あなたのコンテンツにコメントしたりすることを防ぎます。',
    block_prompt:
      'このユーザーをブロックしてもよろしいですか? このユーザーはあなたに連絡したり、あなたのコンテンツにコメントしたりできなくなります。',
    block_success: 'ユーザーを正常にブロックしました。',
    unblock_success: 'ユーザーのブロックを正常に解除しました。',
    unblock_prompt:
      'このユーザーのブロックを解除してもよろしいですか? このユーザーは再びあなたに連絡したり、あなたのコンテンツにコメントしたりできるようになります。',
    mute: 'ミュート',
    mute_user: 'ユーザーの{ugc}をミュート',
    unmute: 'ミュート解除',
    user_muted: 'このユーザーをミュートしたため、その {ugc} は表示されません。',
    mute_user_tooltip:
      'ゲームの閲覧中に、このユーザーが作成した{ugc}が表示されないようにします',
    mute_prompt:
      'このユーザーをミュートしてもよろしいですか?ゲームを閲覧しているときに、そのユーザーが送信した {ugc} は表示されなくなります。',
    mute_success: 'ユーザーを正常にミュートしました。',
    unmute_success: 'ユーザーのミュートを正常に解除しました。',
    unmute_prompt:
      'このユーザーのミュートを解除してよろしいですか?そのユーザーのコンテンツを再び表示できるようになります。',
    publish: '公開',
    block_error: 'ユーザーのブロック状態を更新できませんでした',
    mute_error: 'ユーザーのミュート状態を更新できませんでした',

    // Collections
    collection: 'コレクション | コレクション',
    total_mods: '合計 {ugc}',
    total_filesize: '合計ファイルサイズ',
    follow_collection: 'フォローコレクション',
    unfollow_collection: 'コレクションをフォロー解除する',
    compatibility: '互換性',
    compat_rating: '互換性評価',
    last_30_days: '過去 30 日間',
    all_time: '全時間',
    does_collection_work: 'このコレクションはあなたに合っていますか？',
    collection_works: 'はい、そうです',
    collection_doesnt_work: 'いいえ、そうではありません',
    collection_incomplete_subscriptions: 'サブスクリプションが不完全です',
    vote: '票',
    curator: 'キュレーター',
    creator_count: 'このコレクションには{count}人のクリエイターがいます',
    mods_in_collection: 'このコレクションに含まれるすべての {ugc}',
    mod_not_available: 'この {ugc} はご利用いただけなくなりました',
    unavailable: '利用不可',
    collection_sub_mods: 'このコレクションのすべての {ugc} を購読してください',
    collection_unsub_mods:
      'このコレクションのすべての {ugc} の購読を解除してください',
    collection_unsub_hint:
      'オフのままにしておくと、コレクションはライブラリから削除されますが、その {ugc} の購読は維持されます。',
    collection_error_subscribe: 'コレクション {ugc} の購読に失敗しました',
    collection_error_unsubscribe:
      'コレクション {ugc} の購読を解除できませんでした',
    collection_error_follow: 'コレクションをフォローできませんでした',
    collection_error_unfollow: 'コレクションのフォローを解除できませんでした',
    ugc_count: '{ugc} カウント',
    collections_incomplete:
      '一部の {ugc} は使用できないため、互換性に影響する可能性があります',
    adult: 'アダルト',
    view_more: '詳細を表示',
    view_less: '詳細を非表示',

    // Categories
    category: 'カテゴリー',
    miscellaneous: '雑多',
    essential: '必須',
    themed: 'テーマ',
    animation: '[アニメーション]',
    audio: 'オーディオ',
    bug_fixes: 'バグ修正',
    cheating: '不正行為',
    environment: '環境',
    gameplay: 'ゲームプレイ',
    quality_of_life: 'クオリティ・オブ・ライフ',
    ui: 'UI',
    visuals: 'ビジュアル',

    // Filters
    all: 'すべて',
    available: '利用可能',
    filesize: 'ファイルサイズ',
    downloads: 'ダウンロード数',
    todays_downloads: '今日のダウンロード数',
    subscribers: '購読ユーザー',
    rating: '評価',
    sort_by: '並べ替え',
    creator: 'クリエイター',
    apply: '適用する',
    reset: 'リセット',
    featured: '特徴',
    toggle_filters: 'フィルターを切り替えます',
    show_filters: 'フィルターを表示',
    hide_filters: 'フィルターを非表示',
    admin_options: '管理オプション',
    hidden: '隠れた',
    public: 'パブリック',
    private: 'プライベート',
    pending: '保留中',
    archived: 'アーカイブ済み',
    deleted: '削除されました',
    last_day: '最終日',
    hidden_monetization_disabled:
      '収益化が無効になっているため非表示になります',
    date_live: 'デートライブ',
    last_week: '先週',
    last_month: '先月',
    last_3_months: '過去 3 か月',
    last_year: '去年',
    exclude: '除外',
    no_matching_content: '一致するコンテンツはありません',
    content_type: 'コンテンツタイプ',
    free: '無料',
    premium: 'プレミアム',

    // Login
    signup: 'ログインまたはメールアドレスで登録',
    login_with: '{service}でログインします',
    email_placeholder: 'メールアドレス',
    code_placeholder: '5 桁のコード',
    have_code: 'コードを持っています',
    send_new_code: '新しいコードを送信',
    login_disclaimer:
      '{game} のユーザー生成コンテンツは mod.io によって管理されています。',
    terms_disclaimer: `「ログイン」を押すと{studioterms}、mod.io の {terms} と {privacy} に同意し、{min_age} 歳以上であることを確認したことになります。`,
    terms_disclaimer_studio: '、{studio} の {terms}',
    terms_disclaimer_studio_separator: '、',
    terms_disclaimer_studio_and: ' と ',
    code_error: 'コードをリクエストできません。',
    or: 'または',
    login_prompt:
      'アクセスしようとしているページには認証が必要です。続行するにはログインしてください。',
    receive_code: 'コードを受け取っていませんか？',
    resend_code: 'コードを再送信',
    login_with_email: 'メールでログイン',
    otp_email:
      'ワンタイムパスコード（OTP）を{email}に送信しました。続行するには入力してください。',
    back_to_login: 'ログインオプションに戻る',

    // Terms
    terms: '利用規約',
    privacy: 'プライバシーポリシー',
    aup: '利用規約',
    monetization: '収益化条件',
    game: 'ゲーム規約',
    api: 'APIアクセス規約',
    refund: '返金ポリシー',
    effective: 'から有効',

    // Report
    report_heading: 'この {ugc} を報告してください',
    report_intro:
      '以下のフォームを使用して、コンテンツに関する問題、mod.io {terms} の違反を報告したり、{dmca} を送信したりできます。',
    report_intro_collection:
      '以下のフォームを使用して、コンテンツに関する問題、mod.io {terms} の違反を報告できます。',
    report_details:
      'レポートの解決を容易にするために、すべての関連情報を必ず含めてください。この情報はゲームのモデレーターと共有され、また、侵害の疑いのあるコンテンツを投稿したユーザーと共有される可能性があることに注意してください。',
    report_not_working_prompt:
      '「動作しない」レポートはコンテンツ作成者と直接共有されます。',
    dmca: 'DMCA に関わる苦情',
    report_reason: '報告理由',
    urls: '違反のある URL',
    urls_placeholder: 'URL（1 行ずつ）',
    company_or_name: '会社またはあなたの名前',
    email: 'メール',
    address: 'アドレス',
    country: '国/地域',
    country_placeholder: '国/地域を選択してください',
    details: '侵害・違反の詳細',
    details_placeholder:
      'レポートの解決に役立てるため、できるだけ詳細とコンテキストを提供してください。',
    dmca_1:
      '{mod_io} は他者の知的財産権を尊重しており、当社のネットサイトとサービスをご利用のすべての方にも同様のことを求めています。当社のいずれかのネットサイトまたはサービスにおいて、著作権侵害にあたる何らかの方法で自分の作品が複製されていると思われる場合は、以下のフォームを使用して mod.io の著作権代理人に通知することができます。',
    dmca_2:
      '著作権侵害の申し立てを提出することは、重大な法的事項です。続行する前に、直接個人に連絡し、申し立ての内容に対処することを検討してください。適切な法的手続きをとらずとも対処できる単純な誤解である可能性もあります。',
    dmca_3:
      'デジタルミレニアム著作権法第 512 条(f) に基づき、作品または活動が侵害しているとして、故意に重大な虚偽を訴える者は、損害賠償責任を負う可能可能性があることに注意してください。また、この法的通知で提供される情報は第三者と共有されたり、公開されたりする可能性があることにも注意してください。',
    claim_check:
      '以下のチェックボックスをオンにしてこの申し立てを提出することにより、私は、偽証罪の罰則付きにより、以下のことを表明します。',
    copyright_owner: '私は著作権所有者です。',
    copyright_auth_owner:
      '私は、この状況において、著作権所有者に代わって行動する権限を有しています。',
    authorization: '許可',
    authorization_check:
      '私は、この申し立てに記載されている作品の使用が著作権所有者、その代理人、または法によって許可されていないと確信しています。',
    acknowledgement: '同意',
    acknowledgement_check:
      '私は、DMCA の第 512 条(f) に基づき、作品または活動が侵害しているとして故意に重大な虚偽を訴えた者は、損害賠償責任を負う可能性があることを認めます。',
    required: '必須',
    signature: '署名',
    signature_placeholder:
      'このボックスにデジタル署名として機能する氏名を入力してください。',
    report_success_title: 'あなたの報告を受領いたしました。',
    report_success_text:
      'ご報告の解決にあたり、より詳しい情報が必要な場合は、ご連絡させていただく場合がございます。詳細をお知らせいただきありがとうございます。',
    report_error_title: '報告を提出できませんでした',
    report_email_inform: 'メールアドレスは、この報告の処理にのみ使用されます。',

    // Table
    name: '名前',
    added: '追加',
    updated: '更新',
    date: '日付',
    item: '項目',
    file: 'ファイル',
    version: 'バージョン',
    scan: 'ウイルススキャン',
    actions: 'アクション',
    status: 'ステータス',
    role: '役割',
    live: 'ライブ',
    locally_installed: 'ローカルにインストール済み',

    // Releases
    download_from_game_client: 'ゲームクライアントから {mod} をダウンロード',
    download_payment_required: '購入して {ugc} をダウンロード',
    download_auth_required: 'ログインして {ugc} をダウンロード',
    release_notes: 'リリースノート',
    no_release_notes: 'リリースノートはありません',
    previous_releases: '以前のリリース',
    view_previous_releases: '以前のリリースを表示する',
    no_previous_releases: '以前のリリースはありません',
    no_files_published: 'ファイルは公開されていません',
    download_files_manually: 'ファイルを手動でダウンロードする',
    platforms: 'プラットフォーム | プラットフォーム',

    // Ratings
    overwhelmingly_positive: '圧倒的にポジティブ',
    overwhelmingly_negative: '圧倒的にネガティブ',
    very_positive: '非常にポジティブ',
    very_negative: '非常にネガティブ',
    mostly_positive: 'ほとんどがポジティブ',
    mostly_negative: 'ほとんどがネガティブ',
    negative: 'ネガティブ',
    positive: 'ポジティブ',
    mixed: 'どちらでもない',
    unrated: '未評価',

    // Sort
    sort_comments: 'コメント',
    sort_total_mods: '総改造数',
    sort_trending: 'トレンド',
    sort_highest_rated: '最高評価',
    sort_most_popular: '最も人気のある',
    sort_most_subscribers: 'ほとんどの購読者',
    sort_recently_added: '最近追加された',
    sort_last_updated: '最終更新',
    sort_alphabetical: 'アルファベット順',
    sort_smallest_filesize: '最小ファイルサイズ',

    // Report Reason
    report_dmca: 'DMCA',
    report_not_working: '動作していません',
    report_rude_content: '失礼なコンテンツ',
    report_illegal_content: '違法なコンテンツ',
    report_stolen_content: '盗まれたコンテンツ',
    report_false_information: '虚偽の情報',
    report_other: 'その他',

    // Report not working reasons
    report_crash: 'クラッシュゲーム',
    report_no_load: '読み込まない',
    report_conflicts: '他の {ugc} との競合',
    report_missing_deps: '依存関係が欠落している',
    report_install_issues: 'インストールの問題',
    report_bugs: 'バグっぽい動作',
    report_incompatability: 'ゲームのバージョンと互換性がありません',
    report_corrupt: '破損したファイル',

    // Errors
    warning: '警告',
    error_ref: 'エラーコード: ',
    login_fail: 'ログインに失敗しました',
    login_fail_message:
      'ログインに失敗しました。ちょっと待って、もう一度やり直してください。',
    subscribe_fail: '購読に失敗しました',
    unsubscribe_fail: '登録解除に失敗しました',
    error: 'エラー',
    default_error_message:
      'エラーが発生しました。すぐにもう一度お試しください。',
    follow_error: 'フォローに失敗しました',
    unfollow_error: 'フォローを解除できませんでした',
    upload_file_error:
      '続行するには、少なくとも1つのファイルをアップロードする必要があります',

    agreement_not_found: '合意が見つかりません',
    form_chars_remaining: '{count}文字が残っています。',
    form_not_enough_chars: '{count}より多くの文字が必要です。',
    filter: 'フィルター',
    loading: '読み込み',
    next_version: '次のバージョン',
    no_results_found: '結果が見つかりません',
    page_not_found: 'ページが見つかりません！',
    previous_version: '前のバージョン',
    take_me_home: '家まで連れて帰ってください',
    validation_alpha_num:
      'フィールドには数字または文字のみを含めることができます',
    validation_size: 'フィールドは{size}文字でなければなりません',
    validation_url: 'フィールドはURLでなければなりません',
    validation_min: '最小 {min} 文字数',
    validation_max: '最大{max}文字 {max}',
    validation_email: 'フィールドは電子メールでなければなりません',
    validation_checked: 'フィールドを確認する必要があります',
    validation_required: 'フィールドは必須項目です',
    validation_name:
      'フィールドには文字と名前関連の記号のみを含めることができます',
    validation_image:
      'ファイルは有効な JPEG または PNG 画像でなければなりません',
    validation_youtube: 'フィールドは有効な YouTube URL でなければなりません',
    validation_sketchfab:
      'フィールドは有効な Sketchfab URL でなければなりません',
    validation_zip: 'ファイルは ZIP である必要があります',
    validation_filesize: 'ファイルサイズは {size} を超えてはいけません',
    delete_image: '画像を削除',
    confirm_delete_image: 'この画像を本当に削除しますか？',

    comment: 'コメント',
    team_member: 'チームメンバー',
    game_admin: 'ゲーム管理者',
    site_admin: 'サイト管理者',
    author: '著者',
    good_karma: '良いカルマ',
    bad_karma: '悪いカルマ',
    reply: '返事',
    replies: '返信 |返信する',
    replied: '返信済み',
    reopen: '再度開く',
    close: '閉じる',
    mark_as_read: '既読にする',
    save: '保存',
    delete: '消去',
    archive: '[アーカイブ]',
    edit: '編集',
    post: '役職',
    pinned: 'ピン留め',
    pin: 'ピン',
    unpin: 'ピン留め解除',
    locked: 'ロックされています',
    lock: '[ロック]',
    unlock: 'ロック解除',
    add_comment: 'コメントを追加...',
    comment_cant_reply_locked:
      'コメントスレッドがロックされているため返信できません',
    comment_cant_edit_locked:
      'コメントスレッドがロックされているため編集できません',
    comment_max_pin_limit: 'ピン留めされたコメントの最大制限に達しました',
    comment_below_threshold:
      'コメントがしきい値を下回っています。クリックすると表示されます。',
    comment_login_prompt: 'ログインしてディスカッションに参加してください！',
    comment_error_add: 'コメントを追加できませんでした',
    comment_error_edit: 'コメントの編集に失敗しました',
    comment_error_delete: 'コメントを削除できませんでした',
    comment_error_rate: 'コメントの評価に失敗しました',
    comment_error_update: 'コメントを更新できませんでした',
    comments_error_fetch: 'より多くのコメントをロードできませんでした',
    discussion: '議論',
    load_more_comments: 'より多くのコメントを読み込みます',
    comment_confirm_delete: 'このコメントを削除したいですか？',
    comment_deleted: 'コメントは正常に削除されました',
    comments_disabled:
      'アカウントのペアレンタルコントロール設定により、コメントは無効になっています。',
    comments_age_unverified:
      '年齢確認が完了するまでコメントを追加することはできません',
    review_settings: '設定を確認する',

    // Mod admin
    mod_status: {
      pending_has_file:
        '{ugc} を公開するには、ゲームモデレーターの承認が必要です。',
      pending_curation:
        'ファイルが追加され承認されると、{ugc} はライブステータスに変わります。',
      pending_no_curation:
        'ファイルが追加されると、{ugc} はライブステータスに変わります。',
      archived:
        '{ugc} はアーカイブされました。すべてのサブスクライバーが削除され、API リクエストで表示したり取得したりすることはできません。',
      hidden:
        '{ugc} は非表示になっており、購読者とチームメンバーのみが利用できます。',
      hidden_purchase_disabled:
        '収益化が無効になっているため、{ugc} は非表示になっています。',
      live: '{ugc} はライブで、誰でもプレイできます。',
    },
    mod_profile: '{ugc} プロフィール',
    media: 'メディア',
    file_manager: 'ファイルマネージャー',
    step: 'ステップ{step}',
    save_next: '保存して次へ',
    auth_required: '認証が必要です',
    public_text: '{ugc} はブラウズページで誰でも見つけることができます。',
    private_text:
      '{ugc} にアクセスできるのは、チームメンバー、既存の購読者、およびプレビューアクセス権を持つユーザーのみです。',
    edit_disabled_on_add:
      'この {ugc} が作成されると、Web 経由で変更を加えることはできません。',
    edit_enabled_on_add: '{ugc} は作成後に変更できます。',
    add_mod_monetized:
      'このゲームは収益化された {ugc1} をサポートしています。この {ugc2} をマネタイズする予定なら、とりあえず {private} を選択し、マネタイズを設定した後で {public} にしてください。{ugc2} を作成したら、収益化を設定できます。',
    share_access: '共有アクセス',
    profile_editing_disabled:
      'ウェブ経由のプロフィール編集は、ゲームによって無効になっています。',
    tools_only_1:
      '{game} の {ugc} をここにアップロードすることはできません。ファイルを検証するには、ゲーム開発者が作成したツールを使用してアップロードする必要があります。詳細については、このゲーム用に書かれた {guides} を参照してください。',
    tools_only_2: 'ゲーム開発者が提供する手順は次のとおりです。',
    tools_only_3:
      '{ugc} リストに戻り、そこからリンクを参照することをお勧めします。問題が解決しない場合は、{help_center} にアクセスして詳細を確認してください。',
    unsaved_heading: '変更が保存されていません',
    unsaved_confirm:
      '保存されていない変更がありますが、そのまま保存してもよろしいですか?',
    settings: '[設定]',
    team: 'チーム',
    reports: 'レポート',
    stats: '統計情報',
    moderator: 'モデレーター',
    manager: 'マネージャー',
    error_get_mod: '{ugc} を取得できませんでした',
    archive_reason: 'アーカイブする理由',
    view_mod: '{ugc} を表示',
    error_archive_mod: '{ugc} をアーカイブできませんでした',
    archive_mod_prompt:
      'この {ugc} をアーカイブすると、すべてのユーザーのサブスクライブが解除され、API リクエストから削除されます。',
    archive_mod_confirm:
      'アーカイブされると、チームメンバー全員にこのアクションを通知するメールが送信され、その旨と理由が示されます。\n\nこのアクションはモデレーターのみが元に戻すことができます。続行してもよろしいですか?',

    headline_mod_profile: '{ugc} プロフィールを作成する',
    headline_media: '{ugc} プロフィールにメディアを追加する',
    headline_files: '{ugc} ファイルをアップロードします',
    headline_permissions: '{ugc} の再利用権限を設定する',
    headline_dependencies: '{ugc} 依存関係を追加します',

    // Basics
    basics: '基本',
    logo: '[ロゴ]',
    logo_prompt_1: '{ugc} のロゴを表す画像ファイル。',
    logo_prompt_2: '512 x 288 またはそれ以上',
    logo_prompt_3: '16:9 のアスペクト比を推奨',
    logo_prompt_4: '最大 8 メガバイト',
    summary_placeholder:
      '{ugc} がゲームに加えた変更について、1段落で教えてください。',
    homepage: 'ホームページ',
    profile_url: 'プロフィール URL',
    visibility: '可視性',
    visibility_tip:
      '公開後、公開 {ugc} はすべてのユーザーに表示されます。非表示の {ugc} はチームメンバーと購読者のみに表示されます。',
    upload_images: '画像をアップロード',
    mature_content: '成人向けコンテンツを含む',
    mature_content_alcohol: 'アルコール',
    mature_content_drugs: '医薬品',
    mature_content_violence: '暴力',
    mature_content_explicit: 'エクスプリシット',
    community: 'コミュニティ',
    allow_comments: 'コメントを許可',
    allow_dependants: '扶養家族を許可',
    create_mod: '{ugc} を作成',
    error_mod_create: '{ugc} を作成できませんでした',
    error_mod_update: '{ugc} を更新できませんでした',
    error_tags_update: 'タグを更新できませんでした',
    success_create_mod: '{modname} が正常に作成されました',
    success_update_mod: '{modname} は正常に更新されました',
    description_tip:
      '{ugc} の説明(オプション)には、「概要」、「機能」、「使用方法」、「よくある質問」などの詳細を含めることができます。HTMLがサポートおよび推奨されています',

    // Media
    models: 'モデル',
    media_reorder_hint:
      'ドラッグして既存の画像を並べ替えるか、新しい画像ファイルをドロップしてアップロードします。',
    media_zip_hint_1:
      '一度に最大{count}枚の画像、または画像を含む単一のzipファイルをアップロードします。',
    media_zip_hint_2: 'サポートされている形式は .jpg、.jpeg、.png、.zip です。',
    drag_and_drop_image: '画像をドラッグ&ドロップしてアップロード',
    or_click_to_upload: 'またはクリックしてファイルを選択',
    error_media_update: 'メディアを更新できませんでした',
    error_media_add_links: 'メディアリンクを追加できませんでした',
    error_media_remove_links: 'メディアリンクを削除できませんでした',
    success_media_updated: 'メディアが正常に更新されました',

    // File manager
    add_file: 'ファイルを追加',
    edit_file: '[ファイルを編集]',
    select_zip: 'ZIP ファイルを選択',
    upload: 'アップロード',
    file_id: 'ファイル ID:',
    virus_none: 'ウイルスは検出されませんでした',
    virus_waiting: 'スキャン待ち',
    virus_scanning: 'スキャン中',
    virus_too_large: 'ファイルが大きすぎてスキャンできない',
    virus_not_found: 'ファイルが見つかりません',
    virus_error: 'ファイルのスキャン中にエラーが発生しました',
    virus_found: 'ウイルスが検出されました',
    virus_risk:
      'このファイルには実行ファイルが含まれているため、開く際には注意が必要です。',
    version_placeholder: 'バージョン番号、すなわち 1.0.0',
    release_notes_placeholder: 'それぞれの変更を 1 行ずつ入力してください。',
    game_moderator: 'ゲームモデレーター',
    metadata_blob: 'メタデータブロブ',
    metadata_blob_placeholder:
      'このリリースに対応するゲームのバージョン、インストール方法など、特定のメタデータを入力します。UTF-8の有効なデータがサポートされます。',
    select_platforms: 'プラットフォーム (該当するものをすべて選択)',
    file_pending: '承認待ち',
    file_approved: '承認済み',
    file_approved_live: '承認済みで稼働中',
    file_approved_not_live: '承認済みだが公開されていない',
    file_denied: '拒否',
    file_targeted: 'ターゲット',
    live_file: 'このファイルは現在公開中です。',
    file_is_live: 'ファイルはライブです',
    file_is_not_live: 'ファイルはライブではありません',
    no_delete_file_live: 'ファイルはライブなので削除できません',
    make_file_live: 'このリリースを公開する',
    make_file_live_platforms:
      'このリリースを承認済みのプラットフォーム向けに公開する',
    delete_file_prompt:
      'このファイルを削除してよろしいですか?このアクションは元に戻せません。',
    file_processing_title: 'ファイル処理',
    file_processing:
      'ファイルは処理中です。引き続きサイトを閲覧することはできますが、終了するまでタブやブラウザウィンドウを閉じないでください。',
    file_instructions_1:
      '{ugc} のベースフォルダをZIPしてアップロードします。既存のゲームフォルダにあるファイルの集まりである場合は、それらのファイルをZIPしてください。',
    file_instructions_2: 'ZIP ファイルである必要があります',
    file_instructions_3: 'ファイルサイズは 20 GB を超えることはできません',
    file_instructions_4:
      'ファイル名には次の文字を含めることはできません: \\ / ? " &lt; &gt; &#124; : *',
    file_instructions_5:
      'ファイルを上書きする {ugc} は、ゲームがこれを管理しない限りサポートされません',
    file_instructions_6:
      '複数のゲームディレクトリにまたがる {ugc} は、ゲームがこれを管理しない限りサポートされません',
    file_terms: '{terms} と {privacy} に同意します。',
    error_get_files: 'ファイルを取得できませんでした',
    error_upload_file_name: 'ファイル {filename} のアップロードに失敗しました',
    error_upload_file: 'ファイルをアップロードできませんでした',
    error_update_file: 'ファイルの更新に失敗しました',
    error_delete_file: 'ファイルを削除できませんでした',
    no_permission_delete_files: 'ファイルを削除する権限がありません',
    error_file_required: 'ファイルが必要です',
    error_platform_required:
      '少なくとも 1 つのプラットフォームを選択する必要があります',
    success_file_uploaded: 'ファイルは正常にアップロードされました',
    success_file_moderation:
      'モデレーターは、モデレーションが必要なプラットフォームをレビューします',
    success_file_updated: 'ファイルは正常に更新されました',
    error_no_approved_platforms: 'ライブに設定するプラットフォームはありません',
    error_no_approved_platforms_text:
      'このファイルには、現在稼働していない承認済みのプラットフォームはありません',
    drag_and_drop_file: 'ファイルをドラッグ&ドロップしてアップロード',
    file_upload_hint: '.zipファイルのみ受け付け | {max} 最大ファイルサイズ',
    upload_draft: 'アップロードして下書きとして保存',
    upload_publish: 'アップロードして公開',
    save_draft: '下書きとして保存',
    save_publish: '保存して公開',
    keep_as_draft: '下書きとして保存',
    publish_confirmation: 'このファイルを公開してもよろしいですか？',
    marketplace_file_hint:
      'この{mod}を収益化する予定がある場合は、このファイルを下書きとして保存し、公開する前にまず収益化を設定する必要があります。',
    curation_file_hint:
      'ゲームモデレーターがプレイヤーがアクセスできるようになる前に、あなたの{mod}を承認する必要があります。',
    platform_file_hint:
      'このゲームは選択されたプラットフォームの各{mod}ファイルにプラットフォームの承認が必要です：{platforms}。',
    two_step_approval_process: 'このゲームは2段階の承認プロセスが必要です：',
    two_step_approval_process_step1:
      '選択されたプラットフォームのこの{mod}ファイルに対するゲームモデレーターの承認：{platforms}',
    two_step_approval_process_step2:
      '{mod}をライブにするためのゲームモデレーターの承認',
    two_step_approval_process_live:
      'このファイルを公開すると、両方の承認が完了したら自動的に{mod}もライブに設定されます。',
    one_step_approval_process_live:
      'このファイルを公開すると、承認されたら自動的に{mod}もライブに設定されます。',

    // Reuse permissions form
    reuse_permissions: {
      heading: '権限を再利用する',
      allow_redistribution:
        '他の人が私の {ugc} アセットを他のサイトにアップロードすることを許可するが、私は元の作成者としてクレジットされなければならない',
      allow_porting:
        '他の人が私の {ugc} アセットを他のゲームで使用できるように変換することを許可するが、私は元の作成者としてクレジットされなければならない',
      allow_patching_no_credit:
        '他のユーザーが私の {ugc} アセットを変更し（バグ修正や改善のリリースを含む）、新しい {ugc} としてリリースできるようにする',
      require_credit:
        '私はオリジナルクリエイターとしてクレジットされなければなりません',
      require_permission: '最初に私の許可を要求',
      require_repackage_no_credit:
        '自分の {0} アセットを自分の {1} で使用することを他のユーザーに許可する',
      allow_resell:
        '他の人が私の {ugc} アセットを任意の商用作品の任意の {ugc} /ファイルで使用できるようにする',
      original_assets:
        '私の {ugc} には 100% オリジナルの作品、または再配布可能なアセットが含まれています',
      error_update: '再利用権限を更新できませんでした',
      success_update: '再利用権限が正常に更新されました',
      prompt:
        '自分の {ugc} アセットを他のユーザーのコンテンツ作成にどのように使用できるかについての権限を設定します。他の人にあなたのファイルを使用または変更する許可を与えることで、既に作成された作品に関してそのような許可をさかのぼって取り消すことはできないことを認めたものとみなされます。',
    },

    // Dependencies form
    dependencies_prompt:
      'この {1} が正しく機能するには、必要な {0} を選択してください ({1} が表示されない場合は依存関係が許可されていないため、作成者に連絡して有効にしてください)。',
    remove_dependency: '依存関係を削除',
    dependants: '扶養家族',
    important: '重要',
    error_update_dependencies: '依存関係の更新に失敗しました',
    success_update_dependencies: '依存関係の設定が正常に更新されました',
    dependants_warning_1:
      '許可されると、扶養家族が接続されている {ugc} は次の点に注意してください。',
    dependants_warning_2: '依存関係を無効にできない',
    dependants_warning_3: '削除できません',
    dependants_warning_4: '収益化できない',
    no_dependants: '扶養家族が見つかりません',
    dependencies_allow_prompt:
      '他の {ugc} で自分の扶養家族を追加するには、上記の [扶養家族を許可] をオンにする必要があります。',
    dependencies_deny_prompt:
      '他の {ugc} に依存関係として選択させたくない場合は、上記の [依存を許可] をオフにできます',
    dependencies_not_supported:
      '依存関係は {gamename} ではサポートされていません。すべての {ugc} は独立して実行され、完全に自己完結型でなければなりません。',
    dependency_disabled_monetization:
      '収益化された {ugc} では扶養家族を有効にできません',
    dependency_disabled_dependants:
      '他の {ugc_plural} は依存しているため、この {ugc_single} の依存関係を無効にすることはできません。これらは依存関係タブから確認できます。',
    dependants_confirm_enable:
      'これは、接続された {ugc} の継続的な互換性を確保するためです。有効にすることを確認してください。',
    dependants_confirm_disable:
      '本当に扶養家族を拒否してもよろしいですか？つまり、他の {0} はあなたの {1} を依存関係として追加できなくなります。',
    dependency_monetization_warning:
      '{game}は{mod}の収益化を許可しています。収益化は現在、依存関係を持つ{mods}をサポートしていません。この{mod}を収益化する予定がある場合は、このステップをスキップしてください。',

    // Parental controls
    notify_parent_title: '親または保護者に通知する',
    notify_parent:
      '続行すると、変更が有効になる前に親または保護者に通知され、承認が必要になります。',
    confirm_notify_parent:
      '提案された権限の変更へのアクセスを要求する通知を親または保護者に送信しますか?',
    request_access: 'アクセスをリクエストする',

    // Cloud cooking
    cook_source: 'ソースファイルを作成する',
    source_file: 'ソースファイル',
    targeted_platform: 'ターゲットプラットフォーム',
    metadata: 'メタデータ',
    cook_time: '調理時間',
    download_time: 'ダウンロード時間',
    file_compression_time: 'ファイル圧縮時間',
    file_decompression_time: 'ファイルの解凍時間',
    upload_time: 'アップロード時間',
    total_job_time: '合計作業時間',
    logs: 'ログ',
    view_logs: 'ログを表示',
    logs_available_on_completion: 'ログはクック完了後に利用できます',
    logs_for_file: '{file} のクックログ。',
    no_logs: '{file} のログが見つかりません。',
    get_logs_error: 'クックログを取得できませんでした',
    admin_only: '管理者のみ',
    queue: '列',
    source_file_history: 'ソースファイル履歴',
    no_source_files_found: 'ソースファイルが見つかりません',
    no_cooks_found: '料理人が見つかりません',
    cook_jobs_available: '利用可能なファイルクックジョブ:{count}',
    view_details: '詳細を表示',
    cloud_cooking: 'クラウドクッキング',
    add_file_type: '新しい{string}を追加する',
    edit_file_type: '{string}を編集',
    files: 'ファイル',
    cook_details: '料理の詳細',
    status_queued: 'キューに登録',
    status_cooking: '料理',
    status_success: '成功',
    status_failed: '失敗した',
    status_pending_moderation: '審査待ち',
    status_moderation_rejected: 'クックは拒否した',
    get_cook_files_error: 'クラウドクッキングファイルの取得に失敗しました',
    get_source_files_error: 'ソースファイルの取得に失敗しました',
    download_file_error: 'ファイルのダウンロードに失敗しました',
    source_instructions:
      'ソースファイルをアップロードし、以下のプラットフォームを選択してください。ファイルはCloud Cookingで処理され、各プラットフォーム用の個別のファイルが生成されます。',

    // Marketplace
    marketplace: {
      available_stock: '数量限定 - 残り {count} 個',
      virtual_currency: '仮想通貨',
      marketplace: 'マーケットプレイス',
      order_summary: '注文概要',
      payment_method: '支払い方法 | 支払い方法',
      wallet_balance: 'ウォレット残高',
      vc_balance: '仮想通貨残高',
      credits: 'クレジット',
      currency: '通貨',
      balance_after: '購入後の残高',
      token_purchase_success:
        'ご購入いただきありがとうございます。お支払いが処理され、まもなく納税証明書がEメールに送信されます。{game} の仮想通貨残高が更新されました',
      transaction_id: 'トランザクション ID',
      total_paid: '支払総額',
      agreement: 'mod.io の {terms} と {refund} に同意します',
      change_payment: '支払いを変更',
      error_register: '収益化のための登録に失敗しました',
      error_wallet: 'ゲームウォレットの取得に失敗しました',
      error_process: '支払いを処理できません',
      error_complete: '支払いを完了できません',
      checkout: 'チェックアウト',
      vc_topup_confirmed: '仮想通貨のチャージが確認されました',
      confirm_purchase: '購入を確認',
      continue_browsing: '閲覧を続ける',
      back_to_mod: '{ugc} 購入に戻る',
      ugc_not_refundable:
        '{ugc_plural} 件の購入は返金されません。この {ugc} を購入する前に、弊社の {terms} と {refund} をご覧ください。',
      ugc_purchase_success:
        'ご購入いただきありがとうございます。{ugc} が {library} のサブスクリプションに追加され、ゲーム内でご利用いただけるようになりました。',
      game_virtual_currency: 'ゲーム用仮想通貨 ({virtual_currency})',
      proceed_to_checkout: 'チェックアウトに進む',
      ugc_purchase_confirmed: '{ugc} の購入が確認されました',
      error_already_purchased: 'この {ugc} はすでに所有しています',
      error_sku_packs: '{ugc} 価格を取得できませんでした',
      error_payment_methods: '支払い方法を取得できませんでした',
      calculated_at_checkout: 'チェックアウト時に計算',
      subtotal: '小計',
      taxes: '税金',
      total_due: '未払い金額',
      price: '価格',
      purchased: '購入済み',
      purchases: '{ugc} を購入しました',
      no_purchases: '{ugc} を購入していません',
      purchase_to_rate: '評価できるのは、購入した {ugc} だけです',
      usd_ugc_license:
        'この {ugc} を購入すると、すぐにアクセスするためのライセンスと引き換えに {count} クレジットが付与されます。',
      top_up: 'トップアップ',
      remaining_balance: '残高',
      not_enough_vc:
        '先に進むのに十分な仮想通貨がありません。ゲームウォレットにチャージしてください',
      error_virtual_currency_packs: '仮想通貨パックの取得に失敗しました',
      vc_prompt: '仮想通貨パックを入手',
      vc_description:
        '{game} の仮想通貨パックを購入して、コンテンツクリエーターをサポートし、プレミアムコンテンツにアクセスしましょう',
      vc_agreement:
        '仮想通貨パックを購入する前に、{terms} と {refund} をご覧ください。該当する税金はすべてチェックアウト時に適用されます。',
      error_session: '購入セッションを取得できませんでした',
      sold_out: '完売',
      currency_packs: '通貨パック',
      cancel_transaction: '取引をキャンセル',
      cancel_transaction_text: 'この取引をキャンセルしてもよろしいですか?',
    },
  },
  ko: {
    language: '언어',

    // Nav
    browse: '탐색',
    library: '도서관',
    my_content: '내 콘텐츠',
    account: '내 계정',
    back: '돌아 가라',
    more: '더',
    add_mod: '{ugc} 추가',
    edit_mod: 'mod.io 에서 편집',
    admin: '관리자',
    help_center: '헬프 센터',
    subscribed_ugc: '구독 {ugc}',
    followed_collections: '팔로우한 컬렉션',
    page: '페이지',

    // Guides
    guide: '가이드 | 가이드',
    views: '견해',
    table_of_contents: '목차',
    reading_time: '독서 시간',
    date_added: '추가된 날짜',
    date_updated: '업데이트된 날짜',
    minutes_read: '분 읽기',
    published: '게시됨',
    show_more_tags: '흔하지 않은 태그 표시',
    hide_more_tags: '흔하지 않은 태그 숨기기',

    // Users
    joined: '가입됨',
    last_online: '마지막 온라인',
    online: '온라인',
    followers: '추종자',
    partner: '파트너',
    partnered_creator: '파트너 크리에이터',
    profile_hidden: '이 사용자의 프로필은 숨겨져 있습니다',
    follow: '따르다',
    unfollow: '언팔로우',
    following: '팔로잉',
    user: '사용자',
    user_update_error: '사용자 업데이트에 실패했습니다',
    age_widget_error: '연령 위젯을 로드하는 데 실패했습니다.',

    // Mods
    mod: 'Mod | Mods',
    level: '레벨 | 레벨',
    content: '콘텐츠',
    subscribed: '구독',
    tags: '태그',
    summary: '요약',
    contributors: '기여자',
    description: '설명',
    dependencies: '종속성',
    no_dependencies: '이 {ugc} 에는 종속성이 없습니다.',
    of: '/',
    ago: '~ 전에',
    and: '그리고',
    by: '에 의해',
    reset_filters: '필터 재설정',
    show_more: '자세히보기',
    show_less: '간략히 표시',
    no_ugc_found: '{ugc_name}을(를) 찾을 수 없음',
    no_subscriptions: '{ugc_name}을(를) 구독하지 않았습니다.',
    mod_disclaimer_heading: '법적 면책 조항',
    mod_disclaimer_privacy: '개인정보보호방침을 참조해 주세요',
    thumbs_up_received: '좋아요를 받았습니다.',
    thumbs_up: '엄지손가락',
    total_downloads: '총 다운로드',
    releases: '릴리스',
    bytes: '바이트',
    local_mod_disabled:
      '하나 이상의 종속성이 없기 때문에 이 {ugc} 을 (를) 로드할 수 없습니다. {dependencies}',
    mod_with_collections: '이 {ugc} 를 사용한 컬렉션',
    see_all_collections: '{count} 컬렉션 모두 보기',
    mod_dependencies: '이 {ugc} 가 작동하려면 모든 종속성을 설치해야 합니다.',
    mod_dependencies_prompt:
      '이 {ugc} 에는 필수 종속성이 있습니다.여러분도 구독하고 싶으신가요?',
    allow_in_collections: '컬렉션에 추가되도록 허용',
    allow_in_collections_tip:
      '이 옵션을 활성화하면 다른 사용자가 {ugc}를 컬렉션에 추가할 수 있습니다.',

    // Actions
    login: '로그인',
    logout: '로그 아웃',
    search: '검색',
    clear_all: '모두 지우기',
    download: '다운로드',
    subscribe: '구독',
    unsubscribe: '구독 취소',
    resubscribe: '재구독',
    activate: '활성화',
    deactivate: '비활성화',
    like: '좋아요',
    dislike: '싫어요',
    report: '문제 신고',
    submit: '제출',
    cancel: '취소',
    done: '완료',
    select: '선택하다',
    previous: '이전',
    next: '다음',
    confirm: '확인',
    allow: '허용',
    manage: '관리',
    discard: '변경 내용 취소',
    more_actions: '추가 작업',
    manage_interaction_settings: '상호작용 설정 관리',
    block: '차단',
    block_user: '사용자 연락 차단',
    unblock: '차단 해제',
    user_blocked:
      '이 사용자를 차단하여 나에게 연락하거나 내 콘텐츠에 댓글을 달 수 없습니다.',
    block_user_tooltip:
      '이 사용자가 나에게 연락하거나 내 콘텐츠에 댓글을 다는 것을 방지합니다.',
    block_prompt:
      '이 사용자를 차단하시겠습니까? 이 사용자는 나에게 연락하거나 내 콘텐츠에 댓글을 달 수 없습니다.',
    block_success: '사용자를 성공적으로 차단했습니다.',
    unblock_success: '사용자 차단을 성공적으로 해제했습니다.',
    unblock_prompt:
      '이 사용자의 차단을 해제하시겠습니까? 이 사용자는 다시 나에게 연락하고 내 콘텐츠에 댓글을 달 수 있습니다.',
    mute: '음소거',
    mute_user: '사용자 {ugc} 음소거',
    unmute: '음소거 해제',
    user_muted: '{ugc} 를 볼 수 없도록 이 사용자를 뮤트했습니다',
    mute_user_tooltip:
      '게임 탐색 시 이 사용자가 만든 {ugc}가 나에게 노출되지 않도록 합니다',
    mute_prompt:
      '정말로 이 사용자를 뮤트하시겠습니까?게임을 탐색할 때 해당 사용자가 제출한 {ugc} 를 더 이상 볼 수 없습니다.',
    mute_success: '사용자를 성공적으로 음소거했습니다.',
    unmute_success: '사용자 음소거를 성공적으로 해제했습니다.',
    unmute_prompt:
      '정말로 이 사용자를 차단 해제하시겠습니까?해당 사용자의 콘텐츠를 다시 볼 수 있습니다.',
    publish: '게시',
    block_error: '사용자 차단 상태를 업데이트하지 못했습니다',
    mute_error: '사용자 음소거 상태를 업데이트하지 못했습니다',

    // Collections
    collection: '컬렉션 | 컬렉션',
    total_mods: '합계 {ugc}',
    total_filesize: '전체 파일 크기',
    follow_collection: '팔로우 컬렉션',
    unfollow_collection: '컬렉션 언팔로우',
    compatibility: '호환성',
    compat_rating: '호환성 등급',
    last_30_days: '지난 30일',
    all_time: '전체 시간',
    does_collection_work: '이 컬렉션이 당신에게 적합한가요?',
    collection_works: '네, 그렇습니다',
    collection_doesnt_work: '아니요, 그렇지 않습니다',
    collection_incomplete_subscriptions: '구독이 완료되지 않은 경우',
    vote: '표',
    curator: '큐레이터',
    creator_count: '이 컬렉션의 크리에이터 {count}명',
    mods_in_collection: '이 컬렉션에 포함된 모든 {ugc}',
    mod_not_available: '이 {ugc} 은 (는) 더 이상 사용할 수 없습니다.',
    unavailable: '없는',
    collection_sub_mods: '이 컬렉션의 모든 {ugc} 를 구독하세요',
    collection_unsub_mods: '이 컬렉션의 모든 {ugc} 구독을 취소하세요',
    collection_unsub_hint:
      '체크하지 않으면 컬렉션이 라이브러리에서 제거되지만 해당 컬렉션의 {ugc} 구독은 유지됩니다.',
    collection_error_subscribe: '컬렉션 {ugc} 을 (를) 구독하지 못했습니다.',
    collection_error_unsubscribe: '컬렉션 {ugc} 구독을 취소하지 못했습니다.',
    collection_error_follow: '컬렉션 팔로우 실패',
    collection_error_unfollow: '컬렉션을 언팔로우하지 못했습니다.',
    ugc_count: '{ugc} 개수',
    collections_incomplete:
      '일부 {ugc} 를 사용할 수 없으므로 호환성에 영향을 미칠 수 있습니다.',
    adult: '성인',
    view_more: '더 보기',
    view_less: '더 적게 보기',

    // Categories
    category: '카테고리',
    miscellaneous: '여러 가지 잡다한',
    essential: '에센셜',
    themed: '테마',
    animation: '애니메이션',
    audio: '오디오',
    bug_fixes: '버그 수정',
    cheating: '부정 행위',
    environment: '환경',
    gameplay: '게임플레이',
    quality_of_life: '삶의 질',
    ui: 'UI',
    visuals: '비주얼',

    // Filters
    all: '모두',
    available: '사용 가능',
    filesize: '파일 크기',
    downloads: '다운로드',
    todays_downloads: '오늘의 다운로드',
    subscribers: '가입자',
    rating: '평가',
    sort_by: '정렬 기준',
    creator: '생성자',
    apply: '적용하다',
    reset: '초기화',
    featured: '추천',
    toggle_filters: '전환 필터',
    show_filters: '필터 표시',
    hide_filters: '필터 숨기기',
    admin_options: '관리자 옵션',
    hidden: '숨겨진',
    public: '공개',
    private: '비공개',
    pending: '보류 중',
    archived: '보관됨',
    deleted: '삭제됨',
    last_day: '마지막 날',
    hidden_monetization_disabled: '수익 창출이 비활성화되어 숨겨짐',
    date_live: '데이트 라이브',
    last_week: '지난주',
    last_month: '전달',
    last_3_months: '지난 3개월',
    last_year: '작년',
    exclude: '들어오지 못하게 하다',
    no_matching_content: '일치하는 콘텐츠 없음',
    content_type: '콘텐츠 유형',
    free: '무료',
    premium: '프리미엄',

    // Login
    signup: '이메일로 로그인 또는 가입',
    login_with: '{service}로 로그인',
    email_placeholder: '이메일 주소',
    code_placeholder: '5자리 코드',
    have_code: '코드가 있습니다',
    send_new_code: '새 코드 보내기',
    login_disclaimer: '{game}의 사용자 생성 콘텐츠는 mod.io에서 관리합니다.',
    terms_disclaimer: `"로그인"을 누르면 {studioterms}mod.io의 {terms} 및 {privacy}에 동의하고 {min_age}세 이상임을 확인하게 됩니다.`,
    terms_disclaimer_studio: '{studio}의 {terms}, ',
    terms_disclaimer_studio_separator: ', ',
    terms_disclaimer_studio_and: ' 및 ',
    code_error: '코드를 요청할 수 없습니다.',
    or: '또는',
    login_prompt:
      '액세스하려는 페이지에는 인증이 필요합니다. 계속하려면 로그인하세요.',
    receive_code: '코드를 받지 못하셨나요?',
    resend_code: '코드 재전송',
    login_with_email: '이메일로 로그인',
    otp_email:
      '{email}로 일회용 비밀번호(OTP)를 전송했습니다. 계속하려면 입력하세요.',
    back_to_login: '로그인 옵션으로 돌아가기',

    // Terms
    terms: '이용 약관',
    privacy: '개인정보 보호 정책',
    aup: '허용되는 사용 정책',
    monetization: '수익 창출 조건',
    game: '게임 용어',
    api: 'API 액세스 약관',
    refund: '환불 정책',
    effective: '부터 발효',

    // Report
    report_heading: '이 글을 신고하세요 {ugc}',
    report_intro:
      '아래 양식을 사용하여 콘텐츠 문제, mod.io {terms} 위반 사항을 보고하거나 {dmca}를 제출할 수 있습니다.',
    report_intro_collection:
      '아래 양식을 사용하여 콘텐츠 문제, mod.io {terms} 위반 사항을 신고할 수 있습니다.',
    report_details:
      '신고 내용을 쉽게 해결할 수 있도록 관련 정보를 모두 포함했는지 확인하세요. 이 정보는 게임 중재자와 공유되며, 침해가 의심되는 콘텐츠를 게시한 사용자와도 공유될 수 있습니다.',
    report_not_working_prompt:
      "'작동하지 않음' 보고서는 콘텐츠 작성자와 직접 공유됩니다.",
    dmca: 'DMCA 불만 제기',
    report_reason: '신고 이유',
    urls: '잘못된 URL',
    urls_placeholder: 'URL(한 줄에 1개)',
    company_or_name: '회사 또는 귀하의 이름',
    email: '이메일',
    address: '주소',
    country: '국가/지역',
    country_placeholder: '국가/지역 선택',
    details: '위반 사항 세부 정보',
    details_placeholder:
      '신고하신 내용을 해결하는 데 도움이 되도록 최대한 많은 세부정보와 맥락을 제공해 주시기 바랍니다.',
    dmca_1:
      '{mod_io}는 타인의 지적 재산권을 존중하며 당사 인터넷 사이트 및 서비스를 사용하는 모든 사람이 동일하게 행동할 것을 요청합니다. 자신의 작품이 저작권을 침해하는 방식으로 당사의 인터넷 사이트 또는 서비스 중 하나에 복제되었다고 생각하는 사람은 아래 양식을 사용하여 mod.io의 저작권 대리인에게 알릴 수 있습니다.',
    dmca_2:
      '저작권 침해 주장을 제출하는 것은 심각한 법적 문제입니다. 진행하기 전에 개인에게 직접 연락하여 불만 사항을 처리하는 것을 고려할 수 있습니다. 단순한 오해일 수 있으며 적절한 법적 절차를 거치지 않고 해결할 수 있습니다.',
    dmca_3:
      '디지털 밀레니엄 저작권법(Digital Millennium Copyright Act) 512(f)절에 따라 자료나 활동이 저작권을 침해한다고 고의적으로 실질적으로 허위 진술하는 사람은 손해 배상 책임을 질 수 있습니다. 또한 이 법적 고지에 제공된 정보는 제3자와 공유되거나 공개될 수 있습니다.',
    claim_check:
      '다음 확인란을 선택하고 이러한 불만 사항을 제출함으로써 본인은 위증 시 처벌을 받는다는 조건 하에 다음과 같이 진술합니다.',
    copyright_owner: '본인은 저작권 소유자입니다',
    copyright_auth_owner:
      '본인은 이 상황에서 저작권 소유자를 대신하여 행동할 권한이 있습니다.',
    authorization: '권한 부여',
    authorization_check:
      '본인은 이 불만 사항에 언급된 자료의 사용이 저작권 소유자, 그 대리인 또는 법률에 의해 승인되지 않았음을 선의로 믿습니다.',
    acknowledgement: '인정',
    acknowledgement_check:
      '본인은 DMCA 512(f)절에 따라 자료나 활동이 저작권을 침해한다고 고의적으로 실질적으로 허위 진술하는 사람은 손해 배상 책임을 질 수 있음을 인정합니다.',
    required: '필수',
    signature: '서명',
    signature_placeholder:
      '디지털 서명 역할을 하는 성명을 이 확인란에 입력하십시오.',
    report_success_title: '귀하의 신고가 접수되었습니다',
    report_success_text:
      '신고하신 내용을 해결하는 데 더 자세한 정보가 필요할 경우, 해당 정보를 제공해 달라고 연락드릴 수 있습니다. 자세한 정보를 제공해 주셔서 감사합니다.',
    report_error_title: '보고서를 제출하지 못했습니다',
    report_email_inform:
      '귀하의 이메일 주소는 이 신고를 처리하는 데만 사용됩니다.',

    // Table
    name: '이름',
    added: '추가됨',
    updated: '업데이트됨',
    date: '날짜',
    item: '항목',
    file: '파일',
    version: '버전',
    scan: '바이러스 스캔',
    actions: '행동',
    status: '상태',
    role: '역할',
    live: '라이브',
    locally_installed: '로컬로 설치됨',

    // Releases
    download_from_game_client: '게임 클라이언트에서 {mod} 다운로드',
    download_payment_required: '구매하여 {ugc} 다운로드',
    download_auth_required: '로그인하여 {ugc} 다운로드',
    release_notes: '릴리즈 노트',
    no_release_notes: '릴리스 노트가 제공되지 않음',
    previous_releases: '이전 릴리스',
    view_previous_releases: '이전 릴리스 보기',
    no_previous_releases: '이전 릴리스가 없습니다',
    no_files_published: '게시된 파일 없음',
    download_files_manually: '수동으로 파일 다운로드',
    platforms: '플랫폼 | 플랫폼',

    // Ratings
    overwhelmingly_positive: '압도적으로 긍정적',
    overwhelmingly_negative: '압도적으로 부정적',
    very_positive: '매우 긍정적',
    very_negative: '매우 부정적',
    mostly_positive: '대부분 긍정적',
    mostly_negative: '대부분 부정적',
    negative: '부정적',
    positive: '긍정적',
    mixed: '혼합',
    unrated: '등급 평가 없음',

    // Sort
    sort_comments: '코멘트',
    sort_total_mods: '총 모드',
    sort_trending: '트렌드',
    sort_highest_rated: '최고 평점',
    sort_most_popular: '가장 인기 많은',
    sort_most_subscribers: '대부분의 가입자',
    sort_recently_added: '최근에 추가',
    sort_last_updated: '마지막 업데이트',
    sort_alphabetical: '알파벳순',
    sort_smallest_filesize: '최소 파일 크기',

    // Report Reason
    report_dmca: 'DMCA',
    report_not_working: '작동하지 않음',
    report_rude_content: '무례한 콘텐츠',
    report_illegal_content: '불법 콘텐츠',
    report_stolen_content: '훔친 콘텐츠',
    report_false_information: '거짓 정보',
    report_other: '기타',

    // Report not working reasons
    report_crash: '충돌 게임',
    report_no_load: '로드되지 않음',
    report_conflicts: '다른 {ugc}와의 충돌',
    report_missing_deps: '종속성 누락',
    report_install_issues: '설치 문제',
    report_bugs: '버기 행동',
    report_incompatability: '게임 버전과 호환되지 않음',
    report_corrupt: '손상된 파일',

    // Errors
    warning: '경고',
    error_ref: '오류 코드: ',
    login_fail: '로그인 실패',
    login_fail_message: '로그인 실패. 잠시만 기다려 다시 시도하십시오.',
    subscribe_fail: '구독하지 못했습니다',
    unsubscribe_fail: '구독 취소 실패',
    error: '오류',
    default_error_message: '오류가 발생했습니다. 잠시 후 다시 시도해 주세요.',
    follow_error: '팔로우 실패',
    unfollow_error: '팔로우를 취소하지 못했습니다.',
    upload_file_error: '계속하려면 적어도 하나의 파일을 업로드해야 합니다',

    agreement_not_found: '계약을 찾을 수 없습니다',
    form_chars_remaining: '{count} 남은 문자.',
    form_not_enough_chars: '{count} 더 많은 문자가 필요합니다.',
    filter: '필터',
    loading: '로딩',
    next_version: '다음 버전',
    no_results_found: '검색 결과가 없습니다',
    page_not_found: '페이지를 찾을 수 없습니다!',
    previous_version: '이전 버전',
    take_me_home: '나를 집에 데려가',
    validation_alpha_num: '필드에는 숫자 나 글자 만 포함 할 수 있습니다',
    validation_size: '필드는 {size} 문자 여야합니다',
    validation_url: '필드는 URL이어야합니다',
    validation_min: '최소 {min} 자',
    validation_max: '최대 {max} 문자',
    validation_email: '필드는 이메일이어야합니다',
    validation_checked: '필드를 점검해야합니다',
    validation_required: '필드가 필요합니다',
    validation_name: '필드에는 문자 및 이름 관련 기호만 포함될 수 있습니다.',
    validation_image: '파일은 유효한 jpeg 또는 png 이미지여야 합니다.',
    validation_youtube: '필드는 유효한 유튜브 URL이어야 합니다',
    validation_sketchfab: '필드는 유효한 스케치팹 URL이어야 합니다.',
    validation_zip: '파일은 ZIP이어야 합니다.',
    validation_filesize: '파일 크기는 {size} 를 초과할 수 없습니다.',
    delete_image: '이미지 삭제',
    confirm_delete_image: '이 이미지를 삭제하시겠습니까?',

    comment: '논평',
    team_member: '팀 구성원',
    game_admin: '게임 관리자',
    site_admin: '사이트 관리자',
    author: '작가',
    good_karma: '좋은 카르마',
    bad_karma: '나쁜 카르마',
    reply: '회신하다',
    replies: '답장 | 답글',
    replied: '답장함',
    reopen: '다시 열기',
    close: '닫기',
    mark_as_read: '읽음으로 표시',
    save: '구하다',
    delete: '삭제',
    archive: '아카이브',
    edit: '편집하다',
    post: '우편',
    pinned: '고정됨',
    pin: '핀',
    unpin: '고정 해제',
    locked: '잠김',
    lock: '잠금',
    unlock: '잠금 해제',
    add_comment: '의견을 추가하다...',
    comment_cant_reply_locked:
      '댓글 스레드가 잠겼기 때문에 응답할 수 없습니다.',
    comment_cant_edit_locked: '댓글 스레드가 잠겼기 때문에 편집할 수 없습니다.',
    comment_max_pin_limit: '고정 댓글의 최대 한도에 도달했습니다.',
    comment_below_threshold: '댓글이 임계값 미만입니다.보려면 클릭하세요.',
    comment_login_prompt: '토론에 참여하려면 로그인하십시오!',
    comment_error_add: '댓글을 추가하지 못했습니다',
    comment_error_edit: '주석을 편집하지 못했습니다',
    comment_error_delete: '주석을 삭제하지 못했습니다',
    comment_error_rate: '댓글을 평가하지 못했습니다.',
    comment_error_update: '댓글 업데이트 실패',
    comments_error_fetch: '더 많은 댓글을로드하지 못했습니다',
    discussion: '논의',
    load_more_comments: '더 많은 의견을로드하십시오',
    comment_confirm_delete: '이 의견을 삭제 하시겠습니까?',
    comment_deleted: '의견이 성공적으로 삭제되었습니다',
    comments_disabled:
      '계정의 보호자 관리 설정으로 인해 댓글 기능이 비활성화되었습니다.',
    comments_age_unverified:
      '나이가 확인되기 전까지는 댓글을 추가할 수 없습니다.',
    review_settings: '검토 설정',

    // Mod admin
    mod_status: {
      pending_has_file: '{ugc} 를 출시하려면 게임 운영자의 승인이 필요합니다.',
      pending_curation:
        '파일이 추가되고 승인되면 {ugc} 이 (가) 활성 상태로 변경됩니다.',
      pending_no_curation: '파일이 추가되면 {ugc} 는 라이브 상태로 변경됩니다.',
      archived:
        '{ugc} 이 (가) 보관되었습니다.모든 구독자가 제거되었으며 API 요청을 통해 보거나 검색할 수 없습니다.',
      hidden: '{ugc} 은 숨겨져 있으며 구독자와 팀원만 사용할 수 있습니다.',
      hidden_purchase_disabled:
        '수익 창출이 비활성화되었으므로 {ugc} 은 (는) 숨겨집니다.',
      live: '{ugc} 은 (는) 생방송으로 누구나 플레이할 수 있습니다.',
    },
    mod_profile: '{ugc} 프로필',
    media: '메디아',
    file_manager: '파일 관리자',
    step: '{step}단계',
    save_next: '저장 및 다음',
    auth_required: '인증이 필요합니다.',
    public_text: '{ugc} 는 검색 페이지에서 누구나 검색할 수 있습니다.',
    private_text:
      '{ugc} 는 팀원, 기존 구독자 및 미리 보기 액세스 권한이 있는 사용자만 액세스할 수 있습니다.',
    edit_disabled_on_add: '이 {ugc} 가 생성되면 웹을 통해 변경할 수 없습니다.',
    edit_enabled_on_add: '{ugc} 를 만든 후 변경할 수 있습니다.',
    add_mod_monetized:
      '이 게임은 수익 창출 {ugc1} 을 지원합니다.이 {ugc2} 로 수익을 창출할 계획이라면 지금은 {private} 를 선택하고 수익 창출을 설정한 후 나중에 {public} 로 설정하세요.{ugc2} 를 생성한 후 수익 창출을 설정할 수 있습니다.',
    share_access: '액세스 공유',
    profile_editing_disabled:
      '웹을 통한 프로필 편집이 게임에서 비활성화되었습니다.',
    tools_only_1:
      '여기서 {game} 용 {ugc} 를 업로드할 수 없습니다. 파일을 확인하려면 게임 개발자가 만든 도구를 사용하여 업로드해야 합니다.자세한 내용은 이 게임을 위해 작성된 {guides} 를 참조하십시오. ',
    tools_only_2: '게임 개발자가 제공하는 지침은 다음과 같습니다.',
    tools_only_3:
      '{ugc} 목록으로 돌아가서 링크를 찾아보는 것이 좋습니다.문제가 지속되면 {help_center} 로 이동하여 자세한 내용을 확인하세요.',
    unsaved_heading: '변경 내용을 저장하지 않았습니다.',
    unsaved_confirm:
      '아직 저장되지 않은 변경 사항이 있습니다. 그래도 종료하시겠습니까?',
    settings: '설정',
    team: '팀',
    reports: '보고서',
    stats: '통계',
    moderator: '중재자',
    manager: '매니저',
    error_get_mod: '{ugc} 을 (를) 가져오지 못했습니다.',
    archive_reason: '보관 이유',
    view_mod: '{ugc} 보기',
    error_archive_mod: '{ugc} 을 (를) 아카이브하지 못했습니다.',
    archive_mod_prompt:
      '이 {ugc} 를 보관하면 모든 사용자의 구독이 취소되고 API 요청에서 제거됩니다.',
    archive_mod_confirm:
      '보관이 완료되면 모든 팀 구성원에게 제공된 이유와 함께 이 작업을 알리는 이메일이 발송됩니다.\n\n진행자만 이 작업을 되돌릴 수 있습니다. 계속 진행하시겠습니까?',

    headline_mod_profile: '{ugc} 프로필을 만드세요',
    headline_media: '{ugc} 프로필에 미디어를 추가하세요',
    headline_files: '{ugc} 파일 업로드',
    headline_permissions: '{ugc}에 대한 재사용 권한 설정',
    headline_dependencies: '{ugc} 종속성을 추가하세요.',

    // Basics
    basics: '기초',
    logo: '로고',
    logo_prompt_1: '{ugc} 로고를 나타내는 이미지 파일입니다.',
    logo_prompt_2: '512x288 이상',
    logo_prompt_3: '16:9 화면 비율 권장',
    logo_prompt_4: '최대 8MB',
    summary_placeholder:
      '{ugc} 님이 게임에 적용한 변경 사항을 한 단락으로 알려주세요.',
    homepage: '홈페이지',
    profile_url: '프로필 URL',
    visibility: '가시성',
    visibility_tip:
      '일단 게시되면 모든 사람이 공개 {ugc} 를 볼 수 있습니다.Hidden {ugc} 은 팀원과 구독자만 볼 수 있습니다.',
    upload_images: '이미지 업로드',
    mature_content: '성인용 콘텐츠 포함',
    mature_content_alcohol: '알코올',
    mature_content_drugs: '약물',
    mature_content_violence: '폭력',
    mature_content_explicit: '명시적',
    community: '커뮤니티',
    allow_comments: '댓글 허용',
    allow_dependants: '부양가족 허용',
    create_mod: '{ugc} 만들기',
    error_mod_create: '{ugc} 을 (를) 생성하지 못했습니다.',
    error_mod_update: '{ugc} 을 (를) 업데이트하지 못했습니다.',
    error_tags_update: '태그 업데이트 실패',
    success_create_mod: '{modname} 을 (를) 성공적으로 만들었습니다.',
    success_update_mod: '{modname} 을 (를) 성공적으로 업데이트했습니다.',
    description_tip:
      "{ugc} 에 대한 선택적 설명에는 '정보', '기능', '사용법', 'FAQ' 등과 같은 세부 정보가 포함될 수 있습니다. HTML이 지원되고 권장됩니다.",

    // Media
    models: '모델',
    media_reorder_hint:
      '기존 이미지의 순서를 바꾸려면 드래그하거나 새 이미지 파일을 드롭하여 업로드하세요.',
    media_zip_hint_1:
      '한 번에 최대 {count}개의 이미지 또는 이미지가 포함된 단일 zip 파일을 업로드하세요.',
    media_zip_hint_2: '지원되는 형식은 .jpg, .jpeg, .png 및 .zip입니다.',
    drag_and_drop_image: '이미지를 드래그 앤 드롭하여 업로드',
    or_click_to_upload: '또는 클릭하여 파일 선택',
    error_media_update: '미디어를 업데이트하지 못했습니다.',
    error_media_add_links: '미디어 링크를 추가하지 못했습니다.',
    error_media_remove_links: '미디어 링크를 제거하지 못했습니다.',
    success_media_updated: '미디어를 성공적으로 업데이트했습니다.',

    // File manager
    add_file: '파일 추가',
    edit_file: '파일 편집',
    select_zip: 'zip 파일 선택',
    upload: '업로드',
    file_id: '파일 ID:',
    virus_none: '바이러스가 발견되지 않았습니다.',
    virus_waiting: '스캔 대기 중',
    virus_scanning: '스캔 진행 중',
    virus_too_large: '파일이 너무 커서 스캔할 수 없습니다',
    virus_not_found: '파일을 찾을 수 없음',
    virus_error: '파일 검사 중 오류 발생',
    virus_found: '바이러스가 감지됨',
    virus_risk:
      '이 파일은 실행 파일을 포함하고 있으므로 열 때 주의해야 합니다.',
    version_placeholder: '버전 번호, 즉 1.0.0',
    release_notes_placeholder: '각 변경 사항을 별도의 줄에 입력합니다.',
    game_moderator: '게임 모더레이터',
    metadata_blob: '메타데이터 블럽',
    metadata_blob_placeholder:
      '이 릴리스와 호환되는 게임 버전, 설치 방법 등과 같은 특정 메타데이터를 입력합니다. UTF-8 유효 데이터가 지원됩니다.',
    select_platforms: '플랫폼 (해당하는 항목 모두 선택)',
    file_pending: '승인 보류 중',
    file_approved: '승인됨',
    file_approved_live: '승인 및 라이브',
    file_approved_not_live: '승인되었지만 실제는 아님',
    file_denied: '거부됨',
    file_targeted: '타겟팅',
    live_file: '이 파일은 현재 라이브 상태입니다.',
    file_is_live: '파일이 라이브 상태임',
    file_is_not_live: '파일이 라이브 상태가 아님',
    no_delete_file_live: '파일이 활성 상태이므로 삭제할 수 없습니다.',
    make_file_live: '이 릴리스를 출시하세요',
    make_file_live_platforms: '승인된 플랫폼을 대상으로 이 릴리스를 출시하세요',
    delete_file_prompt:
      '정말로 이 파일을 삭제하시겠습니까?이 작업은 취소할 수 없습니다.',
    file_processing_title: '파일 처리',
    file_processing:
      '파일이 처리 중입니다.사이트를 계속 탐색할 수 있지만 완료될 때까지 탭이나 브라우저 창을 닫지 마십시오.',
    file_instructions_1:
      '{ugc} 의 기본 폴더를 압축하여 업로드하거나 기존 게임 폴더에 있는 파일 모음인 경우 해당 파일을 압축해야 합니다.',
    file_instructions_2: 'ZIP 파일이어야 함',
    file_instructions_3: '파일 크기가 20GB를 초과할 수 없음',
    file_instructions_4:
      '파일 이름에는 다음 문자를 포함할 수 없습니다. \\ / ? " &lt; &gt; &#124; : *',
    file_instructions_5:
      '{ugc} 파일 덮어쓰기는 게임에서 관리하지 않는 한 지원되지 않습니다.',
    file_instructions_6:
      '여러 게임 디렉터리에 걸쳐 있는 {ugc} 는 게임에서 관리하지 않는 한 지원되지 않습니다.',
    file_terms: '{terms} 및 {privacy} 에 동의합니다.',
    error_get_files: '파일을 가져오지 못했습니다.',
    error_upload_file_name: '{filename} 파일을 업로드하지 못했습니다.',
    error_upload_file: '파일 업로드 실패',
    error_update_file: '파일 업데이트 실패',
    error_delete_file: '파일을 삭제하지 못했습니다.',
    no_permission_delete_files: '파일을 삭제할 권한이 없습니다',
    error_file_required: '파일이 필요합니다.',
    error_platform_required: '플랫폼을 하나 이상 선택해야 합니다.',
    success_file_uploaded: '파일이 성공적으로 업로드되었습니다',
    success_file_moderation: '중재자가 조정이 필요한 플랫폼을 검토합니다.',
    success_file_updated: '파일이 성공적으로 업데이트되었습니다.',
    error_no_approved_platforms: '라이브로 설정할 플랫폼 없음',
    error_no_approved_platforms_text:
      '이 파일에는 현재 활성화되지 않은 승인된 플랫폼이 없습니다.',
    drag_and_drop_file: '파일을 드래그 앤 드롭하여 업로드',
    file_upload_hint: '.zip 파일만 허용 | {max} 최대 파일 크기',
    upload_draft: '업로드 및 초안으로 유지',
    upload_publish: '업로드 및 게시',
    save_draft: '저장 및 초안으로 유지',
    save_publish: '저장 및 게시',
    keep_as_draft: '초안으로 유지',
    publish_confirmation: '이 파일을 게시하시겠습니까?',
    marketplace_file_hint:
      '이 {mod}를 수익화할 계획이라면 이 파일을 초안으로 유지하고 게시하기 전에 먼저 수익화를 설정해야 합니다.',
    curation_file_hint:
      '게임 조정자가 플레이어가 액세스할 수 있기 전에 귀하의 {mod}를 승인해야 합니다.',
    platform_file_hint:
      '이 게임은 선택된 플랫폼에서 각 {mod} 파일에 대해 플랫폼 승인이 필요합니다: {platforms}.',
    two_step_approval_process: '이 게임은 2단계 승인 과정이 필요합니다:',
    two_step_approval_process_step1:
      '선택된 플랫폼에서 이 {mod} 파일에 대한 게임 조정자 승인: {platforms}',
    two_step_approval_process_step2:
      '{mod}를 라이브 상태로 만들기 위한 게임 조정자 승인',
    two_step_approval_process_live:
      '이 파일을 게시하면 두 승인이 모두 완료되면 자동으로 {mod}도 라이브로 설정됩니다.',
    one_step_approval_process_live:
      '이 파일을 게시하면 승인되는 즉시 자동으로 {mod}도 라이브로 설정됩니다.',

    // Reuse permissions form
    reuse_permissions: {
      heading: '재사용 권한',
      allow_redistribution:
        '다른 사람들이 내 {ugc} 자산을 다른 사이트에 업로드할 수 있도록 허용하되, 제가 원본 제작자로 인정되어야 합니다.',
      allow_porting:
        '다른 사람이 내 {ugc} 애셋을 다른 게임에서 사용할 수 있도록 허용하세요. 단, 제가 오리지널 크리에이터로 인정되어야 합니다.',
      allow_patching_no_credit:
        '다른 사람들이 내 {ugc} 자산을 수정 (버그 수정 또는 개선 사항 릴리스 포함) 하고 새 {ugc} 로 릴리스하도록 허용',
      require_credit: '제가 오리지널 크리에이터로 인정되어야 합니다',
      require_permission: '먼저 저에게 허락을 구하세요',
      require_repackage_no_credit:
        '다른 사람들이 내 {0} 자산을 자신의 {1} 에서 사용할 수 있도록 허용',
      allow_resell:
        '다른 사람들이 상업 저작물의 {ugc} /파일에서 내 {ugc} 자산을 사용할 수 있도록 허용',
      original_assets:
        'My {ugc} 에는 100% 오리지널 작품 또는 재배포할 수 있는 에셋이 포함되어 있습니다.',
      error_update: '재사용 권한을 업데이트하지 못했습니다.',
      success_update: '재사용 권한을 성공적으로 업데이트했습니다.',
      prompt:
        '{ugc} 자산을 다른 사람의 콘텐츠 제작에 사용할 수 있는 방법에 대한 권한을 설정합니다.다른 사람에게 파일을 사용하거나 수정할 수 있는 권한을 부여하면 이미 만든 저작물에 대해 해당 권한을 소급 취소할 수 없다는 점을 인정하는 것으로 간주됩니다.',
    },

    // Dependencies form
    dependencies_prompt:
      '이 {1} 이 제대로 작동하려면 {0} required를 선택하십시오 ({1} 가 표시되지 않으면 종속성을 허용하지 않았음을 의미하므로 작성자에게 문의하여 켜야 합니다).',
    remove_dependency: '종속성 제거',
    dependants: '부양가족',
    important: '중요한',
    error_update_dependencies: '종속성을 업데이트하지 못했습니다.',
    success_update_dependencies: '종속성 설정을 성공적으로 업데이트했습니다.',
    dependants_warning_1: '허용되면 종속 항목이 연결된 {ugc} 에 유의하세요.',
    dependants_warning_2: '종속 항목을 비활성화할 수 없습니다.',
    dependants_warning_3: '삭제할 수 없음',
    dependants_warning_4: '수익 창출 불가',
    no_dependants: '부양가족을 찾을 수 없음',
    dependencies_allow_prompt:
      '다른 {ugc} 에 대해 위의 부양가족 허용을 켜야 자신의 부양가족으로 추가할 수 있습니다.',
    dependencies_deny_prompt:
      '다른 {ugc} 가 종속성으로 선택하지 않도록 하려면 위의 종속 허용을 끌 수 있습니다.',
    dependencies_not_supported:
      '{gamename} 은 (는) 종속성을 지원하지 않습니다. 모든 {ugc} 는 독립적으로 실행되고 완전히 독립적이어야 합니다.',
    dependency_disabled_monetization:
      '수익 창출된 {ugc} 는 종속 가족을 활성화할 수 없습니다',
    dependency_disabled_dependants:
      '다른 {ugc_plural} 에 의존하므로 이 {ugc_single} 에 대한 종속 항목을 비활성화할 수 없습니다.이러한 정보는 종속성 탭에서 볼 수 있습니다.',
    dependants_confirm_enable:
      '이는 연결된 {ugc} 의 지속적인 호환성을 보장하기 위한 것입니다.활성화할지 확인해 주세요.',
    dependants_confirm_disable:
      '정말로 부양가족을 허용하지 않으시겠습니까?즉, 다른 {0} 에서는 {1} 을 (를) 종속성으로 추가할 수 없습니다.',
    dependency_monetization_warning:
      '{game}는 {mod} 수익화를 허용합니다. 수익화는 현재 종속성이 있는 {mods}를 지원하지 않습니다. 이 {mod}를 수익화하려는 경우 이 단계를 건너뛰십시오.',

    // Parental controls
    notify_parent_title: '부모 또는 보호자에게 알리세요',
    notify_parent:
      '계속 진행하면 부모님이나 보호자에게 알림이 전달되고 변경 사항이 적용되기 전에 승인을 받아야 합니다.',
    confirm_notify_parent:
      '제안된 권한 변경 사항에 대한 접근을 요청하기 위해 부모님이나 보호자에게 알림을 보내시겠습니까?',
    request_access: '접근 요청',

    // Cloud cooking
    cook_source: '소스 파일을 조리합니다',
    source_file: '소스 파일',
    targeted_platform: '타겟 플랫폼',
    metadata: '메타데이터',
    cook_time: '요리 시간',
    download_time: '다운로드 시간',
    file_compression_time: '파일 압축 시간',
    file_decompression_time: '파일 압축 해제 시간',
    upload_time: '업로드 시간',
    total_job_time: '총 작업 시간',
    logs: '로그',
    view_logs: '로그 보기',
    logs_available_on_completion: '로그는 쿠킹이 완료된 후 사용할 수 있습니다',
    logs_for_file: '{file} 에 대한 쿠킹 로그.',
    no_logs: '{file} 에 대한 로그를 찾을 수 없습니다.',
    get_logs_error: '요리 로그를 가져오지 못했습니다.',
    admin_only: '관리자 전용',
    queue: '대기줄',
    source_file_history: '소스 파일 기록',
    no_source_files_found: '소스 파일을 찾을 수 없습니다.',
    no_cooks_found: '요리사를 찾을 수 없습니다.',
    cook_jobs_available: '파일 쿠킹 작업 가능: {count}',
    view_details: '자세한 내용 보기',
    cloud_cooking: '클라우드 쿠킹',
    add_file_type: '새로운 {string}을 추가하세요',
    edit_file_type: '{string}을 편집하세요',
    files: '파일',
    cook_details: '요리 정보',
    status_queued: '대기열에 있음',
    status_cooking: '요리',
    status_success: '성공적인',
    status_failed: '실패한',
    status_pending_moderation: '검토 대기 중',
    status_moderation_rejected: '요리사가 거절함',
    get_cook_files_error: '클라우드 쿠킹 파일을 가져오는 데 실패했습니다.',
    get_source_files_error: '소스 파일을 가져오는 데 실패했습니다.',
    download_file_error: '파일 다운로드에 실패했습니다.',
    source_instructions:
      '소스 파일을 업로드하고 아래에서 원하는 플랫폼을 선택하세요. 그러면 클라우드 쿠킹을 통해 파일이 처리되어 각 플랫폼에 맞는 개별 파일이 생성됩니다.',

    // Marketplace
    marketplace: {
      available_stock: '수량 제한 - {count}개 남음',
      virtual_currency: '가상 화폐',
      marketplace: '마켓플레이스',
      order_summary: '주문 요약',
      payment_method: '결제 방법 | 결제 방법',
      wallet_balance: '월렛 잔고',
      vc_balance: '가상 화폐 잔고',
      credits: '크레딧',
      currency: '화폐',
      balance_after: '구매 후 잔액',
      token_purchase_success:
        '구매해 주셔서 감사합니다.결제가 처리되었으며 곧 세금 영수증이 이메일로 발송됩니다.이제 {game} 의 가상 화폐 잔액이 업데이트되었습니다.',
      transaction_id: '거래 ID',
      total_paid: '총 결제 금액',
      agreement: 'mod.io의 {terms} 및 {refund} 에 동의합니다.',
      change_payment: '결제 변경',
      error_register: '수익 창출 등록 실패',
      error_wallet: '게임 지갑을 가져오지 못했습니다.',
      error_process: '결제를 처리할 수 없습니다',
      error_complete: '결제를 완료할 수 없습니다',
      checkout: '체크아웃',
      vc_topup_confirmed: '가상 화폐 충전 확인',
      confirm_purchase: '구매 확인',
      continue_browsing: '계속 찾아보기',
      back_to_mod: '{ugc} 구매 페이지로 돌아가기',
      ugc_not_refundable:
        '{ugc_plural} 구매는 환불되지 않습니다.이 {ugc} 를 구매하기 전에 {terms} 및 {refund} 을 참조하십시오.',
      ugc_purchase_success:
        '구매해 주셔서 감사합니다.{ugc} 이 (가) {library} 의 구독에 추가되었으며 게임 내에서 사용할 수 있습니다.',
      game_virtual_currency: '게임 가상 화폐 ({virtual_currency})',
      proceed_to_checkout: '결제 진행하기',
      ugc_purchase_confirmed: '{ugc} 구매 확인',
      error_already_purchased: '당신은 이미 이것을 소유하고 있습니다 {ugc}',
      error_sku_packs: '{ugc} 가격을 가져오지 못했습니다.',
      error_payment_methods: '결제 방법을 가져오지 못했습니다.',
      calculated_at_checkout: '결제 시 계산',
      subtotal: '소계',
      taxes: '세금',
      total_due: '총 지불 금액',
      price: '가격',
      purchased: '구입했습니다',
      purchases: '{ugc} 를 구매했습니다.',
      no_purchases: '{ugc} 을 (를) 구매하지 않으셨어요',
      purchase_to_rate: '구매한 {ugc} 에 대해서만 등급을 매길 수 있습니다.',
      usd_ugc_license:
        '이 {ugc} 을 (를) 구매하면 즉시 {count} 크레딧이 부여되며, 이에 액세스할 수 있는 라이선스를 받을 수 있습니다.',
      top_up: '탑업',
      remaining_balance: '남은 잔액',
      not_enough_vc:
        '진행하기에 가상 화폐가 충분하지 않습니다.게임 지갑을 충전해 주세요.',
      error_virtual_currency_packs: '가상 화폐 팩을 가져오지 못했습니다.',
      vc_prompt: '가상 화폐 팩 받기',
      vc_description:
        '{game} 용 가상 화폐 팩을 구매하여 콘텐츠 제작자를 지원하고 프리미엄 콘텐츠를 이용할 수 있습니다.',
      vc_agreement:
        '가상 화폐 팩을 구매하기 전에 {terms} 및 {refund} 를 참조하십시오.모든 관련 세금은 결제 시 적용됩니다.',
      error_session: '구매 세션을 가져오지 못했습니다.',
      sold_out: '매진되었습니다',
      currency_packs: '커런시 팩',
      cancel_transaction: '거래 취소',
      cancel_transaction_text: '이 거래를 취소하시겠습니까?',
    },
  },
  ru: {
    language: 'Язык',

    // Nav
    browse: 'Просмотр',
    library: 'Библиотека',
    my_content: 'Мой контент',
    account: 'Мой счет',
    back: 'Возвращаться',
    more: 'более',
    add_mod: 'Добавить {ugc}',
    edit_mod: 'Редактировать на mod.io',
    admin: 'Администратор',
    help_center: 'справочный центр',
    subscribed_ugc: 'Подписался {ugc}',
    followed_collections: 'Подписанные коллекции',
    page: 'Страница',

    // Guides
    guide: 'Путеводитель | Путеводители',
    views: 'Взгляды',
    table_of_contents: 'Оглавление',
    reading_time: 'Время чтения',
    date_added: 'Дата Добавлена',
    date_updated: 'Дата обновления',
    minutes_read: 'Минута чтения',
    published: 'Опубликовано',
    show_more_tags: 'Показать необычные теги',
    hide_more_tags: 'Скрыть необычные теги',

    // Users
    joined: 'Присоединился',
    last_online: 'Последний раз в сети',
    online: 'В сети',
    followers: 'Последователи',
    partner: 'Партнер',
    partnered_creator: 'Партнерский автор',
    profile_hidden: 'Профиль этого пользователя скрыт',
    follow: 'Следовать',
    unfollow: 'Отписаться',
    following: 'Следующее',
    user: 'пользователя',
    user_update_error: 'Не удалось обновить пользователя.',
    age_widget_error: 'Не удалось загрузить виджет возраста.',

    // Mods
    mod: 'Mod | Mods',
    level: 'Уровень | Уровни',
    content: 'Содержимое',
    subscribed: 'В подписках',
    tags: 'Теги',
    summary: 'Сведения',
    contributors: 'Участники',
    description: 'Описание',
    dependencies: 'Зависимости',
    no_dependencies: 'Этот {ugc} не имеет зависимостей',
    of: 'из',
    ago: 'назад',
    and: 'и',
    by: 'К',
    reset_filters: 'Сбросить фильтры',
    show_more: 'Показать больше',
    show_less: 'Показать меньше',
    no_ugc_found: '{ugc_name} не найдено',
    no_subscriptions: 'Вы не подписаны ни на один {ugc_name}',
    mod_disclaimer_heading: 'Заявление об отказе от ответственности',
    mod_disclaimer_privacy: 'Положением об использовании персональных данных',
    thumbs_up_received: 'Оценка "Нравится" получена',
    thumbs_up: 'Недурно',
    total_downloads: 'Всего загрузок',
    releases: 'Релизы',
    bytes: 'байты',
    local_mod_disabled:
      'Невозможно загрузить этот {ugc}, так как отсутствует одна или несколько зависимостей: {dependencies}',
    mod_with_collections: 'Коллекции с этим {ugc}',
    see_all_collections: 'Смотреть все коллекции {count}',
    mod_dependencies: 'Для работы {ugc} необходимо установить все зависимости.',
    mod_dependencies_prompt:
      'Этот {ugc} имеет необходимые зависимости. Хотели бы вы тоже на них подписаться?',
    allow_in_collections: 'Разрешить добавление в коллекции',
    allow_in_collections_tip:
      'Если эта опция включена, другие пользователи смогут добавлять ваш {ugc} в коллекции.',

    // Actions
    login: 'Авторизоваться',
    logout: 'Выйти',
    search: 'Поиск',
    clear_all: 'Очистить все',
    download: 'Загрузить',
    subscribe: 'Подписаться',
    unsubscribe: 'Отписаться',
    resubscribe: 'Подписаться снова',
    activate: 'Активировать',
    deactivate: 'Деактивировать',
    like: 'Нравится',
    dislike: 'Не нравится',
    report: 'Сообщить о проблеме',
    submit: 'Отправить',
    cancel: 'Отмена',
    done: 'Готово',
    select: 'Выбирать',
    previous: 'Предыдущее',
    next: 'Следующий',
    confirm: 'Подтвердить',
    allow: 'Разрешить',
    manage: 'Управляйте',
    discard: 'Отменить изменения',
    more_actions: 'Больше действий',
    manage_interaction_settings: 'Управление настройками взаимодействия',
    block: 'Заблокировать',
    block_user: 'Заблокировать связь с пользователем',
    unblock: 'Разблокировать',
    user_blocked:
      'Вы заблокировали этого пользователя, поэтому он не может связываться с вами или комментировать ваш контент',
    block_user_tooltip:
      'Запрещает этому пользователю связываться с вами или комментировать ваш контент.',
    block_prompt:
      'Вы уверены, что хотите заблокировать этого пользователя? Он не сможет связываться с вами или комментировать ваш контент.',
    block_success: 'Пользователь успешно заблокирован.',
    unblock_success: 'Пользователь успешно разблокирован.',
    unblock_prompt:
      'Вы уверены, что хотите разблокировать этого пользователя? Он снова сможет связываться с вами и комментировать ваш контент.',
    mute: 'Заглушить',
    mute_user: 'Заглушить {ugc} пользователя',
    unmute: 'Включать звук',
    user_muted:
      'Вы отключили звук этого пользователя, чтобы не было видно ни одного из его {ugc}',
    mute_user_tooltip:
      'Предотвращает показ вам {ugc}, созданных этим пользователем, при просмотре игр',
    mute_prompt:
      'Вы действительно хотите заглушить этого пользователя? При просмотре игр вы больше не увидите отправленных им сообщений {ugc}.',
    mute_success: 'Пользователь успешно заглушен.',
    unmute_success: 'Звук пользователя успешно включен.',
    unmute_prompt:
      'Вы действительно хотите отключить звук этого пользователя? Вы снова сможете увидеть их содержимое.',
    publish: 'Опубликовать',
    block_error: 'Не удалось обновить статус блокировки пользователя',
    mute_error: 'Не удалось обновить статус отключения звука пользователя',

    // Collections
    collection: 'Коллекция | Коллекции',
    total_mods: 'Всего {ugc}',
    total_filesize: 'Общий размер файла',
    follow_collection: 'Следите за коллекцией',
    unfollow_collection: 'Отписаться от коллекции',
    compatibility: 'Совместимость',
    compat_rating: 'Рейтинг совместимости',
    last_30_days: 'Последние 30 дней',
    all_time: 'Все время',
    does_collection_work: 'Подходит ли вам эта коллекция?',
    collection_works: 'Да, это так',
    collection_doesnt_work: 'Нет, это не так.',
    collection_incomplete_subscriptions: 'Неполные подписки',
    vote: 'голоса | голос | голоса',
    curator: 'Куратор',
    creator_count: '{count} создателей в этой коллекции',
    mods_in_collection: 'Все {ugc}, вошедшие в эту коллекцию',
    mod_not_available: 'Этот {ugc} больше не доступен',
    unavailable: 'недоступно',
    collection_sub_mods: 'Подпишитесь на меня на все {ugc} из этой коллекции',
    collection_unsub_mods: 'Отпишитесь от всех {ugc} из этой коллекции',
    collection_unsub_hint:
      'Если этот флажок не установлен, коллекция будет удалена из вашей библиотеки, но вы останетесь подписаны на ее {ugc}.',
    collection_error_subscribe: 'Не удалось подписаться на коллекцию {ugc}',
    collection_error_unsubscribe: 'Не удалось отписаться от коллекции {ugc}',
    collection_error_follow: 'Не удалось проследить за коллекцией',
    collection_error_unfollow: 'Не удалось отписаться от коллекции',
    ugc_count: 'Количество {ugc}',
    collections_incomplete:
      'Некоторые {ugc} недоступны, что может повлиять на совместимость',
    adult: 'Взрослый',
    view_more: 'Показать больше',
    view_less: 'Показать меньше',

    // Categories
    category: 'Категория',
    miscellaneous: 'Разное',
    essential: 'Необходимый',
    themed: 'Тематический',
    animation: 'анимация',
    audio: 'Аудио',
    bug_fixes: 'Исправления ошибок',
    cheating: 'Мошенничество',
    environment: 'окружающая среда',
    gameplay: 'Геймплей',
    quality_of_life: 'Качество жизни',
    ui: 'UI',
    visuals: 'Визуальные эффекты',

    // Filters
    all: 'Все',
    available: 'для загрузки',
    filesize: 'Размер файла',
    downloads: 'Загрузок',
    todays_downloads: 'Загрузок сегодня',
    subscribers: 'Подписчиков',
    rating: 'Рейтинг',
    sort_by: 'Сортировать по',
    creator: 'Создатель',
    apply: 'Применять',
    reset: 'Перезагрузить',
    featured: 'Показан',
    toggle_filters: 'Переверните фильтры',
    show_filters: 'Показать фильтры',
    hide_filters: 'Скрыть фильтры',
    admin_options: 'Опции администратора',
    hidden: 'Скрытый',
    public: 'Общественность',
    private: 'Частное',
    pending: 'В ожидании',
    archived: 'Архивировано',
    deleted: 'Удалено',
    last_day: 'Последний день',
    hidden_monetization_disabled: 'Скрыто, поскольку монетизация отключена',
    date_live: 'Свидание в прямом эфире',
    last_week: 'На прошлой неделе',
    last_month: 'В прошлом месяце',
    last_3_months: 'Последние 3 месяца',
    last_year: 'В прошлом году',
    exclude: 'Исключать',
    no_matching_content: 'Соответствующего контента нет',
    content_type: 'Тип контента',
    free: 'Бесплатно',
    premium: 'премия',

    // Login
    signup: 'Войдите или зарегистрируйтесь с помощью эл. почты',
    login_with: 'Войдите с помощью {service}',
    email_placeholder: 'Адрес эл. почты',
    code_placeholder: '5-значный код',
    have_code: 'У меня есть код',
    send_new_code: 'Отправить новый код',
    login_disclaimer:
      'Контент, созданный пользователями для {game}, обрабатывает mod.io.',
    terms_disclaimer: `Нажимая «Войдите», вы соглашаетесь с {studioterms}{terms} и {privacy} mod.io и подтверждаете, что вам исполнилось {min_age} лет или больше.`,
    terms_disclaimer_studio: '{terms} {studio}, c ',
    terms_disclaimer_studio_separator: ', ',
    terms_disclaimer_studio_and: ' и ',
    code_error: 'Не удается запросить код.',
    or: 'или',
    login_prompt:
      'Страница, к которой вы пытаетесь получить доступ, требует аутентификации. Пожалуйста, войдите, чтобы продолжить.',
    receive_code: 'Не получили код?',
    resend_code: 'Отправить код повторно',
    login_with_email: 'Войти с помощью электронной почты',
    otp_email:
      'Мы отправили одноразовый пароль (OTP) на адрес {email}. Введите его, чтобы продолжить.',
    back_to_login: 'Вернуться к параметрам входа',

    // Terms
    terms: 'Условия использования',
    privacy: 'Политика конфиденциальности',
    aup: 'Политика приемлемого использования',
    monetization: 'Условия монетизации',
    game: 'Условия игры',
    api: 'Условия доступа к API',
    refund: 'Политика возврата средств',
    effective: 'Действует с',

    // Report
    report_heading: 'Сообщить об этом {ugc}',
    report_intro:
      'Вы можете сообщить о проблемах с контентом, нарушениях {terms} mod.io или отправить {dmca}, используя форму ниже.',
    report_intro_collection:
      'Вы можете сообщить о проблемах с контентом, нарушениях mod.io {terms}, используя форму ниже.',
    report_details:
      'Убедитесь, что вы включили всю необходимую информацию, чтобы облегчить разрешение вашего отчета. Обратите внимание, что эта информация будет передана модераторам игры и может быть передана пользователю, разместившему контент, предположительно нарушающий авторские права.',
    report_not_working_prompt:
      'Отчеты о «неработоспособности» будут переданы непосредственно создателю контента.',
    dmca: 'Жалоба на нарушение авторского права',
    report_reason: 'Основания для жалобы',
    urls: 'URL-адреса материалов, нарушающих авторское право',
    urls_placeholder: 'URL-адреса (по 1 в строке)',
    company_or_name: 'Название компании или ваше имя',
    email: 'Адрес эл. почты',
    address: 'Адрес',
    country: 'Страна/регион',
    country_placeholder: 'Выберите страну/регион',
    details: 'Подробности о нарушении авторского права',
    details_placeholder:
      'Чтобы помочь в разрешении вашего отчета, предоставьте как можно больше подробностей и контекста.',
    dmca_1:
      '{mod_io} уважает владельцев прав на интеллектуальную собственность и призывает к этому всех, кто пользуется нашими сайтами и службами. Если вы считаете, что ваша работа была использована на наших сайтах или в службах с нарушением авторского права, вы можете уведомить об этом агента по авторским правам в mod.io, используя форму ниже.',
    dmca_2:
      'Подача иска о нарушении авторского права — серьезный правовой вопрос. Перед тем, как продолжить, вы могли бы связаться с нарушителем и попытаться разрешить проблему напрямую с ним. Возможно, возникло простое недоразумение, которое можно урегулировать без привлечения надлежащих правовых процессов.',
    dmca_3:
      'Помните: в соответствии с разделом 512(f) Закона об авторском праве в цифровую эпоху, лицо, сообщившее заведомо ложные сведения о нарушении авторского права, может быть привлечено к ответственности за причиненный ущерб. Также обратите внимание, что информация, указанная в этом юридическом уведомлении, может быть передана третьим сторонам или стать общедоступной.',
    claim_check:
      'Проставляя отметки и отправляя эту форму, я заявляю, НЕСЯ ОТВЕТСТВЕННОСТЬ ЗА ЛЖЕСВИДЕТЕЛЬСТВО, что:',
    copyright_owner: 'я являюсь правообладателем;',
    copyright_auth_owner:
      'я имею полномочия действовать от имени владельца авторских прав в этой ситуации.',
    authorization: 'Наличие разрешения',
    authorization_check:
      'Я добросовестно полагаю, что использование материалов, указанных в этом заявлении, не разрешено владельцем авторских прав, его представителем или законом.',
    acknowledgement: 'Подтверждение',
    acknowledgement_check:
      'Я понимаю, что в соответствии с разделом 512(f) Закона об авторском праве в цифровую эпоху (DMCA), лицо, сообщившее заведомо ложные сведения о нарушении авторского права, несет ответственность за причиненный ущерб.',
    required: 'обязательное поле',
    signature: 'Цифровая подпись',
    signature_placeholder:
      'Введите в это поле свое полное имя, которое будет использоваться в качестве цифровой подписи.',
    report_success_title: 'Ваша жалоба была получена',
    report_success_text:
      'Если для решения вашего вопроса потребуются дополнительные сведения, мы можем связаться с вами и предоставить их. Спасибо за подробную информацию.',
    report_error_title: 'Не удалось отправить жалобу',
    report_email_inform:
      'Ваш адрес электронной почты используется исключительно для обработки этой жалобы.',

    // Table
    name: 'Название',
    added: 'Добавлен',
    updated: 'Обновлен',
    date: 'Дата',
    item: 'пункт',
    file: 'Файл',
    version: 'Версия',
    scan: 'Сканирование на вирусы',
    actions: 'Действия',
    status: 'Статус',
    role: 'Роль',
    live: 'Прямой эфир',
    locally_installed: 'На устройстве',

    // Releases
    download_from_game_client: 'Загрузить мод {mod} из клиента игры',
    download_payment_required: 'Купите, чтобы загрузить {ugc}',
    download_auth_required: 'Войдите, чтобы загрузить {ugc}',
    release_notes: 'Сведения о версии',
    no_release_notes: 'Сведения о версии не указаны',
    previous_releases: 'Предыдущие версии',
    view_previous_releases: 'Посмотреть предыдущие выпуски',
    no_previous_releases: 'Предыдущие версии отсутствуют',
    no_files_published: 'Нет опубликованных файлов',
    download_files_manually: 'Загрузка файлов вручную',
    platforms: 'Платформа | Платформы',

    // Ratings
    overwhelmingly_positive: 'Крайне положительный',
    overwhelmingly_negative: 'Крайне отрицательный',
    very_positive: 'Очень положительный',
    very_negative: 'Очень отрицательный',
    mostly_positive: 'В основном положительный',
    mostly_negative: 'В основном отрицательный',
    negative: 'Отрицательный',
    positive: 'Положительный',
    mixed: 'Смешанный',
    unrated: 'Без рейтинга',

    // Sort
    sort_comments: 'Комментарии',
    sort_total_mods: 'Всего модов',
    sort_trending: 'В тренде',
    sort_highest_rated: 'Наивысший рейтинг',
    sort_most_popular: 'Самый популярный',
    sort_most_subscribers: 'Большинство подписчиков',
    sort_recently_added: 'Недавно добавленный',
    sort_last_updated: 'Последнее обновление',
    sort_alphabetical: 'Алфавитный',
    sort_smallest_filesize: 'Наименьший размер файла',

    // Report Reason
    report_dmca: 'Закон о защите авторских прав в цифровую эпоху',
    report_not_working: 'Не работает',
    report_rude_content: 'Грубый контент',
    report_illegal_content: 'Незаконный контент',
    report_stolen_content: 'Украденный контент',
    report_false_information: 'Ложная информация',
    report_other: 'Другое',

    // Report not working reasons
    report_crash: 'Вылетает игра',
    report_no_load: 'Не загружается',
    report_conflicts: 'Конфликты с другими {ugc}',
    report_missing_deps: 'Отсутствующие зависимости',
    report_install_issues: 'Проблемы с установкой',
    report_bugs: 'Некорректное поведение',
    report_incompatability: 'Несовместимо с версией игры.',
    report_corrupt: 'Поврежденные файлы',

    // Errors
    warning: 'Предупреждение',
    error_ref: 'Код ошибки: ',
    login_fail: 'Не удалось войти',
    login_fail_message:
      'Не удалось войти. Пожалуйста, подождите минутку и попробуйте еще раз.',
    subscribe_fail: 'Не удалось подписаться',
    unsubscribe_fail: 'Не удалось отписаться',
    error: 'Ошибка',
    default_error_message: 'Произошла ошибка. Повторите попытку позже.',
    follow_error: 'Не удалось подписаться',
    unfollow_error: 'Не удалось отписаться',
    upload_file_error:
      'Вы должны загрузить хотя бы один файл, чтобы продолжить',

    agreement_not_found: 'Соглашение не найдено',
    form_chars_remaining: '{count} оставшиеся символы.',
    form_not_enough_chars: '{count} больше символов требуется.',
    filter: 'Фильтр',
    loading: 'Загрузка',
    next_version: 'Следующая версия',
    no_results_found: 'результатов не найдено',
    page_not_found: 'Страница не найдена!',
    previous_version: 'Предыдущая версия',
    take_me_home: 'Отведи меня домой',
    validation_alpha_num: 'Поле может содержать только цифры или буквы',
    validation_size: 'Поле должно быть {size} символы',
    validation_url: 'Поле должно быть URL',
    validation_min: 'Минимум {min} символов',
    validation_max: 'Максимум {max} символы',
    validation_email: 'Поле должно быть электронным письмом',
    validation_checked: 'Поле должно быть проверено',
    validation_required: 'Поле, обязательное для заполнения',
    validation_name:
      'Поле может содержать только буквы и символы, относящиеся к имени.',
    validation_image:
      'Файл должен быть действительным изображением в формате jpeg или png',
    validation_youtube: 'Поле должно быть действительным URL-адресом Youtube',
    validation_sketchfab:
      'Поле должно содержать действительный URL-адрес Sketchfab',
    validation_zip: 'Файл должен быть в формате ZIP',
    validation_filesize: 'Размер файла не должен превышать {size}',
    delete_image: 'Удалить изображение',
    confirm_delete_image: 'Вы уверены, что хотите удалить это изображение?',

    comment: 'комментарий | комментарии',
    team_member: 'Участник команды',
    game_admin: 'Администратор игры',
    site_admin: 'Администратор сайта',
    author: 'Автор',
    good_karma: 'Хорошая карма',
    bad_karma: 'Плохая карма',
    reply: 'Отвечать',
    replies: 'ответить | ответы',
    replied: 'Ответил',
    reopen: 'Переоткрыть',
    close: 'Закрыть',
    mark_as_read: 'Отметить как прочитанное',
    save: 'Сохранять',
    delete: 'Удалить',
    archive: 'Архив',
    edit: 'Редактировать',
    post: 'Почта',
    pinned: 'Закреплено',
    pin: 'Штифт',
    unpin: 'Открепить',
    locked: 'Заблокировано',
    lock: 'Замок',
    unlock: 'Разблокируйте',
    add_comment: 'Добавить комментарий...',
    comment_cant_reply_locked:
      'Невозможно ответить, так как ветка комментариев заблокирована',
    comment_cant_edit_locked:
      'Невозможно редактировать, так как ветка комментариев заблокирована',
    comment_max_pin_limit:
      'Достигнуто максимальное количество прикрепленных комментариев',
    comment_below_threshold:
      'Комментарий ниже порогового значения. Нажмите для просмотра.',
    comment_login_prompt: 'Войдите, чтобы присоединиться к обсуждению!',
    comment_error_add: 'Не удалось добавить комментарий',
    comment_error_edit: 'Не удалось редактировать комментарий',
    comment_error_delete: 'Не удалось удалить комментарий',
    comment_error_rate: 'Не удалось оценить комментарий',
    comment_error_update: 'Не удалось обновить комментарий',
    comments_error_fetch: 'Не удалось загрузить больше комментариев',
    discussion: 'Дискуссия',
    load_more_comments: 'Загрузите больше комментариев',
    comment_confirm_delete: 'Вы уверенны, что хотите удалить этот комментарий?',
    comment_deleted: 'Комментарий был успешно удален',
    comments_disabled:
      'Комментарии отключены из-за настроек родительского контроля вашей учетной записи.',
    comments_age_unverified:
      'Вы не сможете добавить комментарий, пока ваш возраст не будет подтвержден.',
    review_settings: 'Просмотреть настройки',

    // Mod admin
    mod_status: {
      pending_has_file:
        'Для запуска {ugc} требуется одобрение модератора игры.',
      pending_curation:
        'Как только файл будет добавлен и утвержден, статус {ugc} изменится на активный.',
      pending_no_curation:
        'После добавления файла {ugc} перейдет в активный статус.',
      archived:
        'Файл {ugc} заархивирован. Все подписчики удалены, и их нельзя просмотреть или получить с помощью запросов API.',
      hidden: '{ugc} скрыт и доступен только подписчикам и членам команды.',
      hidden_purchase_disabled: '{ugc} скрыт, так как монетизация отключена.',
      live: 'Игра {ugc} запущена и доступна для всех.',
    },
    mod_profile: '{ugc} профиль',
    media: 'СМИ',
    file_manager: 'Файловый менеджер',
    step: 'ШАГ {step}',
    save_next: 'Сохранить и продолжить',
    auth_required: 'Требуется аутентификация',
    public_text: '{ugc} доступен для всех на страницах просмотра.',
    private_text:
      '{ugc} доступен только членам команды, существующим подписчикам и пользователям с доступом к предварительному просмотру.',
    edit_disabled_on_add:
      'После создания {ugc} вы не сможете вносить изменения через Интернет.',
    edit_enabled_on_add:
      'Вы сможете вносить изменения в {ugc} после его создания.',
    add_mod_monetized:
      'Эта игра поддерживает монетизацию {ugc1}. Если вы планируете монетизировать игру {ugc2}, выберите {private} пока, а {public} позже после настройки монетизации. Настроить монетизацию можно после создания {ugc2}.',
    share_access: 'Поделиться доступом',
    profile_editing_disabled:
      'Редактирование профиля через Интернет в игре отключено.',
    tools_only_1:
      'Здесь вы не можете загрузить {ugc} для {game}, их необходимо загрузить с помощью инструментов, созданных разработчиком игры, чтобы файлы можно было проверить. Дополнительные сведения см. в разделе {guides}, написанные для этой игры. ',
    tools_only_2: 'Вот инструкции, предоставленные разработчиком игры:',
    tools_only_3:
      'Мы рекомендуем вам вернуться к списку {ugc} и просмотреть ссылки оттуда. Если проблема не исчезнет, посетите наш {help_center} для получения дополнительной информации.',
    unsaved_heading: 'У вас есть несохраненные изменения',
    unsaved_confirm:
      'Есть изменения, которые не были сохранены, вы все еще хотите уйти?',
    settings: 'Настройки',
    team: 'Команды',
    reports: 'Отчеты',
    stats: 'Статистика',
    moderator: 'Модератор',
    manager: 'Менеджер',
    error_get_mod: 'Не удалось получить {ugc}',
    archive_reason: 'Причина архивирования',
    view_mod: 'Показать {ugc}',
    error_archive_mod: 'Не удалось заархивировать {ugc}',
    archive_mod_prompt:
      'Архивирование этого {ugc} отменит подписку всех пользователей и удалит их из запросов API.',
    archive_mod_confirm:
      'После архивирования всем членам команды будет отправлено электронное письмо с уведомлением об этом действии с указанием причины.\n\nОтменить это действие могут только модераторы. Вы действительно хотите продолжить?',

    headline_mod_profile: 'Создайте свой профиль {ugc}',
    headline_media: 'Добавьте медиа в свой профиль {ugc}',
    headline_files: 'Загрузите файл {ugc}',
    headline_permissions:
      'Установите разрешения на повторное использование для вашего {ugc}',
    headline_dependencies: 'Добавьте любые зависимости {ugc}',

    // Basics
    basics: 'Основы',
    logo: 'Логотип',
    logo_prompt_1:
      'Файл изображения, который будет представлять логотип вашего {ugc}.',
    logo_prompt_2: '512x288 или больше',
    logo_prompt_3: 'Рекомендуемое соотношение сторон 16:9',
    logo_prompt_4: 'Максимум 8 МБ',
    summary_placeholder:
      'Расскажите нам об изменениях, которые ваш {ugc} вносит в игру, в 1 абзаце.',
    homepage: 'домашняя страница',
    profile_url: 'URL-адрес профиля',
    visibility: 'Видимость',
    visibility_tip:
      'После выхода в эфир публика {ugc} будет видна всем. Скрытые {ugc} видны только членам команды и подписчикам.',
    upload_images: 'Загрузка изображений',
    mature_content: 'Содержит контент для взрослых',
    mature_content_alcohol: 'Алкоголь',
    mature_content_drugs: 'Наркотики',
    mature_content_violence: 'Насилие',
    mature_content_explicit: 'Явный',
    community: 'Сообщество',
    allow_comments: 'Разрешить комментарии',
    allow_dependants: 'Разрешить иждивенцам',
    create_mod: 'Создайте {ugc}',
    error_mod_create: 'Не удалось создать {ugc}',
    error_mod_update: 'Не удалось обновить {ugc}',
    error_tags_update: 'Не удалось обновить теги',
    success_create_mod: 'Успешно создано {modname}',
    success_update_mod: 'Успешно обновлено {modname}',
    description_tip:
      'Дополнительное описание вашего {ugc}, которое может включать такие сведения, как «О нас», «Функции», «Использование», «Часто задаваемые вопросы» и т. д. Поддерживается и поощряется HTML',

    // Media
    models: 'моделей',
    media_reorder_hint:
      'Перетащите, чтобы изменить порядок существующих изображений, или поместите новые файлы изображений для загрузки.',
    media_zip_hint_1:
      'Загружайте до {count} изображений одновременно или один zip-файл, содержащий изображения.',
    media_zip_hint_2: 'Поддерживаемые форматы: .jpg, .jpeg, .png и .zip.',
    drag_and_drop_image: 'Перетащите изображения для загрузки',
    or_click_to_upload: 'Или нажмите, чтобы выбрать файл',
    error_media_update: 'Не удалось обновить носитель',
    error_media_add_links: 'Не удалось добавить ссылки на медиафайлы',
    error_media_remove_links: 'Не удалось удалить ссылки на медиафайлы',
    success_media_updated: 'Медиа успешно обновлены',

    // File manager
    add_file: 'Добавить файл',
    edit_file: 'Редактирование файла',
    select_zip: 'Выберите zip-файл',
    upload: 'Загрузить',
    file_id: 'Идентификатор файла:',
    virus_none: 'Вирус не обнаружен',
    virus_waiting: 'В ожидании сканирования',
    virus_scanning: 'Выполняется сканирование',
    virus_too_large: 'Файл слишком велик для сканирования',
    virus_not_found: 'Файл не найден',
    virus_error: 'Ошибка при сканировании файла',
    virus_found: 'Обнаружен вирус',
    virus_risk:
      'Этот файл содержит исполняемый файл, и его следует соблюдать осторожность при открытии',
    version_placeholder: 'Номер версии, т.е. 1.0.0',
    release_notes_placeholder: 'Введите каждое изменение в отдельной строке',
    game_moderator: 'Игровой модератор',
    metadata_blob: 'Блок метаданных',
    metadata_blob_placeholder:
      'Введите конкретные метаданные, такие как версия игры, с которой совместима эта версия, способ ее установки и т. д. Поддерживаются действительные данные в кодировке UTF-8.',
    select_platforms: 'Платформы (выберите все подходящие)',
    file_pending: 'В ожидании одобрения',
    file_approved: 'Утверждено',
    file_approved_live: 'Утверждено и запущено',
    file_approved_not_live: 'Одобрено, но не запущено',
    file_denied: 'Отказано',
    file_targeted: 'Целенаправленный',
    live_file:
      'Этот файл в настоящее время находится в режиме реального времени.',
    file_is_live: 'Файл находится в режиме реального времени',
    file_is_not_live: 'Файл не находится в режиме реального времени',
    no_delete_file_live:
      'Невозможно удалить, так как файл находится в режиме реального времени',
    make_file_live: 'Сделайте этот релиз в прямом эфире',
    make_file_live_platforms: 'Выпустите этот релиз для одобренных платформ',
    delete_file_prompt:
      'Вы действительно хотите удалить этот файл? Это действие нельзя отменить.',
    file_processing_title: 'Обработка файлов',
    file_processing:
      'Ваш файл обрабатывается. Вы можете продолжать просматривать сайт, но не закрывайте вкладку или окно браузера, пока они не закончатся.',
    file_instructions_1:
      'Заархивируйте архив и загрузите базовую папку вашего {ugc} или, если это набор файлов, которые находятся в уже существующей папке с игрой, вы должны заархивировать эти файлы:',
    file_instructions_2: 'Должен быть ZIP-файл',
    file_instructions_3: 'Размер файла не может превышать 20 ГБ',
    file_instructions_4:
      'Имена файлов не могут содержать следующие символы: \\ / ? " &lt; &gt; &#124; : *',
    file_instructions_5:
      '{ugc}, файлы перезаписи которых не поддерживаются, если игра не справится с этим',
    file_instructions_6:
      '{ugc}, которые занимают несколько игровых каталогов, не поддерживаются, если игра не справится с этим',
    file_terms: 'Я согласен с {terms} и {privacy}.',
    error_get_files: 'Не удалось получить файлы',
    error_upload_file_name: 'Не удалось загрузить файл {filename}',
    error_upload_file: 'Не удалось загрузить файл',
    error_update_file: 'Не удалось обновить файл',
    error_delete_file: 'Не удалось удалить файл',
    no_permission_delete_files: 'У вас нет разрешения на удаление файлов',
    error_file_required: 'Необходим файл',
    error_platform_required: 'Вы должны выбрать хотя бы одну платформу',
    success_file_uploaded: 'Файл успешно загружен',
    success_file_moderation:
      'Модератор рассмотрит платформы, требующие модерации',
    success_file_updated: 'Файл успешно обновлен',
    error_no_approved_platforms: 'Нет платформ для запуска',
    error_no_approved_platforms_text:
      'В этом файле нет утвержденных платформ, которые в настоящее время не работают',
    drag_and_drop_file: 'Перетащите файл для загрузки',
    file_upload_hint:
      'Принимаются только .zip файлы | максимальный размер файла {max}',
    upload_draft: 'Загрузить и сохранить как черновик',
    upload_publish: 'Загрузить и опубликовать',
    save_draft: 'Сохранить и оставить как черновик',
    save_publish: 'Сохранить и опубликовать',
    keep_as_draft: 'Оставить как черновик',
    publish_confirmation: 'Вы уверены, что хотите опубликовать этот файл?',
    marketplace_file_hint:
      'Если вы планируете монетизировать этот {mod}, вы должны оставить этот файл как черновик и настроить монетизацию перед публикацией.',
    curation_file_hint:
      'Модератор игры должен одобрить ваш {mod}, прежде чем игроки смогут получить к нему доступ.',
    platform_file_hint:
      'Эта игра требует одобрения платформы для каждого файла {mod} для выбранной(ых) платформы(м): {platforms}.',
    two_step_approval_process: 'Эта игра требует 2-этапный процесс одобрения:',
    two_step_approval_process_step1:
      'Одобрение игрового модератора для этого файла {mod} для выбранной(ых) платформы(м): {platforms}',
    two_step_approval_process_step2:
      'Одобрение игрового модератора для активации {mod}',
    two_step_approval_process_live:
      'Публикация этого файла также автоматически сделает {mod} активным после завершения обоих одобрений.',
    one_step_approval_process_live:
      'Публикация этого файла также автоматически сделает {mod} активным после одобрения.',

    // Reuse permissions form
    reuse_permissions: {
      heading: 'Разрешения на повторное использование',
      allow_redistribution:
        'Разрешить другим загружать мои ресурсы {ugc} на другие сайты, но я должен быть указан как оригинальный создатель',
      allow_porting:
        'Разрешите другим использовать мои ресурсы {ugc} для работы в других играх, но я должен быть назван автором оригинала',
      allow_patching_no_credit:
        'Разрешить другим изменять мои ресурсы {ugc} (включая исправление ошибок или улучшений) и выпускать их как новый {ugc}',
      require_credit: 'Я должен быть назван оригинальным создателем',
      require_permission: 'Сначала требуйте от меня разрешения',
      require_repackage_no_credit:
        'Разрешить другим использовать мои {0} активы в своих собственных {1}',
      allow_resell:
        'Разрешить другим использовать мои ресурсы {ugc} в любых файлах {ugc} /в любых коммерческих работах',
      original_assets:
        'Мой {ugc} содержит 100% оригинальных работ или активов, которые можно перераспределить',
      error_update: 'Не удалось обновить разрешения на повторное использование',
      success_update: 'Разрешения на повторное использование успешно обновлены',
      prompt:
        'Задайте разрешения на использование ваших ресурсов {ugc} для создания чужого контента. Разрешая другим пользователям использовать или изменять ваши файлы, вы подтверждаете, что такое разрешение не может быть отозвано задним числом в отношении уже созданных произведений.',
    },

    // Dependencies form
    dependencies_prompt:
      'Выберите {0}, необходимый для правильной работы {1} (если {1} не отображается, значит, зависимости запрещены, и вам следует связаться с создателем, чтобы включить его):',
    remove_dependency: 'Удалить зависимость',
    dependants: 'Иждивенцы',
    important: 'ВАЖНЫЙ',
    error_update_dependencies: 'Не удалось обновить зависимости',
    success_update_dependencies: 'Настройки зависимостей успешно обновлены',
    dependants_warning_1:
      'После получения разрешения имейте в виду, что {ugc} с подключенными иждивенцами:',
    dependants_warning_2: 'Невозможно отключить иждивенцев',
    dependants_warning_3: 'Не может быть удалено',
    dependants_warning_4: 'Невозможно монетизировать',
    no_dependants: 'Иждивенцев не обнаружено',
    dependencies_allow_prompt:
      'Вы должны включить опцию «Разрешить иждивенцам» выше, чтобы другие {ugc} могли добавить ваших иждивенцев в число иждивенцев.',
    dependencies_deny_prompt:
      'Вы можете отключить опцию «Разрешить иждивенцам» выше, если не хотите, чтобы другое {ugc} выбирало его в качестве зависимости',
    dependencies_not_supported:
      'Зависимости не поддерживаются {gamename}, все {ugc} должны работать независимо и быть полностью автономными.',
    dependency_disabled_monetization:
      'Монетизированный {ugc} не позволяет иждивенцам',
    dependency_disabled_dependants:
      'Невозможно отключить иждивенцев для этого {ugc_single}, так как другие {ugc_plural} зависят от этого. Их можно посмотреть на вкладке зависимостей.',
    dependants_confirm_enable:
      'Это необходимо для обеспечения постоянной совместимости подключенных {ugc}. Пожалуйста, подтвердите включение.',
    dependants_confirm_disable:
      'Вы действительно хотите запретить иждивенцам? Это означает, что другие {0} не смогут добавить вашу {1} в качестве зависимости.',
    dependency_monetization_warning:
      '{game} разрешает монетизацию {mod}. Монетизация в настоящее время не поддерживает {mods} с зависимостями. Если вы планируете монетизировать этот {mod}, пропустите этот шаг.',

    // Parental controls
    notify_parent_title: 'Уведомить родителя или опекуна',
    notify_parent:
      'Если вы продолжите, ваш родитель или опекун будет уведомлен и должен будет одобрить эти изменения, прежде чем они вступят в силу.',
    confirm_notify_parent:
      'Хотите ли вы отправить уведомление своему родителю или опекуну с просьбой предоставить доступ к предлагаемым изменениям разрешений?',
    request_access: 'Запросить доступ',

    // Cloud cooking
    cook_source: 'Приготовьте исходный файл',
    source_file: 'Исходный файл',
    targeted_platform: 'Целевая платформа',
    metadata: 'Метаданные',
    cook_time: 'время приготовления',
    download_time: 'Время загрузки',
    file_compression_time: 'время сжатия файла',
    file_decompression_time: 'время декомпрессии файла',
    upload_time: 'Время загрузки',
    total_job_time: 'Общее рабочее время',
    logs: 'Журналы',
    view_logs: 'Просмотр журналов',
    logs_available_on_completion:
      'Журналы будут доступны после завершения приготовления',
    logs_for_file: 'Журналы приготовления для {file}.',
    no_logs: 'Журналы для {file} не найдены.',
    get_logs_error: 'Не удалось получить журналы приготовления',
    admin_only: 'Только для администраторов',
    queue: 'Очередь',
    source_file_history: 'История исходных файлов',
    no_source_files_found: 'Исходные файлы не найдены',
    no_cooks_found: 'Повара не найдены',
    cook_jobs_available: 'Доступны вакансии по приготовлению файлов: {count}',
    view_details: 'Посмотреть подробности',
    cloud_cooking: 'Приготовление пищи в облаке',
    add_file_type: 'Добавить новую {string}',
    edit_file_type: 'Редактировать {string}',
    files: 'Файлы',
    cook_details: 'Информация о приготовлении',
    status_queued: 'В очереди',
    status_cooking: 'Приготовление пищи',
    status_success: 'Успешный',
    status_failed: 'Неуспешный',
    status_pending_moderation: 'Ожидается модерация',
    status_moderation_rejected: 'Кук отказался',
    get_cook_files_error:
      'Не удалось получить файлы для облачного приготовления пищи.',
    get_source_files_error: 'Не удалось получить исходные файлы.',
    download_file_error: 'Не удалось загрузить файл.',
    source_instructions:
      'Загрузите исходный файл и выберите нужную(ые) платформу(ы) ниже. Затем файл будет обработан с помощью Cloud Cooking, который создаст отдельные файлы для каждой платформы.',

    // Marketplace
    marketplace: {
      available_stock: 'Доступно ограниченное количество — осталось {count}',
      virtual_currency: 'Виртуальная валюта',
      marketplace: 'Торговая площадка',
      order_summary: 'Сводка заказа',
      payment_method: 'Способ оплаты | Способы оплаты',
      wallet_balance: 'Баланс кошелька',
      vc_balance: 'Баланс виртуальной валюты',
      credits: 'Кредиты',
      currency: 'валюта',
      balance_after: 'Баланс после покупки',
      token_purchase_success:
        'Спасибо за покупку. Ваш платеж обработан, и налоговая квитанция будет отправлена на вашу электронную почту в ближайшее время. Ваш баланс виртуальной валюты теперь обновлен для {game}',
      transaction_id: 'Идентификатор транзакции',
      total_paid: 'Общая выплаченная сумма',
      agreement: 'Я согласен с {terms} и {refund} mod.io',
      change_payment: 'Изменить платеж',
      error_register: 'Не удалось зарегистрироваться для монетизации',
      error_wallet: 'Не удалось получить игровой кошелек',
      error_process: 'Невозможно обработать платеж',
      error_complete: 'Невозможно завершить платеж',
      checkout: 'Оформить заказ',
      vc_topup_confirmed: 'Пополнение виртуальной валюты подтверждено',
      confirm_purchase: 'Подтвердите покупку',
      continue_browsing: 'Продолжить просмотр',
      back_to_mod: 'Вернуться к покупке {ugc}',
      ugc_not_refundable:
        'Покупки {ugc_plural} не возвращаются. Пожалуйста, ознакомьтесь с нашими {terms} и {refund} перед покупкой {ugc}.',
      ugc_purchase_success:
        'Спасибо за покупку. {ugc} добавлен к вашим подпискам в вашем {library} и доступен в игре.',
      game_virtual_currency: 'Игровая виртуальная валюта ({virtual_currency})',
      proceed_to_checkout: 'Перейти к оформлению заказа',
      ugc_purchase_confirmed: 'Покупка {ugc} подтверждена',
      error_already_purchased: 'У тебя уже есть этот {ugc}',
      error_sku_packs: 'Не удалось получить цены {ugc}',
      error_payment_methods: 'Не удалось получить способы оплаты',
      calculated_at_checkout: 'Рассчитывается при оформлении заказа',
      subtotal: 'Промежуточный итог',
      taxes: 'Налоги',
      total_due: 'Общая сумма к уплате',
      price: 'Цена',
      purchased: 'Куплено',
      purchases: 'Куплено {ugc}',
      no_purchases: 'Вы не купили ни одного {ugc}',
      purchase_to_rate: 'Вы можете оценить только купленный вами {ugc}',
      usd_ugc_license:
        'При покупке этого {ugc} вы мгновенно получаете кредиты {count} в обмен на лицензию на доступ к нему.',
      top_up: 'Пополнить',
      remaining_balance: 'Оставшийся баланс',
      not_enough_vc:
        'У вас недостаточно виртуальной валюты для продолжения. Пожалуйста, пополните свой игровой кошелек',
      error_virtual_currency_packs:
        'Не удалось получить пакеты виртуальной валюты',
      vc_prompt: 'Получите пакеты виртуальной валюты',
      vc_description:
        'Поддержите создателей контента и получите доступ к премиум-контенту, купив пакеты виртуальной валюты для {game}',
      vc_agreement:
        'Перед покупкой пакета виртуальной валюты ознакомьтесь с нашими {terms} и {refund}. Все применимые налоги взимаются при оформлении заказа.',
      error_session: 'Не удалось начать сеанс покупки',
      sold_out: 'Распроданный',
      currency_packs: 'Пакеты валют',
      cancel_transaction: 'Отменить транзакцию',
      cancel_transaction_text:
        'Вы уверены, что хотите отменить эту транзакцию?',
    },
  },
  'zh-CN': {
    language: '语言',

    // Nav
    browse: '浏览',
    library: '图书馆',
    my_content: '我的内容',
    account: '我的账户',
    back: '返回',
    more: '更多的',
    add_mod: '添加 {ugc}',
    edit_mod: '在 mod.io 上编辑',
    admin: '管理员',
    help_center: '帮助中心',
    subscribed_ugc: '已订阅 {ugc}',
    followed_collections: '关注的收藏集',
    page: '页面',

    // Guides
    guide: '指南|指南',
    views: '意见',
    table_of_contents: '目录',
    reading_time: '阅读时间',
    date_added: '添加日期',
    date_updated: '更新日期',
    minutes_read: '阅读分钟数',
    published: '已发表',
    show_more_tags: '显示不常见的标签',
    hide_more_tags: '隐藏不常见的标签',

    // Users
    joined: '已加入',
    last_online: '最后在线时间',
    online: '在线的',
    followers: '追随者',
    partner: '伙伴',
    partnered_creator: '合作创作者',
    profile_hidden: '该用户的个人资料已隐藏',
    follow: '跟随',
    unfollow: '取消关注',
    following: '正在关注',
    user: '用户',
    user_update_error: '用户更新失败',
    age_widget_error: '加载年龄小部件失败',

    // Mods
    mod: '模组',
    level: '水平|级别',
    content: '内容',
    subscribed: '已订阅',
    tags: '标签',
    summary: '概要',
    contributors: '作者',
    description: '描述',
    dependencies: '依赖项',
    no_dependencies: '这个 {ugc} 没有依赖关系',
    of: '/',
    ago: '前',
    and: '和',
    by: '经过',
    reset_filters: '重置过滤器',
    show_more: '展示更多',
    show_less: '显示较少',
    no_ugc_found: '未找到 {ugc_name}',
    no_subscriptions: '你还没有订阅任何 {ugc_name}',
    mod_disclaimer_heading: '法律免责声明',
    mod_disclaimer_privacy: '请查看我们的隐私权政策',
    thumbs_up_received: '已收到竖起大拇指',
    thumbs_up: '竖起大拇指',
    total_downloads: '总下载量',
    releases: '发布',
    bytes: '字节',
    local_mod_disabled:
      '由于缺少一个或多个依赖项，无法加载此 {ugc}：{dependencies}',
    mod_with_collections: '带有这个 {ugc} 的收藏集',
    see_all_collections: '查看所有 {count} 集合',
    mod_dependencies: '需要安装所有依赖项才能使此 {ugc} 起作用。',
    mod_dependencies_prompt: '这个 {ugc} 有必需的依赖关系。你也想订阅吗？',
    allow_in_collections: '允许添加到收藏集',
    allow_in_collections_tip:
      '如果启用此选项，其他用户将能够将您的 {ugc} 添加到收藏集。',

    // Actions
    login: '登录',
    logout: '退出',
    search: '搜索',
    clear_all: '全部清除',
    download: '下载',
    subscribe: '订阅',
    unsubscribe: '取消订阅',
    resubscribe: '重新订阅',
    activate: '激活',
    deactivate: '停用',
    like: '赞',
    dislike: '踩',
    report: '报告一个问题',
    submit: '提交',
    cancel: '取消',
    done: '完成',
    select: '选择',
    previous: '以前',
    next: '下一步',
    confirm: '确认',
    allow: '允许',
    manage: '管理',
    discard: '放弃更改',
    more_actions: '更多动作',
    manage_interaction_settings: '管理互动设置',
    block: '屏蔽',
    block_user: '屏蔽用户联系',
    unblock: '取消屏蔽',
    user_blocked: '您已屏蔽该用户，因此他们无法联系您或评论您的内容',
    block_user_tooltip: '阻止该用户联系您或评论您的内容。',
    block_prompt: '您确定要屏蔽该用户吗？他们将无法联系您或评论您的内容。',
    block_success: '用户已成功屏蔽。',
    unblock_success: '用户已成功取消屏蔽。',
    unblock_prompt:
      '您确定要取消屏蔽该用户吗？他们将能够再次联系您并评论您的内容。',
    mute: '静音',
    mute_user: '静音用户{ugc}',
    unmute: '取消静音',
    user_muted: '您已将该用户设为静音，因此您看不到他们的 {ugc}',
    mute_user_tooltip: '在浏览游戏时，阻止该用户创建的 {ugc} 向您展示',
    mute_prompt:
      '您确定要将该用户静音吗？浏览游戏时，您将不会再看到他们提交的任何 {ugc}。',
    mute_success: '用户已成功静音。',
    unmute_success: '用户已成功取消静音。',
    unmute_prompt: '您确定要取消该用户的静音吗？您将能够再次看到他们的内容。',
    publish: '发布',
    block_error: '更新用户屏蔽状态失败',
    mute_error: '更新用户静音状态失败',

    // Collections
    collection: '藏品 | 馆藏',
    total_mods: '总计 {ugc}',
    total_filesize: '文件总大小',
    follow_collection: '关注收藏',
    unfollow_collection: '取消关注收藏',
    compatibility: '兼容性',
    compat_rating: '兼容性评级',
    last_30_days: '最近 30 天',
    all_time: '所有时间',
    does_collection_work: '这个系列对你有用吗？',
    collection_works: '是的，确实如此',
    collection_doesnt_work: '不，不是',
    collection_incomplete_subscriptions: '订阅不完整',
    vote: '票',
    curator: '策展人',
    creator_count: '此收藏中有 {count} 位创作者',
    mods_in_collection: '此集合中包含的所有 {ugc}',
    mod_not_available: '这个 {ugc} 不再可用',
    unavailable: '不可用',
    collection_sub_mods: '为我订阅此收藏集中的所有 {ugc}',
    collection_unsub_mods: '取消我订阅此收藏集中的所有 {ugc}',
    collection_unsub_hint:
      '如果不选中，该馆藏将从您的库中移除，但您将继续订阅其 {ugc}。',
    collection_error_subscribe: '订阅收藏集失败 {ugc}',
    collection_error_unsubscribe: '无法取消订阅收藏集 {ugc}',
    collection_error_follow: '未能关注采集',
    collection_error_unfollow: '取消关注收藏失败',
    ugc_count: '{ugc} 计数',
    collections_incomplete: '有些 {ugc} 不可用，这可能会影响兼容性',
    adult: '成人',
    view_more: '查看更多',
    view_less: '查看更少',

    // Categories
    category: '类别',
    miscellaneous: '杂项',
    essential: '必备',
    themed: '主题',
    animation: '动画',
    audio: '音频',
    bug_fixes: '错误修复',
    cheating: '作弊',
    environment: '环境',
    gameplay: '游戏玩法',
    quality_of_life: '生活质量',
    ui: '用户界面',
    visuals: '视觉效果',

    // Filters
    all: '全部',
    available: '可用',
    filesize: '文件大小',
    downloads: '下载量',
    todays_downloads: '今日下载量',
    subscribers: '订阅者',
    rating: '评分',
    sort_by: '排序方式',
    creator: '创建者',
    apply: '申请',
    reset: '重置',
    featured: '特色',
    toggle_filters: '切换过滤器',
    show_filters: '显示筛选器',
    hide_filters: '隐藏筛选条件',
    admin_options: '管理员选项',
    hidden: '隐',
    public: '公开',
    private: '私人',
    pending: '待办的',
    archived: '已存档',
    deleted: '已删除',
    last_day: '最后一天',
    hidden_monetization_disabled: '由于禁用获利功能而隐藏',
    date_live: '直播日期',
    last_week: '上星期',
    last_month: '上个月',
    last_3_months: '过去 3 个月',
    last_year: '去年',
    exclude: '排除',
    no_matching_content: '没有匹配的内容可用',
    content_type: '内容类型',
    free: '免费',
    premium: '高级',

    // Login
    signup: '使用电子邮件登录或注册',
    login_with: '使用 {service} 登录',
    email_placeholder: '电子邮件地址',
    code_placeholder: '5 位代码',
    have_code: '我有代码',
    send_new_code: '发送新代码',
    login_disclaimer: '{game} 的用户生成内容由 mod.io 管理。',
    terms_disclaimer: `按“登录”即表示您同意 {studioterms}mod.io 的{terms}和{privacy}，并确认您已年满 {min_age} 岁。`,
    terms_disclaimer_studio: '{studio} 的{terms}、',
    terms_disclaimer_studio_separator: '、',
    terms_disclaimer_studio_and: '和',
    code_error: '无法请求代码。',
    or: '或者',
    login_prompt: '您尝试访问的页面需要身份验证。请登录以继续。',
    receive_code: '没有收到代码？',
    resend_code: '重新发送代码',
    login_with_email: '使用电子邮件登录',
    otp_email: '我们已将一次性密码 (OTP) 发送至 {email}。请输入该密码以继续。',
    back_to_login: '返回登录选项',

    // Terms
    terms: '使用条款',
    privacy: '隐私政策',
    aup: '可接受的使用政策',
    monetization: '获利条款',
    game: '游戏条款',
    api: 'API访问条款',
    refund: '退款政策',
    effective: '生效日期：',

    // Report
    report_heading: '举报这个 {ugc}',
    report_intro:
      '您可以报告内容问题、违反 mod.io {terms} 的行为或使用下面的表单提交 {dmca}。',
    report_intro_collection:
      '您可以使用下面的表格报告内容问题、违反 mod.io {terms} 的行为。',
    report_details:
      '确保包含所有相关信息，以促进报告的解决。请注意，此信息将与游戏管理员共享，并可能与发布涉嫌侵权内容的用户共享。',
    report_not_working_prompt: '“不起作用”报告将直接与内容创建者共享。',
    dmca: 'DMCA 投诉',
    report_reason: '举报原因',
    urls: '违规网址',
    urls_placeholder: '网址（每行 1 个）',
    company_or_name: '公司或你的名字',
    email: '电子邮件',
    address: '地址',
    country: '国家/地区',
    country_placeholder: '选择一个国家/地区',
    details: '侵权详情',
    details_placeholder:
      '为了帮助解决您的报告，请提供尽可能多的详细信息和背景。',
    dmca_1:
      '{mod_io} 尊重他人的知识产权，我们要求每个使用我们网站和服务的人都这样做。如果你认为你的作品在我们的网站或服务中被以侵权版权的方式重现，你可以使用以下表单通知 mod.io 的版权代理。',
    dmca_2:
      '提交版权侵犯申诉是一项严肃的法律事务。在继续之前，你可以考虑直接联系当事人以解决投诉。这可能只是一个误会，可以在不涉及适当法律程序的情况下解决。',
    dmca_3:
      '请注意，根据《数字千年版权法案》第 512(f) 条，任何人如果故意歪曲材料或活动侵权，则可能需要承担损害赔偿责任。另请注意，本法律声明中提供的信息可能会与第三方共享或公开。',
    claim_check: '勾选以下方框并提交此申诉，如有伪证则将受罚，我声明',
    copyright_owner: '我是版权所有者',
    copyright_auth_owner: '在这种情况下，我被授权代表版权所有者行事。',
    authorization: '授权',
    authorization_check:
      '我有正当理由相信，本声明中所述材料的使用未经版权所有者、其代理人或法律授权。',
    acknowledgement: '知悉书',
    acknowledgement_check:
      '我知悉，根据 DMCA 第 512(f) 条，任何人如果故意歪曲材料或活动侵权，则可能需要承担损害赔偿责任。',
    required: '必填',
    signature: '签名',
    signature_placeholder: '在此框中输入你的全名，作为你的数字签名。',
    report_success_title: '你的举报已送达',
    report_success_text:
      '如果您的报�需要更多详细信息，我们可能会联系您提供。感谢您提供详细信息。',
    report_error_title: '提交举报失败',
    report_email_inform: '您的电子邮件地址仅用于处理此举报。',

    // Table
    name: '名称',
    added: '存在时长',
    updated: '更新日期',
    date: '日期',
    item: '项目',
    file: '文件',
    version: '版本',
    scan: '病毒扫描',
    actions: '操作',
    status: '状态',
    role: '角色',
    live: '直播',
    locally_installed: '本地安装',

    // Releases
    download_from_game_client: '从游戏客户端下载 {mod}',
    download_payment_required: '购买即可下载 {ugc}',
    download_auth_required: '登录下载 {ugc}',
    release_notes: '版本说明',
    no_release_notes: '未提供版本说明',
    previous_releases: '之前的版本',
    view_previous_releases: '查看以前的版本',
    no_previous_releases: '没有之前的版本',
    no_files_published: '未发布文件',
    download_files_manually: '手动下载文件',
    platforms: '平台 | 平台',

    // Ratings
    overwhelmingly_positive: '好评如潮',
    overwhelmingly_negative: '差评如潮',
    very_positive: '特别好评',
    very_negative: '特别差评',
    mostly_positive: '多半好评',
    mostly_negative: '多半差评',
    negative: '差评',
    positive: '好评',
    mixed: '褒贬不一',
    unrated: '未评分',

    // Sort
    sort_comments: '评论',
    sort_total_mods: '模组总数',
    sort_trending: '热门',
    sort_highest_rated: '收视率最高',
    sort_most_popular: '最受欢迎',
    sort_most_subscribers: '大多数订阅者',
    sort_recently_added: '最近添加的',
    sort_last_updated: '最近更新时间',
    sort_alphabetical: '按字母顺序',
    sort_smallest_filesize: '最小的文件大小',

    // Report Reason
    report_dmca: 'DMCA',
    report_not_working: '不工作',
    report_rude_content: '粗鲁的内容',
    report_illegal_content: '非法内容',
    report_stolen_content: '被盗内容',
    report_false_information: '虚假信息',
    report_other: '其他',

    // Report not working reasons
    report_crash: '游戏崩溃',
    report_no_load: '不加载',
    report_conflicts: '与其他 {ugc} 冲突',
    report_missing_deps: '缺少依赖项',
    report_install_issues: '安装问题',
    report_bugs: '越野车行为',
    report_incompatability: '与游戏版本不兼容',
    report_corrupt: '文件损坏',

    // Errors
    warning: '警告',
    error_ref: '错误代码： ',
    login_fail: '登录失败',
    login_fail_message: '登录失败。请等待一分钟，然后重试。',
    subscribe_fail: '未能订阅',
    unsubscribe_fail: '未能取消订阅',
    error: '错误',
    default_error_message: '发生错误，请尽快重试。',
    follow_error: '未能关注',
    unfollow_error: '取消关注失败',
    upload_file_error: '您必须至少上传一个文件才能继续',

    agreement_not_found: '未找到协议',
    form_chars_remaining: '{count}剩下的字符。',
    form_not_enough_chars: '{count}需要更多字符。',
    filter: '筛选',
    loading: '加载',
    next_version: '下一个版本',
    no_results_found: '未找到结果',
    page_not_found: '找不到网页！',
    previous_version: '以前的版本',
    take_me_home: '带我回家',
    validation_alpha_num: '字段只能包含数字或字母',
    validation_size: '字段必须为{size}字符',
    validation_url: '字段必须是一个URL',
    validation_min: '最少 {min} 个字符',
    validation_max: '最大{max}字符',
    validation_email: '字段必须是一封电子邮件',
    validation_checked: '必须检查字段',
    validation_required: '需要字段',
    validation_name: '字段只能包含字母和与名称相关的符号',
    validation_image: '文件必须是有效的 jpeg 或 png 图片',
    validation_youtube: '字段必须是有效的 Youtube 网址',
    validation_sketchfab: '字段必须是有效的 Sketchfab 网址',
    validation_zip: '文件必须是 ZIP',
    validation_filesize: '文件大小不得超过 {size}',
    delete_image: '删除图片',
    confirm_delete_image: '您确定要删除这张图片吗？',

    comment: '评论',
    team_member: '队员',
    game_admin: '游戏管理员',
    site_admin: '网站管理员',
    author: '作者',
    good_karma: '顶',
    bad_karma: '踩',
    reply: '回复',
    replies: '回复|回复',
    replied: '已回复',
    reopen: '重新打开',
    close: '关闭',
    mark_as_read: '标记为已读',
    save: '保存',
    delete: '删除',
    archive: '档案',
    edit: '编辑',
    post: '发布',
    pinned: '已固定',
    pin: '别针',
    unpin: '取消固定',
    locked: '锁定',
    lock: '锁',
    unlock: '解锁',
    add_comment: '添加评论...',
    comment_cant_reply_locked: '无法回复，因为评论话题已锁定',
    comment_cant_edit_locked: '无法编辑，因为评论话题已被锁定',
    comment_max_pin_limit: '已达到最大置顶评论上限',
    comment_below_threshold: '评论低于阈值。点击查看。',
    comment_login_prompt: '登录以加入讨论！',
    comment_error_add: '未能添加评论',
    comment_error_edit: '未能编辑评论',
    comment_error_delete: '无法删除评论',
    comment_error_rate: '未能对评论进行评级',
    comment_error_update: '更新评论失败',
    comments_error_fetch: '无法加载更多评论',
    discussion: '讨论',
    load_more_comments: '加载更多评论',
    comment_confirm_delete: '你确定要删除此评论吗？',
    comment_deleted: '评论已成功删除',
    comments_disabled: '由于您的帐户已启用家长控制功能，评论功能已被禁用。',
    comments_age_unverified: '您的年龄必须经过验证才能发表评论。',
    review_settings: '查看设置',

    // Mod admin
    mod_status: {
      pending_has_file: '{ugc} 需要游戏管理员的批准才能上线。',
      pending_curation: '添加和批准文件后，{ugc} 将更改为实时状态。',
      pending_no_curation: '添加文件后，{ugc} 将更改为实时状态。',
      archived:
        '{ugc} 已存档。所有订阅者均已删除，无法通过 API 请求查看或检索。',
      hidden: '{ugc} 处于隐藏状态，仅供订阅者和团队成员使用。',
      hidden_purchase_disabled: '由于已禁用获利功能，{ugc} 处于隐藏状态。',
      live: '{ugc} 已上线，可供所有人玩。',
    },
    mod_profile: '{ugc} 个人资料',
    media: '媒体',
    file_manager: '文件管理器',
    step: '第{step}步',
    save_next: '保存并下一步',
    auth_required: '需要进行身份验证',
    public_text: '所有人均可在浏览页面上发现 {ugc}。',
    private_text: '{ugc} 仅供团队成员、现有订阅者和具有预览权限的用户访问。',
    edit_disabled_on_add: '创建此 {ugc} 后，您将无法通过网络进行更改。',
    edit_enabled_on_add: '创建 {ugc} 后，您将能够对其进行更改。',
    add_mod_monetized:
      '该游戏支持获利 {ugc1}。如果你打算通过这个 {ugc2} 获利，请暂时选择 {private}，然后在设置盈利后再使用 {public}。创建 {ugc2} 后，您可以设置获利。',
    share_access: '共享访问权限',
    profile_editing_disabled: '游戏已禁用通过网络编辑个人资料。',
    tools_only_1:
      '你不能在这里上传 {game} 的 {ugc}，它们必须使用游戏开发者创建的工具上传，这样文件才能得到验证。有关更多信息，请参阅为该游戏编写的 {guides}。',
    tools_only_2: '以下是游戏开发者提供的说明：',
    tools_only_3:
      '我们建议您返回 {ugc} 列表并从那里浏览链接。如果问题仍然存在，请前往我们的 {help_center} 获取更多信息。',
    unsaved_heading: '您有未保存的更改',
    unsaved_confirm: '有些更改尚未保存，你还想离开吗？',
    settings: '设置',
    team: '球队',
    reports: '报告',
    stats: '统计数据',
    moderator: '主持人',
    manager: '经理',
    error_get_mod: '无法获取 {ugc}',
    archive_reason: '存档原因',
    view_mod: '查看 {ugc}',
    error_archive_mod: '无法存档 {ugc}',
    archive_mod_prompt:
      '存档此 {ugc} 将取消所有用户的订阅并将其从 API 请求中移除。',
    archive_mod_confirm:
      '存档后，将向所有团队成员发送一封电子邮件，通知他们此操作以及提供的原因。\n\n此操作只能由主持人撤销，您确定要继续吗？',

    headline_mod_profile: '创建您的 {ugc} 个人资料',
    headline_media: '将媒体添加到您的 {ugc} 个人资料',
    headline_files: '上传您的 {ugc} 文件',
    headline_permissions: '为您的 {ugc} 设置重用权限',
    headline_dependencies: '添加任何 {ugc} 依赖项',

    // Basics
    basics: '基础知识',
    logo: '徽标',
    logo_prompt_1: '将代表您的 {ugc} 徽标的图片文件。',
    logo_prompt_2: '512x288 或更大',
    logo_prompt_3: '建议纵横比 16:9',
    logo_prompt_4: '最大 8MB',
    summary_placeholder: '在 1 段中告诉我们您的 {ugc} 对游戏所做的更改。',
    homepage: '主页',
    profile_url: '个人资料网址',
    visibility: '能见度',
    visibility_tip:
      '上线后，所有人都可以看到公开 {ugc}。隐藏的 {ugc} 仅对团队成员和订阅者可见。',
    upload_images: '上传图片',
    mature_content: '包含成人内容',
    mature_content_alcohol: '酒精',
    mature_content_drugs: '毒品',
    mature_content_violence: '暴力',
    mature_content_explicit: '明确的',
    community: '社区',
    allow_comments: '允许评论',
    allow_dependants: '允许受抚养人',
    create_mod: '创建 {ugc}',
    error_mod_create: '创建 {ugc} 失败',
    error_mod_update: '更新 {ugc} 失败',
    error_tags_update: '更新标签失败',
    success_create_mod: '成功创建 {modname}',
    success_update_mod: '成功更新 {modname}',
    description_tip:
      '您的 {ugc} 的可选描述，其中可能包括 “关于”、“功能”、“用法”、“常见问题” 等详细信息。支持和鼓励 HTML',

    // Media
    models: '模型',
    media_reorder_hint: '拖拽以重新排序现有图像，或拖放新的图像文件进行上传。',
    media_zip_hint_1:
      '一次上传最多 {count} 张图片，或包含图片的单个 zip 文件。',
    media_zip_hint_2: '支持的格式是 .jpg、.jpeg、.png 和 .zip。',
    drag_and_drop_image: '拖放图片进行上传',
    or_click_to_upload: '或点击选择文件',
    error_media_update: '更新媒体失败',
    error_media_add_links: '添加媒体链接失败',
    error_media_remove_links: '删除媒体链接失败',
    success_media_updated: '成功更新媒体',

    // File manager
    add_file: '添加一个文件',
    edit_file: '编辑文件',
    select_zip: '选择 zip 文件',
    upload: '上传',
    file_id: '文件编号：',
    virus_none: '未检测到病毒',
    virus_waiting: '等待扫描',
    virus_scanning: '正在扫描',
    virus_too_large: '文件太大而无法扫描',
    virus_not_found: '文件未找到',
    virus_error: '扫描文件时出错',
    virus_found: '检测到病毒',
    virus_risk: '此文件包含可执行文件，打开时应小心',
    version_placeholder: '版本号，即 1.0.0',
    release_notes_placeholder: '在单独的行中输入每项更改',
    game_moderator: '游戏主持人',
    metadata_blob: '元数据 blob',
    metadata_blob_placeholder:
      '输入特定的元数据，例如此版本兼容的游戏版本、如何安装等。支持 UTF-8 有效数据。',
    select_platforms: '平台（选择所有适用的选项）',
    file_pending: '待批准',
    file_approved: '已批准',
    file_approved_live: '已获批准并上线',
    file_approved_not_live: '已批准但未上线',
    file_denied: '已拒绝',
    file_targeted: '有针对性',
    live_file: '此文件当前处于活动状态。',
    file_is_live: '文件已上线',
    file_is_not_live: '文件未上线',
    no_delete_file_live: '无法删除，因为文件处于活动状态',
    make_file_live: '将此版本上线',
    make_file_live_platforms: '在经批准的平台上发布此版本',
    delete_file_prompt: '你确定要删除这个文件吗？此操作无法撤消。',
    file_processing_title: '文件处理',
    file_processing:
      '您的文件正在处理中。您可以继续浏览该站点，但请不要关闭选项卡或浏览器窗口，直到它完成。',
    file_instructions_1:
      '压缩并上传您的 {ugc} 的基本文件夹，或者如果它是存在于现有游戏文件夹中的文件集合，则应压缩这些文件：',
    file_instructions_2: '必须是 ZIP 文件',
    file_instructions_3: '文件大小不能超过 20 GB',
    file_instructions_4:
      '文件名不能包含以下任何字符：\\ / ? " &lt; &gt; &#124; : *',
    file_instructions_5: '除非游戏对此进行管理，否则不支持覆盖文件的 {ugc}',
    file_instructions_6:
      '除非游戏对其进行管理，否则不支持跨越多个游戏目录的 {ugc}',
    file_terms: '我同意 {terms} 和 {privacy}。',
    error_get_files: '无法获取文件',
    error_upload_file_name: '无法上传文件 {filename}',
    error_upload_file: '上传文件失败',
    error_update_file: '更新文件失败',
    error_delete_file: '未能删除文件',
    no_permission_delete_files: '你没有权限删除文件',
    error_file_required: '文件为必填项',
    error_platform_required: '必须选择至少一个平台',
    success_file_uploaded: '文件已成功上传',
    success_file_moderation: '版主将审查需要审核的平台',
    success_file_updated: '文件已成功更新',
    error_no_approved_platforms: '没有平台可以上线',
    error_no_approved_platforms_text: '此文件没有经批准且当前未上线的平台',
    drag_and_drop_file: '拖放文件进行上传',
    file_upload_hint: '仅接受 .zip 文件 | {max} 最大文件大小',
    upload_draft: '上传并保存为草稿',
    upload_publish: '上传并发布',
    save_draft: '保存并保持为草稿',
    save_publish: '保存并发布',
    keep_as_draft: '保存为草稿',
    publish_confirmation: '您确定要发布此文件吗？',
    marketplace_file_hint:
      '如果您打算将此{mod}货币化，您应该将此文件保存为草稿，并在发布前先设置货币化。',
    curation_file_hint: '游戏管理员必须在玩家能够访问之前批准您的{mod}。',
    platform_file_hint:
      '此游戏需要对选定平台上的每个{mod}文件进行平台审批：{platforms}。',
    two_step_approval_process: '此游戏需要两步审批流程：',
    two_step_approval_process_step1:
      '对于选定平台上的此{mod}文件需要游戏管理员审批：{platforms}',
    two_step_approval_process_step2: '游戏管理员审批{mod}上线',
    two_step_approval_process_live:
      '发布此文件也将在两个审批都完成后自动将{mod}设置为活跃状态。',
    one_step_approval_process_live:
      '发布此文件也将在批准后自动将{mod}设置为活跃状态。',

    // Reuse permissions form
    reuse_permissions: {
      heading: '重用权限',
      allow_redistribution:
        '允许其他人将我的 {ugc} 资产上传到其他网站，但我必须记入原始创作者的身份',
      allow_porting:
        '允许其他人将我的 {ugc} 资产转换为在其他游戏中使用，但我必须获得原始创作者的资格',
      allow_patching_no_credit:
        '允许其他人修改我的 {ugc} 资产（包括发布错误修复或改进）并将其作为新的 {ugc} 发布',
      require_credit: '我必须被认定为原创作者',
      require_permission: '首先需要我的许可',
      require_repackage_no_credit: '允许其他人在自己的 {1} 中使用我的 {0} 资产',
      allow_resell:
        '允许其他人在任何商业作品的任何 {ugc} /文件中使用我的 {ugc} 资产',
      original_assets: '我的 {ugc} 包含 100% 的原创作品或可以重新分配的资产',
      error_update: '更新重用权限失败',
      success_update: '成功更新了重用权限',
      prompt:
        '设置如何使用您的 {ugc} 资产创建他人内容的权限。授予他人使用或修改您的文件的权限，即表示您承认无法追溯撤销对已创作品的此类授权。',
    },

    // Dependencies form
    dependencies_prompt:
      '为此 {1} 选择所需的 {0} 才能正常运行（如果未显示 {1}，则表示它不允许依赖关系，您应联系创建者将其打开）：',
    remove_dependency: '移除依赖关系',
    dependants: '受抚养人',
    important: '重要',
    error_update_dependencies: '更新依赖关系失败',
    success_update_dependencies: '成功更新依赖项设置',
    dependants_warning_1: '一旦允许，请注意，连接了受抚养人的 {ugc}：',
    dependants_warning_2: '无法禁用受抚养人',
    dependants_warning_3: '无法删除',
    dependants_warning_4: '无法获利',
    no_dependants: '未找到受抚养人',
    dependencies_allow_prompt:
      '您必须开启上面的 “允许受抚养人”，其他 {ugc} 才能将您的受抚养人添加为受抚养人。',
    dependencies_deny_prompt:
      '如果你不想让其他 {ugc} 将其选为依赖关系，你可以关闭上面的 “允许受抚养人”',
    dependency_disabled_monetization: 'Monetized {ugc} 无法启用受抚养人',
    dependencies_not_supported:
      '{gamename} 不支持依赖关系，所有 {ugc} 必须独立运行并且完全独立。',
    dependency_disabled_dependants:
      '无法禁用此 {ugc_single} 的受抚养人，因为其他 {ugc_plural} 依赖它。可以从 “依赖关系” 选项卡中查看这些内容。',
    dependants_confirm_enable:
      '这是为了确保连接的 {ugc} 的持续兼容性。请确认启用。',
    dependants_confirm_disable:
      '你确定要禁止受抚养人吗？这意味着其他 {0} 将无法将您的 {1} 添加为依赖关系。',
    dependency_monetization_warning:
      '{game} 允许 {mod} 货币化。货币化目前不支持具有依赖关系的 {mods}。如果您打算将此 {mod} 货币化，请跳过此步骤。',

    // Parental controls
    notify_parent_title: '通知家长或监护人',
    notify_parent:
      '如果您继续操作，您的父母或监护人将会收到通知，并且必须批准这些更改后，这些更改才会生效。',
    confirm_notify_parent:
      '您是否希望向您的父母或监护人发送通知，请求他们查看拟议的权限变更？',
    request_access: '请求访问',

    // Cloud cooking
    cook_source: '烹饪源文件',
    source_file: '源文件',
    targeted_platform: '目标平台',
    metadata: '元数据',
    cook_time: '烹饪时间',
    download_time: '下载时间',
    file_compression_time: '文件压缩时间',
    file_decompression_time: '文件解压缩时间',
    upload_time: '上传时间',
    total_job_time: '总工作时间',
    logs: '日志',
    view_logs: '查看日志',
    logs_available_on_completion: '日志将在烹饪完成后提供',
    logs_for_file: '为 {file} 做日志。',
    no_logs: '未找到 {file} 的日志。',
    get_logs_error: '无法获取烹饪日志',
    admin_only: '仅限管理员',
    queue: '队列',
    source_file_history: '源文件历史记录',
    no_source_files_found: '未找到源文件',
    no_cooks_found: '没有找到厨师',
    cook_jobs_available: '文件烹饪任务可用：{count}',
    view_details: '查看详情',
    cloud_cooking: '云烹饪',
    add_file_type: '添加一个新的 {string}',
    edit_file_type: '编辑 {string}',
    files: '文件',
    cook_details: '烹饪详情',
    status_queued: '已排队',
    status_cooking: '烹饪',
    status_success: '成功的',
    status_failed: '失败的',
    status_pending_moderation: '待审核',
    status_moderation_rejected: '库克拒绝',
    get_cook_files_error: '获取云端烹饪文件失败',
    get_source_files_error: '获取源文件失败',
    download_file_error: '文件下载失败',
    source_instructions:
      '上传源文件，并在下方选择目标平台。文件将通过云端编译处理，生成适用于各个平台的独立文件。',

    // Marketplace
    marketplace: {
      available_stock: '数量有限，剩余 {count} 件',
      virtual_currency: '虚拟货币',
      marketplace: '市场',
      order_summary: '订单摘要',
      payment_method: '付款方式 | 付款方式',
      wallet_balance: '钱包余额',
      vc_balance: '虚拟货币余额',
      credits: '积分',
      currency: '货币',
      balance_after: '购买后的余额',
      token_purchase_success:
        '感谢您的购买。您的付款已处理完毕，税收收据将很快发送到您的电子邮件中。您的 {game} 虚拟货币余额现已更新',
      transaction_id: '交易编号',
      total_paid: '支付的总金额',
      agreement: '我同意 mod.io 的 {terms} 和 {refund}',
      change_payment: '更改付款',
      error_register: '未能注册获利',
      error_wallet: '无法获取游戏钱包',
      error_process: '无法处理付款',
      error_complete: '无法完成付款',
      checkout: '结账',
      vc_topup_confirmed: '虚拟货币充值已确认',
      confirm_purchase: '确认购买',
      continue_browsing: '继续浏览',
      back_to_mod: '返回 {ugc} 购买',
      ugc_not_refundable:
        '{ugc_plural} 购买的商品不可退款。在购买这个 {ugc} 之前，请查看我们的 {terms} 和 {refund}。',
      ugc_purchase_success:
        '感谢您的购买。{ugc} 已添加到您的 {library} 的订阅中，并且可以在游戏中使用。',
      game_virtual_currency: '游戏虚拟货币 ({virtual_currency})',
      proceed_to_checkout: '继续结账',
      ugc_purchase_confirmed: '{ugc} 已确认购买',
      error_already_purchased: '你已经拥有这个 {ugc}',
      error_sku_packs: '无法获取 {ugc} 价格',
      error_payment_methods: '无法获取付款方式',
      calculated_at_checkout: '结账时计算',
      subtotal: '小计',
      taxes: '税收',
      total_due: '应付总金额',
      price: '价格',
      purchased: '已购买',
      purchases: '已购买 {ugc}',
      no_purchases: '你还没有购买任何 {ugc}',
      purchase_to_rate: '您只能对已购买的 {ugc} 进行评分',
      usd_ugc_license:
        '购买这个 {ugc} 会立即获得 {count} 积分，以换取访问它的许可证。',
      top_up: '充值',
      remaining_balance: '剩余余额',
      not_enough_vc: '您没有足够的虚拟货币来继续。请给你的游戏钱包充值',
      error_virtual_currency_packs: '无法获取虚拟货币包',
      vc_prompt: '获取您的虚拟货币包',
      vc_description:
        '通过购买 {game} 的虚拟货币包来支持内容创作者并访问优质内容',
      vc_agreement:
        '在购买虚拟货币包之前，请查看我们的 {terms} 和 {refund}。所有适用的税费均在结账时适用。',
      error_session: '无法获取购买会话',
      sold_out: '售罄',
      currency_packs: '货币包',
      cancel_transaction: '取消交易',
      cancel_transaction_text: '您确定要取消这笔交易吗？',
    },
  },
  'zh-TW': {
    language: '語言',

    // Nav
    browse: '瀏覽',
    library: '圖書館',
    my_content: '我的內容',
    account: '我的賬戶',
    back: '返回',
    more: '更多的',
    add_mod: '添加 {ugc}',
    edit_mod: '在 {模組 .io} 上進行編輯',
    admin: '管理員',
    help_center: '幫助中心',
    subscribed_ugc: '已訂閱 {ugc}',
    followed_collections: '關注的收藏',
    page: '頁面',

    // Guides
    guide: '指南|指南',
    views: '意見',
    table_of_contents: '目錄',
    reading_time: '閱讀時間',
    date_added: '新增日期',
    date_updated: '更新日期',
    minutes_read: '閱讀分鐘數',
    published: '已發表',
    show_more_tags: '顯示不常見的標籤',
    hide_more_tags: '隱藏不常見的標籤',

    // Users
    joined: '已加入',
    last_online: '最後在線時間',
    online: '在線的',
    followers: '追隨者',
    partner: '夥伴',
    partnered_creator: '合作創作者',
    profile_hidden: '該用戶的個人資料已隱藏',
    follow: '跟隨',
    unfollow: '取消追蹤',
    following: '下列',
    user: '用戶',
    user_update_error: '使用者更新失敗',
    age_widget_error: '載入年齡小部件失敗',

    // Mods
    mod: '模組',
    level: '水平|等級',
    content: '內容',
    subscribed: '已訂閱',
    tags: '標籤',
    summary: '摘要',
    contributors: '作者',
    description: '說明',
    dependencies: '依賴項',
    no_dependencies: '這個 {ugc} 沒有依賴關係',
    of: '/',
    ago: '前',
    and: '和',
    by: '經過',
    reset_filters: '重置過濾器',
    show_more: '展示更多',
    show_less: '顯示較少',
    no_ugc_found: '未找到 {ugc_name}',
    no_subscriptions: '你還沒有訂閱任何 {ugc_name}',
    mod_disclaimer_heading: '法律免責聲明',
    mod_disclaimer_privacy: '隱私權政策',
    thumbs_up_received: '已收到豎起大拇指',
    thumbs_up: '豎起大拇指',
    total_downloads: '總下載量',
    releases: '發布',
    bytes: '位元組',
    local_mod_disabled:
      '這個 {ugc} 無法載入，因為缺少一個或多個依賴項：{dependencies}',
    mod_with_collections: '具有這個 {ugc} 的合集',
    see_all_collections: '查看所有 {count} 系列',
    mod_dependencies: '需要安裝所有依賴項才能運作此 {ugc}。',
    mod_dependencies_prompt:
      '這個 {ugc} 具有必要的依賴關係。你也想訂閱它們嗎？',
    allow_in_collections: '允許添加到收藏集',
    allow_in_collections_tip:
      '如果啟用此選項，其他使用者將能夠將您的 {ugc} 新增至收藏集。',

    // Actions
    login: '登入',
    logout: '登出',
    search: '搜尋',
    clear_all: '全部清除',
    download: '下載',
    subscribe: '訂閱',
    unsubscribe: '取消訂閱',
    resubscribe: '重新訂閱',
    activate: '啟用',
    deactivate: '停用',
    like: '喜歡',
    dislike: '不喜歡',
    report: '報告一個問題',
    submit: '提交',
    cancel: '取消',
    done: '完成',
    select: '選擇',
    previous: '上一頁',
    next: '下一頁',
    confirm: '確認',
    allow: '允許',
    manage: '管理',
    discard: '取消變更',
    more_actions: '更多動作',
    manage_interaction_settings: '管理互動設定',
    block: '封鎖',
    block_user: '封鎖用戶聯絡',
    unblock: '解除封鎖',
    user_blocked: '您已封鎖此用戶，因此他們無法聯絡您或評論您的內容',
    block_user_tooltip: '防止此用戶聯絡您或評論您的內容。',
    block_prompt: '您確定要封鎖此用戶嗎？他們將無法聯絡您或評論您的內容。',
    block_success: '用戶已成功封鎖。',
    unblock_success: '用戶已成功解除封鎖。',
    unblock_prompt:
      '您確定要解除封鎖此用戶嗎？他們將能夠再次聯絡您並評論您的內容。',
    mute: '靜音',
    mute_user: '靜音用戶{ugc}',
    unmute: '取消靜音',
    user_muted: '您已將此用戶靜音，因此無法看到他們的任何 {ugc}',
    mute_user_tooltip: '在瀏覽遊戲時，防止此用戶建立的 {ugc} 向您顯示',
    mute_prompt:
      '您確定要將此用戶靜音嗎？瀏覽遊戲時，您將不再看到他們提交的任何 {ugc}。',
    mute_success: '用戶已成功靜音。',
    unmute_success: '用戶已成功取消靜音。',
    unmute_prompt: '您確定要將此用戶取消靜音嗎？您將能夠再次看到他們的內容。',
    publish: '發布',
    block_error: '更新用戶封鎖狀態失敗',
    mute_error: '更新用戶靜音狀態失敗',

    // Collections
    collection: '系列 | 系列',
    total_mods: '總數 {UGC}',
    total_filesize: '檔案總大小',
    follow_collection: '關注收藏',
    unfollow_collection: '取消收藏',
    compatibility: '相容性',
    compat_rating: '相容性評級',
    last_30_days: '過去 30 天',
    all_time: '所有時間',
    does_collection_work: '這個系列適合你嗎？',
    collection_works: '是的，它是的',
    collection_doesnt_work: '不，它不是',
    collection_incomplete_subscriptions: '未完成訂閱',
    vote: '票',
    curator: '策展人',
    creator_count: '此系列中有 {count} 個創作者',
    mods_in_collection: '此系列中包含的所有 {ugc}',
    mod_not_available: '此 {ugc} 不再可用',
    unavailable: '不可用',
    collection_sub_mods: '將我訂閱此系列中的所有 {ugc}',
    collection_unsub_mods: '取消訂閱本集合中的所有 {ugc}',
    collection_unsub_hint:
      '如果未勾選，系列將從您的資料庫中移除，但您仍會繼續訂閱其 {ugc}。',
    collection_error_subscribe: '無法訂閱系列 {ugc}',
    collection_error_unsubscribe: '無法取消訂閱集合 {ugc}',
    collection_error_follow: '無法追蹤收集',
    collection_error_unfollow: '取消追蹤收集失敗',
    ugc_count: '{ugc} 計數',
    collections_incomplete: '某些 {ugc} 無法使用，可能會影響兼容性',
    adult: '成人',
    view_more: '查看更多',
    view_less: '查看更少',

    // Categories
    category: '分類',
    miscellaneous: '雜項',
    essential: '必備',
    themed: '主題',
    animation: '動畫',
    audio: '音頻',
    bug_fixes: '錯誤修正',
    cheating: '作弊',
    environment: '環境',
    gameplay: '遊戲玩法',
    quality_of_life: '生活品質',
    ui: 'UI',
    visuals: '視覺效果',

    // Filters
    all: '全部',
    available: '可用',
    filesize: '檔案大小',
    downloads: '下載次數',
    todays_downloads: '本日下載次數',
    subscribers: '訂閱者',
    rating: '評分',
    sort_by: '排序方式',
    creator: '建立者',
    apply: '申請',
    reset: '重置',
    featured: '特色',
    toggle_filters: '切換過濾器',
    show_filters: '顯示篩選器',
    hide_filters: '隱藏篩選條件',
    admin_options: '管理員選項',
    hidden: '隱',
    public: '公眾',
    private: '私人',
    pending: '待辦的',
    archived: '已存檔',
    deleted: '已刪除',
    last_day: '最後一天',
    hidden_monetization_disabled: '隱藏為停用營利',
    date_live: '日期現場',
    last_week: '上個星期',
    last_month: '上個月',
    last_3_months: '過去 3 個月',
    last_year: '去年',
    exclude: '排除',
    no_matching_content: '沒有相符的內容可用',
    content_type: '內容類型',
    free: '免費',
    premium: '額外費用',

    // Login
    signup: '以電子郵件登入或註冊',
    login_with: '使用 {service} 登入',
    email_placeholder: '電子郵件地址',
    code_placeholder: '5 位代碼',
    have_code: '我有代碼',
    send_new_code: '傳送新代碼',
    login_disclaimer: '使用者為「{game}」產生的內容由 mod.io 管理。',
    terms_disclaimer: `按下「登入」即表示您同意 {studioterms}mod.io 的{terms}和{privacy}，並確認您已年滿 {min_age} 歲。`,
    terms_disclaimer_studio: '{studio} 的{terms}、',
    terms_disclaimer_studio_separator: '、',
    terms_disclaimer_studio_and: '和',
    code_error: '無法要求代碼。',
    or: '或者',
    login_prompt: '您嘗試造訪的頁面需要身份驗證。請登入以繼續。',
    receive_code: '沒有收到代碼？',
    resend_code: '重新發送程式碼',
    login_with_email: '使用電子郵件登入',
    otp_email: '我們已將一次性密碼 (OTP) 發送至 {email}。請輸入該密碼以繼續。',
    back_to_login: '返回登入選項',

    // Terms
    terms: '使用條款',
    privacy: '隱私權政策',
    aup: '可接受的使用政策',
    monetization: '獲利條款',
    game: '遊戲條款',
    api: 'API存取條款',
    refund: '退款政策',
    effective: '生效日期：',

    // Report
    report_heading: '報告這個 {ugc}',
    report_intro:
      '您可以報告內容問題、違反 mod.io {terms} 的行為或使用下面的表單提交 {dmca}。',
    report_intro_collection:
      '您可以使用下面的表格報告內容問題、違反 mod.io {terms} 的行為。',
    report_details:
      '確保包含所有相關信息，以促進報告的解決。請注意，此資訊將與遊戲管理員分享，並可能與發布涉嫌侵權內容的使用者共用。',
    report_not_working_prompt: '「不起作用」報告將直接與內容創作者分享。',
    dmca: 'DMCA 投訴',
    report_reason: '檢舉的原因',
    urls: '違規網址',
    urls_placeholder: '網址 (每行 1 個)',
    company_or_name: '公司或你的姓名',
    email: '電子郵件',
    address: '地址',
    country: '國家/地區',
    country_placeholder: '選取國家/地區',
    details: '侵權或違規的細節',
    details_placeholder:
      '為了幫助解決您的報告，請提供盡可能多的詳細資訊和背景。',
    dmca_1:
      '{mod_io} 尊重他人的智慧財產權，也要求每個使用我們網站和服務的人也這麼做。如果有人認為自己的作品在我們的網站或服務中遭到複製，從而構成著作權侵犯，請使用下方的表格來通知 mod.io 的著作權代理人。',
    dmca_2:
      '提出侵犯著作權的申訴是一件嚴肅的法律事務。在你繼續之前，或許可以考慮直接聯繫涉及此事的個人來解決問題。這可能只是一個簡單的誤會，或許不用牽涉到正式的法律程序也能處理。',
    dmca_3:
      '請注意，根據數位千禧年著作權法案第 512(f) 款，如有任何人明知不實仍陳述某些材料或活動侵犯著作權，均可能承擔損害賠償責任。另外，請注意，這份法律通知中提供的資訊可能會與第三方分享或公開。',
    claim_check: '透過勾選以下方塊並提交本申訴，我依法據實陳述',
    copyright_owner: '我是著作權所有人',
    copyright_auth_owner: '在此種情況下，我有權代表著作權所有人行事。',
    authorization: '授權',
    authorization_check:
      '我有正當理由相信，本申訴所指材料之使用，未經著作權所有人、其代理人或法律授權。',
    acknowledgement: '知悉書',
    acknowledgement_check:
      '我知悉，根據數位千禧年著作權法案第 512(f) 款，任何明知不實仍陳述某些材料或活動侵犯著作權者，均可能承擔損害賠償責任。',
    required: '必填',
    signature: '簽名',
    signature_placeholder: '在此框中鍵入你的全名，作為你的數位簽名。',
    report_success_title: '你的檢舉已送達',
    report_success_text:
      '如果您的報告需要更多詳細信息，我們可能會聯絡您提供。感謝您提供詳細資訊。',
    report_error_title: '提交檢舉失敗',
    report_email_inform: '您的電子郵件地址僅用於處理此檢舉。',

    // Table
    name: '名稱',
    added: '建立時間',
    updated: '更新時間',
    date: '日期',
    item: '項目',
    file: '檔案',
    version: '版本',
    scan: '病毒掃描',
    actions: '動作',
    status: '狀態',
    role: '角色',
    live: '現場',
    locally_installed: '已安裝於本機',

    // Releases
    download_from_game_client: '從遊戲用戶端下載 {mod}',
    download_payment_required: '購買即可下載 {ugc}',
    download_auth_required: '登入以下載 {ugc}',
    release_notes: '版本說明',
    no_release_notes: '未提供版本說明',
    previous_releases: '之前的版本',
    view_previous_releases: '查看先前的版本',
    no_previous_releases: '沒有之前的版本',
    no_files_published: '未發佈檔案',
    download_files_manually: '手動下載文件',
    platforms: '平台 | 平台',

    // Ratings
    overwhelmingly_positive: '壓倒性好評',
    overwhelmingly_negative: '壓倒性負評',
    very_positive: '非常多好評',
    very_negative: '非常多負評',
    mostly_positive: '多數好評',
    mostly_negative: '多數負評',
    negative: '負評',
    positive: '好評',
    mixed: '褒貶不一',
    unrated: '未評分',

    // Sort
    sort_comments: '評論',
    sort_total_mods: '模組總數',
    sort_trending: '熱門',
    sort_highest_rated: '收視率最高',
    sort_most_popular: '最受歡迎',
    sort_most_subscribers: '大多數訂閱者',
    sort_recently_added: '最近添加的',
    sort_last_updated: '最近更新時間',
    sort_alphabetical: '按字母順序',
    sort_smallest_filesize: '最小的檔案大小',

    // Report Reason
    report_dmca: 'DMCA',
    report_not_working: '不工作',
    report_rude_content: '粗魯的內容',
    report_illegal_content: '非法內容',
    report_stolen_content: '被盜內容',
    report_false_information: '虛假信息',
    report_other: '其他',

    // Report not working reasons
    report_crash: '遊戲崩潰',
    report_no_load: '不加載',
    report_conflicts: '與其他 {ugc} 衝突',
    report_missing_deps: '缺少依賴項',
    report_install_issues: '安裝問題',
    report_bugs: '越野車行為',
    report_incompatability: '與遊戲版本不相容',
    report_corrupt: '文件損壞',

    // Errors
    warning: '警告',
    error_ref: '錯誤代碼： ',
    login_fail: '登錄失敗',
    login_fail_message: '登錄失敗。請等待一分鐘，然後重試。',
    subscribe_fail: '未能訂閱',
    unsubscribe_fail: '未能取消訂閱',
    error: '錯誤',
    default_error_message: '發生錯誤，請盡快重試。',
    follow_error: '未能關注',
    unfollow_error: '取消追蹤失敗',
    upload_file_error: '您必須至少上傳一個檔案才能繼續',

    agreement_not_found: '未找到協議',
    form_chars_remaining: '{count}剩下的字符。',
    form_not_enough_chars: '{count}需要更多字符。',
    filter: '篩選',
    loading: '加載',
    next_version: '下一個版本',
    no_results_found: '未找到結果',
    page_not_found: '找不到網頁！',
    previous_version: '以前的版本',
    take_me_home: '帶我回家',
    validation_alpha_num: '字段只能包含數字或字母',
    validation_size: '字段必須為{size}字符',
    validation_url: '字段必須是一個URL',
    validation_min: '最少 {min} 個字符',
    validation_max: '最大{max}字符',
    validation_email: '字段必須是一封電子郵件',
    validation_checked: '必須檢查字段',
    validation_required: '需要字段',
    validation_name: '欄位只能包含字母和與名稱相關的符號',
    validation_image: '文件必須是有效的 jpeg 或 png 圖像',
    validation_youtube: '欄位必須是有效的 Youtube 網址',
    validation_sketchfab: '欄位必須是有效的草圖構造網址',
    validation_zip: '檔案必須是 ZIP',
    validation_filesize: '檔案大小不得超過 {size}',
    delete_image: '刪除圖片',
    confirm_delete_image: '您確定要刪除此圖片嗎？',

    comment: '評論',
    team_member: '隊員',
    game_admin: '遊戲管理員',
    site_admin: '網站管理員',
    author: '作者',
    good_karma: 'ding',
    bad_karma: '踩',
    reply: '回覆',
    replies: '回覆|回覆',
    replied: '已回覆',
    reopen: '重新打開',
    close: '關閉',
    mark_as_read: '標記為已讀',
    save: '保存',
    delete: '刪除',
    archive: '存檔',
    edit: '編輯',
    post: '發佈',
    pinned: '已固定',
    pin: '引腳',
    unpin: '解鎖',
    locked: '鎖定',
    lock: '鎖',
    unlock: '解鎖',
    add_comment: '添加評論...',
    comment_cant_reply_locked: '因為評論主題被鎖定，無法回复',
    comment_cant_edit_locked: '由於評論線程被鎖定，無法編輯',
    comment_max_pin_limit: '已達到最大固定留言限制',
    comment_below_threshold: '在臨界值以下的評論。按一下以檢視。',
    comment_login_prompt: '登錄以加入討論！',
    comment_error_add: '未能添加評論',
    comment_error_edit: '未能編輯評論',
    comment_error_delete: '無法刪除評論',
    comment_error_rate: '評分評論失敗',
    comment_error_update: '更新註解失敗',
    comments_error_fetch: '無法加載更多評論',
    discussion: '討論',
    load_more_comments: '加載更多評論',
    comment_confirm_delete: '你確定要刪除此評論嗎？',
    comment_deleted: '評論已成功刪除',
    comments_disabled: '由於您的帳號已啟用家長監護功能，評論功能已停用。',
    comments_age_unverified: '您的年齡必須經過驗證才能發表評論。',
    review_settings: '查看設定',

    // Mod admin
    mod_status: {
      pending_has_file: '{ugc} 需要遊戲主持人批准才能上線。',
      pending_curation: '新增和核准檔案後，{ugc} 將變更為即時狀態。',
      pending_no_curation: '新增檔案後，{ugc} 將變更為即時狀態。',
      archived:
        '{ugc} 已存檔。所有訂戶都已被刪除，無法通過 API 請求查看或檢索。',
      hidden: '{ugc} 是隱藏的，僅供訂閱者和團隊成員使用。',
      hidden_purchase_disabled: '因為已停用營利，{ugc} 被隱藏。',
      live: '{ugc} 正式播放，所有人都可以玩。',
    },
    mod_profile: '{ugc} 個人資料',
    media: '媒體',
    file_manager: '文件管理器',
    step: '第{step}步',
    save_next: '儲存與下一步',
    auth_required: '需要驗證',
    public_text: '所有人都可以在瀏覽頁面上發現 {ugc}。',
    private_text:
      '{ugc} 只有團隊成員、現有訂閱者和具有預覽訪問權限的用戶才能訪問。',
    edit_disabled_on_add: '一旦建立此 {ugc}，您將無法通過網絡進行更改。',
    edit_enabled_on_add: '建立 {ugc} 後，您將能夠對 {ugc} 進行更改。',
    add_mod_monetized:
      '此遊戲支持獲利的 {ugc1}。如果您打算利用此 {ugc2}，請立即選擇 {private}，然後在設定營利化之後再將其設定為 {public}。您可以在建立 {ugc2} 之後設定營利化。',
    share_access: '共享存取權',
    profile_editing_disabled: '遊戲已禁用通過 Web 進行個人資料編輯。',
    tools_only_1:
      '您無法在這裡上傳 {game} 的 {ugc}，它們必須使用遊戲開發人員創建的工具上傳，以便可以驗證文件。有關更多信息，請參閱為此遊戲撰寫的 {guides}。',
    tools_only_2: '以下是遊戲開發人員提供的說明：',
    tools_only_3:
      '我們建議您返回 {ugc} 列表並從那裡瀏覽鏈接。如果問題仍然存在，請前往我們的 {help_center} 以獲取更多信息。',
    unsaved_heading: '您有未儲存的變更',
    unsaved_confirm: '有些更改尚未保存，您還想離開嗎？',
    settings: '設定',
    team: '團隊',
    reports: '報告',
    stats: '統計',
    moderator: '主持人',
    manager: '經理',
    error_get_mod: '無法取得 {ugc}',
    archive_reason: '歸檔的原因',
    view_mod: '查看 {ugc}',
    error_archive_mod: '無法存檔 {ugc}',
    archive_mod_prompt:
      '封存此 {ugc} 將取消訂閱所有用戶並將其從 API 請求中刪除。',
    archive_mod_confirm:
      '封存後，將發送一封電子郵件給所有團隊成員，通知他們此操作以及提供的原因。\n\n此操作只能由主持人恢復，您確定要繼續嗎？',

    headline_mod_profile: '建立您的 {ugc} 個人資料',
    headline_media: '將媒體新增至您的 {ugc} 個人資料',
    headline_files: '上傳您的 {ugc} 文件',
    headline_permissions: '為您的 {ugc} 設定重複使用權限',
    headline_dependencies: '新增任何 {ugc} 依賴項',

    // Basics
    basics: '基礎知識',
    logo: '標誌',
    logo_prompt_1: '將代表您的 {ugc} 標誌的圖像文件。',
    logo_prompt_2: '512x288 或更大',
    logo_prompt_3: '建議 16:9 寬高比',
    logo_prompt_4: '最大 8 MB',
    summary_placeholder: '在 1 段中告訴我們您的 {ugc} 對遊戲所做的更改。',
    homepage: '主頁',
    profile_url: '個人資料網址',
    visibility: '能見度',
    visibility_tip:
      '一旦上線，所有人都可以看到公共 {ugc}。隱藏的 {ugc} 僅對團隊成員和訂閱者看到。',
    upload_images: '上傳圖片',
    mature_content: '包含成人內容',
    mature_content_alcohol: '酒精',
    mature_content_drugs: '藥物',
    mature_content_violence: '暴力',
    mature_content_explicit: '明確',
    community: '社區',
    allow_comments: '允許留言',
    allow_dependants: '允許受養人',
    create_mod: '建立 {ugc}',
    error_mod_create: '無法建立 {ugc}',
    error_mod_update: '無法更新 {ugc}',
    error_tags_update: '更新標籤失敗',
    success_create_mod: '成功建立 {modname}',
    success_update_mod: '已成功更新 {模式名稱}',
    description_tip:
      '您的 {ugc} 的可選描述，其中可包含「關於」，「功能」，「使用情況」，「常見問題」等詳細信息。支持和鼓勵 HTML',

    // Media
    models: '模型',
    media_reorder_hint: '拖曳以重新排序現有圖像，或拖放新的圖像檔案進行上傳。',
    media_zip_hint_1:
      '一次上傳最多 {count} 張圖片，或包含圖片的單個 zip 檔案。',
    media_zip_hint_2: '支援的格式為 .jpg、.jpeg、.png 和 .zip。',
    drag_and_drop_image: '拖放圖片進行上傳',
    or_click_to_upload: '或點擊選擇檔案',
    error_media_update: '無法更新媒體',
    error_media_add_links: '無法新增媒體連結',
    error_media_remove_links: '無法移除媒體連結',
    success_media_updated: '已成功更新媒體',

    // File manager
    add_file: '新增檔案',
    edit_file: '編輯檔案',
    select_zip: '選擇 zip 文件',
    upload: '上傳',
    file_id: '檔案識別碼：',
    virus_none: '未偵測到任何病毒',
    virus_waiting: '等待掃描',
    virus_scanning: '掃描進行中',
    virus_too_large: '檔案太大無法掃描',
    virus_not_found: '找不到檔案',
    virus_error: '掃描檔案時發生錯誤',
    virus_found: '偵測到病毒',
    virus_risk: '此文件包含可執行文件，打開時應注意',
    version_placeholder: '版本號碼，即 1.0.0',
    release_notes_placeholder: '在單獨的行上輸入每個變更',
    game_moderator: '遊戲主持人',
    metadata_blob: '中繼資料區塊',
    metadata_blob_placeholder:
      '輸入特定的元數據，例如此版本相容的遊戲版本，如何安裝它等。支持 UTF-8 有效數據。',
    select_platforms: '平台（選擇所有適用的）',
    file_pending: '等待核准',
    file_approved: '已核准',
    file_approved_live: '已核准並現場',
    file_approved_not_live: '已核准但未實時',
    file_denied: '拒絕',
    file_targeted: '針對性',
    live_file: '此檔案目前正在執行中。',
    file_is_live: '檔案已上線',
    file_is_not_live: '檔案未上線',
    no_delete_file_live: '無法刪除，因為文件是即時的',
    make_file_live: '讓這個發行版本進行',
    make_file_live_platforms: '將此版本推出適用於已核准的平台',
    delete_file_prompt: '您確定要刪除此文件嗎？此動作無法復原。',
    file_processing_title: '文件處理',
    file_processing:
      '您的檔案正在處理中。您可以繼續瀏覽網站，但在完成之前請勿關閉標籤或瀏覽器窗口。',
    file_instructions_1:
      '壓縮並上傳 {ugc} 的基本文件夾，或者如果它是存在於先前存在的遊戲文件夾中的文件夾中的文件集合，則應將這些文件壓縮這些文件：',
    file_instructions_2: '必須是一個 ZIP 文件',
    file_instructions_3: '檔案大小不能超過 20GB',
    file_instructions_4:
      '檔案名稱不能包含下列任何字元：\\ / ? " &lt; &gt; &#124; : *',
    file_instructions_5: '除非遊戲管理此操作，否則不支持覆寫文件的 {ugc}',
    file_instructions_6: '除非遊戲管理此操作，否則不支持跨多個遊戲目錄的 {ugc}',
    file_terms: '我同意 {terms} 和 {privacy}。',
    error_get_files: '無法取得檔案',
    error_upload_file_name: '無法上傳檔案 {filename}',
    error_upload_file: '無法上傳檔案',
    error_update_file: '無法更新檔案',
    error_delete_file: '無法刪除檔案',
    no_permission_delete_files: '您沒有刪除文件的權限',
    error_file_required: '文件是必需的',
    error_platform_required: '您必須至少選擇一個平台',
    success_file_uploaded: '檔案上傳成功',
    success_file_moderation: '主持人將審核需要審核的平台',
    success_file_updated: '檔案已成功更新',
    error_no_approved_platforms: '沒有平台可以直播',
    error_no_approved_platforms_text: '此文件沒有目前未正在使用的核准平台',
    drag_and_drop_file: '拖放檔案進行上傳',
    file_upload_hint: '僅接受 .zip 檔案 | {max} 最大檔案大小',
    upload_draft: '上傳並保存為草稿',
    upload_publish: '上傳並發布',
    save_draft: '保存並保持為草稿',
    save_publish: '保存並發布',
    keep_as_draft: '保存為草稿',
    publish_confirmation: '您確定要發布此檔案嗎？',
    marketplace_file_hint:
      '如果您打算將此{mod}貨幣化，您應該將此檔案保存為草稿，並在發布前先設定貨幣化。',
    curation_file_hint: '遊戲主持人必須在玩家能夠存取之前批准您的{mod}。',
    platform_file_hint:
      '此遊戲需要對選定平台上的每個{mod}檔案進行平台審批：{platforms}。',
    two_step_approval_process: '此遊戲需要兩步驟审批流程：',
    two_step_approval_process_step1:
      '對於選定平台上的此{mod}檔案需要遊戲主持人审批：{platforms}',
    two_step_approval_process_step2: '遊戲主持人审批{mod}上線',
    two_step_approval_process_live:
      '發布此檔案也將在兩個审批都完成後自動將{mod}設定為活躍狀態。',
    one_step_approval_process_live:
      '發布此檔案也將在批准後自動將{mod}設定為活躍狀態。',

    // Reuse permissions form
    reuse_permissions: {
      heading: '重複使用權限',
      allow_redistribution:
        '允許其他人將我的 {ugc} 資產上傳到其他網站，但我必須被認為是原始創作者',
      allow_porting:
        '允許其他人將我的 {ugc} 資產轉換為其他遊戲中使用，但我必須被認為是原始創作者',
      allow_patching_no_credit:
        '允許其他人修改我的 {ugc} 資產（包括發布錯誤修復或改進）並將其發布為新的 {ugc}',
      require_credit: '我必須被認為是原始創作者',
      require_permission: '首先要求我的許可',
      require_repackage_no_credit: '允許其他人在自己的 {1} 中使用我的 {0} 資產',
      allow_resell:
        '允許其他人在任何商業作品中使用我的 {ugc} 資產中的任何 {ugc}/文件中',
      original_assets: '我的 {ugc} 包含 100％ 的原始作品，或可以重新分發的資產',
      error_update: '無法更新重複使用權限',
      success_update: '成功更新重複使用權限',
      prompt:
        '設定您的 {ugc} 資產如何用於其他人內容創建的權限。授予其他人使用或修改您的文件的權限，即表示您確認對已創建的作品無法回溯撤銷該等授權。',
    },

    // Dependencies form
    dependencies_prompt:
      '選擇所需的 {0} 才能正確運作的 {1}（如果沒有顯示 {1}，這意味著它不允許依賴關係，您應該聯繫創建者以打開它）：',
    remove_dependency: '移除相依性',
    dependants: '受養人',
    important: '重要',
    error_update_dependencies: '無法更新相依性',
    success_update_dependencies: '成功更新相依性設定',
    dependants_warning_1: '一旦允許，請注意，{ugc} 與家屬相關聯：',
    dependants_warning_2: '無法停用受屬人',
    dependants_warning_3: '無法刪除',
    dependants_warning_4: '無法獲利',
    no_dependants: '找不到受養人',
    dependencies_allow_prompt:
      '您必須在上方開啟「允許依賴人」，才能將其他 {ugc} 新增為依賴人。',
    dependencies_deny_prompt:
      '如果您不希望其他 {ugc} 將其選擇為依賴項，則可以關閉上面的允許相依人',
    dependency_disabled_monetization: '獲利的 {ugc} 無法啟用相依人',
    dependencies_not_supported:
      '{gamename} 不支持依賴關係，所有 {ugc} 都必須獨立運行並完全獨立運行。',
    dependency_disabled_dependants:
      '無法為此 {ugc_single} 停用相依者，因為其他 {ugc_plural} 依賴它。這些可以從「依賴關係」標籤中查看。',
    dependants_confirm_enable:
      '這是為了確保連接的 {ugc} 的持續兼容性。請確認以啟用。',
    dependants_confirm_disable:
      '您確定要禁止受養人？這意味著其他 {0} 將無法將您的 {1} 添加為依賴項。',
    dependency_monetization_warning:
      '{game} 允許 {mod} 貨幣化。貨幣化目前不支援具有相依性的 {mods}。如果您打算將此 {mod} 貨幣化，請跳過此步驟。',

    // Parental controls
    notify_parent_title: '通知家長或監護人',
    notify_parent:
      '如果您繼續操作，您的父母或監護人將會收到通知，並且必須批准這些變更後，這些變更才會生效。',
    confirm_notify_parent:
      '您是否希望向您的父母或監護人發送通知，請他們查看建議的權限變更？',
    request_access: '請求訪問',

    // Cloud cooking
    cook_source: '烹飪原始檔',
    source_file: '原始檔',
    targeted_platform: '目標平台',
    metadata: '元數據',
    cook_time: '烹飪時間',
    download_time: '下載時間',
    file_compression_time: '檔案壓縮時間',
    file_decompression_time: '檔案解壓縮時間',
    upload_time: '上傳時間',
    total_job_time: '總工作時間',
    logs: '紀錄',
    view_logs: '檢視記錄',
    logs_available_on_completion: '記錄將在烹飪完成後提供',
    logs_for_file: '{file} 的烹飪日誌。',
    no_logs: '找不到 {file} 的記錄檔。',
    get_logs_error: '無法取得烹飪記錄',
    admin_only: '限管理員',
    queue: '佇列',
    source_file_history: '來源文件歷史記錄',
    no_source_files_found: '未找到原始檔案',
    no_cooks_found: '沒有找到廚師',
    cook_jobs_available: '可用的廚師工作檔案：{count}',
    view_details: '看詳情',
    cloud_cooking: '雲烹飪',
    add_file_type: '新增一個新的 {string}',
    edit_file_type: '編輯 {string}',
    files: '文件',
    cook_details: '烹飪詳情',
    status_queued: '已排隊',
    status_cooking: '烹飪',
    status_success: '成功的',
    status_failed: '失敗的',
    status_pending_moderation: '待審核',
    status_moderation_rejected: '庫克拒絕',
    get_cook_files_error: '取得雲端烹飪文件失敗',
    get_source_files_error: '取得原始檔失敗',
    download_file_error: '文件下載失敗',
    source_instructions:
      '上傳來源文件，並在下方選擇目標平台。文件將透過雲端編譯處理，產生適用於各個平台的獨立檔案。',

    // Marketplace
    marketplace: {
      available_stock: '數量有限，剩餘 {count} 件',
      virtual_currency: '虛擬貨幣',
      marketplace: '市場',
      order_summary: '訂單摘要',
      payment_method: '付款方式 | 付款方式',
      wallet_balance: '錢包餘額',
      vc_balance: '虛擬貨幣餘額',
      credits: '積分',
      currency: '貨幣',
      balance_after: '購買後餘額',
      token_purchase_success:
        '感謝您的購買。您的付款已經處理，稅收據將很快發送到您的電子郵件。您的 {game} 虛擬貨幣餘額現已更新',
      transaction_id: '交易編號',
      total_paid: '支付總金額',
      agreement: '我同意模組 .io 的 {terms} 和 {refund}',
      change_payment: '更改付款',
      error_register: '無法註冊獲利',
      error_wallet: '無法取得遊戲錢包',
      error_process: '無法處理付款',
      error_complete: '無法完成付款',
      checkout: '結帳',
      vc_topup_confirmed: '虛擬貨幣充值確認',
      confirm_purchase: '確認購買',
      continue_browsing: '繼續瀏覽',
      back_to_mod: '返回 {ugc} 購買',
      ugc_not_refundable:
        '{ugc_plural} 購買的商品不予退款。購買此 {ugc} 之前，請參閱我們的 {terms} 和 {refund}。',
      ugc_purchase_success:
        '感謝您的購買。{ugc} 已在您的 {library} 中添加到您的訂閱中，並且可以在遊戲中使用。',
      game_virtual_currency: '遊戲虛擬貨幣（{virtual_currency}）',
      proceed_to_checkout: '繼續結帳',
      ugc_purchase_confirmed: '{ugc} 已確認購買',
      error_already_purchased: '您已經擁有這個 {ugc}',
      error_sku_packs: '無法取得 {ugc} 價格',
      error_payment_methods: '無法取得付款方式',
      calculated_at_checkout: '結帳時計算',
      subtotal: '小計',
      taxes: '稅',
      total_due: '到期總金額',
      price: '價格',
      purchased: '已購買',
      purchases: '已購買的 {ugc}',
      no_purchases: '您尚未購買任何 {ugc}',
      purchase_to_rate: '您只能評價您已購買的 {ugc}',
      usd_ugc_license:
        '購買此 {ugc} 即時獲得 {count} 積分，以換取訪問它的許可證。',
      top_up: '充值',
      remaining_balance: '剩餘餘額',
      not_enough_vc: '您沒有足夠的虛擬貨幣來繼續進行。請充值您的遊戲錢包',
      error_virtual_currency_packs: '無法取得虛擬貨幣套件',
      vc_prompt: '取得虛擬貨幣套件',
      vc_description:
        '通過購買 {game} 的虛擬貨幣包，支持內容創作者並訪問高級內容',
      vc_agreement:
        '購買虛擬貨幣包之前，請參閱我們的 {terms} 和 {refund}。所有適用的稅金均在結帳時收取。',
      error_session: '無法取得購買階段',
      sold_out: '售罄',
      currency_packs: '貨幣組合',
      cancel_transaction: '取消交易',
      cancel_transaction_text: '您確定要取消這筆交易嗎？',
    },
  },
}
